import type { TranslationMap } from './types';

// Portuguese (Português) translations. Keys mirror en.ts; missing/
// English-identical values fall back to English via I18nContext.resolveEn().
const messages: TranslationMap = {
  'connections.header.companion':
    'Um companheiro de ambiente de trabalho flutuante para ajuda rápida e sempre disponível.',
  'settings.assistant.desktopCompanion': 'Companheiro de área de trabalho',
  'settings.assistant.desktopCompanionDesc':
    'Modo companheiro sempre ativo com atalho na bandeja do sistema',
  'pages.settings.features.desktopCompanion': 'Companion Desktop',
  'settings.companion.title': 'Companheiro de Área de Trabalho',
  'settings.companion.session': 'Sessão',
  'settings.companion.activeLabel': 'Ativo',
  'settings.companion.inactiveStatus': 'Inativo',
  'settings.companion.stopping': 'Parando…',
  'settings.companion.stopSession': 'Interromper sessão',
  'settings.companion.starting': 'Iniciando…',
  'settings.companion.startSession': 'Iniciar sessão',
  'settings.companion.sessionId': 'ID da sessão',
  'settings.companion.turns': 'Turnos',
  'settings.companion.remaining': 'Restante',
  'settings.companion.configuration': 'Configuração',
  'settings.companion.hotkey': 'Tecla de atalho',
  'settings.companion.activationMode': 'Modo de ativação',
  'settings.companion.sessionTtl': 'Sessão TTL',
  // Share cards (#5006).
  'share.button': 'Partilhar',
  'share.modalTitle': 'Partilhe este momento',
  'share.modalSubtitle': 'Publique o que o seu agente fez no X ou no LinkedIn',
  'share.drafting': 'A criar o seu cartão...',
  'share.cardAlt': 'Pré-visualização do cartão de partilha',
  'share.imageError': 'Não foi possível gerar a imagem. Tente novamente.',
  'share.captionLabel': 'Legenda',
  'share.captionPlaceholder': 'Escreva uma legenda...',
  'share.privacyNote':
    'Apenas o título, a legenda, o nome do agente e a marca são partilhados. O seu chat, a memória e os ficheiros permanecem privados.',
  'share.defaultHeadline': 'Veja o que o meu agente OpenHuman acabou de fazer',
  'share.defaultAgentName': 'O meu agente',
  'share.defaultCaption': 'Veja o que o meu agente OpenHuman acabou de fazer.',
  'share.captionWithHeadline': '{headline}. Feito com o meu agente OpenHuman.',
  'share.linkedInHint': 'Legenda copiada. Cole-a na sua publicação do LinkedIn.',
  'share.shareX': 'Partilhar no X',
  'share.shareLinkedIn': 'Partilhar no LinkedIn',
  'share.copyImage': 'Copiar imagem',
  'share.copiedImage': 'Imagem copiada',
  'share.copyCaption': 'Copiar legenda',
  'share.copiedCaption': 'Legenda copiada',
  'agentWorld.welcome.nav': 'Bem-vindo',
  'agentWorld.welcome.eyebrow': 'TinyPlace',
  'agentWorld.welcome.title': 'Um mundo onde os seus agentes se encontram',
  'agentWorld.welcome.body':
    'O TinyPlace é a camada social para agentes de IA: o seu pode descobrir outros agentes, enviar-lhes mensagens, aceitar recompensas e negociar, tudo em seu nome. Entre no mundo e veja o que eles andam a fazer.',
  'agentWorld.welcome.ctaWorld': 'Entrar no mundo',
  'agentWorld.welcome.ctaFeed': 'Explorar o feed',
  'agentWorld.welcome.ctaDirectory': 'Encontrar agentes',
  'agentWorld.welcome.featsLabel': 'O que acontece aqui',
  'agentWorld.welcome.feat1Title': 'Conheça outros agentes',
  'agentWorld.welcome.feat1Body': 'Descubra agentes de toda a rede e envie-lhes mensagens.',
  'agentWorld.welcome.feat2Title': 'Aceite recompensas',
  'agentWorld.welcome.feat2Body': 'O seu agente pode ganhar ao concluir trabalhos publicados.',
  'agentWorld.welcome.feat3Title': 'Negocie & transacione',
  'agentWorld.welcome.feat3Body': 'Pagamentos com carteira entre agentes, com a sua aprovação.',
  'brain.header.graph': 'Como o conhecimento do seu agente se conecta: pessoas, temas e memórias.',
  'brain.header.goals': 'Aquilo em que o seu agente está a trabalhar, e porquê.',
  'brain.header.sources': 'Os dados com que o seu agente aprende.',
  'brain.header.sync': 'Mantenha a sua memória atualizada e reveja o que mudou.',
  'brain.header.subconscious': 'Pensamento em segundo plano que corre enquanto está ausente.',
  'brain.welcome.nav': 'Bem-vindo',
  'brain.welcome.eyebrow': 'Cérebro',
  'brain.welcome.title': 'A memória do seu agente, mapeada',
  'brain.welcome.body':
    'O Cérebro é onde o seu agente guarda o que sabe: as pessoas, conversas, fontes e objetivos de que se serve para o ajudar com contexto real em vez de começar do zero de cada vez.',
  'brain.welcome.ctaGraph': 'Abrir grafo de memória',
  'brain.welcome.ctaGoals': 'Definir objetivos',
  'brain.welcome.ctaSources': 'Ligar fontes',
  'brain.welcome.featsLabel': 'O que vive aqui',
  'brain.welcome.feat1Title': 'Grafo de memória',
  'brain.welcome.feat1Body': 'Veja num relance como pessoas, temas e mensagens se conectam.',
  'brain.welcome.feat2Title': 'Objetivos & foco',
  'brain.welcome.feat2Body': 'Diga ao seu agente o que importa para que priorize o trabalho certo.',
  'brain.welcome.feat3Title': 'Fontes & sincronização',
  'brain.welcome.feat3Body':
    'Ligue os dados com que o seu agente aprende e mantenha-os atualizados.',
  'feedback.header.title': 'Comentários',
  'feedback.header.desc': 'Partilhe ideias e vote no que vamos construir a seguir.',
  'feedback.welcome.nav': 'Bem-vindo',
  'feedback.welcome.main': 'Quadro de comentários',
  'feedback.welcome.eyebrow': 'Comentários',
  'feedback.welcome.title': 'Ajude a moldar o que construímos',
  'feedback.welcome.body':
    'Diga-nos o que funciona, o que falta e o que tornaria o OpenHuman melhor. Publique uma ideia, vote nas sugestões dos outros e veja as melhores subirem ao topo do nosso roteiro.',
  'feedback.welcome.ctaShare': 'Partilhar uma ideia',
  'feedback.welcome.ctaBoard': 'Ver o quadro',
  'feedback.welcome.featsLabel': 'O que pode fazer',
  'feedback.welcome.feat1Title': 'Partilhar ideias',
  'feedback.welcome.feat1Body':
    'Erros, pedidos de funcionalidades, ideias soltas: tudo é bem-vindo.',
  'feedback.welcome.feat2Title': 'Votar',
  'feedback.welcome.feat2Body': 'Vote no que importa para sabermos o que priorizar.',
  'feedback.welcome.feat3Title': 'Acompanhar o progresso',
  'feedback.welcome.feat3Body': 'Veja o que está planeado, em curso e concluído.',
  'connections.header.composio': 'Ligue as aplicações em que o seu agente pode agir.',
  'connections.header.channels': 'Ligue as aplicações de chat onde a sua comunidade vive.',
  'connections.header.mcp': 'Adicione servidores MCP para ampliar as ferramentas do seu agente.',
  'connections.header.skills': 'Instale e faça a gestão das competências do agente.',
  'connections.header.meetings': 'Ligue calendários e deixe o seu agente participar em chamadas.',
  'connections.header.llm':
    'Configure fornecedores de IA, modelos locais e o testador de chat do agente.',
  'connections.header.embeddings': 'Escolha o modelo de embeddings usado na pesquisa da memória.',
  'connections.header.search': 'Configure a pesquisa na web para o seu agente.',
  'connections.header.wallet': 'O saldo da sua carteira local e a sua frase de recuperação.',
  'connections.header.composioKey':
    'Adicione uma chave de API do Composio para desbloquear centenas de integrações de aplicações.',
  'connections.llm.apiKeys': 'Chaves de API e encaminhamento',
  'connections.welcome.nav': 'Bem-vindo',
  'connections.welcome.eyebrow': 'Ligações',
  'connections.welcome.title': 'Tudo o que usa, num só lugar',
  'connections.welcome.body':
    'Ligue as suas aplicações de mensagens, email, calendário e ferramentas para que o seu agente possa ler o contexto e agir em todas elas, sem copiar e colar entre uma dúzia de separadores. Você mantém o controlo daquilo em que ele pode tocar.',
  'connections.welcome.ctaChannel': 'Ligar um canal',
  'connections.welcome.ctaApps': 'Ligar aplicações',
  'connections.welcome.ctaSkills': 'Explorar competências',
  'connections.welcome.featsLabel': 'O que pode fazer aqui',
  'connections.welcome.feat1Title': 'Traga os canais',
  'connections.welcome.feat1Body':
    'Slack, WhatsApp, Telegram, Gmail e mais: ligados em poucos cliques.',
  'connections.welcome.feat2Title': 'Deixe o seu agente agir',
  'connections.welcome.feat2Body':
    'Ele lê, redige e responde com todo o contexto de tudo o que está ligado.',
  'connections.welcome.feat3Title': 'Mantenha o controlo',
  'connections.welcome.feat3Body':
    'Conceda ou revogue o acesso por canal, a qualquer momento. Nada corre sem a sua palavra.',
  'alerts.header.desc': 'Atividade do agente e tudo o que precisa da sua atenção.',
  'notifications.welcome.nav': 'Bem-vindo',
  'notifications.welcome.main': 'Alertas',
  'notifications.welcome.eyebrow': 'Notificações',
  'notifications.welcome.title': 'Apenas o que realmente precisa de si',
  'notifications.welcome.body':
    'Um resumo calmo e classificado do que os seus agentes fizeram e do que precisa de uma decisão, para que o importante venha à tona e o ruído fique fora do seu caminho.',
  'notifications.welcome.ctaView': 'Ver alertas',
  'notifications.welcome.featsLabel': 'O que vai ver',
  'notifications.welcome.feat1Title': 'O que precisa de si',
  'notifications.welcome.feat1Body':
    'Decisões e menções que os seus agentes sinalizaram para um humano.',
  'notifications.welcome.feat2Title': 'Atividade do agente',
  'notifications.welcome.feat2Body': 'Um registo contínuo do que correu e do que produziu.',
  'notifications.welcome.feat3Title': 'Filtrado por categoria',
  'notifications.welcome.feat3Body': 'Mensagens, reuniões, lembretes: organizados como você pensa.',
  'rewards.header.desc': 'Os seus pontos, sequências, indicações e vantagens.',
  'rewards.welcome.nav': 'Bem-vindo',
  'rewards.welcome.main': 'Recompensas',
  'rewards.welcome.eyebrow': 'Recompensas',
  'rewards.welcome.title': 'Seja recompensado por aparecer',
  'rewards.welcome.body':
    'Ganhe pontos à medida que usa o OpenHuman e convida outros, mantenha a sua sequência viva e resgate o que ganhou, tudo registado num só lugar.',
  'rewards.welcome.ctaView': 'Ver recompensas',
  'rewards.welcome.featsLabel': 'Como funciona',
  'rewards.welcome.feat1Title': 'Ganhe pontos',
  'rewards.welcome.feat1Body': 'Ações do dia a dia e indicações somam-se ao longo do tempo.',
  'rewards.welcome.feat2Title': 'Mantenha a sequência',
  'rewards.welcome.feat2Body': 'Apareça regularmente para desbloquear bónus de sequência.',
  'rewards.welcome.feat3Title': 'Resgate vantagens',
  'rewards.welcome.feat3Body': 'Transforme pontos em cupões e recompensas.',
  'flows.welcome.nav': 'Bem-vindo',
  'flows.welcome.main': 'Fluxos de trabalho',
  'flows.welcome.eyebrow': 'Fluxos de trabalho',
  'flows.welcome.title': 'Coloque o trabalho repetitivo em piloto automático',
  'flows.welcome.body':
    'Descreva algo que faz uma e outra vez (triagem, acompanhamentos, resumos) e o seu agente transforma-o num fluxo de trabalho que pode executar de ponta a ponta, de acordo com um horário ou a pedido.',
  'flows.welcome.ctaNew': 'Novo fluxo de trabalho',
  'flows.welcome.ctaBrowse': 'Explorar fluxos de trabalho',
  'flows.welcome.featsLabel': 'O que pode automatizar',
  'flows.welcome.feat1Title': 'Descreva por palavras',
  'flows.welcome.feat1Body': 'Diga o que quer em linguagem simples; o construtor redige o fluxo.',
  'flows.welcome.feat2Title': 'Execute num horário',
  'flows.welcome.feat2Body': 'Dispare por temporizador, por evento ou por um botão: você decide.',
  'flows.welcome.feat3Title': 'Mantenha os humanos no circuito',
  'flows.welcome.feat3Body': 'Aprove passos sensíveis antes de qualquer coisa sair.',
  // Privacy Mode selector (#4435): data-egress posture
  'privacy.mode.title': 'Modo de privacidade',
  'privacy.mode.description':
    'Controla quanto dos seus dados pode sair deste dispositivo. Separado do modo de acesso do agente.',
  'privacy.mode.localOnly': 'Apenas local',
  'privacy.mode.localOnlyDesc':
    'Apenas modelos no dispositivo. Chamadas a modelos externos são bloqueadas.',
  'privacy.mode.standard': 'Padrão',
  'privacy.mode.standardDesc': 'Equilibrado. Modelos externos são usados conforme configurado.',
  'privacy.mode.sensitive': 'Sensível',
  'privacy.mode.sensitiveDesc': 'Cuidado extra com dados sensíveis. Mais controles em breve.',
  'privacy.mode.saved': 'Salvo',
  'privacy.mode.saveError': 'Não foi possível atualizar o modo de privacidade.',
  'skills.recallCalendar.title': 'Google Agenda',
  'skills.recallCalendar.description':
    'Entrar automaticamente nas chamadas do Google Meet via Recall.ai',
  // Core connection panel (GH-4396)
  'settings.core.title': 'Conexão do core',
  'settings.core.menuDesc': 'Use o core local integrado ou conecte-se a um core remoto.',
  'settings.core.useRemoteToggle': 'Usar core remoto',
  'settings.core.useRemoteToggleDesc':
    'Conecte-se a um core remoto por HTTP em vez do core local integrado.',
  'settings.core.statusConnectedRemote': 'Conectado ao core remoto',
  'settings.core.statusConnectedLocal': 'Conectado ao core local',
  'settings.core.statusChecking': 'Verificando a conexão…',
  'settings.core.statusAuthFailed': 'Acessível, mas o token foi rejeitado',
  'settings.core.statusUnreachable': 'Não é possível acessar o core',
  'settings.core.recheck': 'Verificar novamente',
  'settings.core.save': 'Salvar e reiniciar',
  'settings.core.applyRestartNote': 'Salvar reinicia o OpenHuman para reconectar.',
  // Cross-host vault (#4278)
  'crossHostVault.title': 'O vault está no host do core.',
  'crossHostVault.message':
    'Este vault de memória fica armazenado no host openhuman-core ({os}). Só pode ser aberto ou exibido nessa máquina, não a partir deste dispositivo.',
  'conversations.toolFailure.whyLabel': 'Por quê',
  'conversations.toolFailure.nextLabel': 'O que fazer a seguir',
  'conversations.toolFailure.missingPermission.cause':
    'O OpenHuman ainda não tem permissão para fazer isso.',
  'conversations.toolFailure.missingPermission.next':
    'Conceda a permissão necessária e tente novamente.',
  'conversations.toolFailure.missingApp.cause':
    'O app ou programa necessário para esta ação não está disponível.',
  'conversations.toolFailure.missingApp.next': 'Instale ou abra o app e tente novamente.',
  'conversations.toolFailure.serviceUnavailable.cause':
    'Um serviço de que o OpenHuman precisa está temporariamente indisponível.',
  'conversations.toolFailure.serviceUnavailable.next':
    'O OpenHuman tentará de novo em breve: nenhuma ação necessária.',
  'conversations.toolFailure.badCredentials.cause':
    'Os dados de login salvos estão ausentes ou não são mais válidos.',
  'conversations.toolFailure.badCredentials.next':
    'Faça login novamente ou atualize as credenciais e tente de novo.',
  'conversations.toolFailure.blockedByPolicy.cause':
    'Esta ação está bloqueada pelas suas configurações de segurança.',
  'conversations.toolFailure.blockedByPolicy.next':
    'Permita-a em Configurações → Acesso do agente se quiser que ela seja executada.',
  'conversations.toolFailure.modelConnection.cause':
    'O OpenHuman não conseguiu acessar o modelo de IA.',
  'conversations.toolFailure.modelConnection.next':
    'Verifique sua conexão ou as configurações do modelo; o OpenHuman tentará novamente.',
  'conversations.toolFailure.timeout.cause': 'A ação demorou demais e foi interrompida.',
  'conversations.toolFailure.timeout.next':
    'O OpenHuman tentará novamente, ou você pode tentar manualmente.',
  'conversations.toolFailure.denied.cause': 'Você recusou esta ação.',
  'conversations.toolFailure.denied.next':
    'Nada a fazer: ela não foi executada. Peça novamente se mudar de ideia.',
  'conversations.toolFailure.approvalExpired.cause':
    'A solicitação de aprovação expirou antes que alguém respondesse.',
  'conversations.toolFailure.approvalExpired.next':
    'Peça novamente para executá-la: o OpenHuman não tentará de novo sozinho.',
  'conversations.toolFailure.unknown.cause': 'Algo deu errado com esta ação.',
  'conversations.toolFailure.unknown.next':
    'Tente novamente; se continuar falhando, execute o diagnóstico nas Configurações.',
  'conversations.backgroundTasks.title': 'Tarefas em segundo plano',
  'nav.feedback': 'Enviar feedback',
  'feedback.board': 'Quadro de feedback',
  'feedback.empty': 'Ainda não há feedback. Seja o primeiro a compartilhar uma ideia.',
  'feedback.loadMore': 'Carregar mais',
  'feedback.loadError': 'Falha ao carregar o feedback',
  'feedback.expand': 'Mostrar mais',
  'feedback.collapse': 'Mostrar menos',
  'feedback.comments': 'comentários',
  'feedback.viewIssue': 'Ver issue',
  'feedback.status.open': 'Aberto',
  'feedback.status.planned': 'Planejado',
  'feedback.status.completed': 'Concluído',
  'feedback.status.closed': 'Fechado',
  'feedback.type.feature': 'Recurso',
  'feedback.type.bug': 'Bug',
  'feedback.sort.hot': 'Em alta',
  'feedback.sort.top': 'Mais votados',
  'feedback.sort.new': 'Recentes',
  'feedback.filter.allTypes': 'Todos os tipos',
  'feedback.filter.allStatuses': 'Todos os status',
  'feedback.vote.up': 'Votar a favor',
  'feedback.vote.down': 'Votar contra',
  'feedback.submit.heading': 'Compartilhe seu feedback',
  'feedback.submit.subheading':
    'Sugira um recurso ou relate um bug. Outras pessoas podem votar nele.',
  'feedback.submit.titlePlaceholder': 'Título',
  'feedback.submit.bodyPlaceholder': 'Descreva sua ideia ou o problema que você encontrou',
  'feedback.submit.action': 'Enviar',
  'feedback.submit.success': 'Obrigado! Seu feedback já está no quadro.',
  'feedback.submit.rejected': 'Não foi possível publicar seu feedback.',
  'feedback.submit.error': 'Algo deu errado. Tente novamente.',
  'feedback.admin.status': 'Status',
  'feedback.admin.updateFailed': 'Falha ao atualizar o status',
  'feedback.comments.empty': 'Ainda não há comentários.',
  'feedback.comments.placeholder': 'Adicionar um comentário',
  'feedback.comments.post': 'Publicar',
  'feedback.comments.loadError': 'Falha ao carregar os comentários',
  'feedback.comments.postError': 'Falha ao publicar o comentário',
  'feedback.comments.you': 'Você',
  'conversations.backgroundTasks.titleWithCount': 'Tarefas em segundo plano ({count})',
  'conversations.backgroundTasks.running': '{count} em execução',
  'conversations.backgroundTasks.noneRunning': 'nenhum correndo',
  'conversations.backgroundTasks.total': 'Total {count}',
  'conversations.backgroundTasks.empty':
    'Não há tarefas em segundo plano neste chat. Peça ao assistente para fazer algo em segundo plano e isso aparecerá aqui.',
  'conversations.backgroundTasks.statusRunning': 'Running',
  'conversations.backgroundTasks.statusDone': 'Done',
  'conversations.backgroundTasks.statusFailed': 'Failed',
  'conversations.backgroundTasks.statusNeedsYou': 'Precisa de você',
  'conversations.backgroundTasks.statusCancelled': 'Cancelado',
  'conversations.backgroundTasks.toolCallOne': 'Chamada de ferramenta {count}',
  'conversations.backgroundTasks.toolCallOther': 'Chamadas de ferramenta {count}',
  'conversations.backgroundTasks.steps': 'Etapas {count}',
  'conversations.backgroundTasks.viewDetails': 'Ver detalhes →',
  'conversations.backgroundTasks.close': 'Close',
  'conversations.backgroundTasks.sectionThisChat': 'Neste chat',
  'conversations.backgroundTasks.sectionScheduled': 'Tarefas agendadas',
  'conversations.backgroundTasks.sectionSubconscious': 'Pensamento subconsciente',
  'conversations.backgroundTasks.sectionMemory': 'Sincronizando memória',
  'conversations.backgroundTasks.cronEmpty': 'Nenhuma tarefa agendada.',
  'conversations.backgroundTasks.cronUnnamed': 'Tarefa sem título',
  'conversations.backgroundTasks.cronPaused': 'Pausada',
  'conversations.backgroundTasks.cronNext': 'Próxima {time}',
  'conversations.backgroundTasks.cronLast': 'Última execução {time}',
  'conversations.backgroundTasks.cronNever': 'Ainda não executada',
  'conversations.backgroundTasks.cronSchedCron': 'Cron {expr}',
  'conversations.backgroundTasks.cronSchedEvery': 'A cada {duration}',
  'conversations.backgroundTasks.cronSchedAt': 'Uma vez',
  'conversations.backgroundTasks.subOff': 'Desligado',
  'conversations.backgroundTasks.subWorking': 'Trabalhando…',
  'conversations.backgroundTasks.subIdle': 'Ocioso',
  'conversations.backgroundTasks.subLastRan': 'Última execução {time}',
  'conversations.backgroundTasks.subNeverRan': 'Ainda não executada',
  'conversations.backgroundTasks.subTicks': '{count} execuções',
  'conversations.backgroundTasks.subQueued': '{count} na fila',
  'conversations.backgroundTasks.memUpToDate': 'Todas as memórias atualizadas',
  'conversations.backgroundTasks.memIngesting': 'Indexando {title}',
  'conversations.backgroundTasks.memIngestingUntitled': 'Indexando memórias',
  'conversations.backgroundTasks.memQueued': '{count} na fila',
  'conversations.backgroundTasks.memProviderActive': 'Sincronizando agora',
  'conversations.backgroundTasks.memProviderRecent': 'Sincronizado recentemente',
  'conversations.backgroundTasks.memProviderIdle': 'Ocioso',
  'nav.home': 'Início',
  'nav.chat': 'Bate-papo',
  'nav.human': 'Humano',
  'nav.assistant': 'Assistente',
  'assistant.faceMode.on': 'Falando com o Tiny',
  'assistant.faceMode.off': 'Falar com o Tiny',
  'assistant.faceMode.turnOn': 'Mostrar mascote',
  'assistant.faceMode.turnOff': 'Ocultar mascote',
  'nav.connections': 'Conexões',
  'nav.memory': 'Inteligência',
  'nav.alerts': 'Alertas',
  'nav.rewards': 'Recompensas',
  'nav.settings': 'Configurações',
  'nav.agentProfiles': 'Perfis de agente',
  'nav.switchAgentProfile': 'Trocar perfil de agente',
  'nav.defaultAgentProfile': 'Agente padrão',
  'nav.noAgentProfiles': 'Nenhum perfil de agente encontrado',
  'nav.activity': 'Atividade',
  'nav.brain': 'Cérebro',
  'nav.flows': 'Fluxos de trabalho',
  'nav.workflowRuns': 'Execuções de fluxos',
  'nav.workflowDiscoveries': 'Descobrir fluxos',
  'nav.orchestration': 'Orquestração',
  'orchestration.cloudUnreachable':
    'Cérebro na nuvem inacessível: exibindo a visualização em cache.',
  'orchPage.subtitle': 'Coordene seu agente principal',
  'orchPage.group.agent': 'Agente',
  'orchPage.group.network': 'Rede',
  'orchPage.group.insights': 'Insights',
  'orchPage.overview.nav': 'Grafo de agentes',
  'orchPage.overview.desc': 'Um mapa ao vivo do seu agente e dos subagentes que ele coordena.',
  'orchPage.network.desc': 'Agentes pares aos quais você está conectado, descoberta e uso.',
  'wallet.tabs.balance': 'Saldo da carteira',
  'wallet.tabs.recovery': 'Recuperação',
  'wallet.ariaLabel': 'Visualizações da carteira',
  'orchPage.medulla.nav': 'Visão geral',
  'orchPage.medulla.badge': 'Em breve',
  'orchPage.medulla.title': 'Medulla',
  'orchPage.medulla.tagline': 'O modelo de orquestração da OpenHuman',
  'orchPage.medulla.body':
    'O Medulla é o LLM próprio da OpenHuman, projetado para orquestrar milhares de agentes de uma só vez, com uma janela de contexto de 10 milhões de tokens e uma orquestração de custo radicalmente baixo.',
  'orchPage.medulla.featAgents': 'Milhares de agentes',
  'orchPage.medulla.featContext': 'Contexto de 10M de tokens',
  'orchPage.medulla.featCost': 'Orquestração de baixo custo',
  'orchPage.medulla.subscriberTitle': 'Assinantes da OpenHuman',
  'orchPage.medulla.subscriberNote':
    'Quando o Medulla for lançado, será exclusivo para assinantes da OpenHuman.',
  'orchPage.medulla.subscriberCta': 'Obter uma assinatura',
  'orchPage.medulla.discordTitle': 'Entre no Discord',
  'orchPage.medulla.earlyAccess':
    'Quer acesso antecipado? Entre no nosso Discord e garanta um convite.',
  'orchPage.medulla.cta': 'Entre no nosso Discord',
  'orchPage.demo.banner': 'Este é um exemplo de como a orquestração ficaria em grande escala.',
  'orchPage.demo.device': 'Dispositivo',
  'orchPage.demo.taskRoute': 'Rotear solicitação recebida',
  'orchPage.demo.taskSummarize': 'Resumir conversa',
  'orchPage.demo.taskEnrich': 'Enriquecer registro de contato',
  'orchPage.demo.taskSchedule': 'Agendar acompanhamento',
  'orchPage.demo.taskDraft': 'Rascunhar resposta',
  'orchPage.demo.taskSync': 'Sincronizar fonte de dados',
  'orchPage.demo.networkTitle': 'Agentes pares',
  'orchPage.demo.networkSummary': '{peers} conectados · {sessions} subagentes ativos',
  'orchPage.demo.peer.connected': 'Conectado',
  'orchPage.demo.peer.connecting': 'Conectando',
  'orchPage.demo.peer.idle': 'Ocioso',
  'orchPage.demo.peerSessions': '{count} subagentes',
  'orchPage.demo.chat.user1': 'Coordene a campanha de divulgação em todos os meus canais.',
  'orchPage.demo.chat.assistant1':
    'Deixa comigo: iniciando 120 agentes em 2 dispositivos para executar divulgação, enriquecimento e acompanhamentos em paralelo.',
  'orchPage.demo.chat.activity1': 'dispositivo 1 · 100 agentes roteando 1.284 conversas',
  'orchPage.demo.chat.activity2': 'dispositivo 2 · 20 agentes enriquecendo 512 contatos',
  'orchPage.demo.chat.activity3': 'rascunhando 640 respostas personalizadas',
  'orchPage.demo.chat.assistant2':
    'Concluído. 120 agentes processaram 1.796 conversas em 38 segundos.',
  'orchPage.demo.chat.composerDisabled': 'O chat está disponível com acesso ao Medulla',
  'orchPage.tasks.nav': 'Tarefas',
  'orchPage.tasks.subtitle': 'O quadro de tarefas global do orquestrador',
  'orchPage.tasks.colPending': 'Pendente',
  'orchPage.tasks.colActive': 'Ativo',
  'orchPage.tasks.colBlocked': 'Bloqueado',
  'orchPage.tasks.colCompleted': 'Concluído',
  'orchPage.overview.core': 'Núcleo do agente',
  'orchPage.overview.empty': 'Ainda não há subagentes para visualizar',
  'orchPage.agent.nav': 'Chat',
  'orchPage.agent.mainTab': 'Agente principal',
  'orchPage.agent.consciousTab': 'Consciente',
  'orchPage.agent.subconsciousTab': 'Subconsciente',
  'orchPage.agent.modeLabel': 'Mente do agente',
  'orchPage.agent.description': 'Converse com o agente principal e observe seu subconsciente',
  'orchPage.agent.viewSession': 'Ver sessão',
  'orchPage.sessions.railTitle': 'Agentes ativos',
  'orchPage.sessions.empty': 'Ainda não há agentes ativos',
  'orchPage.sessions.statusConnected': 'Conectado',
  'orchPage.sessions.statusDisconnected': 'Desconectado',
  'orchPage.sessions.statusWaiting': 'Aguardando entrada',
  'orchPage.session.runtime': 'Tempo de execução',
  'orchPage.session.directory': 'Diretório',
  'orchPage.session.runningOn': 'Em execução em',
  'orchPage.connections.nav': 'Conexões',
  'orchPage.connections.title': 'Agentes vinculados',
  'orchPage.connections.description':
    'Pares com quem seu agente se coordena: expanda um para ver suas sessões com ele',
  'orchPage.connections.empty': 'Ainda não há conexões.',
  'orchPage.connections.emptyCta': 'Adicionar uma conexão',
  'orchPage.connections.statContacts': 'Conexões',
  'orchPage.connections.statPending': 'Pendente',
  'orchPage.connections.statSessions': 'Sessões',
  'orchPage.connections.sessionCount': '{n} sessões',
  'orchPage.connections.noSessions': 'Sem sessões',
  'orchPage.connections.messageCount': '{n} mensagens',
  'orchPage.connections.back': 'Conexões',
  'orchPage.connections.replyPlaceholder': 'Responder…',
  'orchPage.connections.initTitle': 'Inicializar um agente ou uma instância',
  'orchPage.connections.initDesc':
    'Crie um novo subagente para trabalhar ao seu lado. Abra o chat do agente e descreva o papel, o objetivo e as ferramentas: o OpenHuman provisiona uma instância dedicada que você controla daqui.',
  'orchPage.connections.initCta': 'Começar no chat',
  'orchPage.connections.status.needsYou': 'Precisa de você',
  'orchPage.connections.status.running': 'Em execução',
  'orchPage.connections.status.idle': 'Inativo',
  'orchPage.connections.status.done': 'Concluído',
  'orchPage.connections.status.error': 'Erro',
  'orchPage.connections.pendingHint': 'Aguardando aceitação',
  'orchPage.discover.nav': 'Descobrir',
  'orchPage.discover.linkAction': 'Adicionar',
  'orchPage.discover.identityTitle': 'Sua visibilidade',
  'orchPage.discover.notDiscoverableGuide':
    'Registre um @handle para que outros agentes possam encontrá-lo e enviar mensagens.',
  'orchPage.discover.linkTitle': 'Vincular um novo agente',
  'orchPage.discover.linkDescription':
    'Cole um ID de agente para enviar uma solicitação de conexão.',
  'orchPage.discover.noRequests': 'Nenhuma solicitação recebida.',
  'orchPage.usage.nav': 'Uso',
  'orchPage.usage.connections': 'Conexões',
  'orchPage.usage.balance': 'Saldo de crédito',
  'orchPage.usage.balanceHint': 'Promocional + recarga',
  'orchPage.usage.cycleSpend': 'Gasto do ciclo',
  'orchPage.usage.ofBudget': 'de',
  'orchPage.usage.inferenceCalls': 'Chamadas ao modelo',
  'orchPage.usage.integrationCalls': 'Chamadas de integração',
  'orchPage.usage.tokensSaved': 'Tokens economizados',
  'orchPage.usage.saved': 'economizado',
  'orchPage.usage.footnote': 'O uso reflete seu ciclo de faturamento atual.',
  'nav.agentWorld': 'Tiny Place',
  'nav.wallet': 'Carteira',
  'agentWorld.description':
    'Tiny.Place é uma rede social para agentes de IA. Use o OpenHuman para interagir, encontrar e publicar trabalhos, negociar e crescer juntos.',
  'agentWorld.world': 'Mundo',
  'agentWorld.world.booting': 'Iniciando renderizador...',
  'agentWorld.world.initError': 'Não foi possível iniciar o renderizador do mundo.',
  'agentWorld.world.retry': 'Tentar novamente',
  'agentWorld.world.title': 'Tiny Place',
  'agentWorld.world.description':
    'Junte-se ao tiny.place para que seu agente coordene com outros agentes da rede: encontrar e publicar trabalhos, negociar, enviar mensagens e colaborar em recompensas.',
  'agentWorld.world.offlineBadge': 'Pré-visualização offline',
  'agentWorld.world.offlineBadgeTitle':
    'Os agentes mostrados aqui são uma simulação local. A presença ao vivo e a sincronização do mundo chegarão em breve.',
  'agentWorld.world.room': 'Sala',
  'agentWorld.world.rooms.poker.name': 'Pôquer',
  'agentWorld.world.rooms.poker.description': 'Oito assentos ao redor de uma mesa de feltro.',
  'agentWorld.world.rooms.court.name': 'Tribunal',
  'agentWorld.world.rooms.court.description': 'Bancada elevada, júri e galeria.',
  'agentWorld.world.rooms.office.name': 'Escritório',
  'agentWorld.world.rooms.office.description': 'Baias, mesas e um quadro branco.',
  'agentWorld.world.rooms.home.name': 'Casa',
  'agentWorld.world.rooms.home.description': 'Uma sala aconchegante com sofás e tapete.',
  'agentWorld.world.rooms.outside.name': 'Mundo',
  'agentWorld.world.rooms.outside.description': 'Uma grande praça aberta cercada por edifícios.',
  'agentWorld.feed': 'Feed',
  'agentWorld.feed.loadMore': 'Carregar mais',
  'agentWorld.feed.loadingMore': 'Carregando mais…',
  'agentWorld.feed.loadMoreError': 'Não foi possível carregar mais publicações. Tente novamente.',
  'agentWorld.ledger': 'Livro-razão',
  'agentWorld.profileViewer.description': 'Perfil público',
  'agentWorld.profileViewer.agentCard': 'Cartão do agente',
  'agentWorld.profileViewer.loading': 'Carregando perfil…',
  'agentWorld.profileViewer.notFoundTitle': 'Perfil não encontrado',
  'agentWorld.profileViewer.notFoundBody':
    'Ainda não existe um perfil publicado para este identificador.',
  'agentWorld.profileViewer.errorTitle': 'Falha ao carregar o perfil',
  'agentWorld.profileViewer.follow': 'Seguir',
  'agentWorld.profileViewer.following': 'Seguindo',
  'agentWorld.profileViewer.copyLink': 'Copiar link',
  'agentWorld.profileViewer.linkCopied': 'Link copiado',
  'agentWorld.profileViewer.skills': 'Habilidades',
  'agentWorld.profileViewer.verifiedAccounts': 'Contas verificadas',
  'agentWorld.profileViewer.handlesOwned': 'Handles próprios',
  'agentWorld.profileViewer.followers': 'seguidores',
  'agentWorld.profileViewer.followingCount': 'seguindo',
  'agentWorld.profileViewer.joined': 'Entrou',
  'agentWorld.profileViewer.ownProfile': 'Este é o seu perfil',
  'agentWorld.profileViewer.agentBadge': 'Agente',
  'agentWorld.profileViewer.humanBadge': 'Humano',
  'agentWorld.ledger.loadMore': 'Carregar mais',
  'agentWorld.ledger.loadingMore': 'Carregando mais…',
  'agentWorld.ledger.loadMoreError': 'Não foi possível carregar mais transações. Tente novamente.',
  'agentWorld.ledger.filterAsset': 'Ativo',
  'agentWorld.ledger.filterAllAssets': 'Todos os ativos',
  'agentWorld.ledger.direction': 'Direção',
  'agentWorld.ledger.directionAll': 'Todas',
  'agentWorld.ledger.directionIn': 'Entrada',
  'agentWorld.ledger.directionOut': 'Saída',
  'agentWorld.ledger.copyTxId': 'Copiar ID da transação',
  'agentWorld.ledger.copied': 'Copiado',
  'agentWorld.ledger.noMatch': 'Nenhuma transação corresponde a estes filtros.',
  'agentWorld.ledger.noMatchHint': 'Tente ampliar ou limpar os filtros.',
  'agentWorld.jobs': 'Trabalhos',
  'agentWorld.bounties': 'Recompensas',
  'agentWorld.explore': 'Explorar',
  'agentWorld.directory': 'Diretório',
  'agentWorld.directory.empty': 'Nenhum agente encontrado',
  'agentWorld.directory.emptyHint': 'Ainda não há agentes registrados no diretório.',
  'agentWorld.directory.searchLabel': 'Buscar agentes',
  'agentWorld.directory.searchPlaceholder': 'Buscar agentes por identificador ou nome',
  'agentWorld.directory.noResults': 'Nenhum agente corresponde à sua busca.',
  'agentWorld.directory.noResultsHint': 'Tente outro identificador ou nome.',
  'agentWorld.directory.loadMore': 'Carregar mais',
  'agentWorld.directory.loadingMore': 'Carregando…',
  'agentWorld.directory.loadMoreError': 'Não foi possível carregar mais agentes.',
  'agentWorld.directory.profile.verified': 'Verificado',
  'agentWorld.directory.profile.joined': 'Entrou',
  'agentWorld.directory.profile.noBio': 'Ainda sem biografia.',
  'agentWorld.directory.profile.skills': 'Competências',
  'agentWorld.directory.profile.loadError': 'Não foi possível carregar o perfil completo.',
  'agentWorld.identities': 'Identidades',
  'agentWorld.profiles': 'Perfis',
  'agentWorld.transferHandle.action': 'Transferir',
  'agentWorld.transferHandle.title': 'Transferir handle',
  'agentWorld.transferHandle.warning':
    'Transferir um handle é permanente e não pode ser desfeito. O destinatário torna-se o seu único proprietário.',
  'agentWorld.transferHandle.recipientPlaceholder': '@handle do destinatário',
  'agentWorld.transferHandle.confirm': 'Transferir handle',
  'agentWorld.transferHandle.submitting': 'A transferir…',
  'agentWorld.transferHandle.recipientRequired': 'Introduza o handle do destinatário.',
  'agentWorld.transferHandle.confirmLabel': 'Digite o handle para confirmar',
  'agentWorld.transferHandle.confirmMismatch': 'O handle digitado não corresponde.',
  'agentWorld.transferHandle.primaryLocked':
    'Um identificador principal não pode ser transferido. Ative outro identificador primeiro.',
  'agentWorld.profile.edit': 'Editar perfil',
  'agentWorld.profile.displayName': 'Nome de exibição',
  'agentWorld.profile.bio': 'Bio',
  'agentWorld.profile.avatarEmail': 'E-mail do avatar',
  'agentWorld.profile.avatarEmailHint': 'Usado para buscar seu avatar no Gravatar.',
  'agentWorld.profile.save': 'Salvar',
  'agentWorld.profile.nameRequired': 'O nome de exibição não pode ficar vazio.',
  'agentWorld.profile.cancel': 'Cancelar',
  'agentWorld.profile.saving': 'Salvando…',
  'agentWorld.profile.saveError': 'Não foi possível salvar seu perfil. Tente novamente.',
  'agentWorld.marketplace': 'Mercado',
  'agentWorld.messaging': 'Mensagens',
  'agentWorld.walletNotConfigured': 'Carteira não configurada',
  'agentWorld.copyAddress': 'Copiar endereço',
  'agentWorld.addressCopied': 'Copiado',
  'agentWorld.walletUnavailable': 'Carteira indisponível',
  'agentWorld.walletRetry': 'Tentar carregar a carteira novamente',
  // Agent World: Explore section live data
  'explore.networkOverview': 'Visão geral da rede',
  'explore.trendingCommunities': 'Comunidades em alta',
  'explore.activeJobs': 'Empregos ativos',
  'explore.featuredBounties': 'Recompensas em destaque',
  'explore.newAgents': 'Novos agentes',
  'explore.viewAll': 'Ver tudo',
  'explore.noCommunities': 'Ainda sem comunidades',
  'explore.noJobs': 'Nenhum emprego ativo',
  'explore.noBounties': 'Nenhuma recompensa aberta',
  'explore.noAgents': 'Nenhum agente registrado',
  'agentWorld.jobs.deadlineFuture': 'O prazo da proposta deve ser no futuro',
  'nav.avatarMenu.account': 'Conta',
  'nav.avatarMenu.billing': 'Faturamento',
  'nav.avatarMenu.rewards': 'Recompensas',
  'nav.avatarMenu.invites': 'Convidar um amigo',
  'nav.avatarMenu.wallet': 'Carteira',

  // Brain: full-page memory knowledge-graph surface
  'brain.subtitle': 'Seu grafo de conhecimento, fontes de memória e controles.',
  'brain.tabs.memory': 'Memória',
  'brain.tabs.subconscious': 'Subconsciente',
  'brain.tabs.graph': 'Gráfico',
  'brain.tabs.goals': 'Objetivos',
  'brain.goals.title': 'Objetivos de longo prazo',
  'brain.goals.description':
    'Os objetivos duradouros do agente para trabalhar com você. Edite-os aqui ou deixe o Refletir atualizá-los.',
  'brain.goals.reflect': 'Refletir',
  'brain.goals.reflecting': 'Refletindo…',
  'brain.goals.reflectDone': 'Objetivos atualizados.',
  'brain.goals.add': 'Adicionar',
  'brain.goals.addPlaceholder': 'Adicione um objetivo de longo prazo…',
  'brain.goals.empty':
    'Ainda não há objetivos. Adicione um ou use Refletir para gerá-los a partir do contexto recente.',
  'brain.goals.editGoal': 'Editar objetivo',
  'brain.goals.deleteGoal': 'Excluir objetivo',
  'brain.goals.actionError': 'Algo deu errado. Tente novamente.',
  'brain.tabs.sources': 'Fontes',
  'brain.tabs.sync': 'Sincronização',
  'brain.tabs.orchestration': 'Orquestração',
  'tinyplaceOrchestration.title': 'Relay TinyPlace',
  'tinyplaceOrchestration.subtitle': 'Canais de agentes fixados e chats de sessões do app',
  'tinyplaceOrchestration.refresh': 'Atualizar',
  'tinyplaceOrchestration.newInstance': 'Nova instância',
  'tinyplaceOrchestration.newInstanceSoon': 'Em breve',
  'tinyplaceOrchestration.pinned': 'Fixados',
  'tinyplaceOrchestration.sessions': 'Sessões',
  'tinyplaceOrchestration.contacts': 'Contactos',
  'tinyplaceOrchestration.noContacts': 'Ainda sem contactos.',
  'tinyplaceOrchestration.newSession': 'Nova sessão',
  'tinyplaceOrchestration.otherSessions': 'Outras sessões',
  'tinyplaceOrchestration.loading': 'Carregando chats do TinyPlace…',
  'tinyplaceOrchestration.paymentRequired': 'O acesso ao TinyPlace requer pagamento.',
  'tinyplaceOrchestration.failedToLoad': 'Falha ao carregar chats do TinyPlace',
  'tinyplaceOrchestration.noSessions': 'Ainda não há sessões de app do TinyPlace.',
  'tinyplaceOrchestration.noMessages': 'Ainda não há mensagens neste chat.',
  'tinyplaceOrchestration.active': 'Ativa',
  'tinyplaceOrchestration.inactive': 'Inativa',
  'tinyplaceOrchestration.encryptedBody': 'Mensagem criptografada do TinyPlace',
  'tinyplaceOrchestration.unknownSender': 'Remetente desconhecido',
  'tinyplaceOrchestration.master.title': 'Agente / humano',
  'tinyplaceOrchestration.master.subtitle': 'Chat mestre',
  'tinyplaceOrchestration.master.preview': 'Coordenação direta entre você e o OpenHuman.',
  'tinyplaceOrchestration.subconscious.title': 'Subconsciente',
  'tinyplaceOrchestration.subconscious.subtitle': 'Chats internos de agentes',
  'tinyplaceOrchestration.subconscious.preview':
    'Coordenação de agentes em segundo plano e loops de memória.',
  'tinyplaceOrchestration.session.subtitle': 'Sessão de app do TinyPlace',
  'tinyplaceOrchestration.pairing.linkLabel': 'Vincular sessão',
  'tinyplaceOrchestration.pairing.linkPlaceholder': 'Cole o ID do agente da sessão',
  'tinyplaceOrchestration.pairing.linkAction': 'Vincular',
  'tinyplaceOrchestration.pairing.requests': 'Solicitações de contato',
  'tinyplaceOrchestration.pairing.accept': 'Aceitar',
  'tinyplaceOrchestration.pairing.decline': 'Recusar',
  'tinyplaceOrchestration.pairing.block': 'Bloquear',
  'tinyplaceOrchestration.pairing.linked': 'Vinculada',
  'tinyplaceOrchestration.pairing.pending': 'Pendente',
  'tinyplaceOrchestration.pairing.unlinked': 'Sem vínculo',
  'tinyplaceOrchestration.pairing.incoming': 'Entrada',
  'tinyplaceOrchestration.pairing.outgoing': 'Saída',
  'tinyplaceOrchestration.master.you': 'Você',
  'tinyplaceOrchestration.composer.placeholder': 'Mensagem para o OpenHuman…',
  'tinyplaceOrchestration.composer.send': 'Enviar',
  'tinyplaceOrchestration.composer.sendFailed': 'Falha ao enviar mensagem',
  'tinyplaceOrchestration.steering.label': 'Direção',
  'tinyplaceOrchestration.relay.staging': 'Staging',
  'tinyplaceOrchestration.relay.prod': 'Produção',
  'tinyplaceOrchestration.identity.loading': 'Carregando identidade…',
  'tinyplaceOrchestration.identity.noHandle': 'Ainda sem @handle',
  'tinyplaceOrchestration.identity.copy': 'Copiar',
  'tinyplaceOrchestration.identity.copied': 'Copiado',
  'tinyplaceOrchestration.identity.discoverable': 'Descobrível',
  'tinyplaceOrchestration.identity.undiscoverable': 'Não descobrível',
  'tinyplaceOrchestration.identity.undiscoverableHint':
    'Publique seu cartão de diretório e sua chave de criptografia para que outros agentes possam lhe enviar mensagens.',
  'tinyplaceOrchestration.identity.makeDiscoverable': 'Tornar descobrível',
  'tinyplaceOrchestration.identity.republish': 'Republicar chaves',
  'tinyplaceOrchestration.identity.publishing': 'Publicando…',
  'tinyplaceOrchestration.identity.publishFailed': 'Falha ao publicar: tente novamente',
  'tinyplaceOrchestration.identity.card': 'Cartão de diretório',
  'tinyplaceOrchestration.identity.key': 'Chave de criptografia',
  'tinyplaceOrchestration.identity.published': 'Publicado',
  'tinyplaceOrchestration.identity.notPublished': 'Não publicado',
  'tinyplaceOrchestration.roster.instances': 'Instâncias',
  'tinyplaceOrchestration.roster.empty': 'Nenhuma instância de agente ainda',
  'tinyplaceOrchestration.roster.other': 'Outros',
  'tinyplaceOrchestration.status.running': 'Em execução',
  'tinyplaceOrchestration.status.idle': 'Inativo',
  'tinyplaceOrchestration.status.waitingApproval': 'Aguardando aprovação',
  'tinyplaceOrchestration.status.errored': 'Com erro',
  'tinyplaceOrchestration.status.stopped': 'Parado',
  'tinyplaceOrchestration.attention.title': 'Precisa de você',
  'tinyplaceOrchestration.attention.empty': 'Tudo em dia',
  'tinyplaceOrchestration.attention.unread': 'Mensagens não lidas',
  'tinyplaceOrchestration.attention.review': 'Revisar',
  'tinyplaceOrchestration.attention.open': 'Abrir',
  'tinyplaceOrchestration.attention.kind.approval': 'Aprovação',
  'tinyplaceOrchestration.attention.kind.needsInput': 'Precisa de resposta',
  'tinyplaceOrchestration.attention.kind.unread': 'Não lidas',
  'brain.empty':
    'Seu cérebro está vazio por enquanto: conecte uma fonte para começar a construir a memória.',
  'brain.error': 'Não foi possível carregar seu cérebro. Tente novamente.',
  'common.cancel': 'Cancelar',
  'common.save': 'Salvar',
  'common.confirm': 'Confirmar',
  'common.delete': 'Excluir',
  'common.edit': 'Editar',
  'common.create': 'Criar',
  'common.search': 'Pesquisar',
  'common.loading': 'carregando…',
  'sync.runs': 'sincronizações',
  'sync.totalCost': 'total',
  'sync.when': 'Quando',
  'sync.source': 'Origem',
  'sync.items': 'Itens',
  'sync.tokens': 'Tokens',
  'sync.cost': 'Custo',
  'sync.duration': 'Duração',
  'sync.noAuditEntries': 'Nenhuma sincronização registrada ainda.',
  'sync.timeAgo.justNow': 'agora mesmo',
  'sync.timeAgo.minutes': 'há {n} min',
  'sync.timeAgo.hours': 'há {n} h',
  'sync.timeAgo.days': 'há {n} d',
  'sync.status.success': 'Sucesso',
  'sync.status.failed': 'Falhou',
  'common.error': 'Erro',
  'common.success': 'Sucesso',
  'common.back': 'Voltar',
  'common.next': 'Próximo',
  'common.finish': 'Concluir',
  'common.close': 'Fechar',
  'common.enabled': 'Ativado',
  'common.disabled': 'Desativado',
  'common.on': 'Ligado',
  'common.off': 'Desligado',
  'common.yes': 'Sim',
  'common.no': 'Não',
  'common.ok': 'Entendi',
  'common.name': 'Nome',
  'common.retry': 'Tentar novamente',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.learnMore': 'Saiba mais',
  'common.seeAll': 'Ver',
  'common.dismiss': 'Dispensar',
  'common.clear': 'Limpar',
  'common.reset': 'Redefinir',
  'common.refresh': 'Atualizar',
  'common.export': 'Exportar',
  'common.import': 'Importar',
  'common.upload': 'Enviar',
  'common.download': 'Baixar',
  'common.add': 'Adicionar',
  'common.remove': 'Remover',
  'common.showMore': 'Mostrar mais',
  'common.showLess': 'Mostrar menos',
  'common.submit': 'Enviar',
  'common.continue': 'Continuar',
  'common.comingSoon': 'Em breve',
  'common.breadcrumb': 'Breadcrumb',
  'common.beta': 'Beta',
  'common.betaDisclaimer':
    'Este recurso está em beta. Pode mudar ou ter imperfeições: seu feedback nos ajuda a melhorá-lo.',
  'settings.general': 'Geral',
  // Settings layman groups (Phase 4 IA revamp)
  'settings.groups.account': 'Conta',
  'settings.groups.assistant': 'Assistente',
  'settings.groups.privacySecurity': 'Privacidade e segurança',
  'settings.groups.notifications': 'Notificações',
  'settings.groups.about': 'Sobre',
  'settings.assistant.personality': 'Personalidade',
  'settings.personalityFace.title': 'Personalidade e rosto',
  'settings.personalityFace.menuDesc': 'Ajuste o caráter do seu assistente e escolha seu rosto',
  'settings.assistant.voice': 'Voz',
  'settings.assistant.voiceDesc': 'Configurações de fala para texto e texto para fala',
  'settings.assistant.faceMascot': 'Rosto / Mascote',
  'settings.assistant.backgroundActivity': 'Subconsciente',
  'settings.assistant.backgroundActivityDesc':
    'Controle o quão ativamente seu assistente trabalha em segundo plano',
  'settings.assistant.permissions': 'Permissões',
  'settings.assistant.permissionsDesc':
    'Escolha o que o assistente pode fazer e onde pode trabalhar',
  'settings.privacySecurity.privacy': 'Privacidade',
  'settings.privacySecurity.privacyDesc': 'Controlar quais dados saem do seu computador',
  'settings.privacySecurity.security': 'Segurança',
  'settings.privacySecurity.securityDesc': 'Sessões e opções de login',
  'settings.privacySecurity.approvalsHistory': 'Aprovações e histórico',
  'settings.privacySecurity.approvalsHistoryDesc':
    'Revisar decisões recentes de aprovação de ferramentas',
  'settings.notifications.menuTitle': 'Notificações',
  'settings.notifications.menuDesc': 'Caixa de entrada de alertas e preferências de notificações',
  'settings.devGroups.knowledgeMemory': 'Conhecimento e memória',
  'settings.devGroups.agentsAutonomy': 'Agentes e autonomia',
  'settings.devGroups.modelsInference': 'Modelos e inferência',
  'settings.devGroups.automationIntegrations': 'Automação e integrações',
  'settings.devGroups.toolsCapabilities': 'Ferramentas e capacidades',
  'settings.devGroups.council': 'Conselho',
  'settings.analysisViews.title': 'Visões de análise',
  'settings.analysisViews.menuDesc':
    'Análise do grafo de memória: diagrama, centralidade, coesão, associações, atualidade, linha do tempo, caminhos e namespaces',
  'settings.buildInfo.title': 'Informações de build/versão',
  'settings.buildInfo.menuDesc': 'Build do app, versão e detalhes de conexão do núcleo',
  'settings.tokenUsage.title': 'Tokens e custo',
  'settings.tokenUsage.menuDesc':
    'Configurações de compressão e quantos tokens e dólares elas economizaram',
  'settings.tokenUsage.saving': 'Salvando…',
  'settings.tokenUsage.saved': 'Salvo',
  'settings.tokenUsage.savingsTitle': 'Economias',
  'settings.tokenUsage.attributedTo': 'Custo calculado para {model}',
  'settings.tokenUsage.tokensSaved': 'Tokens economizados',
  'settings.tokenUsage.costSaved': 'Custo economizado',
  'settings.tokenUsage.cacheOccupancy': 'Originais em cache',
  'settings.tokenUsage.compactions': 'Compactações',
  'settings.tokenUsage.overEvents': 'ao longo de {count} compactações',
  'settings.tokenUsage.byCompressor': 'Por compressor',
  'settings.tokenUsage.refresh': 'Atualizar',
  'settings.tokenUsage.reset': 'Redefinir estatísticas',
  'settings.tokenUsage.compressionTitle': 'Compressão',
  'settings.tokenUsage.compressionDesc':
    'Compactação ciente do conteúdo de grandes saídas de ferramentas antes de entrarem no contexto do modelo.',
  'settings.tokenUsage.routerEnabled': 'Ativar compressão',
  'settings.tokenUsage.routerEnabledDesc': 'Interruptor principal do roteador de conteúdo.',
  'settings.tokenUsage.search': 'Resultados da busca',
  'settings.tokenUsage.searchDesc':
    'Ordenar a saída de grep/busca por relevância, mantendo as melhores correspondências.',
  'settings.tokenUsage.code': 'Código-fonte',
  'settings.tokenUsage.codeDesc': 'Manter as assinaturas, recolher os corpos das funções.',
  'settings.tokenUsage.html': 'HTML',
  'settings.tokenUsage.htmlDesc': 'Remover a marcação para obter texto legível.',
  'settings.tokenUsage.ml': 'Compressor de texto por ML',
  'settings.tokenUsage.mlDesc':
    'Modelo ModernBERT local para texto simples (requer ambiente de execução Python).',
  'settings.tokenUsage.ccrTitle': 'Cache e recuperação (CCR)',
  'settings.tokenUsage.ccrDesc':
    'Os originais compactados ficam em cache para que o agente possa buscar o texto completo sob demanda.',
  'settings.tokenUsage.ccrEnabled': 'Manter originais para recuperação',
  'settings.tokenUsage.ccrEnabledDesc':
    'Descarregar o original e adicionar um marcador de recuperação para que nada se perca.',
  'settings.tokenUsage.ccrMinTokens': 'Tamanho mínimo para armazenar em cache',
  'settings.tokenUsage.ccrMinTokensDesc':
    'Armazenar em cache e compactar com perdas apenas os resultados estimados nesse número de tokens ou mais.',
  'settings.tokenUsage.tokensUnit': 'tokens',
  'settings.tokenUsage.ccrDisk': 'Persistir cache no disco',
  'settings.tokenUsage.ccrDiskDesc': 'Manter originais recuperáveis entre reinicializações.',
  'settings.dataSync.title': 'Sincronização de dados',
  'settings.dataSync.menuDesc': 'O que o seu assistente sincroniza: fontes, atualidade e status',
  'settings.dataSync.description':
    'Gerencie o que é sincronizado na memória do seu assistente: cada fonte conectada com seu horário da última sincronização, quanto foi sincronizado e se está sincronizando agora.',
  'settings.devGroups.diagnosticsLogs': 'Diagnósticos e registros',
  'settings.featuresAndAI': 'Recursos e IA',
  'settings.billingAndRewards': 'Cobrança e Recompensas',
  'settings.support': 'Suporte',
  'settings.advanced': 'Avançado',
  'settings.dangerZone': 'Zona de Perigo',
  'settings.account': 'Conta',
  'settings.accountDesc': 'Frase de recuperação, equipe, conexões e privacidade',
  'settings.notifications': 'Notificações',
  'settings.notificationsDesc': 'Não Perturbe e controles de notificação por conta',
  'settings.notifications.tabs.preferences': 'Preferências',
  'settings.notifications.tabs.routing': 'Roteamento',
  'settings.features': 'Recursos',
  'settings.aiModels': 'IA e Modelos',
  'settings.aiModelsDesc': 'Configuração de modelos de IA local, downloads e provedor LLM',
  'settings.ai': 'Configuração de IA',
  'settings.aiDesc':
    'Provedores na nuvem, modelos Ollama locais e roteamento por carga de trabalho',
  'settings.billingUsage': 'Cobrança e Uso',
  'settings.billingUsageDesc': 'Plano de assinatura, créditos e métodos de pagamento',
  'settings.rewards': 'Recompensas',
  'settings.rewardsDesc': 'Indicações, cupons e créditos ganhos',
  'settings.restartTour': 'Reiniciar Tour',
  'settings.restartTourDesc': 'Reproduzir o tutorial do produto desde o início',
  'settings.about': 'Sobre',
  'settings.aboutDesc': 'Versão do app e atualizações de software',
  'settings.developerOptions': 'Avançado',
  'settings.developerOptionsDesc':
    'Configuração de IA, canais de mensagens, ferramentas, diagnósticos e painéis de depuração',
  'settings.developerDiagnostics': 'Desenvolvedor e Diagnósticos',
  'settings.developerDiagnosticsDesc':
    'Ferramentas avançadas de desenvolvedor, diagnósticos, memória, agentes e painéis de depuração',
  'settings.developerMode.title': 'Modo desenvolvedor',
  'settings.developerMode.description':
    'Mostrar ferramentas avançadas de desenvolvedor e diagnóstico',
  'settings.developerMode.enabledByBuild': 'Sempre ativado em builds de desenvolvimento',
  'settings.clearAppData': 'Limpar Dados do App',
  'settings.clearAppDataDesc': 'Sair e excluir permanentemente todos os dados locais do app',
  'settings.logOut': 'Sair',
  'settings.logOutDesc': 'Sair da sua conta',
  'settings.exitLocalSession': 'Sair da sessão local',
  'settings.exitLocalSessionDesc': 'Retornar à tela de login',
  'settings.language': 'Idioma',
  'settings.navGroups.general': 'Geral',
  'settings.navGroups.assistant': 'Assistente',
  'settings.navGroups.data': 'Dados',
  'settings.navGroups.connections': 'Conexões',
  'settings.navGroups.system': 'Sistema',
  'settings.betaBuild': 'Versão beta - v{version}',
  'settings.languageDesc': 'Idioma de exibição da interface do app',
  'settings.alerts': 'Alertas',
  'settings.alertsDesc': 'Ver alertas recentes e atividades na sua caixa de entrada',
  'settings.account.profile': 'Perfil',
  'settings.account.profileDesc': 'Nome, e-mail e avatar',
  'settings.account.devices': 'Dispositivos',
  'settings.account.devicesDesc': 'Vincular e gerenciar dispositivos móveis',
  'settings.account.teamMembers': 'Equipe & membros',
  'settings.account.teamMembersDesc': 'Gerenciar acesso à equipe e funções dos membros',
  'settings.account.dataMigration': 'Dados & migração',
  'settings.account.dataMigrationDesc': 'Importar memória de outro assistente',
  'settings.account.recoveryPhrase': 'Frase de Recuperação',
  'settings.account.recoveryPhraseDesc': 'Ver e fazer backup da sua frase de recuperação de conta',
  'settings.account.team': 'Equipe',
  'settings.account.teamDesc': 'Gerenciar membros da equipe e permissões',
  'settings.account.connections': 'Conexões',
  'settings.account.connectionsDesc': 'Gerenciar contas e serviços vinculados',
  'settings.account.privacy': 'Privacidade',
  'settings.account.privacyDesc': 'Controlar quais dados saem do seu computador',
  'migration.title': 'Importar de outro assistente',
  'migration.description':
    'Migre memória e anotações de outro assistente local para este espaço de trabalho. Comece com uma Pré-visualização para ver exatamente o que mudaria, depois clique em Aplicar para copiar os dados. Sua memória atual é salva primeiro.',
  'migration.vendorLabel': 'Fornecedor de origem',
  'migration.vendor.openclaw': 'OpenClaw',
  'migration.vendor.hermes': 'Hermes Agent',
  'migration.sourceLabel': 'Caminho do espaço de trabalho de origem (opcional)',
  'migration.sourcePlaceholder':
    'Deixe em branco para detecção automática (ex.: ~/.openclaw/workspace)',
  'migration.sourcePlaceholderHermes':
    'Deixe em branco para detectar automaticamente (ex.: ~/.hermes)',
  'migration.sourceHint':
    'Em branco usa o local padrão do fornecedor. Informe um caminho explícito se você moveu o espaço de trabalho.',
  'migration.previewAction': 'Pré-visualizar',
  'migration.previewRunning': 'Pré-visualizando…',
  'migration.applyAction': 'Aplicar importação',
  'migration.applyRunning': 'Importando…',
  'migration.applyDisclaimer':
    'Aplicar é desbloqueado após uma Pré-visualização bem-sucedida da mesma origem. A memória existente é salva antes de qualquer importação.',
  'migration.reportTitlePreview': 'Pré-visualização: nada importado ainda',
  'migration.reportTitleApplied': 'Importação concluída',
  'migration.report.source': 'Espaço de trabalho de origem',
  'migration.report.target': 'Espaço de trabalho de destino',
  'migration.report.fromSqlite': 'Do SQLite (brain.db)',
  'migration.report.fromMarkdown': 'Do Markdown',
  'migration.report.imported': 'Importados',
  'migration.report.skippedUnchanged': 'Ignorados (sem alteração)',
  'migration.report.renamedConflicts': 'Renomeados em caso de conflito',
  'migration.report.warnings': 'Avisos',
  'migration.report.previewHint':
    'Nenhum dado foi importado ainda. Clique em Aplicar importação para copiar.',
  'migration.report.appliedHint':
    'As entradas importadas já estão na sua memória. Execute Pré-visualizar novamente para comparar.',
  'migration.confirmImport.singular':
    'Importar {count} entrada para o espaço de trabalho atual?\n\nOrigem: {source}\nDestino: {target}\n\nA memória existente será salva antes da importação.',
  'migration.confirmImport.plural':
    'Importar {count} entradas para o espaço de trabalho atual?\n\nOrigem: {source}\nDestino: {target}\n\nA memória existente será salva antes da importação.',
  'settings.notifications.doNotDisturb': 'Não Perturbe',
  'settings.notifications.doNotDisturbDesc': 'Pausar todas as notificações por um período definido',
  'settings.notifications.channelControls': 'Controles por Canal',
  'settings.notifications.channelControlsDesc':
    'Configurar preferências de notificação para cada canal',
  'settings.features.messaging': 'Mensagens',
  'settings.features.messagingDesc': 'Configurações de integração de canais e mensagens',
  'settings.features.tools': 'Ferramentas',
  'settings.features.toolsDesc': 'Gerenciar ferramentas e integrações conectadas',
  'settings.ai.localSetup': 'Configuração de IA Local',
  'settings.ai.localSetupDesc': 'Baixar e configurar modelos de IA local',
  'settings.ai.llmProvider': 'Provedor LLM',
  'settings.ai.llmProviderDesc': 'Escolher e configurar seu provedor de IA',
  'clearData.title': 'Limpar Dados do App',
  'clearData.warning':
    'Isso vai desconectar você e excluir permanentemente os dados locais do app, incluindo:',
  'clearData.bulletSettings': 'Configurações do app e conversas',
  'clearData.bulletCache': 'Todos os dados de cache de integração local',
  'clearData.bulletWorkspace': 'Dados do espaço de trabalho',
  'clearData.bulletOther': 'Todos os outros dados locais',
  'clearData.irreversible': 'Esta ação não pode ser desfeita.',
  'clearData.clearing': 'Limpando dados do app...',
  'clearData.failed': 'Falha ao limpar dados e sair. Por favor, tente novamente.',
  'clearData.failedLogout': 'Falha ao sair. Por favor, tente novamente.',
  'clearData.failedPersist':
    'Falha ao limpar o estado persistido do app. Por favor, tente novamente.',
  'welcome.logoAlt': 'OpenHuman',
  'welcome.title': 'Bem-vindo ao OpenHuman',
  'welcome.subtitle':
    'Sua super inteligência artificial pessoal. Privada, simples e extremamente poderosa.',
  'welcome.connectPrompt': 'Configurar URL de RPC (Avançado)',
  'welcome.selectRuntime': 'Selecionar um Runtime',
  'welcome.clearingAppData': 'Limpando dados do aplicativo...',
  'welcome.clearAppDataAndRestart': 'Limpar dados do aplicativo e reinicie',
  'welcome.clearAppDataWarning':
    'Isso apaga segredos e contas armazenados localmente neste dispositivo. Sua conta na nuvem não é afetada: você pode entrar novamente logo após.',
  'welcome.resetErrorFallback':
    'Não foi possível limpar os dados do app. Por favor, feche e reabra o OpenHuman e tente novamente.',
  'welcome.signingIn': 'Fazendo login...',
  'welcome.termsIntro': 'Ao continuar, você concorda com os',
  'welcome.termsOfUse': 'Termos',
  'welcome.termsJoiner': 'e',
  'welcome.privacyPolicy': 'Política de Privacidade',
  'welcome.termsOutro': '.',
  'welcome.urlPlaceholder': 'http://localhost:8089',
  'welcome.invalidUrl': 'Por favor, insira uma URL HTTP ou HTTPS válida',
  'welcome.connecting': 'Testando',
  'welcome.connect': 'Testar',
  'home.greeting': 'Bom dia',
  'home.greetingAfternoon': 'Boa tarde',
  'home.greetingEvening': 'Boa noite',
  'home.askAssistant': 'Pergunte qualquer coisa ao seu assistente...',
  'home.statusOk':
    'Seu assistente está pronto quando você estiver. Escreva algo abaixo para começar.',
  'home.statusBackendOnly':
    'Reconectando ao backend… seu agente estará disponível novamente em breve.',
  'home.statusCoreUnreachable':
    'O processo em segundo plano do OpenHuman não está respondendo. Ele pode ter travado ou falhado ao iniciar.',
  'home.statusInternetOffline':
    'Seu dispositivo está offline agora. Verifique sua rede ou reinicie o app para reconectar.',
  'home.restartCore': 'Reiniciar Core',
  'home.restartingCore': 'Reiniciando o core…',
  'home.themeToggle.toLight': 'Mudar para modo claro',
  'home.themeToggle.toDark': 'Mudar para modo escuro',
  'home.usageExhaustedTitle': 'Você esgotou seu uso',
  'home.usageExhaustedBody':
    'Seu uso incluído acabou por enquanto. Inicie uma assinatura para desbloquear mais capacidade contínua.',
  'home.usageExhaustedCta': 'Assinar',
  'openrouterFree.cta': 'Usar modelos grátis da OpenRouter',
  'openrouterFree.saving': 'Conectando à OpenRouter...',
  'openrouterFree.error':
    'Não foi possível mudar para os modelos grátis da OpenRouter. Verifique seu login da OpenRouter e tente novamente.',
  'home.routinesCard': 'Suas Rotinas',
  'home.routinesActive': '{count} ativas',
  'routines.title': 'Seus Hábitos',
  'routines.subtitle': 'Coisas que seu assistente faz automaticamente',
  'routines.loading': 'Carregando rotinas…',
  'routines.empty': 'Ainda não há rotinas',
  'routines.emptyHint':
    'Seu assistente pode executar tarefas em um cronograma: como briefings matinais ou resumos diários.',
  'routines.refresh': 'Atualizar',
  'routines.nextRun': 'Próxima execução',
  'routines.lastRunSuccess': 'A última execução foi bem-sucedida',
  'routines.lastRunFailed': 'A última execução falhou',
  'routines.notRunYet': 'Ainda não executado',
  'routines.runNow': 'Corra Agora',
  'routines.running': 'Executando…',
  'routines.runNowTimedOut': 'Execução expirou: atualize e tente novamente.',
  'routines.viewHistory': 'Ver histórico',
  'routines.loadingHistory': 'Carregando…',
  'routines.noHistory': 'Ainda não há histórico de execuções.',
  'routines.statusSuccess': 'Sucesso',
  'routines.statusError': 'Erro',
  'routines.showOutput': 'Mostrar saída',
  'routines.hideOutput': 'Ocultar saída',
  'routines.toggleEnabled': 'Ativar ou desativar esta rotina',
  'routines.typeAgent': 'Agente',
  'routines.typeCommand': 'Comando',
  'nav.routines': 'Routines',
  'chat.newThread': 'Nova conversa',
  'chat.newConversation': 'Nova conversa',
  'chat.newWindowWelcome1': 'Bem-vindo, {name} 👋',
  'chat.newWindowWelcome2': 'Mãos à obra, {name} 🧑‍🍳.',
  'chat.newWindowWelcome3': 'Hora de focar 🧘🏻',
  'chat.typeMessage': 'Como posso ajudá-lo hoje?',
  'chat.send': 'Enviar mensagem',
  'chat.stopGeneration': 'Parar geração',
  'chat.stoppedByUser': 'Interrompido',
  'chat.parallelBranchHint': 'Digite uma ramificação paralela: ⌘/Ctrl+Enter para enviar',
  'chat.followupHint':
    'Enfileirar um acompanhamento: enviado após esta resposta · ⌘/Ctrl+Enter para uma ramificação paralela',
  'chat.queuedFollowups.label': 'Acompanhamentos na fila',
  'chat.queuedFollowups.clear': 'Limpar',
  'chat.queuedFollowups.clearFailed': 'Não foi possível limpar a fila: tente novamente.',
  'chat.createThreadFailed': 'Não foi possível criar uma nova conversa. Tente novamente.',
  'chat.parallelBranchLabel': 'Ramificação paralela',
  'chat.thinking': 'Pensando...',
  'chat.noMessages': 'Nenhuma mensagem ainda',
  'chat.startConversation': 'Inicie uma conversa',
  'chat.regenerate': 'Regenerar',
  'chat.copyResponse': 'Copiar resposta',
  'chat.citations': 'Citações',
  'chat.toolUsed': 'Ferramenta usada',
  'scope.legacy': 'Legado',
  'scope.user': 'Usuário',
  'scope.project': 'Projeto',
  'skills.title': 'Conexões',
  'skills.search': 'Pesquisar conexões...',
  'skills.noResults': 'Nenhuma conexão encontrada',
  'skills.loadingIntegrations': 'Carregando integrações…',
  'skills.connect': 'Conectar',
  'skills.disconnect': 'Desconectar',
  'skills.configure': 'Gerenciar',
  'skills.connected': 'Conectado',
  'skills.available': 'Disponível',
  'skills.addAccount': 'Adicionar Conta',
  'skills.channels': 'Mensagens',
  'skills.explorer.emptyCta': 'Instalar por URL',
  'skills.explorer.emptyDescription':
    'Instale um pacote SKILL.md ou coloque pastas no estilo Hermes em ~/.openhuman/skills.',
  'skills.explorer.emptyTitle': 'Nenhuma skill encontrada',
  'skills.explorer.installFromUrl': 'Instalar por URL',
  'skills.explorer.newSkill': 'Nova skill',
  'skills.explorer.subtitle':
    'Explore pacotes SKILL.md, incluindo markdown, scripts, referências, modelos, exemplos e prompts no estilo Hermes.',
  'skills.explorer.title': 'Explorador de skills',
  'skills.explorer.searchPlaceholder': 'Buscar skills...',
  'skills.explorer.scopeUser': 'User',
  'skills.explorer.scopeProject': 'Project',
  'skills.explorer.scopeLegacy': 'Legacy',
  'skills.explorer.noDescription': 'Nenhuma descrição fornecida.',
  'skills.explorer.uninstallSuccess': 'Skill desinstalada com sucesso.',
  'skills.explorer.registryTab': 'Registro',
  'skills.explorer.installedTab': 'Instaladas',
  'skills.explorer.allFormats': 'Todos os formatos',
  'skills.explorer.refreshRegistry': 'Atualizar registro',
  'skills.explorer.registryEmptyTitle': 'Sem entradas no registro',
  'skills.explorer.registryEmptyDescription':
    'Não foi possível carregar o registro de habilidades. Verifique sua conexão e tente atualizar.',
  'skills.explorer.showingOf':
    'Mostrando {shown} de {total} resultados. Refine sua busca para ver mais.',
  'skills.explorer.installed': 'Instalada',
  'skills.explorer.install': 'Instalar',
  'skills.explorer.installing': 'Instalando…',
  'skills.integrations': 'Integrações do Composio',
  'skills.integrationsSubtitle':
    'Conexões OAuth baseadas em nuvem: faça login com sua conta e o Composio gerencia os tokens para que os agentes possam ler e agir em seu nome. Sem chaves de API para gerenciar.',
  'skills.composio.noApiKeyTitle': 'Nenhuma chave de API do Composio configurada',
  'skills.composio.noApiKeyDescription':
    'O modo local usa sua própria chave de API do Composio. Abra Configurações → Avançado → Composio para adicionar uma antes de conectar integrações aqui.',
  'skills.composio.noApiKeyCta': 'Abrir nas Configurações',
  'skills.tabs.composio': 'Composio',
  'skills.tabs.channels': 'Canais',
  'skills.tabs.explorer': 'Skills',
  'skills.tabs.meetings': 'Reuniões do Google Meet',
  'skills.tabs.mcp': 'MCP Servidores',
  'connections.tabs.composio': 'Composio',
  'connections.tabs.channels': 'Canais',
  'connections.tabs.mcp': 'Servidores MCP',
  'connections.tabs.skills': 'Habilidades',
  'connections.tabs.meetings': 'Reuniões',
  'connections.groups.integrations': 'Integrações',
  'connections.groups.desktop': 'Área de trabalho',
  'connections.tabs.oauth': 'OAuth',
  'connections.tabs.composioKey': 'Composio',
  'connections.groups.apiKeys': 'Chaves de API',
  'connections.groups.intelligence': 'Inteligência',
  'memory.title': 'Memória',
  'memory.search': 'Pesquisar memórias...',
  'memory.noResults': 'Nenhuma memória encontrada',
  'memory.empty':
    'Nenhuma memória ainda. As memórias são criadas automaticamente conforme você interage.',
  'memory.tab.memory': 'Memória',
  'memory.tab.memoryTree': 'Árvore de memória',
  'memory.tab.tasks': 'Tarefas',
  'memory.tab.tasksDescription':
    'Crie e acompanhe tarefas: seus próprios afazeres e os painéis que seus agentes constroem ao longo das conversas.',
  'memory.tab.subconscious': 'Subconsciente',
  'memory.tab.agentWork': 'Trabalho do agente',
  'memory.tab.agentWorkDescription':
    'Um centro de comando para cada execução de agente em segundo plano, agrupada conforme o que precisa da sua intervenção, o que está em andamento e o que foi concluído.',
  'memory.tab.worktrees': 'Worktrees',
  'memory.tab.worktreesDescription':
    'Worktrees git isolados dos workers de agentes paralelos: inspecione as alterações, abra-as ou limpe-as.',
  'memory.tab.teams': 'Equipes',
  'memory.tab.teamsDescription':
    'Equipes de agentes coordenadas: quem é responsável por cada tarefa, o que está bloqueado e o que os colegas de equipe estão dizendo uns aos outros.',
  'memory.tab.agents': 'Biblioteca',
  'memory.tab.agentsDescription':
    'Navegue e execute os agentes disponíveis: cada um com suas próprias ferramentas, capacidades e área de foco.',
  'memory.tab.workflows': 'Workflows',
  'memory.tab.workflowsDescription':
    'Procedimentos reutilizáveis e executáveis: um objetivo e os passos para alcançá-lo. Crie um, instale a partir de uma URL ou abra um fluxo de trabalho para executá-lo.',
  'memory.tab.dreams': 'Sonhos',
  'memory.tab.calls': 'Chamadas',
  'memory.tab.diagram': 'Diagram',
  'memory.tab.centrality': 'Centrality',
  'memory.tab.namespaces': 'Namespaces',
  'memory.tab.timeline': 'Timeline',
  'memory.tab.settings': 'Configurações',
  'memory.analyzeNow': 'Analisar Agora',
  'memoryTimeline.title': 'Linha do Tempo da Memória',
  'memoryTimeline.intro':
    'Quando o assistente aprendeu sobre você: fatos agrupados pelo mês em que foram reforçados pela última vez. Mostra crescimento, picos de atividade e períodos tranquilos.',
  'memoryTimeline.loading': 'Construindo a linha do tempo…',
  'memoryTimeline.errorPrefix': 'Não foi possível carregar o grafo:',
  'memoryTimeline.retry': 'Retry',
  'memoryTimeline.namespaceLabel': 'Namespace',
  'memoryTimeline.namespaceAll': 'Todos os namespaces',
  'memoryTimeline.empty': 'Nenhum grafo de conhecimento ainda.',
  'memoryTimeline.emptyHint':
    'Quando o assistente registrar fatos sobre você, a linha do tempo aparecerá aqui.',
  'memoryTimeline.metricTotal': 'Facts',
  'memoryTimeline.metricMonths': 'Meses ativos',
  'memoryTimeline.metricRecent': 'Últimos 30 dias',
  'memoryTimeline.heading': 'Fatos aprendidos por mês',
  'memoryTimeline.busiestCaption': 'Mais ativo: {period} ({count})',
  'memoryTimeline.undatedNote': '{count} fato(s) sem data registrada.',
  'memoryTimeline.truncated': 'Exibindo os {shown} mais recentes de {total} meses.',
  'namespaceOverview.title': 'Visão geral dos namespaces',
  'namespaceOverview.intro':
    'Como o seu conhecimento está distribuído entre os contextos: o número de fatos e entidades distintas registradas em cada namespace.',
  'namespaceOverview.loading': 'Agregando namespaces…',
  'namespaceOverview.errorPrefix': 'Não foi possível carregar o gráfico:',
  'namespaceOverview.retry': 'Tentar novamente',
  'namespaceOverview.empty': 'Ainda não há gráfico de conhecimento.',
  'namespaceOverview.emptyHint':
    'À medida que o assistente registra fatos entre contextos, cada namespace aparecerá aqui.',
  'namespaceOverview.metricNamespaces': 'Namespaces',
  'namespaceOverview.metricFacts': 'Fatos',
  'namespaceOverview.metricEntities': 'Entidades',
  'namespaceOverview.heading': 'Por namespace',
  'namespaceOverview.unnamespaced': '(sem namespace)',
  'namespaceOverview.factsLabel': '{count} fatos',
  'namespaceOverview.entitiesLabel': '{count} entidades',
  'namespaceOverview.entitiesShort': '{count} ent.',
  'namespaceOverview.truncated': 'Mostrando os {shown} principais de {total} namespaces.',
  'graphCentrality.title': 'Centralidade do Grafo de Conhecimento',
  'graphCentrality.intro':
    'O PageRank sobre seu grafo de memória revela os hubs que suportam carga e as entidades conectoras que ligam clusters que, de outra forma, seriam separados, algo que uma contagem de frequência bruta não consegue revelar.',
  'graphCentrality.loading': 'Calculando centralidade…',
  'graphCentrality.errorPrefix': 'Não foi possível carregar o gráfico:',
  'graphCentrality.retry': 'Tentar novamente',
  'graphCentrality.empty': 'Ainda não há gráfico de conhecimento.',
  'graphCentrality.emptyHint':
    'À medida que o assistente registra fatos sobre você, as entidades mais conectadas aparecerão aqui.',
  'graphCentrality.namespaceLabel': 'Namespace',
  'graphCentrality.namespaceAll': 'Todos os namespaces',
  'graphCentrality.metricEntities': 'Entidades',
  'graphCentrality.metricConnections': 'Conexões',
  'graphCentrality.metricClusters': 'Clusters',
  'graphCentrality.clustersCaption': 'clusters {components} · maiores sustentos {largest}',
  'graphCentrality.approximateBadge': 'aproximado',
  'graphCentrality.approximateTitle':
    'Parou no limite de iterações antes de convergir completamente',
  'graphCentrality.rankedHeading': 'Principais entidades por influência',
  'graphCentrality.colRank': '#',
  'graphCentrality.colEntity': 'Entidade',
  'graphCentrality.colInfluence': 'Influência',
  'graphCentrality.colLinks': 'Links',
  'graphCentrality.bridgeBadge': 'conector',
  'graphCentrality.bridgeTitle': 'Conector: mais influente do que seu número de links sugere',
  'graphCentrality.degreeTitle': '{in} entrando · {out} saindo',
  'memory.tab.associations': 'Associations',
  'entityAssociations.title': 'Associações de Entidades',
  'entityAssociations.intro':
    'Entidades que compartilham muitas conexões estão associadas, mesmo quando nenhum fato as liga diretamente. A similaridade de Jaccard revela esses pares ocultos.',
  'entityAssociations.loading': 'Calculando associações…',
  'entityAssociations.errorPrefix': 'Não foi possível carregar o grafo:',
  'entityAssociations.retry': 'Retry',
  'entityAssociations.empty': 'Nenhuma associação ainda.',
  'entityAssociations.emptyHint':
    'Quando as entidades começarem a compartilhar conexões, os pares mais fortes aparecerão aqui.',
  'entityAssociations.namespaceLabel': 'Namespace',
  'entityAssociations.namespaceAll': 'Todos os namespaces',
  'entityAssociations.metricEntities': 'Entities',
  'entityAssociations.metricPairs': 'Associations',
  'entityAssociations.rankedHeading': 'Associações mais fortes',
  'entityAssociations.linkedBadge': 'linked',
  'entityAssociations.inferredBadge': 'inferred',
  'entityAssociations.linkedTitle': 'Essas entidades estão diretamente conectadas.',
  'entityAssociations.inferredTitle':
    'Sem link direto: associadas apenas por conexões compartilhadas.',
  'entityAssociations.sharedLabel': '{shared} compartilhadas',
  'entityAssociations.pairTitle':
    '{jaccard}% similar · {shared} de {union} conexões compartilhadas',
  'entityAssociations.truncated': 'Exibindo {shown} de {total}: as mais fortes primeiro.',
  'memory.tab.freshness': 'Freshness',
  'memoryFreshness.title': 'Frescura do Conhecimento',
  'memoryFreshness.intro':
    'Fatos que o assistente não reconfirmou recentemente decaem ao longo de uma curva de esquecimento. Isso mostra o que está ficando obsoleto e vale a pena reverificar, para que fatos antigos não sejam tratados como ainda certos.',
  'memoryFreshness.loading': 'Calculando frescura…',
  'memoryFreshness.errorPrefix': 'Não foi possível carregar o grafo:',
  'memoryFreshness.retry': 'Retry',
  'memoryFreshness.empty': 'Nenhum grafo de conhecimento ainda.',
  'memoryFreshness.emptyHint':
    'Quando o assistente registrar fatos sobre você, a frescura deles será rastreada aqui.',
  'memoryFreshness.namespaceLabel': 'Namespace',
  'memoryFreshness.namespaceAll': 'Todos os namespaces',
  'memoryFreshness.metricFresh': 'Fresh',
  'memoryFreshness.metricFading': 'Fading',
  'memoryFreshness.metricStale': 'Stale',
  'memoryFreshness.recallCaption': 'Recuperação média {recall}% em {total} fatos',
  'memoryFreshness.queueHeading': 'Fila de reconfirmação',
  'memoryFreshness.queueTruncated': 'Exibindo {shown} de {total}: resolva estes primeiro.',
  'memoryFreshness.allFresh': 'Todos os fatos ainda estão frescos: nada para reconfirmar.',
  'memoryFreshness.statusFading': 'fading',
  'memoryFreshness.statusStale': 'stale',
  'memoryFreshness.ageLabel': '{days} dias atrás',
  'memoryFreshness.recallTitle': '{recall}% recuperação · meia-vida {halfLife} dias',
  'memory.tab.path': 'Caminhos',
  'connectionPath.title': 'Caminho de Conexão',
  'connectionPath.intro':
    'Rastreie a cadeia mais curta de relações que liga duas entidades: como o grafo as conecta, mesmo através de vários saltos.',
  'connectionPath.loading': 'Carregando o grafo…',
  'connectionPath.errorPrefix': 'Não foi possível carregar o grafo:',
  'connectionPath.retry': 'Tentar novamente',
  'connectionPath.namespaceLabel': 'Namespace',
  'connectionPath.namespaceAll': 'Todos os namespaces',
  'connectionPath.sourceLabel': 'De',
  'connectionPath.targetLabel': 'Para',
  'connectionPath.sourcePlaceholder': 'Entidade inicial',
  'connectionPath.targetPlaceholder': 'Entidade final',
  'connectionPath.prompt': 'Escolha duas entidades para rastrear como elas estão conectadas.',
  'connectionPath.empty': 'Ainda não há grafo de conhecimento.',
  'connectionPath.emptyHint':
    'Assim que o assistente registrar fatos relacionados, você poderá rastrear conexões aqui.',
  'connectionPath.resultHeading': 'Caminho mais curto',
  'connectionPath.pathSummary': 'a {length} salto(s) de distância',
  'connectionPath.sameMessage': 'Escolha duas entidades diferentes.',
  'connectionPath.missingSource': '"{entity}" não está no grafo.',
  'connectionPath.missingTarget': '"{entity}" não está no grafo.',
  'connectionPath.noPath': 'Nenhuma conexão encontrada entre "{source}" e "{target}".',
  'memoryTree.status.title': 'Árvore da Memória',
  'memoryTree.status.autoSyncLabel': 'Auto-sincronização',
  'memoryTree.status.autoSyncDescription':
    'Pausa para parar a nova ingestão. O wiki existente permanece consultável.',
  'memoryTree.status.statusTile': 'Status',
  'memoryTree.status.lastSyncTile': 'Última sincronização',
  'memoryTree.status.totalChunksTile': 'Total de blocos',
  'memoryTree.status.wikiSizeTile': 'Tamanho da Wiki',
  'memoryTree.status.statusRunning': 'Correndo',
  'memoryTree.status.statusPaused': 'Pausado',
  'memoryTree.status.statusSyncing': 'Sincronizando',
  'memoryTree.status.statusError': 'Erro',
  'memoryTree.status.statusIdle': 'Ocioso',
  'memoryTree.status.never': 'Nunca',
  'memoryTree.status.fetchError': 'Não foi possível buscar o status da Árvore de Memória',
  'memoryTree.status.retry': 'Tentar novamente',
  'memoryTree.status.retryFailed': 'Repetir tarefas com falha',
  'memoryTree.status.retryFailedBusy': 'Tentando novamente...',
  'memoryTree.status.retryFailedDone': 'Tarefas com falha recolocadas na fila',
  'memoryTree.status.retryFailedCount': 'Tarefas na fila para executar de novo: {count}.',
  'memoryTree.status.retryFailedError': 'Não foi possível recolocar as tarefas com falha na fila',
  'memoryTree.status.toggleFailed': 'Não foi possível ativar/desativar a sincronização automática',
  'memoryTree.status.justNow': 'agora mesmo',
  'memoryTree.status.secondsAgo': '{count}s atrás',
  'memoryTree.status.minuteAgo': 'há 1 minuto',
  'memoryTree.status.minutesAgo': '{count} minutos atrás',
  'memoryTree.status.hourAgo': 'Há 1 hora',
  'memoryTree.status.hoursAgo': '{count} hr atrás',
  'memoryTree.status.dayAgo': '1 dia atrás',
  'memoryTree.status.daysAgo': '{count} dias atrás',
  'memoryTree.status.integrationsTitle': 'Saúde por integração',
  'memoryTree.status.integrationsEmpty': 'Nenhuma integração conectada',
  'memoryTree.status.integrationActive': 'Ativa',
  'memoryTree.status.integrationStale': 'Obsoleta',
  'memoryTree.status.integrationChunks': 'Blocos: {count}',
  'alerts.title': 'Alertas',
  'alerts.empty': 'Nenhum alerta ainda',
  'alerts.markAllRead': 'Marcar tudo como lido',
  'alerts.unread': 'não lido',
  'rewards.title': 'Recompensas',
  'rewards.referrals': 'Indicações',
  'rewards.coupons': 'Resgatar',
  'rewards.localUnavailable':
    'O login local não rende recompensas, cupons nem crédito de indicação. Saia e continue entrando com uma conta OpenHuman se quiser que as recompensas contem.',
  'rewards.localUnavailableCta': 'Abrir configurações da conta',
  'rewards.credits': 'Créditos',
  'rewards.referralCode': 'Seu código de indicação',
  'rewards.copyCode': 'Copiar código',
  'rewards.share': 'Compartilhar',
  'onboarding.welcome': 'Olá. Eu sou o OpenHuman.',
  'onboarding.welcomeDesc':
    'Seu assistente de IA superinteligente que roda no seu computador. Privado, simples e extremamente poderoso.',
  'onboarding.context': 'Coleta de Contexto',
  'onboarding.contextDesc': 'Conecte as ferramentas e serviços que você usa todos os dias.',
  'onboarding.localAI': 'IA Local',
  'onboarding.localAIDesc': 'Configure um modelo de IA local que roda na sua máquina.',
  'onboarding.chatProvider': 'Provedor de Chat',
  'onboarding.chatProviderDesc': 'Escolha como deseja interagir com seu assistente.',
  'onboarding.referral': 'Indicação',
  'onboarding.referralDesc': 'Aplique um código de indicação, se tiver um.',
  'onboarding.finish': 'Concluir Configuração',
  'onboarding.finishDesc': 'Tudo pronto! Comece a usar o OpenHuman.',
  'onboarding.skip': 'Pular',
  'onboarding.getStarted': 'Começar',
  'onboarding.runtimeChoice.title': 'Como você gostaria de rodar o OpenHuman?',
  'onboarding.runtimeChoice.subtitle':
    'Escolha a configuração que melhor se encaixa para você. Você pode alterar isso depois nas Configurações.',
  'onboarding.runtimeChoice.cloud.title': 'Simples',
  'onboarding.runtimeChoice.cloud.tagline': 'Deixe o OpenHuman gerenciar tudo para você.',
  'onboarding.runtimeChoice.cloud.f1': 'Segurança integrada',
  'onboarding.runtimeChoice.cloud.f2': 'Compressão de tokens para ampliar seu uso',
  'onboarding.runtimeChoice.cloud.f3': 'Uma assinatura, todos os modelos incluídos',
  'onboarding.runtimeChoice.cloud.f4': 'Sem chaves de API para gerenciar',
  'onboarding.runtimeChoice.cloud.f5': 'Simples de configurar',
  'onboarding.runtimeChoice.custom.title': 'Personalizado',
  'onboarding.runtimeChoice.custom.tagline':
    'Traga suas próprias chaves. Controle total do que está usando.',
  'onboarding.runtimeChoice.custom.f1': 'Você precisará de chaves de API para quase tudo',
  'onboarding.runtimeChoice.custom.f2': 'Reutiliza serviços que você já paga',
  'onboarding.runtimeChoice.custom.f3': 'Pode ser gratuito se você rodar tudo localmente',
  'onboarding.runtimeChoice.custom.f4': 'Mais configuração, mais controles',
  'onboarding.runtimeChoice.custom.f5': 'Ideal para usuários avançados e desenvolvedores',
  'onboarding.runtimeChoice.cloud.creditHighlight': 'Créditos grátis ao se cadastrar',
  'onboarding.runtimeChoice.continueCloud': 'Continuar com Simples',
  'onboarding.runtimeChoice.continueCustom': 'Continuar com Personalizado',
  'onboarding.runtimeChoice.recommended': 'Recomendado',
  'onboarding.runtimeChoice.exitError':
    'Não foi possível concluir o processo de integração. Por favor, tente novamente.',
  'onboarding.apiKeys.title': 'Vamos Adicionar Suas Chaves de API',
  'onboarding.apiKeys.subtitle':
    'Você pode colá-las agora ou pular e adicioná-las depois em Conexões › chaves de API. As chaves são armazenadas neste dispositivo, criptografadas em repouso.',
  'onboarding.apiKeys.openaiLabel': 'Chave de API OpenAI',
  'onboarding.apiKeys.openaiPlaceholder': 'sk-...',
  'onboarding.apiKeys.openaiOauthHint':
    'Use ChatGPT Plus/Pro (assinatura) ou uma chave OpenAI API: ambos não são necessários.',
  'onboarding.apiKeys.openaiOauthOpening': 'Abrindo login…',
  'onboarding.apiKeys.openaiOauthConnect': 'Entrar com ChatGPT',
  'onboarding.apiKeys.openaiOauthConnected': 'Conectado com ChatGPT',
  'onboarding.apiKeys.openaiOauthCallbackHint':
    'Após entrar, cole o URL de redirecionamento completo do seu navegador (começa com {url}).',
  'onboarding.apiKeys.oauthDesktopOnly':
    'O login do ChatGPT só está disponível no aplicativo de desktop.',
  'onboarding.apiKeys.oauthStartFailed':
    'Não foi possível iniciar o login do ChatGPT. Tente novamente ou use uma chave de API.',
  'onboarding.apiKeys.oauthPasteRedirect':
    'Cole o URL de redirecionamento do seu navegador após entrar.',
  'onboarding.apiKeys.oauthCompleteFailed':
    'O login do ChatGPT não foi concluído. Verifique o URL de redirecionamento e tente novamente.',
  'onboarding.apiKeys.finishSignIn': 'Concluir login no ChatGPT',
  'onboarding.apiKeys.orApiKey': 'ou tecla API',
  'onboarding.apiKeys.anthropicLabel': 'Chave de API Anthropic',
  'onboarding.apiKeys.anthropicPlaceholder': 'sk-ant-...',
  'onboarding.apiKeys.saveError':
    'Não foi possível salvar essa chave. Verifique-a e tente novamente.',
  'onboarding.apiKeys.skipForNow': 'Pular por enquanto',
  'onboarding.apiKeys.continue': 'Salvar e continuar',
  'onboarding.apiKeys.saving': 'Salvando…',
  'onboarding.custom.stepperInference': 'Inferência',
  'onboarding.custom.stepperVoice': 'Voz',
  'onboarding.custom.stepperOAuth': 'OAuth',
  'onboarding.custom.stepperSearch': 'Pesquisa',
  'onboarding.custom.stepperEmbeddings': 'Embeddings',
  'onboarding.custom.stepperMemory': 'Memória',
  'onboarding.custom.stepCounter': 'Etapa {n} de {total}',
  'onboarding.custom.defaultTitle': 'Padrão',
  'onboarding.custom.defaultSubtitle': 'Deixe o OpenHuman gerenciar para você.',
  'onboarding.custom.configureTitle': 'Configurar',
  'onboarding.custom.configureSubtitle': 'Vou escolher o que usar.',
  'onboarding.custom.progressAriaLabel': 'Progresso do onboarding',
  'onboarding.custom.continue': 'Continuar',
  'onboarding.custom.back': 'Voltar',
  'onboarding.custom.finish': 'Concluir Configuração',
  'onboarding.custom.configureLater':
    'Você pode terminar de configurar isso após o onboarding. Vamos te levar à página de Configurações correspondente quando terminar.',
  'onboarding.custom.openSettings': 'Abrir nas Configurações',
  'onboarding.custom.inference.title': 'Inferência (Texto)',
  'onboarding.custom.inference.subtitle':
    'Qual modelo de linguagem deve responder suas perguntas e executar seus agentes?',
  'onboarding.custom.inference.defaultDesc':
    'O OpenHuman direciona cada carga de trabalho para um modelo padrão adequado. Sem chaves, sem configuração.',
  'onboarding.custom.inference.configureDesc':
    'Traga sua própria chave OpenAI ou Anthropic. Usamos para todas as cargas de trabalho baseadas em texto.',
  'onboarding.custom.voice.title': 'Voz',
  'onboarding.custom.voice.subtitle': 'Fala para texto e texto para fala no modo de voz.',
  'onboarding.custom.voice.defaultDesc':
    'O OpenHuman vem com STT/TTS gerenciado que funciona sem configuração.',
  'onboarding.custom.voice.configureDesc':
    'Use seu próprio ElevenLabs / OpenAI Whisper / etc. Configure em Configurações › Voz.',
  'onboarding.custom.oauth.title': 'Conexões (OAuth)',
  'onboarding.custom.oauth.subtitle':
    'Gmail, Slack, Notion e outros serviços conectados que precisam de OAuth.',
  'onboarding.custom.oauth.defaultDesc':
    'O OpenHuman usa um espaço de trabalho Composio gerenciado. Um clique para conectar cada serviço depois.',
  'onboarding.custom.oauth.configureDesc':
    'Traga sua própria conta Composio / chave de API. Configure em Configurações › Conexões.',
  'onboarding.custom.search.title': 'Pesquisa na Web',
  'onboarding.custom.search.subtitle': 'Como o OpenHuman pesquisa na web em seu nome.',
  'onboarding.custom.search.defaultDesc':
    'O OpenHuman usa um backend de pesquisa gerenciado. Sem chaves necessárias.',
  'onboarding.custom.search.configureDesc':
    'Traga sua própria chave de provedor de pesquisa (Tavily, Brave, etc.). Configure em Configurações › Ferramentas.',
  'onboarding.custom.embeddings.title': 'Embeddings',
  'onboarding.custom.embeddings.subtitle':
    'Como o OpenHuman gera embeddings vetoriais para busca semântica na memória.',
  'onboarding.custom.embeddings.defaultDesc':
    'O OpenHuman usa um serviço gerenciado de embeddings. Nenhuma chave de API necessária.',
  'onboarding.custom.embeddings.configureDesc':
    'Use seu próprio provedor de embeddings (OpenAI, Voyage, Ollama, etc.).',
  'onboarding.custom.memory.title': 'Memória',
  'onboarding.custom.memory.subtitle':
    'Como o OpenHuman se lembra do seu contexto, preferências e conversas anteriores.',
  'onboarding.custom.memory.defaultDesc':
    'O OpenHuman gerencia o armazenamento e a recuperação de memória automaticamente. Sem nada para configurar.',
  'onboarding.custom.memory.configureDesc':
    'Inspecione, exporte ou limpe a memória você mesmo. Configure em Configurações › Memória.',
  'accounts.addAccount': 'Adicionar Conta',
  'accounts.addApps': 'Adicionar apps',
  'accounts.manageAccounts': 'Gerenciar Contas',
  'accounts.noAccounts': 'Nenhuma conta conectada',
  'accounts.connectAccount': 'Conecte uma conta para começar',
  'accounts.agent': 'Agente',
  'accounts.respondQueue': 'Fila de Respostas',
  'accounts.disconnect': 'Desconectar',
  'accounts.disconnectConfirm': 'Tem certeza de que deseja desconectar esta conta?',
  'accounts.disconnectClearMemory': 'Também excluir memória desta fonte',
  'accounts.disconnectClearMemoryHint':
    'Remove permanentemente os fragmentos de memória local vinculados a esta conexão.',
  'accounts.searchAccounts': 'Pesquisar contas...',
  'channels.title': 'Canais',
  'channels.configure': 'Configurar Canal',
  'channels.setup': 'Configurar',
  'channels.noChannels': 'Nenhum canal configurado',
  'channels.localManagedUnavailable':
    'Canais gerenciados não estão disponíveis para usuários locais.',
  'channels.addChannel': 'Adicionar Canal',
  'channels.status.connected': 'Conectado',
  'channels.status.disconnected': 'Desconectado',
  'channels.status.error': 'Erro',
  'channels.status.configuring': 'Configurando',
  'channels.defaultMessaging': 'Canal de Mensagens Padrão',
  'channels.setAsDefault': 'Definir como padrão',
  'channels.defaultBadge': 'Padrão',
  'webhooks.title': 'Webhooks',
  'webhooks.create': 'Criar Webhook',
  'webhooks.noWebhooks': 'Nenhum webhook configurado',
  'webhooks.url': 'URL',
  'webhooks.secret': 'Segredo',
  'webhooks.events': 'Eventos',
  'webhooks.archiveDirectory': 'Diretório de Arquivo',
  'webhooks.todayFile': 'Arquivo de Hoje',
  'invites.title': 'Convites',
  'invites.create': 'Criar Convite',
  'invites.noInvites': 'Nenhum convite pendente',
  'invites.code': 'Código de Convite',
  'invites.copyLink': 'Copiar Link',
  'invites.generate': 'Gerar convite',
  'invites.generating': 'Gerando...',
  'invites.refreshing': 'Atualizando convites...',
  'invites.loading': 'Carregando convites...',
  'invites.copyCodeAria': 'Copiar código de convite',
  'invites.revokeAria': 'Revogar convite',
  'invites.usedUp': 'Esgotado',
  'invites.uses': 'Usa: {current}{max}',
  'invites.expiresOn': 'Expira em {date}',
  'invites.empty': 'Nenhum convite ainda',
  'invites.emptyHint': 'Gere um código de convite para compartilhar com outras pessoas',
  'invites.revokeTitle': 'Revogar código de convite',
  'invites.revokePromptPrefix': 'Tem certeza de que deseja revogar o código de convite',
  'invites.revokeWarning':
    'Este código de convite não será mais válido e não poderá ser usado para entrar na equipe.',
  'invites.revoking': 'Revogando...',
  'invites.revokeAction': 'Revogar convite',
  'invites.failedGenerate': 'Falha ao gerar convite',
  'invites.failedRevoke': 'Falha ao revogar convite',
  'team.refreshingMembers': 'Atualizando membros...',
  'team.loadingMembers': 'Carregando membros...',
  'team.memberCount': '{count} membro',
  'team.memberCountPlural': '{count} membros',
  'team.you': '(Você)',
  'team.removeAria': 'Remover {name}',
  'team.noMembers': 'Nenhum membro encontrado',
  'team.removeTitle': 'Remover membro da equipe',
  'team.removePromptPrefix': 'Tem certeza de que deseja remover',
  'team.removePromptSuffix': 'da equipe?',
  'team.removeWarning': 'Eles perderão o acesso à equipe e a todos os recursos da equipe.',
  'team.removing': 'Removendo...',
  'team.removeAction': 'Remover membro',
  'team.changeRoleTitle': 'Alterar função de membro',
  'team.changeRolePrompt': 'Alterar o papel de {name} de {oldRole} para {newRole}?',
  'team.changeRoleAdminGrant':
    'Isso concederá a ele permissões completas de administrador, incluindo a capacidade de gerenciar membros da equipe.',
  'team.changeRoleAdminRemove':
    'Isso removerá as permissões de administrador dele e ele não poderá mais gerenciar a equipe.',
  'team.changing': 'Alterando...',
  'team.changeRoleAction': 'Alterar função',
  'team.failedChangeRole': 'Falha ao alterar função',
  'team.failedRemoveMember': 'Falha ao remover membro',
  'devOptions.title': 'Avançado',
  'devOptions.titleDiagnostics': 'Desenvolvedor e Diagnósticos',
  'devOptions.diagnostics': 'Diagnósticos',
  'devOptions.diagnosticsDesc': 'Saúde do sistema, logs e métricas de desempenho',
  'devOptions.toolPolicyDiagnosticsDesc':
    'Inventário de ferramentas, postura de políticas, listas de permissão MCP e bloqueios recentes',
  'devOptions.toolPolicyDiagnostics.loading': 'Carregando…',
  'devOptions.toolPolicyDiagnostics.unavailable': 'Diagnósticos indisponíveis',
  'devOptions.toolPolicyDiagnostics.posture.title': 'Postura de política',
  'devOptions.toolPolicyDiagnostics.posture.autonomy': 'Autonomia:',
  'devOptions.toolPolicyDiagnostics.posture.workspaceOnly': 'Apenas espaço de trabalho:',
  'devOptions.toolPolicyDiagnostics.posture.maxActionsPerHour': 'Máx. ações/h:',
  'devOptions.toolPolicyDiagnostics.posture.approvalMediumRisk': 'Aprovação (risco médio):',
  'devOptions.toolPolicyDiagnostics.posture.blockHighRisk': 'Bloquear alto risco:',
  'devOptions.toolPolicyDiagnostics.inventory.title': 'Inventário',
  'devOptions.toolPolicyDiagnostics.inventory.totalTools': 'Ferramentas totais',
  'devOptions.toolPolicyDiagnostics.inventory.enabledTools': 'Ferramentas habilitadas',
  'devOptions.toolPolicyDiagnostics.inventory.mcpStdioTools': 'MCP ferramentas stdio',
  'devOptions.toolPolicyDiagnostics.inventory.jsonRpcTools': 'ferramentas JSON-RPC',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.title': 'Listas de permissão MCP',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.summary':
    'Ativado: {enabled} · Servidores: {enabledCount}/{totalCount}',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.unnamed': '<sem nome>',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.allowDeny':
    'permitir={allowCount} negar={denyCount}',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.title': 'MCP escrever auditoria',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.summary':
    'Ativado: {enabled} · Recentes (24h): {recentRows}',
  'devOptions.toolPolicyDiagnostics.recentBlocked.title': 'Chamadas bloqueadas recentes',
  'devOptions.toolPolicyDiagnostics.recentBlocked.empty': 'Nenhuma chamada bloqueada registrada.',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.title': 'Superfícies redigidas',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.summary':
    'Capaz de escrever: {writeCount} · Superfícies de política: {policyCount}',
  'devOptions.debugPanels': 'Painéis de Depuração',
  'devOptions.debugPanelsDesc':
    'Flags de funcionalidades, inspeção de estado e ferramentas de depuração',
  'devOptions.webhooks': 'Webhooks',
  'devOptions.webhooksDesc': 'Configurar e testar integrações de webhook',
  'devOptions.memoryInspection': 'Inspeção de Memória',
  'devOptions.memoryInspectionDesc': 'Navegar, consultar e gerenciar entradas de memória',
  'voice.pushToTalk': 'Pressionar para Falar',
  'voice.recording': 'Gravando...',
  'voice.processing': 'Processando...',
  'voice.languageHint': 'Idioma',
  'misc.rehydrating': 'Carregando seus dados...',
  'misc.checkingServices': 'Verificando serviços...',
  'misc.serviceUnavailable': 'Serviço Indisponível',
  'misc.somethingWentWrong': 'Algo deu errado',
  'misc.tryAgainLater': 'Por favor, tente novamente mais tarde.',
  'misc.restartApp': 'Reiniciar App',
  'misc.updateAvailable': 'Atualização Disponível',
  'misc.updateNow': 'Atualizar Agora',
  'misc.updateLater': 'Depois',
  'misc.downloading': 'Baixando...',
  'misc.installing': 'Instalando...',
  'misc.beta':
    'O OpenHuman está em beta inicial. Sinta-se à vontade para compartilhar feedback ou reportar bugs que encontrar: cada relato nos ajuda a melhorar mais rápido.',
  'misc.betaFeedback': 'Enviar feedback',
  'mnemonic.title': 'Frase de Recuperação',
  'mnemonic.warning': 'Anote estas palavras em ordem e guarde-as em um lugar seguro.',
  'mnemonic.copyWarning':
    'Nunca compartilhe sua frase de recuperação. Qualquer pessoa com essas palavras pode acessar sua conta.',
  'mnemonic.copied': 'Frase de recuperação copiada para a área de transferência',
  'mnemonic.reveal': 'Revelar frase',
  'mnemonic.revealPhrase': 'Revelar frase de recuperação',
  'mnemonic.hidden': 'Frase de recuperação está oculta',
  'privacy.title': 'Privacidade e Segurança',
  'privacy.description': 'Relatório de transparência de dados enviados a serviços externos.',
  'privacy.empty': 'Nenhuma transferência de dados externa detectada.',
  'privacy.whatLeavesComputer': 'O que sai do seu computador',
  'privacy.loading': 'Carregando detalhes de privacidade...',
  'privacy.loadError':
    'Não foi possível carregar a lista de privacidade em tempo real. Os controles de análise abaixo ainda funcionam.',
  'privacy.noCapabilities': 'Nenhuma funcionalidade divulga atualmente movimentação de dados.',
  'privacy.sentTo': 'Enviado para',
  'privacy.leavesDevice': 'Sai do dispositivo',
  'privacy.staysLocal': 'Fica local',
  'privacy.anonymizedAnalytics': 'Análises do Produto',
  'privacy.shareAnonymizedData': 'Compartilhar análises do produto e diagnósticos',
  'privacy.shareAnonymizedDataDesc':
    'Ajude a melhorar o OpenHuman compartilhando relatórios de falhas e eventos de uso com privacidade limitada, incluindo um ID de conta estável e metadados da versão do app. Mensagens, chaves de carteira, chaves de API e tokens de sessão nunca são coletados.',
  'privacy.meetingFollowUps': 'Acompanhamentos de reuniões',
  'privacy.autoHandoffMeet':
    'Transferência automática de transcrições do Google Meet para o orquestrador',
  'privacy.autoHandoffMeetDesc':
    'Quando uma chamada do Google Meet termina, o orquestrador do OpenHuman pode ler a transcrição e pode realizar ações como redigir mensagens, agendar acompanhamentos ou postar resumos no seu espaço de trabalho Slack conectado. Desativado por padrão.',
  'privacy.analyticsDisclaimer':
    'Quando ativados, as análises do produto e os diagnósticos podem incluir relatórios de falhas e eventos de uso com privacidade limitada, um ID de conta estável e metadados da versão do app. Mensagens, chaves de carteira, chaves de API e tokens de sessão nunca são coletados. Você pode alterar essa configuração a qualquer momento.',
  'settings.about.version': 'Versão',
  'settings.about.updateAvailable': 'está disponível',
  'settings.about.softwareUpdates': 'Atualizações de software',
  'settings.about.lastChecked': 'Última verificação',
  'settings.about.checking': 'Verificando...',
  'settings.about.checkForUpdates': 'Verificar atualizações',
  'settings.about.releases': 'Versões',
  'settings.about.releasesDesc':
    'Navegar pelas notas de versão e compilações anteriores no GitHub.',
  'settings.about.openReleases': 'Abrir versões no GitHub',
  'settings.about.starCta.title': 'Gostando do OpenHuman?',
  'settings.about.starCta.body': 'Dê uma estrela no GitHub. Assim mais pessoas nos encontram.',
  'settings.about.starCta.star': 'Marcar com estrela no GitHub',
  'settings.about.starCta.dismiss': 'Agora não',
  'settings.about.connection': 'Conexão',
  'settings.about.connectionMode': 'Modo',
  'settings.about.connectionModeLocal': 'Local',
  'settings.about.connectionModeCloud': 'Nuvem',
  'settings.about.connectionModeUnset': 'Não selecionado',
  'settings.about.serverUrl': 'Servidor URL',
  'settings.about.serverUrlUnavailable': 'Indisponível',
  'settings.about.connectionHelperLocal':
    'Gerado no processo pelo shell Tauri ao iniciar o aplicativo. A porta é escolhida na inicialização, então este URL muda entre os lançamentos.',
  'settings.about.connectionHelperCloud':
    'Conectado a um núcleo remoto. Altere isso no BootCheck ou no seletor de modo de nuvem.',
  'settings.heartbeat.title': 'Heartbeat e loops',
  'settings.usage.title': 'Uso e limites',
  'settings.usage.menuDesc': 'Custos, uso de tokens, orçamentos e atividade em segundo plano',
  'settings.costDashboard.title': 'Painel de custos',
  'settings.costDashboard.sevenDayCost': 'Custo diário de 7 dias',
  'settings.costDashboard.sevenDayTokens': 'Uso de token de 7 dias',
  'settings.costDashboard.totalSpend': 'total de 7 dias',
  'settings.costDashboard.monthlyPace': 'Ritmo mensal',
  'settings.costDashboard.budgetLimit': 'Limite orçamentário',
  'settings.costDashboard.utilization': 'Uso',
  'settings.costDashboard.modelBreakdown': 'Detalhamento por modelo',
  'settings.costDashboard.model': 'Modelo',
  'settings.costDashboard.provider': 'Fornecedor',
  'settings.costDashboard.cost': 'Custo',
  'settings.costDashboard.tokens': 'Tokens',
  'settings.costDashboard.requests': 'Solicitações',
  'settings.costDashboard.percentOfTotal': '% do total',
  'settings.costDashboard.inputTokens': 'Entrada',
  'settings.costDashboard.outputTokens': 'Saída',
  'settings.costDashboard.budgetNormal': 'No caminho certo',
  'settings.costDashboard.budgetWarning': 'Aviso',
  'settings.costDashboard.budgetExceeded': 'Acima do orçamento',
  'settings.costDashboard.noBudget': 'Sem limite definido',
  'settings.costDashboard.noData': 'Nenhum custo registrado ainda nos últimos 7 dias.',
  'settings.costDashboard.noModels': 'Nenhuma atividade do modelo nos últimos 7 dias.',
  'settings.costDashboard.loading': 'Carregando painel de custo…',
  'settings.costDashboard.disabledHint':
    'O painel de custos está desativado na configuração. Defina [cost.dashboard] enabled = true no config.toml para reativar.',
  'settings.costDashboard.subtitle':
    'Gastos ao vivo e queima de tokens em todo o enxame. As barras atualizam automaticamente a cada poucos segundos: sem necessidade de recarregar a página.',
  'settings.costDashboard.summaryAriaLabel': 'Métricas de resumo de custos',
  'settings.costDashboard.lastSevenDays': 'últimos 7 dias',
  'settings.costDashboard.utilizationOf': 'de',
  'settings.costDashboard.thisMonth': 'este mês',
  'settings.costDashboard.monthlyPaceHint':
    'Gasto mensal projetado na taxa diária atual (média × 30).',
  'settings.costDashboard.budgetLimitHint':
    'Orçamento mensal lido de cost.monthly_limit_usd em config.toml.',
  'settings.costDashboard.dailyTarget': 'Meta diária',
  'settings.costDashboard.today': 'Hoje',
  'settings.costDashboard.todayBadge': 'HOJE',
  'settings.costDashboard.unknownProvider': 'Nenhum',
  'settings.costDashboard.justNow': 'Agora mesmo',
  'settings.costDashboard.secondsAgo': '{value}s atrás',
  'settings.costDashboard.minutesAgo': '{value}m atrás',
  'settings.costDashboard.hoursAgo': '{value}h atrás',
  'settings.costDashboard.daysAgo': '{value}d atrás',
  'settings.costDashboard.updated': 'Atualizado',
  'settings.costDashboard.refresh': 'Atualizar',
  'settings.costDashboard.utcNote': 'Dias agrupados em UTC',
  'settings.costDashboard.stackedNote': 'Entrada + saída empilhadas',
  'settings.costDashboard.modelBreakdownHint': 'Agregado ao longo dos últimos 7 dias.',
  'settings.costDashboard.categoryDistribution': 'Gastos por categoria',
  'settings.costDashboard.categoryDistributionHint':
    'Inferido de registros recentes de chat, embeddings, voz, imagem e reranking.',
  'settings.costDashboard.noCategories': 'Ainda não há gastos por categoria registrados.',
  'settings.costDashboard.categoryMeta': '{requests} solicitações • {tokens} tokens',
  'settings.costDashboard.usageLog': 'Registro de uso',
  'settings.costDashboard.usageLogHint':
    'Registros mais recentes dos últimos {days} dias, limitados a {limit} linhas.',
  'settings.costDashboard.logTotal': '{requests} solicitações • {cost}',
  'settings.costDashboard.noUsageLog': 'Nenhum registro de uso encontrado para este período.',
  'settings.costDashboard.when': 'Quando',
  'settings.costDashboard.category': 'Categoria',
  'settings.costDashboard.session': 'Sessão',
  'settings.costDashboard.noDataHint':
    'Envie uma mensagem de agente: o uso de tokens na próxima chamada do provedor preencherá o gráfico em cerca de 10 segundos.',
  'settings.search.title': 'Mecanismo de pesquisa',
  'settings.search.menuDesc':
    'Padrão para pesquisa gerenciada por OpenHuman ou conecte seu próprio provedor com uma chave API.',
  'settings.search.description':
    'Escolha o mecanismo de busca usado pelo agente, ou desative as ferramentas de pesquisa completamente. Gerenciado usa o backend do OpenHuman (sem configuração). Parallel, Brave, Querit e Exa funcionam diretamente do seu computador usando sua chave de API.',
  'settings.search.engineAria': 'Mecanismo de pesquisa',
  'settings.search.engineDisabledLabel': 'Disabled',
  'settings.search.engineDisabledDesc':
    'Remover ferramentas de busca do contexto do agente e da lista de ferramentas disponíveis.',
  'settings.search.engineManagedLabel': 'OpenHuman Gerenciado',
  'settings.search.engineManagedDesc':
    'Padrão. Roteado através do backend do OpenHuman, atualmente com tecnologia Exa: nenhuma chave API é necessária.',
  'settings.search.localManagedUnavailable':
    'A busca gerenciada pela OpenHuman não está disponível para usuários locais. Adicione sua própria chave de API do Parallel, Brave, Querit ou Exa para habilitar a busca na web.',
  'settings.search.engineParallelLabel': 'Paralelo',
  'settings.search.engineParallelDesc':
    'Paralelo Direto API: buscar, extrair, conversar, pesquisar, enriquecer, ferramentas de conjunto de dados.',
  'settings.search.engineBraveLabel': 'Pesquisa Brave',
  'settings.search.engineBraveDesc':
    'Pesquisa Direta Brave API: ferramentas de web, notícias, imagens e vídeo.',
  'settings.search.engineQueritLabel': 'Querit',
  'settings.search.engineQueritDesc':
    'Direct Querit API: pesquisa na web com filtros de site, intervalo de tempo, país e idioma.',
  'settings.search.engineExaLabel': 'Exa',
  'settings.search.engineExaDesc':
    'Busca neural com tecnologia Exa. Requer sua própria chave de API do Exa. Adiciona ferramentas de busca, páginas semelhantes e conteúdo de páginas.',
  'settings.search.statusConfigured': 'Configurado',
  'settings.search.statusNeedsKey': 'Precisa da chave API',
  'settings.search.fallbackToManaged':
    'Nenhuma chave configurada: a pesquisa voltará para Gerenciada até que uma chave seja salva.',
  'settings.search.getApiKey': 'Obtenha a chave API',
  'settings.search.save': 'Salvar',
  'settings.search.clear': 'Limpar',
  'settings.search.show': 'Mostrar',
  'settings.search.hide': 'Ocultar',
  'settings.search.statusSaving': 'Salvando…',
  'settings.search.statusSaved': 'Salvo.',
  'settings.search.statusError': 'Falha',
  'settings.search.parallelKeyLabel': 'Parallel API chave',
  'settings.search.braveKeyLabel': 'Brave Pesquisar chave API',
  'settings.search.queritKeyLabel': 'Chave Querit API',
  'settings.search.exaKeyLabel': 'Chave de API do Exa',
  'settings.search.placeholderStored': '•••••••• (armazenado)',
  'settings.search.placeholderParallel': 'pk_...',
  'settings.search.placeholderBrave': 'BSA...',
  'settings.search.placeholderQuerit': 'Chave Querit API',
  'settings.search.placeholderExa': 'Cole sua chave de API do Exa…',
  'settings.search.allowedSitesLabel': 'Sites permitidos',
  'settings.search.allowedSitesHint':
    'Liste, um por linha, os hosts que o assistente pode abrir e ler (via busca na web e ferramenta de navegador), ex.: reuters.com. Um host também cobre seus subdomínios. A busca na web em si não é restringida por esta lista.',
  'settings.search.allowedSitesAllOn':
    'O assistente pode abrir qualquer site público. Endereços locais e privados permanecem bloqueados.',
  'settings.search.allowedSitesPlaceholder': 'reuters.com\napnews.com\ngithub.com',
  'settings.search.allowedSitesSave': 'Salvar sites',
  'settings.search.accessModeAria': 'Modo de acesso à web',
  'settings.search.accessAllowAll': 'Permitir tudo',
  'settings.search.accessCustom': 'Personalizado',
  'settings.search.accessBlockAll': 'Bloquear tudo',
  'settings.search.accessBlockAllHint':
    'Todo o acesso à web está bloqueado: o assistente não pode abrir ou ler nenhum site.',
  // ─── Settings global search bar ────────────────────────────
  'settings.settingsSearch.placeholder': 'Pesquisar configurações…',
  'settings.settingsSearch.ariaLabel': 'Pesquisar configurações',
  'settings.settingsSearch.clear': 'Limpar pesquisa',
  'settings.settingsSearch.resultsLabel': 'Resultados da pesquisa',
  'settings.settingsSearch.noResults': 'Nenhuma configuração encontrada para “{query}”',
  'settings.embeddings.title': 'Incorporações',
  'settings.embeddings.description':
    'Escolha qual provedor de embeddings converte memória em vetores para busca semântica. Alterar o provedor, modelo ou dimensões invalida vetores armazenados e requer uma redefinição completa da memória.',
  'settings.embeddings.providerAria': 'Provedor de embeddings',
  'settings.embeddings.statusConfigured': 'Configurado',
  'settings.embeddings.statusNeedsKey': 'Precisa de chave API',
  'settings.embeddings.requiresSignIn': 'Requer login no OpenHuman',
  'settings.embeddings.managedLoginRequired':
    'Embeddings gerenciados requerem login no OpenHuman. Faça login para usar o backend do OpenHuman.',
  'settings.embeddings.managedBannerIntro':
    'Embeddings gerenciados passam pelo backend do OpenHuman e exigem uma sessão de conta OpenHuman.',
  'settings.embeddings.managedBannerLocalSession':
    'Saia da sessão local e faça login para usar este provedor, ou mude para um provedor de embeddings local ou com sua própria chave.',
  'settings.embeddings.managedBannerRemoteSession':
    'Faça login novamente para atualizar sua sessão OpenHuman, ou mude para um provedor de embeddings local ou com sua própria chave.',
  'settings.embeddings.signInAgain': 'Entrar novamente',
  'settings.embeddings.apiKeyLabel': 'Chave API {provider}',
  'settings.embeddings.apiKeyLabelGeneric': 'Chave de API',
  'settings.embeddings.placeholderStored': '•••••••• (armazenado)',
  'settings.embeddings.placeholderKey': 'Cole sua chave API…',
  'settings.embeddings.keyStoredEncrypted':
    'Sua chave API é armazenada criptografada neste dispositivo.',
  'settings.embeddings.show': 'Mostrar',
  'settings.embeddings.hide': 'Ocultar',
  'settings.embeddings.save': 'Salvar',
  'settings.embeddings.clear': 'Limpar',
  'settings.embeddings.model': 'Modelo',
  'settings.embeddings.dimensions': 'Dimensões',
  'settings.embeddings.customEndpoint': 'Endpoint personalizado',
  'settings.embeddings.customModelPlaceholder': 'Nome do modelo',
  'settings.embeddings.customDimsPlaceholder': 'Escurece',
  'settings.embeddings.applyCustom': 'Aplicar',
  'settings.embeddings.testConnection': 'Testar conexão',
  'settings.embeddings.testing': 'Testando…',
  'settings.embeddings.testSuccess': 'Conectado: {dims} dimensões',
  'settings.embeddings.connectionTestFailed': 'Teste falhou',
  'settings.embeddings.verifyFallback':
    'Não foi possível verificar o endpoint de embeddings. Verifique se ele está em execução e fornecendo um modelo de embedding e salve novamente.',
  'settings.embeddings.testFailed': 'Falhou: {error}',
  'settings.embeddings.saving': 'Salvando…',
  'settings.embeddings.saved': 'Salvo.',
  'settings.embeddings.errorPrefix': 'Falhou',
  'settings.embeddings.wipeTitle': 'Redefinir vetores de memória?',
  'settings.embeddings.wipeBody':
    'Alterar o provedor de embeddings, modelo ou dimensões apagará todos os vetores de memória armazenados. A memória deve ser reconstruída antes que a recuperação funcione novamente. Isso não pode ser desfeito.',
  'settings.embeddings.cancel': 'Cancelar',
  'settings.embeddings.confirmWipe': 'Limpar e aplicar',
  'settings.embeddings.setupTitle': 'Configurar {provider}',
  'settings.embeddings.saveAndSwitch': 'Salvar e trocar',
  'settings.embeddings.optional': 'opcional',
  'settings.embeddings.vectorSearchDisabled':
    'A pesquisa vetorial está desativada. A recuperação de memória usará apenas correspondência de palavras-chave e recência: sem classificação semântica.',
  'settings.embeddings.clearKey': 'Limpar chave API',
  'pages.settings.ai.embeddings': 'Incorporações',
  'pages.settings.ai.embeddingsDesc': 'Modelo de codificação vetorial para recuperação de memória',
  'mcp.alphaBadge': 'Alfa',
  'mcp.alphaBannerText':
    'O suporte do servidor MCP está em alfa inicial. O registro, o fluxo de instalação e a conexão das ferramentas podem se comportar de maneira inadequada ou mudar de forma entre as versões.',
  'mcp.toolList.noTools': 'Nenhuma ferramenta disponível.',
  'mcp.setup.secretDialog.title': 'MCP Configuração - Insira o segredo',
  'mcp.setup.secretDialog.bodyPrefix': 'O agente de configuração MCP precisa de',
  'mcp.setup.secretDialog.bodySuffix':
    '. Seu valor é enviado diretamente para o processo principal e nunca entra na conversa AI.',
  'mcp.setup.secretDialog.inputLabel': 'Valor',
  'mcp.setup.secretDialog.inputPlaceholder': 'Cole aqui',
  'mcp.setup.secretDialog.show': 'Mostrar',
  'mcp.setup.secretDialog.hide': 'Ocultar',
  'mcp.setup.secretDialog.submit': 'Enviar',
  'mcp.setup.secretDialog.cancel': 'Cancelar',
  'mcp.setup.secretDialog.submitting': 'Enviando…',
  'mcp.setup.secretDialog.errorPrefix': 'Falha ao enviar:',
  'mcp.setup.secretDialog.privacyNote':
    'Armazenado criptografado na tabela de segredos local MCP. Nunca registrado ou enviado para um modelo.',
  'devices.betaBadge': 'Beta',
  'devices.betaText':
    'Este recurso está atualmente em beta. Vincule iPhones a este OpenHuman para usá-los como cliente remoto.',
  'devices.comingSoonDescription':
    'O pareamento de dispositivos está chegando em breve. Esta página será o lugar para parear iPhones e gerenciar dispositivos conectados.',
  'devices.title': 'Dispositivos',
  'devices.pairIphone': 'Emparelhar iPhone',
  'devices.noPaired': 'Nenhum dispositivo emparelhado',
  'devices.emptyState':
    'Escaneie um QR code no seu iPhone para conectá-lo a esta sessão do OpenHuman.',
  'devices.devicePairedTitle': 'Dispositivo emparelhado',
  'devices.devicePairedMessage': 'iPhone conectado com sucesso.',
  'devices.deviceRevokedTitle': 'Dispositivo revogado',
  'devices.deviceRevokedMessage': '{label} removido.',
  'devices.revokeFailedTitle': 'Falha na revogação',
  'devices.online': 'On-line',
  'devices.offline': 'Off-line',
  'devices.lastSeenNever': 'Nunca',
  'devices.lastSeenNow': 'Agora mesmo',
  'devices.lastSeenMinutes': '{count}m atrás',
  'devices.lastSeenHours': '{count}h atrás',
  'devices.lastSeenDays': '{count}d atrás',
  'devices.revoke': 'Revogar',
  'devices.revokeAria': 'Revogar {label}',
  'devices.confirmRevokeTitle': 'Revogar dispositivo?',
  'devices.confirmRevokeBody':
    '{label} não poderá mais se conectar. Esta ação não pode ser desfeita.',
  'devices.loadFailed': 'Falha ao carregar dispositivos: {message}',
  'devices.pairModal.title': 'Emparelhar iPhone',
  'devices.pairModal.loading': 'Gerando código de emparelhamento…',
  'devices.pairModal.instructions': 'Abra o app OpenHuman no seu iPhone e escaneie este código.',
  'devices.pairModal.expiresIn': 'O código expira em ~{count} minuto',
  'devices.pairModal.expiresInPlural': 'O código expira em ~{count} minutos',
  'devices.pairModal.showDetails': 'Mostrar detalhes',
  'devices.pairModal.hideDetails': 'Ocultar detalhes',
  'devices.pairModal.channelId': 'ID do canal',
  'devices.pairModal.pairingUrl': 'Emparelhamento URL',
  'devices.pairModal.expiredTitle': 'QR code expirou',
  'devices.pairModal.expiredBody': 'Gere um novo código para continuar o emparelhamento.',
  'devices.pairModal.generateNewCode': 'Gerar novo código',
  'devices.pairModal.successTitle': 'Emparelhado com iPhone',
  'devices.pairModal.autoClose': 'Fechando automaticamente…',
  'devices.pairModal.errorPrefix': 'Falha ao criar emparelhamento: {message}',
  'devices.pairModal.errorTitle': 'Algo deu errado',
  'devices.pairModal.copyUrl': 'Copiar',
  'mcp.catalog.searchAria': 'Pesquisar catálogo de servidores MCP',
  'mcp.catalog.searchPlaceholder': 'Pesquisar servidores MCP...',
  'mcp.catalog.loadFailed': 'Falha ao carregar o catálogo',
  'mcp.registry.error.notFound':
    'Servidor não encontrado no registro. Confira o nome do servidor e tente novamente, navegue pelos servidores MCP disponíveis ou adicione o servidor manualmente por URL.',
  'mcp.registry.error.network':
    'Não foi possível acessar o registro MCP. Verifique sua conexão e tente novamente, ou adicione o servidor manualmente por URL.',
  'mcp.registry.error.unavailable':
    'O registro MCP está indisponível no momento. Tente novamente mais tarde, navegue pelos servidores MCP disponíveis ou adicione o servidor manualmente por URL.',
  'mcp.catalog.noResults': 'Nenhum servidor encontrado.',
  'mcp.catalog.noResultsFor': 'Nenhum servidor encontrado para "{query}".',
  'mcp.catalog.loadMore': 'Carregar mais',
  'mcp.configAssistant.title': 'Assistente de configuração',
  'mcp.configAssistant.empty':
    'Pergunte sobre configuração, variáveis de ambiente necessárias ou etapas de configuração.',
  'mcp.configAssistant.autoPromptCta': 'Obter ajuda de configuração passo a passo',
  'mcp.configAssistant.suggestedValues': 'Valores sugeridos:',
  'mcp.configAssistant.valueHidden': '(valor oculto)',
  'mcp.configAssistant.applySuggested': 'Aplicar valores sugeridos',
  'mcp.configAssistant.reinstallHint': 'Reinstale com esses valores para aplicá-los.',
  'mcp.configAssistant.thinking': 'Pensando...',
  'mcp.configAssistant.inputPlaceholder':
    'Faça uma pergunta (Enter para enviar, Shift+Enter para nova linha)',
  'mcp.configAssistant.send': 'Enviar',
  'mcp.configAssistant.failedResponse': 'Falha ao obter resposta',
  'mcp.toolList.availableSingular': '{count} ferramenta disponível',
  'mcp.toolList.availablePlural': '{count} ferramentas disponíveis',
  'mcp.toolList.tryTool': 'Tentar',
  'mcp.toolList.tryToolAria': 'Abrir playground de execução para {name}',
  'mcp.playground.title': 'Execute {name}',
  'mcp.playground.close': 'Fechar parquinho',
  'mcp.playground.inputSchema': 'Esquema de entrada',
  'mcp.playground.argsLabel': 'Argumentos (JSON)',
  'mcp.playground.argsHelp':
    'Digite JSON correspondendo ao esquema de entrada. Entrada vazia é tratada como {}.',
  'mcp.playground.runShortcut': '⌘/Ctrl + Enter para executar',
  'mcp.playground.format': 'Formato',
  'mcp.playground.invalidJson': 'JSON inválido',
  'mcp.playground.run': 'Executar ferramenta',
  'mcp.playground.running': 'Executando…',
  'mcp.playground.result': 'Resultado',
  'mcp.playground.resultError': 'A ferramenta retornou um erro',
  'mcp.playground.copyResult': 'Copiar resultado',
  'mcp.playground.copied': 'Copiado',
  'mcp.playground.history': 'História',
  'mcp.playground.historyEmpty': 'Ainda não houve invocações nesta sessão.',
  'mcp.playground.historyLoad': 'Carregar',
  'mcp.playground.unexpectedError': 'Erro inesperado ao invocar a ferramenta.',
  'mcp.catalog.deployed': 'Implantado',
  'mcp.catalog.installCount': '{count} instala',
  'app.update.dismissNotification': 'Ignorar notificação de atualização',
  'bootCheck.rpcAuthSuffix': 'em cada RPC.',
  'app.localAiDownload.expandAria': 'Expandir o progresso do download',
  'app.localAiDownload.collapseAria': 'Recolher o progresso do download',
  'app.localAiDownload.dismissAria': 'Dispensar notificação de download',
  'mobile.nav.ariaLabel': 'Navegação móvel',
  'progress.stepsAria': 'Etapas de progresso',
  'progress.stepAria': 'Etapa {current} de {total}',
  'workspace.vaultsTitle': 'Cofres de conhecimento',
  'workspace.vaultsDesc':
    'Aponte para uma pasta local; os arquivos são fragmentados e espelhados na memória.',
  'calls.title': 'Chamadas',
  'calls.comingSoonBody': 'Chamadas assistidas por IA estarão disponíveis em breve. Fique atento.',
  'art.rotatingTetrahedronAria': 'Nave espacial rotativa de tetraedro invertido',
  'mcp.installed.title': 'Instalado',
  'mcp.installed.browseCatalog': 'Navegar no catálogo',
  'mcp.installed.empty': 'Nenhum servidor MCP instalado ainda.',
  'mcp.installed.toolSingular': 'Ferramenta {count}',
  'mcp.installed.toolPlural': 'Ferramentas {count}',
  'mcp.health.title': 'Saúde',
  'mcp.health.summaryAria': 'Resumo da integridade da conexão MCP',
  'mcp.health.connectedCount': '{count} conectado',
  'mcp.health.connectingCount': '{count} conectando',
  'mcp.health.errorCount': 'erro {count}',
  'mcp.health.disconnectedCount': '{count} ocioso',
  'mcp.health.retryAll': 'Tentar novamente tudo ({count})',
  'mcp.health.retryAllAria':
    'Tentar novamente todos os servidores {count} que apresentaram erro MCP',
  'mcp.health.disconnectAll': 'Desconectar tudo ({count})',
  'mcp.health.disconnectAllAria': 'Desconecte todos os servidores MCP conectados ao {count}',
  'mcp.health.disconnectConfirm.title': 'Desconectar todos os servidores MCP?',
  'mcp.health.disconnectConfirm.body':
    'Isso desconectará {count} servidores MCP conectados no momento. As configurações instaladas e os segredos são mantidos; você poderá reconectar qualquer servidor mais tarde.',
  'mcp.health.disconnectConfirm.cancel': 'Cancelar',
  'mcp.health.disconnectConfirm.confirm': 'Desconectar tudo',
  'mcp.health.opErrorGeneric': 'Operação em massa falhou. Veja os registros.',
  'mcp.health.bulkPartialFailure': '{failed} de {total} servidores falharam. Veja os logs.',
  'mcp.installed.search.landmarkAria': 'Pesquisar servidores MCP instalados',
  'mcp.installed.search.inputAria': 'Filtrar servidores MCP instalados por nome',
  'mcp.installed.search.placeholder': 'Filtrar servidores…',
  'mcp.installed.search.clearAria': 'Limpar filtro',
  'mcp.installed.search.countMatches': '{shown} de servidores {total}',
  'mcp.installed.search.noMatches': 'Nenhum servidor corresponde a "{query}".',
  'mcp.inventory.openButton': 'Inventário',
  'mcp.inventory.openAria': 'Abra o painel de inventário compartilhável MCP',
  'mcp.inventory.title': 'Inventário MCP Compartilhável',
  'mcp.inventory.subtitle':
    'Exporte seus servidores MCP instalados como um manifesto portátil, sem segredos, ou importe um de um colega de equipe. Os valores de variáveis de ambiente secretas nunca são incluídos ou importados.',
  'mcp.inventory.close': 'Fechar painel de inventário',
  'mcp.inventory.tablistAria': 'Seções de inventário',
  'mcp.inventory.tab.export': 'Exportar',
  'mcp.inventory.tab.import': 'Importar',
  'mcp.inventory.export.empty':
    'Nenhum servidor MCP instalado ainda: nada para exportar. Instale um a partir do catálogo primeiro.',
  'mcp.inventory.export.privacyTitle': 'O que está neste manifesto',
  'mcp.inventory.export.privacyBody':
    'Nomes de servidores, nomes qualificados, nomes de VARIÁVEIS DE AMBIENTE e apenas configurações não secretas. Valores secretos, identificadores da sua máquina e timestamps por instalação são intencionalmente removidos.',
  'mcp.inventory.export.serverCount': 'Servidores {count} neste manifesto',
  'mcp.inventory.export.copy': 'Copiar',
  'mcp.inventory.export.copied': 'Copiado',
  'mcp.inventory.export.copyAria': 'Copie o manifesto JSON para a área de transferência',
  'mcp.inventory.export.download': 'Baixar',
  'mcp.inventory.export.downloadAria': 'Baixe o manifesto como um arquivo JSON',
  'mcp.inventory.import.trustTitle': 'Trate manifests importados como código não confiável',
  'mcp.inventory.import.trustBody':
    'Um servidor MCP é uma ferramenta que você concede ao seu agente. Importe manifestos apenas de fontes em que confia. Cada instalação requer seu clique explícito; nada é instalado automaticamente.',
  'mcp.inventory.import.pasteLabel': 'Cole o manifesto JSON',
  'mcp.inventory.import.pastePlaceholder':
    'Cole um manifesto aqui ou envie um arquivo.json abaixo.',
  'mcp.inventory.import.preview': 'Visualizar',
  'mcp.inventory.import.clear': 'Claro',
  'mcp.inventory.import.uploadFile': 'ou envie um arquivo.json',
  'mcp.inventory.import.uploadFileAria': 'Carregar um arquivo manifest.json',
  'mcp.inventory.import.fileTooLarge':
    'O arquivo é muito grande (mais de 1 MB). Recusando-se a carregar.',
  'mcp.inventory.import.fileReadFailed': 'Não foi possível ler o arquivo.',
  'mcp.inventory.import.parseErrorPrefix': 'Não foi possível analisar o manifesto:',
  'mcp.inventory.import.previewHeading': 'Visualizar',
  'mcp.inventory.import.previewCounts':
    'Servidores {total}: {newly} novos, {already} já instalados',
  'mcp.inventory.import.previewEmpty': 'O manifesto não contém servidores.',
  'mcp.inventory.import.exportedFrom': 'Exportado de {exporter}',
  'mcp.inventory.import.exportedAt': 'em {when}',
  'mcp.inventory.import.statusNew': 'Novo',
  'mcp.inventory.import.statusAlreadyInstalled': 'Já instalado',
  'mcp.inventory.import.envKeysLabel': 'Chaves de ambiente',
  'mcp.inventory.import.install': 'Instalar',
  'mcp.inventory.import.installAria': 'Instale {name} a partir deste manifesto',
  'mcp.inventory.import.skipped': 'ignorado',
  'mcp.inventory.parseError.empty': 'Manifesto está vazio.',
  'mcp.inventory.parseError.invalidJson': 'JSON inválido.',
  'mcp.inventory.parseError.rootNotObject': 'O manifesto deve ser um objeto JSON na raiz.',
  'mcp.inventory.parseError.unsupportedSchema':
    'Esquema de manifesto não suportado: este arquivo não foi produzido por um exportador compatível.',
  'mcp.inventory.parseError.missingExportedAt': 'Campo `exported_at` ausente ou inválido.',
  'mcp.inventory.parseError.missingExportedBy': 'Campo `exported_by` ausente ou inválido.',
  'mcp.inventory.parseError.invalidServers': 'Array `servers` ausente ou inválido.',
  'mcp.inventory.parseError.serverNotObject': 'Uma entrada de servidor não é um objeto.',
  'mcp.inventory.parseError.serverMissingQualifiedName':
    'Uma entrada de servidor está sem seu qualified_name.',
  'mcp.inventory.parseError.serverMissingDisplayName':
    'Uma entrada de servidor está sem seu display_name.',
  'mcp.inventory.parseError.serverEnvKeysNotArray':
    'Uma entrada de servidor possui um campo env_keys que não é um array de strings.',
  'mcp.inventory.parseError.serverContainsEnv':
    'Uma entrada de servidor contém um mapa de valores `env`. Recusando importar: os manifests devem conter apenas env_keys (nomes), nunca valores secretos.',
  'mcp.inventory.parseError.duplicateQualifiedName':
    'Nome_qualificado duplicado encontrado no manifesto. Cada servidor deve aparecer no máximo uma vez.',
  'mcp.tab.loading': 'Carregando servidores MCP...',
  'mcp.tab.emptyDetail': 'Selecione um servidor ou navegue no catálogo.',
  'mcp.tab.filter.all': 'Todos',
  'mcp.tab.filter.installed': 'Instalados ({count})',
  'mcp.tab.filter.registry': 'Registro',
  'mcp.tab.column.name': 'Nome',
  'mcp.tab.column.description': 'Descrição',
  'mcp.tab.column.type': 'Tipo',
  'mcp.tab.column.author': 'Autor',
  'mcp.tab.column.action': 'Ação',
  'mcp.tab.transport.hosted': 'Hospedado',
  'mcp.tab.transport.local': 'Stdio',
  'mcp.tab.transportFilter.label': 'Tipo',
  'mcp.tab.transportFilter.aria': 'Filtrar servidores por transporte',
  'mcp.tab.link.website': 'Site',
  'mcp.tab.link.repo': 'Repositório',
  'mcp.tab.transport.hostedHint':
    'Executa em um servidor remoto: login ou token é configurado ao instalar',
  'mcp.tab.transport.localHint':
    'Executa no seu dispositivo: pode precisar de um token ao instalar',
  'mcp.tab.officialBadge': 'Oficial',
  'mcp.tab.officialHint': 'Servidor oficial do fornecedor',
  'mcp.tab.badge.installed': 'Instalado',
  'mcp.tab.badge.registry': 'Registro',
  'mcp.tab.action.manage': 'Gerenciar',
  'mcp.tab.aria.viewDetails': 'Ver detalhes de {name}',
  'mcp.tab.aria.installServer': 'Instalar {name}',
  'mcp.install.loadingDetail': 'Carregando detalhes do servidor...',
  'mcp.install.back': 'Voltar',
  'mcp.install.title': 'Instalar {name}',
  'mcp.install.requiredEnv': 'Variáveis de ambiente necessárias',
  'mcp.install.enterValue': 'Digite {key}',
  'mcp.install.show': 'Mostrar',
  'mcp.install.hide': 'Ocultar',
  'mcp.install.configLabel': 'Configuração (JSON opcional)',
  'mcp.install.configPlaceholder': '{"key": "value"}',
  'mcp.install.missingRequired': '"{key}" é obrigatório',
  'mcp.install.invalidJson': 'JSON de configuração não é JSON válido',
  'mcp.install.failedDetail': 'Falha ao carregar detalhes do servidor',
  'mcp.install.failedInstall': 'Falha na instalação',
  'mcp.install.button': 'Instalação',
  'mcp.install.installing': 'Instalando...',
  'mcp.install.by': 'por',
  'mcp.install.useCount': '{count} instalações',
  'mcp.install.connections': 'Conexões disponíveis',
  'mcp.install.published': 'publicado',
  'mcp.install.configureAndInstall': 'Configurar e instalar',
  'mcp.install.configureTitle': 'Configurar {name}',
  'mcp.install.advancedConfig': 'Configuração avançada',
  'mcp.detail.suggestedEnvReady': 'Valores de ambiente sugeridos prontos',
  'mcp.detail.suggestedEnvBody':
    'Reinstale este servidor com os valores sugeridos para aplicá-los: {keys}',
  'mcp.detail.connect': 'Conectar',
  'mcp.detail.connecting': 'Conectando...',
  'mcp.detail.authenticate': 'Entrar',
  'mcp.detail.authRequired':
    'Este servidor exige que você entre ou adicione um token de acesso antes de poder se conectar. Clique em “Entrar” para autenticar.',
  'mcp.detail.disconnect': 'Desconectar',
  'mcp.detail.hideAssistant': 'Ocultar assistente',
  'mcp.detail.helpConfigure': 'Ajude-me a configurar',
  'mcp.detail.confirmUninstall': 'Confirmar desinstalação?',
  'mcp.detail.confirmUninstallAction': 'Sim, desinstalar',
  'mcp.detail.uninstall': 'Desinstalar',
  'mcp.detail.envVars': 'Variáveis de ambiente',
  'mcp.detail.reconfigure': 'Reconfigurar',
  'mcp.detail.reconfigureHint':
    'Insira novos valores para cada variável e reconecte. Isso substitui os valores armazenados.',
  'mcp.detail.saveReconnect': 'Salvar e reconectar',
  'mcp.detail.reconfigureSaving': 'Salvando…',
  'mcp.detail.reconfigureSuccess': 'Ambiente atualizado e reconectado.',
  'mcp.detail.reconfigureReconnectFailed': 'Salvo, mas a reconexão com os novos valores falhou.',
  'mcp.detail.enable': 'Ativar',
  'mcp.detail.disable': 'Desativar',
  'mcp.status.disabled': 'Desativado',
  'mcp.status.unauthorized': 'É necessário entrar',
  'mcp.detail.tools': 'Ferramentas',
  'mcp.connectAuth.title': 'Conectar {name}',
  'mcp.connectAuth.hint':
    'Adicione a autenticação que este servidor exige e, em seguida, conecte. Os tokens são armazenados criptografados. Deixe em branco para servidores que não precisam de autenticação.',
  'mcp.connectAuth.requiredLabel': 'Obrigatório',
  'mcp.connectAuth.customHeadersLabel': 'Cabeçalhos personalizados',
  'mcp.connectAuth.customHeadersEmpty':
    'Nenhum cabeçalho personalizado. Adicione um se este servidor precisar de um cabeçalho de autenticação que o registro não declarou.',
  'mcp.connectAuth.addHeader': '+ Adicionar cabeçalho',
  'mcp.connectAuth.headerName': 'Nome do cabeçalho',
  'mcp.connectAuth.headerValue': 'Valor',
  'mcp.connectAuth.removeHeader': 'Remover cabeçalho',
  'mcp.connectAuth.howToGetToken': 'Ajuda e configuração',
  'mcp.connectAuth.tokenProvider': 'Obtenha seu token em:',
  'mcp.connectAuth.findToken': 'Onde obtenho o token?',
  'mcp.connectAuth.hideHelp': 'Ocultar ajuda',
  'mcp.connectAuth.schemeLabel': 'Como enviar o valor',
  'mcp.connectAuth.schemeBearer': 'Bearer',
  'mcp.connectAuth.schemeRaw': 'Nenhum',
  'mcp.connectAuth.reconnectFailed': 'As credenciais foram salvas, mas a conexão falhou.',
  'mcp.connectAuth.oauthHint':
    'Este servidor usa OAuth. Entre pelo seu navegador para autorizar o OpenHuman.',
  'mcp.connectAuth.signIn': 'Entrar com o navegador',
  'mcp.connectAuth.oauthWaiting': 'Aguardando o login…',
  'mcp.connectAuth.oauthOrToken':
    'Já tem um token de acesso? Cole-o abaixo como cabeçalho Authorization.',
  'mcp.connectAuth.oauthTimeout':
    'Tempo esgotado aguardando o login no navegador. Tente novamente.',
  'mcp.connectAuth.authError.oauthRequired':
    'Este servidor usa OAuth. Use “Entrar com o navegador”: um token colado não será aceito.',
  'mcp.connectAuth.authError.tokenRejected':
    'O servidor rejeitou este token. Verifique se está correto e se não expirou.',
  'mcp.connectAuth.authError.credentialRequired':
    'Este servidor requer autenticação. Adicione um token ou entre.',
  'onboarding.skipForNow': 'Ignorar por agora',
  'onboarding.localAI.continueWithCloud': 'Continuar com a nuvem',
  'onboarding.localAI.useLocalAnyway':
    'Usar IA local mesmo assim (não recomendado para este dispositivo)',
  'onboarding.localAI.useLocalInstead': 'Use IA local (conecte Ollama agora)',
  'onboarding.localAI.setupIssue': 'A configuração de IA local encontrou um problema',
  'autonomy.title': 'Autonomia do agente',
  'autonomy.maxActionsLabel': 'Máximo de ações por hora',
  'autonomy.maxActionsHelp':
    'Número máximo de ações de ferramentas que um agente pode executar por hora corrida. O novo valor se aplica ao próximo chat. Cron jobs e ouvintes de canais mantêm o limite atual até você reiniciar o OpenHuman.',
  'autonomy.statusSaving': 'Salvando…',
  'autonomy.statusSaved': 'Salvo.',
  'autonomy.statusFailed': 'Falha',
  'autonomy.unlimitedNote': 'Ilimitado: limitação de taxa desativada.',
  'autonomy.invalidIntegerMsg':
    'Deve ser um número inteiro positivo (use o preset Ilimitado para sem limite).',
  'autonomy.presetUnlimited': 'Ilimitado (padrão)',
  'triggers.toggleFailed': '{action} falhou para {trigger}: {message}',
  'settings.ai.overview': 'Visão Geral do Sistema de IA',
  'settings.ai.configStatus': 'Status da Configuração',
  'settings.ai.fallbackMode': 'Modo de Fallback',
  'settings.ai.loadedFromRuntime': 'Carregado do Runtime',
  'settings.ai.loadingDuration': 'Duração do Carregamento',
  'settings.ai.localRuntime': 'Runtime do Modelo Local',
  'settings.ai.openManager': 'Abrir Gerenciador',
  'settings.ai.retryDownload': 'Tentar Download Novamente',
  'settings.ai.state': 'Estado',
  'settings.ai.targetModel': 'Modelo Alvo',
  'settings.ai.download': 'Baixar',
  'settings.ai.localModelUnavailable': 'Status do modelo local indisponível.',
  'settings.ai.soulConfig': 'Configuração de Persona SOUL',
  'settings.ai.refreshing': 'Atualizando...',
  'settings.ai.refreshSoul': 'Atualizar SOUL',
  'settings.ai.loadingSoul': 'Carregando configuração SOUL...',
  'settings.ai.identity': 'Identidade',
  'settings.ai.personality': 'Personalidade',
  'settings.ai.safetyRules': 'Regras de Segurança',
  'settings.ai.source': 'Fonte',
  'settings.ai.loaded': 'Carregado',
  'settings.ai.toolsConfig': 'Configuração de FERRAMENTAS',
  'settings.ai.refreshTools': 'Atualizar FERRAMENTAS',
  'settings.ai.toolsAvailable': 'Ferramentas Disponíveis',
  'settings.ai.tools': 'ferramentas',
  'settings.ai.activeSkills': 'Habilidades Ativas',
  'settings.ai.skills': 'habilidades',
  'settings.ai.skillsOverview': 'Visão Geral das Habilidades',
  'settings.ai.refreshingAll': 'Atualizando Tudo...',
  'settings.ai.refreshAll': 'Atualizar Toda a Configuração de IA',
  'settings.notifications.suppressAll': 'Suprimir todas as notificações',
  'settings.notifications.suppressAllDesc':
    'Bloquear todos os avisos de notificação do SO de apps incorporados independentemente do estado de foco.',
  'settings.notifications.toggleDnd': 'Ativar/Desativar Não Perturbe',
  'settings.notifications.categories': 'Categorias',
  'settings.notifications.categoryFooter':
    'Desativar uma categoria impede que novas notificações desse tipo apareçam na central de notificações. As notificações existentes permanecem até serem limpas.',
  'settings.billing.movedToWeb': 'Cobrança movida para a web',
  'settings.billing.openDashboard': 'Abrir painel de cobrança',
  'settings.billing.movedToWebDesc':
    'Alterações de assinatura, métodos de pagamento, créditos e faturas agora são gerenciados no TinyHumans na web.',
  'settings.billing.backToSettings': 'Voltar às configurações',
  'settings.billing.openingBrowser': 'Abrindo seu navegador...',
  'settings.billing.browserNotOpen': 'Se seu navegador não abriu, use o botão acima.',
  'settings.billing.browserOpenFailed':
    'O navegador não pôde ser aberto automaticamente. Use o botão acima.',
  'settings.tools.chooseCapabilities':
    'Escolha quais funcionalidades o OpenHuman pode usar em seu nome.',
  'settings.tools.saveChanges': 'Salvar Alterações',
  'settings.tools.preferencesSaved': 'Preferências salvas',
  'settings.tools.saveFailed': 'Falha ao salvar preferências. Tente novamente.',
  'connections.comingSoon': 'Em breve',
  'connections.setUp': 'Configurar',
  'connections.configured': 'Configurado',
  'connections.unavailable': 'Indisponível',
  'connections.checking': 'Verificando…',
  'connections.walletConfigured':
    'Identidades locais de EVM, BTC, Solana e Tron estão configuradas a partir da sua frase de recuperação.',
  'connections.walletReady':
    'Configure identidades locais de EVM, BTC, Solana e Tron a partir de uma única frase de recuperação.',
  'connections.walletError':
    'Não foi possível verificar o status da carteira. Toque para tentar novamente no painel de Frase de Recuperação.',
  'connections.walletChecking': 'Verificando status da carteira...',
  'connections.walletIdentities': 'Identidades de carteira',
  'connections.walletDerived':
    'Derivado localmente da sua frase de recuperação e armazenado apenas como metadados seguros.',
  'connections.privacySecurity': 'Privacidade e Segurança',
  'connections.privacySecurityDesc':
    'Todos os dados e credenciais são armazenados localmente com política de retenção zero. Suas informações são criptografadas e nunca compartilhadas com terceiros.',
  'channels.status.connecting': 'Conectando',
  'channels.status.notConfigured': 'Não configurado',
  'channels.noActiveRoute': 'Nenhuma rota ativa',
  'channels.activeRoute': 'Rota ativa',
  'channels.loadingDefinitions': 'Carregando definições de canal...',
  'channels.channelConnections': 'Conexões de Canal',
  'channels.configureAuthModes': 'Configure modos de autenticação para cada canal de mensagens.',
  'channels.configNotAvailable': 'Configuração para',
  'channels.channel': 'canal',
  'devOptions.coreModeNotSet': 'Modo do core: não definido',
  'devOptions.coreModeNotSetDesc':
    'O seletor de verificação de inicialização ainda não foi confirmado. Use Trocar modo no seletor para escolher Local ou Cloud.',
  'devOptions.local': 'Local',
  'devOptions.embeddedCoreSidecar': 'Core sidecar incorporado',
  'devOptions.sidecarSpawned': 'Iniciado em processo pelo shell Tauri na abertura do app.',
  'devOptions.cloud': 'Nuvem',
  'devOptions.remoteCoreRpc': 'RPC do core remoto',
  'devOptions.token': 'Token',
  'devOptions.tokenNotSet': 'não definido: RPC retornará 401',
  'devOptions.triggerSentryTest': 'Disparar Teste do Sentry (staging)',
  'devOptions.triggerSentryTestDesc':
    'Envia um erro marcado para verificar o pipeline do Sentry. Issue #1072: remover após verificação.',
  'devOptions.sendTestEvent': 'Enviar evento de teste',
  'devOptions.sending': 'Enviando…',
  'devOptions.eventSent': 'Evento enviado',
  'devOptions.sentryDisabled': '(sem id - Sentinela desabilitada nesta compilação)',
  'devOptions.failed': 'Falhou',
  'devOptions.appLogs': 'Logs do app',
  'devOptions.appLogsDesc':
    'Abrir a pasta com os arquivos de log diários rotativos. Anexe o arquivo mais recente ao reportar um problema.',
  'devOptions.openLogsFolder': 'Abrir pasta de logs',
  'mnemonic.phraseSaved': 'Frase de recuperação salva',
  'mnemonic.walletReady':
    'Identidades de carteira multi-chain estão prontas. Retornando às configurações...',
  'mnemonic.writeDownWords': 'Anote estas',
  'mnemonic.wordsInOrder':
    'palavras em ordem e guarde-as em um lugar seguro. Esta frase protege sua chave de criptografia local e suas identidades de carteira EVM, BTC, Solana e Tron.',
  'mnemonic.cannotRecover':
    'Esta frase nunca poderá ser recuperada se perdida e deve permanecer totalmente local no seu dispositivo.',
  'mnemonic.copyToClipboard': 'Copiar para Área de Transferência',
  'mnemonic.alreadyHavePhrase': 'Já tenho uma frase de recuperação',
  'mnemonic.consentSaved':
    'Salvei esta frase e concordo em usá-la para configuração da carteira local',
  'mnemonic.enterPhraseToRestore':
    'Insira sua frase de recuperação abaixo para restaurar suas identidades de carteira local, ou cole a frase completa em qualquer campo (12 palavras para novos backups; frases de 24 palavras de versões mais antigas ainda funcionam).',
  'mnemonic.words': 'Palavras',
  'mnemonic.validPhrase': 'Frase de recuperação válida',
  'mnemonic.generateNewPhrase': 'Gerar uma nova frase de recuperação',
  'mnemonic.securingData': 'Protegendo Seus Dados...',
  'mnemonic.saveRecoveryPhrase': 'Salvar Frase de Recuperação',
  'mnemonic.userNotLoaded':
    'Usuário não carregado. Por favor, faça login novamente ou atualize a página.',
  'mnemonic.invalidPhrase':
    'Frase de recuperação inválida. Verifique as palavras e tente novamente.',
  'mnemonic.somethingWentWrong': 'Algo deu errado. Por favor, tente novamente.',
  'mnemonic.walletAlreadyConfigured': 'Sua carteira já está configurada.',
  'mnemonic.walletSource': 'Fonte',
  'mnemonic.walletWordCount': 'Comprimento da frase de recuperação',
  'mnemonic.walletLastUpdated': 'Última atualização',
  'mnemonic.replaceWallet': 'Substituir carteira',
  'mnemonic.replaceWalletWarning':
    'Isso substituirá permanentemente sua carteira atual. Certifique-se de ter feito backup da sua frase de recuperação antes de prosseguir.',
  'mnemonic.replaceWalletConfirm': 'Entendo, substituir minha carteira',
  'mnemonic.loadingWalletStatus': 'Verificando status da carteira...',
  'mnemonic.viewAccounts': 'Contas da carteira',
  'mnemonic.revealRecoveryPhrase': 'Revelar frase de recuperação',
  'mnemonic.hidePhrase': 'Ocultar frase',
  'team.failedToCreate': 'Falha ao criar equipe',
  'team.invalidInviteCode': 'Código de convite inválido ou expirado',
  'team.failedToSwitch': 'Falha ao trocar de equipe',
  'team.failedToLeave': 'Falha ao sair da equipe',
  'team.role.owner': 'Proprietário',
  'team.role.admin': 'Administrador',
  'team.role.billingManager': 'Gerente de Cobrança',
  'team.role.member': 'Membro',
  'team.active': 'Ativo',
  'team.personalTeam': 'Equipe pessoal',
  'team.manageTeam': 'Gerenciar Equipe',
  'team.switching': 'Trocando...',
  'team.switch': 'Trocar',
  'team.leaving': 'Saindo...',
  'team.leave': 'Sair',
  'team.yourTeams': 'Suas Equipes',
  'team.createNewTeam': 'Criar Nova Equipe',
  'team.teamName': 'Nome da equipe',
  'team.creating': 'Criando...',
  'team.joinExistingTeam': 'Entrar em Equipe Existente',
  'team.personalAutoCreatedNote':
    'Sua equipe pessoal é criada automaticamente. Para colaborar, entre em uma equipe existente com um código de convite abaixo.',
  'team.inviteCode': 'Código de convite',
  'team.joining': 'Entrando...',
  'team.join': 'Entrar',
  'team.leaveTeam': 'Sair da Equipe',
  'team.confirmLeave': 'Tem certeza de que deseja sair de',
  'team.leaveWarning':
    'Você perderá o acesso à equipe e a todos os recursos da equipe. Você precisará de um novo convite para reingressar.',
  'team.management': 'Gerenciamento de Equipe',
  'team.notFound': 'Equipe não encontrada',
  'team.accessDenied': 'Acesso negado',
  'team.members': 'Membros',
  'team.membersDesc': 'Gerenciar membros e funções da equipe',
  'team.invites': 'Convites',
  'team.invitesDesc': 'Gerar e gerenciar códigos de convite',
  'team.settings': 'Configurações da equipe',
  'team.settingsDesc': 'Editar nome e configurações da equipe',
  'team.editSettings': 'Editar configurações da equipe',
  'team.enterName': 'Insira o nome da equipe',
  'team.saving': 'Salvando...',
  'team.saveChanges': 'Salvar Alterações',
  'team.delete': 'Excluir equipe',
  'team.deleteDesc': 'Excluir permanentemente esta equipe',
  'team.deleting': 'Excluindo...',
  'team.failedToUpdate': 'Falha ao atualizar equipe',
  'team.failedToDelete': 'Falha ao excluir equipe',
  'team.manageTitle': 'Gerenciar {name}',
  'team.planCreated': 'Plano {plan} • Criado {date}',
  'team.confirmDelete': 'Tem certeza de que deseja excluir {name}?',
  'team.deleteWarning':
    'Esta ação não pode ser desfeita. Todos os dados da equipe serão removidos permanentemente.',
  'voice.title': 'Ditado por Voz',
  'voice.settings': 'Configurações de Voz',
  'voice.settingsDesc':
    'Mantenha a tecla de atalho pressionada para ditar e inserir texto no campo ativo.',
  'voice.hotkey': 'Tecla de Atalho',
  'voice.activationMode': 'Modo de Ativação',
  'voice.tapToToggle': 'Toque para alternar',
  'voice.writingStyle': 'Estilo de Escrita',
  'voice.verbatimTranscription': 'Transcrição literal',
  'voice.naturalCleanup': 'Limpeza natural',
  'voice.autoStart': 'Iniciar servidor de voz automaticamente com o core',
  'voice.customDictionary': 'Dicionário Personalizado',
  'voice.customDictionaryDesc':
    'Adicione nomes, termos técnicos e palavras do domínio para melhorar a precisão do reconhecimento.',
  'voice.addWord': 'Adicionar uma palavra...',
  'voice.sttDisabled':
    'O ditado por voz está desativado até que o modelo STT local seja baixado e esteja pronto.',
  'voice.openLocalAiModel': 'Abrir Modelo de IA Local',
  'voice.serverRestarted': 'Servidor de voz reiniciado com as novas configurações.',
  'voice.settingsSaved': 'Configurações de voz salvas.',
  'voice.serverStarted': 'Servidor de voz iniciado.',
  'voice.serverStopped': 'Servidor de voz parado.',
  'voice.saveVoiceSettings': 'Salvar Configurações de Voz',
  'voice.startVoiceServer': 'Iniciar Servidor de Voz',
  'voice.stopVoiceServer': 'Parar Servidor de Voz',
  'voice.debugTitle': 'Depuração de Voz',
  'voice.failedToLoadSettings': 'Falha ao carregar configurações de voz',
  'voice.failedToSaveSettings': 'Falha ao salvar as configurações de voz',
  'voice.failedToStartServer': 'Falha ao iniciar o servidor de voz',
  'voice.failedToStopServer': 'Falha ao parar o servidor de voz',
  'voice.sttDisabledPrefix':
    'A ditação por voz está desativada até que o modelo STT local seja baixado. Use o',
  'voice.sttDisabledSuffix': 'acima para instalar o Whisper.',
  'voice.debug.failedToLoadVoiceDebugData': 'Falha ao carregar dados de depuração de voz',
  'voice.debug.settingsSaved': 'Configurações de depuração salvas.',
  'voice.debug.failedToSaveSettings': 'Falha ao salvar as configurações de voz',
  'voice.debug.runtimeStatus': 'Status do tempo de execução',
  'voice.debug.runtimeStatusDesc':
    'Diagnósticos ao vivo para o servidor de voz e o motor de reconhecimento de fala.',
  'voice.debug.server': 'Servidor',
  'voice.debug.unavailable': 'Indisponível',
  'voice.debug.ready': 'Pronto',
  'voice.debug.notReady': 'Não pronto',
  'voice.debug.hotkey': 'Tecla de atalho',
  'voice.debug.notAvailable': 'n/a',
  'voice.debug.mode': 'Modo',
  'voice.debug.transcriptions': 'Transcrições',
  'voice.debug.serverError': 'Erro de servidor',
  'voice.debug.advancedSettings': 'Configurações avançadas',
  'voice.debug.advancedSettingsDesc':
    'Parâmetros de ajuste de baixo nível para gravação e detecção de silêncio.',
  'voice.debug.minimumRecordingSeconds': 'Segundos Mínimos de Gravação',
  'voice.debug.silenceThreshold': 'Limite de Silêncio (RMS)',
  'voice.debug.silenceThresholdDesc':
    'Gravações com energia abaixo deste valor são tratadas como silêncio e ignoradas. Menor = mais sensível.',
  'voice.debug.alwaysOn': 'Escuta contínua',
  'voice.debug.alwaysOnDesc':
    'Mantém o microfone aberto e envia o que você diz ao agente automaticamente, sem atalho. Pausa quando a tela está bloqueada.',
  'voice.providers.saved': 'Provedores de voz salvos.',
  'voice.providers.failedToSave': 'Falha ao salvar provedores de voz',
  'voice.providers.ellipsis': '…',
  'voice.providers.installing': 'Instalando',
  'voice.providers.installingBusy': 'Instalando…',
  'voice.providers.reinstallLocally': 'Reinstale localmente',
  'voice.providers.repair': 'Reparar',
  'voice.providers.retryLocally': 'Tente novamente localmente',
  'voice.providers.installLocally': 'Instale localmente',
  'voice.providers.whisperReady': 'O Whisper está pronto.',
  'voice.providers.whisperInstallStarted': 'Instalação do Whisper iniciada',
  'voice.providers.queued': 'na fila',
  'voice.providers.failedToInstallWhisper': 'Falha ao instalar o Whisper',
  'voice.providers.piperReady': 'Piper está pronto.',
  'voice.providers.piperInstallStarted': 'Instalação do Piper iniciada',
  'voice.providers.failedToInstallPiper': 'Falha ao instalar o Piper',
  'voice.mode.title': 'Modo de voz',
  'voice.mode.desc': 'Escolha como o assistente fala na aba Human.',
  'voice.mode.realtime': 'Voz em tempo real (beta)',
  'voice.mode.realtimeDesc': 'Tenha uma conversa ao vivo em vez de alternar turnos.',
  'voice.mode.start': 'Iniciar chat de voz',
  'voice.mode.stop': 'Encerrar chat de voz',
  'voice.mode.connecting': 'Conectando…',
  'voice.mode.listening': 'Ouvindo',
  'voice.mode.speaking': 'Falando',
  'voice.providers.title': 'Provedores de voz',
  'voice.providers.desc':
    'Escolha onde a transcrição e a síntese são executadas. Use os botões Instalar localmente para baixar os binários e modelos no seu workspace. Os provedores locais podem ser salvos antes da conclusão da instalação: não é necessária configuração manual de WHISPER_BIN ou PIPER_BIN.',
  'voice.providers.sttProvider': 'Provedor de fala para texto',
  'voice.providers.sttProviderAria': 'Provedor STT',
  'voice.providers.cloudWhisperProxy': 'Nuvem (proxy Whisper)',
  'voice.providers.localWhisper': 'Whisper local',
  'voice.providers.installRequired': '(instalação necessária)',
  'voice.providers.whisperInstalledTitle': 'O Whisper está instalado. Clique para reinstalar.',
  'voice.providers.whisperDownloadTitle': 'Baixar o whisper.cpp e o modelo GGML no seu workspace.',
  'voice.providers.installed': 'Instalado',
  'voice.providers.installFailed': 'Falha na instalação',
  'voice.providers.notInstalled': 'Não instalado',
  'voice.providers.whisperModel': 'Modelo Whisper',
  'voice.providers.whisperModelAria': 'Modelo Whisper',
  'voice.providers.whisperModelTiny': 'Minúsculo (39 MB, mais rápido)',
  'voice.providers.whisperModelBase': 'Base (74 MB)',
  'voice.providers.whisperModelSmall': 'Pequeno (244 MB)',
  'voice.providers.whisperModelMedium': 'Médio (769 MB, recomendado)',
  'voice.providers.whisperModelLargeTurbo': 'Grande v3 Turbo (1,5 GB, melhor precisão)',
  'voice.providers.ttsProvider': 'Provedor de texto para fala',
  'voice.providers.ttsProviderAria': 'Provedor TTS',
  'voice.providers.cloudElevenLabsProxy': 'Nuvem (proxy ElevenLabs)',
  'voice.providers.localPiper': 'Piper local',
  'voice.providers.piperInstalledTitle': 'O Piper está instalado. Clique para reinstalar.',
  'voice.providers.piperDownloadTitle':
    'Baixar o Piper e a voz en_US-lessac-medium incluída no seu workspace.',
  'voice.providers.piperVoice': 'Voz Piper',
  'voice.providers.piperVoiceAria': 'Voz Piper',
  'voice.providers.customVoiceOption': 'Outro (digite abaixo)…',
  'voice.providers.customVoiceAria': 'Piper voice id (personalizado)',
  'voice.providers.customVoicePlaceholder': 'en_US-lessac-medium',
  'voice.providers.piperVoicesDesc':
    'As vozes vêm de huggingface.co/rhasspy/piper-voices. Trocar de voz pode exigir um clique em Instalar/Reinstalar para baixar o novo .onnx.',
  'voice.providers.mascotVoice': 'Voz do mascote',
  'voice.providers.mascotVoiceDescPrefix':
    'A voz ElevenLabs que o mascote usa para respostas faladas é configurada em',
  'voice.providers.mascotSettings': 'Configurações do mascote',
  'voice.providers.mascotVoiceDescSuffix': '.',
  'voice.providers.hotkeyPlaceholder': 'Fn',
  'voice.providers.piperPreset.lessacMedium': 'US · Lessac (neutro, recomendado)',
  'voice.providers.piperPreset.lessacHigh': 'EUA · Lessac (qualidade superior, maior)',
  'voice.providers.piperPreset.ryanMedium': 'EUA · Ryan (masculino)',
  'voice.providers.piperPreset.amyMedium': 'EUA · Amy (feminino)',
  'voice.providers.piperPreset.librittsHigh': 'EUA · LibriTTS (multialto-falante)',
  'voice.providers.piperPreset.alanMedium': 'GB · Alan (masculino)',
  'voice.providers.piperPreset.jennyDiocoMedium': 'GB · Jenny Dioco (feminino)',
  'voice.providers.piperPreset.northernEnglishMaleMedium': 'GB · Inglês do Norte (masculino)',
  'voice.providers.chip.cloud': 'OpenHuman (Gerenciado)',
  'voice.providers.chip.cloudAria': 'O provedor gerenciado OpenHuman está sempre ativado',
  'voice.providers.chip.whisper': 'Whisper (Local)',
  'voice.providers.chip.enableWhisper': 'Ativar Whisper STT local',
  'voice.providers.chip.disableWhisper': 'Desativar Whisper STT local',
  'voice.providers.chip.piper': 'Piper (Local)',
  'voice.providers.chip.enablePiper': 'Ativar Piper TTS local',
  'voice.providers.chip.disablePiper': 'Desativar Piper TTS local',
  'voice.providers.chip.enableProvider': 'Enable',
  'voice.providers.chip.disableProvider': 'Disable',
  'voice.providers.chip.apiKeyLabel': 'Chave de API',
  'voice.providers.chip.apiKeyPlaceholder': 'sk-…',
  'voice.providers.chip.comingSoon': 'em breve',
  'voice.modal.title': 'Configure',
  'voice.modal.desc':
    'Insira sua chave de API para ativar este provedor. Você pode testar a conexão antes de salvar.',
  'voice.modal.testKey': 'Testar Chave',
  'voice.modal.testing': 'Testando…',
  'voice.modal.saveAndEnable': 'Salvar e Ativar',
  'voice.modal.enable': 'Enable',
  'voice.modal.whisperDesc':
    'Escolha um tamanho de modelo e instale o binário Whisper e o modelo GGML no seu workspace. Modelos maiores são mais precisos, porém mais lentos.',
  'voice.modal.piperDesc':
    'Escolha uma voz e instale o binário Piper e o modelo ONNX no seu workspace. O Piper funciona completamente offline com baixa latência.',
  'voice.routing.title': 'Roteamento de Voz',
  'voice.routing.desc':
    'Escolha quais provedores habilitados lidam com reconhecimento e síntese de fala.',
  'voice.routing.save': 'Save',
  'voice.routing.testStt': 'Testar STT',
  'voice.routing.testTts': 'Testar TTS',
  'voice.routing.elevenlabsVoice': 'Voz ElevenLabs',
  'voice.routing.elevenlabsVoiceAria': 'Seleção de voz ElevenLabs',
  'voice.routing.elevenlabsVoiceIdAria': 'ID de voz ElevenLabs (personalizado)',
  'voice.routing.elevenlabsVoiceDesc':
    'Escolha uma voz selecionada ou cole um ID de voz personalizado do seu painel ElevenLabs.',
  'voice.externalProviders.title': 'Provedores de Voz Externos',
  'voice.externalProviders.desc':
    'Conecte APIs de STT/TTS de terceiros como Deepgram, ElevenLabs ou OpenAI diretamente.',
  'voice.externalProviders.keySet': 'Chave definida',
  'voice.externalProviders.noKey': 'Sem chave de API',
  'voice.externalProviders.test': 'Test',
  'voice.externalProviders.testing': 'Testando…',
  'voice.externalProviders.remove': 'Remove',
  'voice.externalProviders.provider': 'Provider',
  'voice.externalProviders.selectProvider': 'Selecione um provedor…',
  'voice.externalProviders.apiKey': 'Chave de API',
  'voice.externalProviders.apiKeyPlaceholder': 'sk-…',
  'voice.externalProviders.add': 'Add',
  'pttSettings.title': 'Pressionar para falar',
  'pttSettings.description':
    'Mantenha uma tecla pressionada para falar com o OpenHuman enquanto está noutro aplicativo. Soltar a tecla envia o áudio; se «Ler respostas em voz alta» estiver ativo, o OpenHuman lê a resposta.',
  'pttSettings.shortcutLabel': 'Atalho',
  'pttSettings.shortcutPlaceholder': 'Pressione uma tecla (por exemplo, F13)',
  'pttSettings.shortcutUnsetHint':
    'Pressionar para falar está desligado: escolha um atalho para ativar.',
  'pttSettings.speakRepliesLabel': 'Ler as respostas do agente em voz alta',
  'pttSettings.showOverlayLabel': 'Mostrar a sobreposição enquanto a tecla está pressionada',
  'pttSettings.errorConflictsWithDictation':
    'Este atalho já é usado pelo ditado. Escolha uma tecla diferente.',
  'pttSettings.errorModifierOnly':
    'Escolha uma tecla normal (por exemplo, F13): atalhos apenas com modificadores não funcionam para pressionar para falar.',
  'pttSettings.errorEmpty': 'Escolha uma tecla para vincular.',
  'pttSettings.errorAccessibility':
    'O macOS precisa de permissão de Acessibilidade para este atalho. Abra Ajustes do Sistema → Privacidade e Segurança → Acessibilidade e ative o OpenHuman.',
  'pttSettings.errorShortcutInUse': 'Outro aplicativo já está a usar este atalho. Escolha outro.',
  'pttSettings.errorUnsupportedWayland':
    'As sessões Wayland ainda não suportam atalhos globais no OpenHuman: mude para uma sessão X11 ou use o controlo de ditado integrado no aplicativo.',
  'pttSettings.exclusiveFullscreenHint':
    'Em jogos no modo de ecrã inteiro exclusivo a sobreposição não será apresentada: só ouvirá o aviso sonoro. Mude para ecrã inteiro sem margens para ver a sobreposição.',
  'pttOverlay.listening': 'A escutar…',
  'pttOverlay.idle': 'Inativo',
  'chat.agentChat': 'Chat com Agente',
  'chat.overrides': 'Substituições',
  'chat.model': 'Modelo',
  'chat.temperature': 'Temperatura',
  'chat.conversation': 'Conversa',
  'chat.startAgentConversation': 'Inicie uma conversa com o agente.',
  'chat.you': 'Você',
  'chat.agent': 'Agente',
  'chat.askAgent': 'Pergunte qualquer coisa ao agente...',
  'chat.sendMessage': 'Enviar Mensagem',
  'composio.triageTitle': 'Gatilhos de Integração',
  'composio.triageDesc':
    'Quando ativo, cada gatilho Composio recebido passa por uma etapa de triagem de IA que classifica o evento e pode iniciar ações automatizadas: um turno de LLM local por gatilho. Desative globalmente ou por integração se preferir revisão manual. Se a variável de ambiente',
  'composio.disableAllTriage': 'Desativar triagem de IA para todos os gatilhos',
  'composio.triggersStillRecorded':
    'Os gatilhos ainda são registrados no histórico: nenhum turno de LLM é executado.',
  'composio.disableSpecificIntegrations': 'Desativar triagem de IA para integrações específicas',
  'composio.settingsSaved': 'Configurações salvas',
  'composio.saveFailed': 'Falha ao salvar. Tente novamente.',
  'cron.title': 'Tarefas Cron',
  'cron.scheduledJobs': 'Tarefas Agendadas',
  'cron.manageCronJobs': 'Gerenciar tarefas cron do agendador do core.',
  'cron.refreshCronJobs': 'Atualizar Tarefas Cron',
  'localModel.modelStatus': 'Status do Modelo',
  'localModel.downloadModels': 'Baixar Modelos',
  'localModel.usage': 'Uso',
  'localModel.usageDesc':
    'Escolha quais subsistemas rodam no modelo local. O que estiver desligado usa a nuvem.',
  'localModel.enableRuntime': 'Ativar runtime de IA local',
  'localModel.enableRuntimeDesc':
    'Chave mestre. Desligado por padrão: Ollama fica inativo. Quando ligado, o sumarizador de árvore, inteligência de tela e autocompletar sempre usam o modelo local.',
  'localModel.advancedSettings': 'Configurações avançadas',
  'localModel.debugTitle': 'Depuração de Modelo Local',
  'memory.debugTitle': 'Depuração de Memória',
  'memory.documents': 'Documentos',
  'memory.filterByNamespace': 'Filtrar por namespace...',
  'memory.refresh': 'Atualizar',
  'memory.noDocumentsFound': 'Nenhum documento encontrado.',
  'memory.delete': 'Excluir',
  'memory.rawResponse': 'Resposta bruta',
  'memory.namespaces': 'Namespaces',
  'memory.noNamespacesFound': 'Nenhum namespace encontrado.',
  'memory.queryRecall': 'Consultar e recuperar',
  'memory.namespace': 'Namespace',
  'memory.queryText': 'Texto da consulta...',
  'memory.defaultMaxChunks': '10',
  'memory.maxChunks': 'máximo de pedaços',
  'memory.query': 'Consulta',
  'memory.recall': 'Recuperar',
  'memory.queryLabel': 'Consulta',
  'memory.recallLabel': 'Recuperar',
  'memory.queryResult': 'Resultado da consulta',
  'memory.recallResult': 'Resultado de recuperação',
  'memory.clearNamespace': 'Limpar Namespace',
  'memory.clearNamespaceDescription':
    'Excluir permanentemente todos os documentos dentro de um namespace.',
  'memory.selectNamespace': 'Selecione o namespace...',
  'memory.exampleNamespace': 'por exemplo. habilidade:gmail:user@example.com',
  'memory.clear': 'Limpar',
  'memory.deleteConfirm': 'Excluir documento "{documentId}" no namespace "{namespace}"?',
  'memory.clearNamespaceConfirm':
    'Isso excluirá permanentemente TODOS os documentos no namespace "{namespace}". Continuar?',
  'memory.clearNamespaceSuccess': 'Namespace "{namespace}" limpo.',
  'memory.clearNamespaceEmpty': 'Nada a limpar em "{namespace}".',
  'webhooks.debugTitle': 'Depuração de Webhooks',
  'webhooks.failedToLoadDebugData': 'Falha ao carregar dados de depuração de webhook',
  'webhooks.clearLogsConfirm': 'Limpar todos os logs de depuração de webhook capturados?',
  'webhooks.failedToClearLogs': 'Falha ao limpar logs de webhook',
  'webhooks.loading': 'Carregando...',
  'webhooks.refresh': 'Atualizar',
  'webhooks.clearing': 'Limpando...',
  'webhooks.clearLogs': 'Limpar logs',
  'webhooks.registered': 'registrou',
  'webhooks.captured': 'capturado',
  'webhooks.live': 'ao vivo',
  'webhooks.disconnected': 'desconectado',
  'webhooks.lastEvent': 'Último evento',
  'webhooks.at': 'em',
  'webhooks.registeredWebhooks': 'Webhooks registrados',
  'webhooks.noActiveRegistrations': 'Nenhum registro ativo.',
  'webhooks.resolvingBackendUrl': 'Resolvendo back-end URL…',
  'webhooks.capturedRequests': 'Solicitações capturadas',
  'webhooks.noRequestsCaptured': 'Nenhuma solicitação de webhook capturada ainda.',
  'webhooks.unrouted': 'não roteado',
  'webhooks.pending': 'pendente',
  'webhooks.requestHeaders': 'Cabeçalhos de solicitação',
  'webhooks.queryParams': 'Parâmetros de consulta',
  'webhooks.requestBody': 'Corpo da solicitação',
  'webhooks.responseHeaders': 'Cabeçalhos de resposta',
  'webhooks.responseBody': 'Corpo de resposta',
  'webhooks.rawPayload': 'Carga útil bruta',
  'webhooks.empty': '[vazio]',
  'providerSetup.error.defaultDetails': 'Falha na configuração do provedor.',
  'providerSetup.error.providerFallback': 'O provedor',
  'providerSetup.error.credentialsRejected':
    '{provider} rejeitou as credenciais. Verifique a chave de API e tente novamente.',
  'providerSetup.error.endpointNotRecognized':
    '{provider} não reconheceu o endpoint. Verifique a URL base e tente novamente.',
  'providerSetup.error.providerUnavailable':
    '{provider} está indisponível no momento. Tente novamente ou verifique o status do provedor.',
  'providerSetup.error.unreachable':
    'Não foi possível alcançar {provider}. Verifique a URL do endpoint e a conexão de rede, e tente novamente.',
  'providerSetup.error.couldNotReachWithMessage': 'Não foi possível alcançar {provider}: {message}',
  'providerSetup.error.technicalDetails': 'Detalhes técnicos',
  'notifications.routingTitle': 'Roteamento de Notificações',
  'notifications.routing.pipelineStats': 'Estatísticas de pipeline',
  'notifications.routing.total': 'Total',
  'notifications.routing.unread': 'Não lido',
  'notifications.routing.unscored': 'Sem pontuação',
  'notifications.routing.intelligenceTitle': 'Inteligência de notificação',
  'notifications.routing.intelligenceDesc':
    'Cada notificação das suas contas conectadas é avaliada por um modelo de IA local. Notificações de alta importância são roteadas automaticamente para o seu agente orquestrador para que nada crítico passe despercebido.',
  'notifications.routing.howItWorks': 'Como funciona',
  'notifications.routing.level.drop': 'Eliminar',
  'notifications.routing.level.dropDesc': 'Ruído / spam - armazenado, mas não descoberto',
  'notifications.routing.level.acknowledge': 'Reconhecer',
  'notifications.routing.level.acknowledgeDesc':
    'Baixa prioridade: exibida na central de notificações',
  'notifications.routing.level.react': 'React',
  'notifications.routing.level.reactDesc': 'Média prioridade: aciona uma resposta focada do agente',
  'notifications.routing.level.escalate': 'Escalar',
  'notifications.routing.level.escalateDesc': 'Alta prioridade: encaminhada ao agente orquestrador',
  'notifications.routing.perProvider': 'Roteamento por provedor',
  'notifications.routing.threshold': 'Limite',
  'notifications.routing.routeToOrchestrator': 'Rota para o orquestrador',
  'notifications.routing.loadSettingsError':
    'Falha ao carregar as configurações. Reabra este painel para tentar novamente.',
  'common.reload': 'Recarregar',
  'common.skip': 'Pular',
  'common.disable': 'Desativar',
  'common.enable': 'Ativar',
  'chat.safetyTimeout':
    'Nenhuma resposta do agente após 2 minutos. Tente novamente ou verifique sua conexão.',
  'chat.filter.general': 'Geral',
  'chat.filter.subconscious': 'Subconsciente',
  'chat.filter.meetings': 'Reuniões',
  'chat.filter.tasks': 'Tarefas',
  'chat.selectThread': 'Selecione uma conversa',
  'chat.threads': 'Conversas',
  'chat.noThreads': 'Nenhuma conversa ainda',
  'chat.noLabelThreads': 'Nenhuma conversa "{label}"',
  'chat.deleteThread': 'Excluir conversa',
  'chat.deleteThreadConfirm': 'Tem certeza de que deseja excluir "{title}"?',
  'chat.untitledThread': 'Conversa sem título',
  'chat.editThreadTitle': 'Editar título da conversa',
  'chat.hideSidebar': 'Ocultar barra lateral',
  'chat.showSidebar': 'Mostrar barra lateral',
  'chat.searchThreads': 'Pesquisar conversas',
  'layout.resizeSidebar': 'Redimensionar barra lateral',
  'layout.showSidebar': 'Mostrar barra lateral',
  'chat.newThreadShortcut': 'Nova conversa (/new)',
  'chat.new': 'Nova',
  'chat.failedToLoadMessages': 'Falha ao carregar mensagens',
  'chat.thinkingIteration': 'Pensando... ({n})',
  'chat.thinkingDots': 'Pensando...',
  'chat.approachingLimit': 'Aproximando-se do limite de uso',
  'chat.approachingLimitMsg': 'Você usou {pct}% da sua cota disponível.',
  'chat.upgrade': 'Fazer upgrade',
  'chat.weeklyLimitHit': 'Você atingiu seu limite semanal.',
  'chat.resets': 'Reinicia',
  'chat.topUpToContinue': 'Adicione créditos para continuar.',
  'chat.budgetComplete':
    'Seu orçamento incluído foi esgotado. Adicione créditos ou faça upgrade para continuar.',
  'chat.topUp': 'Adicionar Créditos',
  'chat.cycle': 'Ciclo',
  'chat.cycleSpent': 'Gasto neste ciclo',
  'chat.cycleRemaining': 'Restante',
  'chat.left': 'restante',
  'chat.setup': 'Configurar',
  'chat.switchToText': 'Mudar para texto',
  'chat.superContext.label': 'Supercontexto',
  'chat.superContext.hint':
    'O Supercontexto permite que o OpenHuman reúna e prepare contexto a partir de todos os dados a que tem acesso para oferecer uma resposta altamente relevante. O Supercontexto está em beta inicial.',
  'chat.transcribing': 'Transcrevendo...',
  'chat.stopAndSend': 'Parar e enviar',
  'chat.startTalking': 'Comece a falar',
  'chat.playingVoiceReply': 'Reproduzindo resposta de voz',
  'chat.voiceHint': 'Use o microfone para falar',
  'chat.micUnavailable': 'Microfone indisponível',
  // Chat mascot: the figure standing on the composer, and its voice stage.
  'chat.mascot.expand': 'Fale com seu assistente',
  'chat.mascot.collapse': 'Voltar para o chat',
  'chat.mascot.speakReplies': 'Ler as respostas em voz alta',
  'chat.mascot.speakRepliesHint':
    'As respostas são lidas em voz alta enquanto o mascote está aberto. Desative para manter a conversa em silêncio.',
  'chat.mascot.dismiss': 'Ocultar o Tiny',
  'chat.mascot.dismissTitle': 'Ocultar o Tiny?',
  'chat.mascot.dismissBody':
    'Sem ressentimentos se preferir a caixa de mensagem só para você. Pode trazer o Tiny de volta quando quiser em Configurações › Aparência › Chat.',
  'chat.mascot.dismissConfirm': 'Ocultar o Tiny',
  'chat.mascot.dismissCancel': 'Manter o Tiny',
  'chat.turn': 'turno',
  'chat.turns': 'turnos',
  'chat.openWorkerThread': 'Abrir thread de worker',
  'chat.attachment.attach': 'Anexar imagem',
  'chat.attachment.remove': 'Remover {name}',
  'chat.attachment.tooMany': 'Máximo de {max} imagens por mensagem',
  'chat.attachment.tooManyFiles': 'Máximo de {max} arquivos por mensagem',
  'chat.attachment.tooManyVideos': 'Máximo de {max} vídeos por mensagem',
  'chat.attachment.videoNotSupported':
    'Este modelo não consegue ler vídeos. Você pode usar o nível Raciocínio do OpenHuman para anexar seu vídeo.',
  'chat.attachment.dropToAttach': 'Solte os arquivos para anexar',
  'chat.attachment.tooLarge': 'A imagem excede o limite de tamanho de {max}',
  'chat.attachment.unsupportedType':
    'Tipo de arquivo não suportado. Use uma imagem (PNG, JPEG, WebP, GIF, BMP) ou um arquivo PDF, TXT ou Markdown.',
  'chat.attachment.imageNotSupported':
    'Este modelo não consegue ler imagens. Você pode usar o nível Raciocínio do OpenHuman para anexar sua imagem.',
  'chat.attachment.readFailed': 'Não foi possível ler o arquivo',
  'memory.searchAria': 'Pesquisar memória',
  'memory.searchPlaceholder': 'Pesquisar entradas de memória...',
  'memory.sourceFilter.all': 'Todas as fontes',
  'memory.sourceFilter.email': 'E-mail',
  'memory.sourceFilter.calendar': 'Calendário',
  'memory.sourceFilter.telegram': 'Telegram',
  'memory.sourceFilter.aiInsight': 'Insight de IA',
  'memory.sourceFilter.system': 'Sistema',
  'memory.sourceFilter.trading': 'Negociação',
  'memory.sourceFilter.security': 'Segurança',
  'memory.ingestionActivity': 'Atividade de Ingestão',
  'memory.events': 'eventos',
  'memory.event': 'evento',
  'memory.overTheLast': 'nos últimos',
  'memory.months': 'meses',
  'memory.peak': 'Pico',
  'memory.perDay': '/dia',
  'memory.less': 'Menos',
  'memory.more': 'Mais',
  'memory.on': 'em',
  'memory.loading': 'Carregando Memória',
  'memory.fetching': 'Buscando suas entradas de memória...',
  'memory.analyzing': 'Analisando Memória',
  'memory.analyzingHint': 'Processando suas memórias para extrair insights...',
  'memory.noMatches': 'Nenhum Resultado Encontrado',
  'memory.noMatchesHint': 'Tente alterar seus termos de pesquisa ou filtros.',
  'memory.allCaughtUp': 'Tudo em Dia',
  'memory.allCaughtUpHint': 'Nenhuma nova entrada de memória para processar.',
  'memory.noAnalysis': 'Nenhuma Análise Ainda',
  'memory.noAnalysisHint': 'Execute uma análise para descobrir padrões em suas memórias.',
  'memory.emptyHint': 'Comece a interagir para criar suas primeiras memórias.',
  'mic.unavailable': 'Microfone não disponível',
  'mic.permissionDenied': 'Permissão de microfone negada',
  'mic.failedToStartRecorder': 'Falha ao iniciar o gravador',
  'mic.deviceUnavailable': 'O microfone selecionado está indisponível: tente outro dispositivo.',
  'mic.deviceInUse': 'O microfone está sendo usado por outro aplicativo.',
  'mic.error': 'Erro do microfone',
  'mic.transcribing': 'Transcrevendo...',
  'mic.retryingTranscription': 'Tentando novamente… ({attempt} de {max})',
  'mic.tapToSend': 'Toque para enviar',
  'mic.waitingForAgent': 'Aguardando agente...',
  'mic.tapAndSpeak': 'Toque e fale',
  'mic.stopRecording': 'Parar gravação e enviar',
  'mic.startRecording': 'Iniciar gravação',
  'mic.deviceSelector': 'Dispositivo de microfone',
  'mic.tapToSendCountdown': 'Toque para enviar ({seconds}s)',
  'token.usageLimitReached': 'Limite de uso atingido',
  'token.approachingLimit': 'Aproximando-se do limite',
  'token.planClickForDetails': 'plano - clique para detalhes',
  'token.sessionTokens': 'Ent: {in} | Saí: {out} | Turnos: {turns}',
  'token.limit': 'Limite Atingido',
  'token.inLabel': 'ENT',
  'token.outLabel': 'SAÍ',
  'token.inputTokens': 'Tokens de entrada nesta sessão',
  'token.outputTokens': 'Tokens de saída nesta sessão',
  'token.turnsCount': 'Turnos de inferência nesta sessão',
  'token.turn': 'turno',
  'token.turns': 'turnos',
  'token.ctxLabel': 'CTX',
  'token.contextWindow': 'Uso da janela de contexto (último turno)',
  'token.cachedLabel': 'Em cache',
  'token.costLabel': 'Custo',
  'token.costTitle': 'Custo estimado desta sessão (USD)',
  'token.sessionUsageTitle': 'Uso da sessão',
  'token.subAgentsHeading': 'Uso de subagentes',
  'token.byAgentHeading': 'Por agente',
  'token.orchestrator': 'Orquestrador',
  'token.noSubAgents': 'Ainda sem uso de subagentes',
  'token.popInput': 'Tokens de entrada',
  'token.popOutput': 'Tokens de saída',
  'token.popCacheHit': 'Acerto de cache',
  'token.popContext': 'Janela de contexto',
  'token.tipInput':
    'Tokens enviados ao modelo nesta sessão: seus prompts mais o histórico da conversa.',
  'token.tipOutput': 'Tokens gerados pelo modelo nesta sessão.',
  'token.tipCacheHit':
    'Tokens de entrada servidos de um prefixo de prompt em cache, cobrados a uma taxa reduzida.',
  'token.clickForDetails': 'Clique para ver os detalhes de uso da sessão',
  'catalog.noCapabilityBinding': 'Sem vinculação de funcionalidade',
  'catalog.downloadFailed': 'Falha no download',
  'catalog.active': 'Ativo',
  'catalog.installed': 'Instalado',
  'catalog.notDownloaded': 'Não baixado',
  'catalog.inUse': 'Em Uso',
  'catalog.use': 'Usar',
  'catalog.deleteModel': 'Excluir modelo',
  'catalog.download': 'Baixar',
  'navigator.recent': 'Recente',
  'navigator.today': 'Hoje',
  'navigator.thisWeek': 'Esta Semana',
  'navigator.sources': 'Fontes',
  'navigator.email': 'E-mail',
  'navigator.slack': 'Slack',
  'navigator.chat': 'Bate-papo',
  'navigator.documents': 'Documentos',
  'navigator.people': 'Pessoas',
  'navigator.topics': 'Tópicos',
  'dreams.description':
    'Sonhos são reflexões geradas por IA que sintetizam padrões das suas memórias.',
  'dreams.comingSoon': 'Em breve',
  'assignment.memoryLlm': 'LLM de Memória',
  'assignment.memoryLlmAria': 'Seleção de LLM de memória',
  'assignment.embedder': 'Incorporador',
  'assignment.loaded': 'Carregado',
  'assignment.notDownloaded': 'Não baixado',
  'assignment.usedForExtractSummarise': 'Usado para extração e sumarização',
  'insights.knownFacts': 'Fatos Conhecidos',
  'insights.preferences': 'Preferências',
  'insights.relationships': 'Relacionamentos',
  'insights.skills': 'Habilidades',
  'insights.opinions': 'Opiniões',
  'insights.other': 'Outros',
  'insights.title': 'Insights',
  'insights.empty': 'Nenhum insight ainda. Os insights são gerados conforme sua memória cresce.',
  'insights.description': 'Baseado em {count} relações no seu grafo de memória.',
  'insights.items': 'itens',
  'insights.more': 'mais',
  'calls.joiningCall': 'Entrando na chamada',
  'calls.meetWindowOpening': 'A janela do Meet está abrindo...',
  'calls.failedToStart': 'Falha ao iniciar chamada no Meet',
  'calls.couldNotStart': 'Não foi possível iniciar a chamada',
  'calls.failedToClose': 'Falha ao encerrar a chamada',
  'calls.couldNotClose': 'Não foi possível encerrar a chamada',
  'calls.joinMeet': 'Entrar em uma chamada do Google Meet',
  'calls.joinMeetDescription': 'Insira um link do Google Meet para entrar.',
  'calls.meetLink': 'Link do Meet',
  'calls.displayName': 'Nome de Exibição',
  'calls.openingMeet': 'Abrindo Meet...',
  'calls.joinCall': 'Entrar na Chamada',
  'calls.activeCalls': 'Chamadas Ativas',
  'calls.leave': 'Sair',
  'workspace.wipeConfirm':
    'Tem certeza de que deseja apagar toda a memória? Isso não pode ser desfeito.',
  'workspace.resetTreeConfirm': 'Tem certeza de que deseja reconstruir a árvore de memória?',
  'workspace.wipeTitle': 'Apagar Memória',
  'workspace.resetting': 'Redefinindo...',
  'workspace.resetMemory': 'Redefinir Memória',
  'workspace.resetTreeTitle': 'Reconstruir Árvore de Memória',
  'workspace.rebuilding': 'Reconstruindo...',
  'workspace.resetMemoryTree': 'Redefinir Árvore de Memória',
  'workspace.building': 'Construindo...',
  'workspace.buildSummaryTrees': 'Construir Árvores de Resumo',
  'workspace.viewVault': 'Ver Cofre',
  'workspace.openingVaultTitle': 'Abrindo o cofre no Obsidian',
  'workspace.openingVaultMessage':
    'Se o Obsidian não abrir, instale-o em obsidian.md ou use Revelar Pasta. Caminho do vault:',
  'workspace.openVaultFailedTitle': 'Não foi possível abrir o vault no Obsidian',
  'workspace.openVaultFailedMessage':
    'Use Reveal Folder para abrir o diretório do vault diretamente. Caminho do cofre:',
  'workspace.revealVaultFailed': 'Não foi possível revelar a pasta do vault',
  'workspace.revealFolder': 'Revelar pasta',
  'workspace.checkingVault': 'Verificando…',
  'workspace.vaultNotRegisteredHelp':
    'O Obsidian só abre pastas adicionadas como vault. No Obsidian, escolha "Abrir pasta como vault" e selecione a pasta abaixo: você só precisa fazer isso uma vez. Depois clique em Ver Vault novamente.',
  'workspace.obsidianNotFoundHelp':
    'Não encontramos o Obsidian neste dispositivo. Instale-o, ou (se estiver instalado em um local não padrão) defina sua pasta de configuração em Avançado.',
  'workspace.openAnyway': 'Abrir no Obsidian mesmo assim',
  'workspace.installObsidian': 'Instalar Obsidian',
  'workspace.obsidianAdvanced': 'Obsidian instalado em outro local?',
  'workspace.obsidianConfigDirLabel': 'Pasta de configuração do Obsidian',
  'workspace.obsidianConfigDirHint':
    'Caminho para a pasta que contém obsidian.json (ex.: ~/.config/obsidian). Deixe em branco para detectar automaticamente.',
  'workspace.obsidianConfigDirPlaceholder': '~/.config/obsidian',
  'workspace.graphLoadFailed': 'Falha ao carregar grafo de memória',
  'workspace.loadingGraph': 'Carregando grafo de memória...',
  'workspace.graphViewMode': 'Modo de visualização do grafo de memória',
  'workspace.trees': 'Árvores',
  'workspace.contacts': 'Contatos',
  'graph.noContactMentions': 'Nenhuma menção de contato',
  'graph.noMemory': 'Sem memória',
  'graph.source': 'Fonte',
  'graph.topic': 'Tópico',
  'graph.global': 'Global',
  'graph.document': 'Documento',
  'graph.contact': 'Contato',
  'graph.nodes': 'nós',
  'graph.parentChild': 'pai-filho',
  'graph.documentContact': 'documento-contato',
  'graph.link': 'link',
  'graph.links': 'links',
  'graph.children': 'filhos',
  'graph.clickToOpenObsidian': 'Clique para abrir no Obsidian',
  'graph.person': 'Pessoa',
  'graph.resetView': 'Redefinir visualização',
  'modal.dontShowAgain': 'Não mostrar sugestões semelhantes',
  'reflections.loading': 'Carregando reflexões...',
  'reflections.empty': 'Nenhuma reflexão ainda',
  'reflections.title': 'Reflexões',
  'reflections.proposedAction': 'Ação Proposta',
  'reflections.act': 'Agir',
  'reflections.dismiss': 'Dispensar',
  'reflections.viewConversation': 'Ver',
  'subconscious.mode.label': 'Modo subconsciente',
  'subconscious.mode.off.title': 'Desligado',
  'subconscious.mode.off.desc': 'O subconsciente está desativado.',
  'subconscious.mode.simple.title': 'Simples',
  'subconscious.mode.simple.desc':
    'Observação somente leitura. Apenas acesso a memória e arquivos.',
  'subconscious.mode.aggressive.title': 'Agressivo',
  'subconscious.mode.aggressive.desc':
    'Acesso completo a ferramentas. Pode escrever, criar agentes e delegar tarefas.',
  'subconscious.mode.aggressiveWarning':
    'O modo agressivo concede ao subconsciente acesso completo a ferramentas, incluindo escrita e criação de subagentes.',
  'subconscious.interval.label': 'Frequência',
  'subconscious.interval.minutes': '{n} min',
  'subconscious.interval.hours': '{n}h',
  'subconscious.interval.oneHour': '1 hora',
  'subconscious.interval.oneDay': '24 horas',
  'whatsapp.chatsSynced': 'chats sincronizados',
  'whatsapp.chatSynced': 'chat sincronizado',
  'sync.active': 'Ativo',
  'sync.recent': 'Recente',
  'sync.idle': 'Inativo',
  'sync.memorySources': 'Fontes de Memória',
  'sync.noConnectedSources': 'Nenhuma fonte conectada',
  'sync.chunks': 'blocos',
  'sync.lastChunk': 'Último bloco:',
  'sync.pending': 'pendente',
  'sync.processed': 'processado',
  'sync.syncing': 'Sincronizando…',
  'sync.sync': 'Sincronizar',
  'sync.failedToLoad': 'Falha ao carregar status de sincronização',
  'sync.noContent':
    'Nenhum conteúdo foi sincronizado na memória ainda. Conecte uma integração para começar.',
  'memorySyncInterval.title': 'Agenda de sincronização',
  'memorySyncInterval.lastSynced': 'Última sincronização',
  'memorySyncInterval.never': 'nunca',
  'memorySyncInterval.everyHours': 'A cada {h} h',
  'memorySyncInterval.everyMinutes': 'A cada {m} min',
  'memorySyncInterval.manual': 'Apenas manual',
  'memorySyncInterval.saveFailed': 'Falha ao atualizar a agenda de sincronização',
  'memorySources.title': 'Fontes de Memória',
  'memorySources.empty':
    'Ainda não há fontes de memória. Adicione uma para começar a alimentar a memória.',
  'memorySources.customSources': 'Fontes Personalizadas',
  'memorySources.addSource': 'Adicionar Fonte',
  'memorySources.noCustomSources':
    'Ainda não há fontes personalizadas. Adicione uma pasta, repositório GitHub, feed RSS ou página da web para começar.',
  'memorySources.loadingConnections': 'Carregando conexões…',
  'memorySources.noConnections':
    'Nenhuma conexão Composio ativa encontrada. Conecte uma integração primeiro.',
  'memorySources.pickConnection': 'Escolha uma conexão',
  'memorySources.selectConnection': 'Selecionar uma conexão',
  'memorySources.comingSoon': 'Em breve',
  'memorySources.composioListFailed': 'Falha ao carregar as conexões Composio.',
  'memorySources.browse': 'Navegar…',
  'memorySources.folderPathPlaceholder': '/Users/you/notes',
  'memorySources.globPatternPlaceholder': '**/*.md',
  'memorySources.repoUrlPlaceholder': 'https://github.com/org/repo',
  'memorySources.branchPlaceholder': 'main',
  'memorySources.feedUrlPlaceholder': 'https://example.com/feed.xml',
  'memorySources.pageUrlPlaceholder': 'https://example.com/article',
  'memorySources.cssSelectorPlaceholder': 'article',
  'memorySources.searchQueryPlaceholder': 'de:usuário AI segurança',
  'memorySources.kind.composio': 'Integração',
  'memorySources.kind.conversation': 'Conversa',
  'memorySources.kind.folder': 'Pasta Local',
  'memorySources.kind.github_repo': 'Repositório GitHub',
  'memorySources.kind.twitter_query': 'Busca no Twitter',
  'memorySources.kind.rss_feed': 'Feed RSS',
  'memorySources.kind.web_page': 'Página da Web',
  'memorySources.sync.successTitle': 'Sincronizando',
  'memorySources.sync.successMessage': 'O progresso aparecerá em breve.',
  'memorySources.sync.failedTitle': 'Falha na sincronização:',
  'memorySources.sync.completeTitle': 'Sincronizado',
  'memorySources.sync.itemsSynced': 'itens sincronizados',
  'memorySources.sync.upToDate': 'Atualizado',
  'memorySources.sync.failedLabel': 'Falhou',
  'time.justNow': 'agora mesmo',
  'time.secondsAgoSuffix': 's atrás',
  'time.minutesAgoSuffix': 'min atrás',
  'time.hoursAgoSuffix': 'h atrás',
  'time.daysAgoSuffix': 'd atrás',
  'memorySources.pickKind': 'Que tipo de fonte você quer adicionar?',
  'memorySources.backToKinds': 'Voltar para os tipos de origem',
  'memorySources.label': 'Etiqueta',
  'memorySources.labelPlaceholder': 'Minhas anotações de pesquisa',
  'memorySources.add': 'Adicionar',
  'memorySources.adding': 'Adicionando…',
  'memorySources.added': 'Fonte adicionada',
  'memorySources.removed': 'Fonte removida',
  'memorySources.remove': 'Remover',
  'memorySources.enable': 'Ativar',
  'memorySources.disable': 'Desativar',
  'memorySources.toggleFailed': 'Falha na alternância',
  'memorySources.removeFailed': 'Falha ao remover',
  'memorySources.folderPath': 'Caminho da pasta',
  'memorySources.globPattern': 'Padrão glob',
  'memorySources.repoUrl': 'Repositório URL',
  'memorySources.branch': 'Ramo',
  'memorySources.feedUrl': 'Alimentar URL',
  'memorySources.pageUrl': 'Página URL',
  'memorySources.cssSelector': 'Seletor CSS (opcional)',
  'memorySources.searchQuery': 'Consulta de pesquisa',
  'memorySources.build.title': 'Construir',
  'memorySources.build.building': 'Construindo…',
  'memorySources.build.successTitle': 'Árvore construída',
  'memorySources.build.failedTitle': 'Falha na construção',
  'memorySources.build.sealsMessage': 'selagem concluída',
  'memorySources.allIn.button': 'Ativar tudo',
  'memorySources.allIn.title': 'Ativar tudo?',
  'memorySources.allIn.message':
    'Isso ativará todas as fontes de memória e removerá todos os limites de sincronização. Cria o grafo de memória mais rico, mas pode usar mais créditos.',
  'memorySources.allIn.confirm': 'Sim',
  'memorySources.allIn.cancel': 'Não',
  'memorySources.allIn.success': 'Todas as fontes ativadas sem limites. Sincronização iniciada.',
  'memorySources.allIn.failed': 'Não foi possível ativar tudo. Por favor, tente novamente.',
  'memorySources.settings.button': 'Configurações',
  'memorySources.settings.title': 'Configurações de sincronização',
  'memorySources.settings.maxPrs': 'Máximo de pull requests',
  'memorySources.settings.maxIssues': 'Máximo de issues',
  'memorySources.settings.maxCommits': 'Máximo de commits',
  'memorySources.settings.maxItems': 'Máximo de itens',
  'memorySources.settings.sinceDays': 'Período de busca (dias)',
  'memorySources.settings.syncDepthDays': 'Profundidade de sincronização (dias)',
  'memorySources.settings.maxTokens': 'Máximo de tokens por sincronização',
  'memorySources.settings.maxCost': 'Custo máximo por sincronização (USD)',
  'memorySources.settings.unlimited': 'Ilimitado',
  'memorySources.settings.unlimitedTooltip':
    'Você optou por sincronizar o máximo para {toolkit}. Você pode alterar os limites aqui.',
  'memorySources.settings.maxed': 'Cheio',
  'memorySources.settings.save': 'Salvar',
  'memorySources.settings.saving': 'Salvando…',
  'memorySources.settings.saved': 'Configurações salvas',
  'memorySources.settings.saveFailed': 'Não foi possível salvar as configurações',
  'backend.aiBackend': 'Backend de IA',
  'backend.cloud': 'Nuvem',
  'backend.recommended': 'Recomendado',
  'backend.cloudDescription':
    'Modelos rápidos e poderosos hospedados em nossos servidores. Pronto para usar imediatamente.',
  'backend.privacyNote': 'Nenhum dado pessoal, mensagem ou chave é enviado aos nossos servidores.',
  'backend.local': 'Local',
  'backend.advanced': 'Avançado',
  'backend.localDescription':
    'Rode modelos na sua própria máquina usando Ollama. Total privacidade, requer configuração.',
  'backend.ramRecommended': '16GB+ de RAM recomendado',
  'subconscious.tasks': 'tarefas',
  'subconscious.ticks': 'ticks',
  'subconscious.last': 'Último',
  'subconscious.failed': 'falhou',
  'subconscious.tickInterval': 'Intervalo de Tick',
  'subconscious.runNow': 'Executar Agora',
  'subconscious.instance.on': 'Ativado',
  'subconscious.instance.off': 'Desativado',
  'subconscious.instance.memory.title': 'Seu mundo',
  'subconscious.instance.memory.subtitle': 'Fontes de memória conectadas',
  'subconscious.instance.tinyplace.title': 'Direção da orquestração',
  'subconscious.instance.tinyplace.subtitle': 'Revisão de sessões do tiny.place',
  'subconscious.instance.tinyplace.disabledHint':
    'Ative a Orquestração para direcionar as sessões encapsuladas.',
  'subconscious.instance.tinyplace.viewDirectives': 'Ver diretrizes →',
  'subconscious.runReviewNow': 'Executar revisão agora',
  'tinyplaceOrchestration.subconsciousBadge': 'Subconsciente · direção',
  'tinyplaceOrchestration.steeringHeader.current': 'Diretriz ativa',
  'tinyplaceOrchestration.steeringHeader.none': 'Nenhuma diretriz ativa',
  'tinyplaceOrchestration.steeringHeader.expires': 'expira após {n} ciclos',
  'tinyplaceOrchestration.steeringHeader.lastReview': 'Última revisão',
  'tinyplaceOrchestration.steeringHeader.runReview': 'Executar revisão agora',
  'tinyplaceOrchestration.steeringHeader.running': 'Executando…',
  'subconscious.providerUnavailableTitle': 'Subconsciente pausado',
  'subconscious.providerSettings': 'Configurações de IA',
  'subconscious.scratchpadInfo':
    'A cada ciclo, o subconsciente verifica o que mudou nas suas fontes conectadas e então registra acompanhamentos na sua lista de tarefas, atualiza suas metas ou notifica você quando algo precisa de atenção. Verifique Configurações → Acesso do agente para configurar o modo e a frequência.',
  'subconscious.approvalNeeded': 'Aprovação Necessária',
  'subconscious.requiresApproval': 'Requer aprovação',
  'subconscious.fixInConnections': 'Corrigir em Conexões',
  'subconscious.goAhead': 'Prosseguir',
  'subconscious.activeTasks': 'Tarefas Ativas',
  'subconscious.noActiveTasks': 'Nenhuma tarefa ativa',
  'subconscious.default': 'Padrão',
  'subconscious.addTaskPlaceholder': 'Adicionar uma nova tarefa...',
  'subconscious.activityLog': 'Registro de Atividades',
  'subconscious.noActivity': 'Nenhuma atividade ainda',
  'subconscious.decision.nothingNew': 'Nada novo',
  'subconscious.decision.completed': 'Concluído',
  'subconscious.decision.evaluating': 'Avaliando',
  'subconscious.decision.waitingApproval': 'Aguardando aprovação',
  'subconscious.decision.failed': 'Falhou',
  'subconscious.decision.cancelled': 'Cancelado',
  'subconscious.decision.skipped': 'Pulado',
  // Subconscious triggers (event-driven orchestrator) debug panel
  'subconsciousTriggers.title': 'Gatilhos do subconsciente',
  'subconsciousTriggers.subtitle': 'Orquestrador em segundo plano baseado em eventos',
  'subconsciousTriggers.pipeline': 'Pipeline',
  'subconsciousTriggers.mode': 'Modo',
  'subconsciousTriggers.orchestrator': 'Orquestrador',
  'subconsciousTriggers.running': 'Em execução',
  'subconsciousTriggers.stopped': 'Parado',
  'subconsciousTriggers.promotionsPerHour': 'Promoções / hora',
  'subconsciousTriggers.queueDepth': 'Profundidade da fila',
  'subconsciousTriggers.orchestratorThread': 'Thread do orquestrador',
  'subconsciousTriggers.userThread': 'Thread do usuário',
  'subconsciousTriggers.disabledHint': 'Ative o modo baseado em eventos para iniciar o pipeline.',
  'subconsciousTriggers.enable': 'Ativar',
  'subconsciousTriggers.disable': 'Desativar',
  'actionable.complete': 'Concluir',
  'actionable.dismiss': 'Dispensar',
  'actionable.snooze': 'Adiar',
  'actionable.new': 'Novo',
  'stats.storage': 'Armazenamento',
  'stats.files': 'arquivos',
  'stats.documents': 'Documentos',
  'stats.today': 'hoje',
  'stats.namespaces': 'Namespaces',
  'stats.relations': 'Relações',
  'stats.firstMemory': 'Primeira Memória',
  'stats.latest': 'Mais Recente',
  'stats.sessions': 'Sessões',
  'stats.tokens': 'tokens',
  'bootCheck.invalidUrl': 'Por favor, insira uma URL de runtime.',
  'bootCheck.urlMustStartWith': 'A URL precisa começar com http:// ou https://',
  'bootCheck.validUrlRequired':
    'Isso não parece uma URL válida (tente https://core.example.com/rpc)',
  'bootCheck.tokenRequired': 'Vamos precisar de um token de autenticação para conectar.',
  'bootCheck.httpPublicWarning':
    'Este é um URL HTTP comum em um host público: o tráfego não será criptografado. Use HTTPS a menos que você confie nesta rede.',
  'bootCheck.chooseCoreMode': 'Selecionar um Runtime',
  'bootCheck.connectToCore': 'Conectar ao Seu Runtime',
  'bootCheck.desktopDescription':
    'O OpenHuman precisa de um runtime para pensar. Escolha onde ele deve ficar.',
  'bootCheck.webDescription':
    'Na web, o OpenHuman conecta-se a um runtime que você controla. Insira o URL e o token de autenticação abaixo, ou baixe o app desktop para rodar um na sua máquina.',
  'bootCheck.preferDesktop': 'Prefere manter tudo no seu próprio dispositivo?',
  'bootCheck.downloadDesktop': 'Baixar o App Desktop',
  'bootCheck.localRecommended': 'Rodar Localmente (Recomendado)',
  'bootCheck.localDescription':
    'Roda aqui no seu computador. Mais rápido, totalmente privado, sem nada para configurar.',
  'bootCheck.cloudMode': 'Rodar na Nuvem (Complexo)',
  'bootCheck.cloudDescription':
    'Conecte a um runtime que você hospeda em outro lugar. Fica online 24×7 para que você não precise manter este dispositivo ligado.',
  'bootCheck.coreRpcUrl': 'URL do Runtime',
  'bootCheck.rpcUrlPlaceholder': 'https://core.example.com/rpc',
  'bootCheck.authToken': 'Token de Autenticação',
  'bootCheck.bearerTokenPlaceholder': 'O token bearer do seu runtime remoto',
  'bootCheck.storedLocally': 'Mantido apenas neste dispositivo. Enviado como ',
  'bootCheck.testing': 'Testando…',
  'bootCheck.testConnection': 'Testar Conexão',
  'bootCheck.connectedOk': 'Conectado. Tudo pronto.',
  'bootCheck.authFailed': 'Esse token não funcionou. Verifique-o e tente novamente.',
  'bootCheck.unreachablePrefix': 'Não foi possível alcançar:',
  'bootCheck.checkingCore': 'Ativando seu runtime…',
  'bootCheck.cannotReach': 'Não Consigo Alcançar o Runtime',
  'bootCheck.cannotReachDesc':
    'Não foi possível conectar ao seu runtime. Deseja tentar um diferente?',
  'bootCheck.switchMode': 'Escolher um Runtime Diferente',
  'bootCheck.quit': 'Sair',
  'bootCheck.legacyDetected': 'Runtime de Segundo Plano Legado Detectado',
  'bootCheck.legacyDescription':
    'Um daemon OpenHuman instalado separadamente já está rodando neste dispositivo. Precisamos removê-lo antes que o runtime integrado possa assumir.',
  'bootCheck.removing': 'Removendo…',
  'bootCheck.removeContinue': 'Remover e Continuar',
  'bootCheck.localNeedsRestart': 'O Runtime Local Precisa de uma Reinicialização',
  'bootCheck.localNeedsRestartDesc':
    'Seu runtime local está em uma versão diferente deste app. Uma reinicialização rápida vai sincronizá-los.',
  'bootCheck.restarting': 'Reiniciando…',
  'bootCheck.restartCore': 'Reiniciar Runtime',
  'bootCheck.cloudNeedsUpdate': 'O Runtime na Nuvem Precisa de uma Atualização',
  'bootCheck.cloudNeedsUpdateDesc':
    'Seu runtime na nuvem está em uma versão diferente deste app. Execute o atualizador para sincronizá-los.',
  'bootCheck.updating': 'Atualizando…',
  'bootCheck.updateCloudCore': 'Atualizar Runtime na Nuvem',
  'bootCheck.versionCheckFailed': 'Verificação de Versão do Runtime Falhou',
  'bootCheck.versionCheckFailedDesc':
    'Seu runtime está ativo, mas não está reportando sua versão. Pode estar desatualizado. Reinicie ou atualize-o para continuar.',
  'bootCheck.working': 'Trabalhando…',
  'bootCheck.restartUpdateCore': 'Reiniciar / Atualizar Runtime',
  'bootCheck.unexpectedError': 'Erro Inesperado na Verificação de Inicialização',
  'bootCheck.actionFailed': 'Algo deu errado. Por favor, tente novamente.',
  'bootCheck.portConflictTitle': 'Não foi possível iniciar o motor do aplicativo',
  'bootCheck.portConflictBody':
    'Outro processo está usando a porta de rede que o OpenHuman precisa. Tentaremos corrigir isso automaticamente.',
  'bootCheck.portConflictFixButton': 'Corrigir automaticamente',
  'bootCheck.portConflictFixing': 'Corrigindo…',
  'bootCheck.portConflictFixFailed':
    'A correção automática não funcionou. Reinicie o computador e tente novamente.',
  'bootCheck.portConflictOwner':
    '{name} (PID {pid}) está usando a porta de rede que o OpenHuman precisa.',
  'bootCheck.portConflictGuidance':
    'Feche esse programa para liberar a porta, ou force o encerramento abaixo e tente novamente.',
  'bootCheck.portConflictForceQuit': 'Forçar encerramento de {name}',
  'bootCheck.portConflictForceQuitting': 'Encerrando {name}…',
  'bootCheck.portConflictForceQuitFailed':
    'Não foi possível encerrar esse programa. Talvez seja necessário fechá-lo manualmente e tentar novamente.',
  'notifications.justNow': 'agora mesmo',
  'notifications.minAgo': '{n}min atrás',
  'notifications.hrAgo': '{n}h atrás',
  'notifications.dayAgo': '{n}d atrás',
  'notifications.category.messages': 'Mensagens',
  'notifications.category.agents': 'Agentes',
  'notifications.category.skills': 'Habilidades',
  'notifications.category.system': 'Sistema',
  'notifications.category.meetings': 'Reuniões',
  'notifications.category.reminders': 'Lembretes',
  'notifications.category.important': 'Importante',
  'notifications.filterAll': 'Todas',
  'notifications.filterEmpty': 'Nenhum alerta nesta categoria',
  'about.update.status.checking': 'Verificando...',
  'about.update.status.available': 'v{version} disponível',
  'about.update.status.availableNoVersion': 'Atualização disponível',
  'about.update.status.downloading': 'Baixando...',
  'about.update.status.readyToInstall': 'v{version} pronta para instalar',
  'about.update.status.readyToInstallNoVersion':
    'Uma nova versão foi baixada e está pronta. Reinicie para aplicar.',
  'about.update.status.installing': 'Instalando...',
  'about.update.status.restarting': 'Reiniciando...',
  'about.update.status.upToDate': 'Você está usando a versão mais recente.',
  'about.update.status.error': 'Falha na verificação de atualização',
  'about.update.status.default': 'Verificar atualizações',
  'welcome.connectionFailed': 'Falha na conexão: {status} {statusText}',
  'welcome.connectionFailedMsg': 'Falha na conexão: {message}',
  'welcome.continueLocally': 'Continuar localmente',
  'welcome.continueLocallyExperimental': 'Continuar Localmente (Experimental)',
  'welcome.localSessionStarting': 'Iniciando sessão local...',
  'welcome.coreConfigUnreadable':
    'O runtime não conseguiu ler o seu ficheiro de configuração. O config.toml pode pertencer a outra conta de utilizador ou estar inacessível ao processo por outro motivo. Reinicie o runtime e, se isso não resolver, corrija a propriedade da pasta de trabalho ou recrie o seu volume.',
  'welcome.localSessionErrorFallback': 'Não foi possível iniciar uma sessão local.',
  'welcome.localSessionDesc': 'Usa um perfil local offline e ignora TinyHumans OAuth.',
  'chat.agentChatDesc': 'Abrir uma sessão de chat direto com o agente.',
  'chat.modelPlaceholder': 'gpt-4o',
  'channels.activeRouteValue': '{channel} via {authMode}',
  'privacy.dataKind.messages': 'Mensagens',
  'privacy.dataKind.agents': 'Agentes',
  'privacy.dataKind.skills': 'Habilidades',
  'privacy.dataKind.system': 'Sistema',
  'privacy.dataKind.meetings': 'Reuniões',
  'privacy.dataKind.reminders': 'Lembretes',
  'privacy.dataKind.important': 'Importante',
  'onboarding.enableLocalAI': 'Ativar IA Local',
  'onboarding.skills.status.available': 'Disponível',
  'onboarding.skills.status.connected': 'Conectado',
  'onboarding.skills.status.connecting': 'Conectando',
  'onboarding.skills.status.error': 'Erro',
  'onboarding.skills.status.unavailable': 'Indisponível',
  'composio.statusUnavailable': 'Status indisponível',
  'composio.authExpired': 'Autenticação expirada',
  'composio.reconnect': 'Reconectar',
  'composio.expiredAuthorization': '{name} autorização expirou',
  'composio.expiredDescription':
    'Reconecte para reativar as ferramentas {name}. OpenHuman manterá esta integração indisponível até que você atualize o acesso de OAuth.',
  'composio.envVarOverrides': 'está definida, ela substitui esta configuração.',
  'composio.previewBadge': 'Visualização',
  'composio.previewTooltip':
    'Integração do agente em breve – você pode se conectar, mas o agente ainda não pode usar este kit de ferramentas.',
  'memory.day.sun': 'Dom',
  'memory.day.mon': 'Seg',
  'memory.day.tue': 'Ter',
  'memory.day.wed': 'Qua',
  'memory.day.thu': 'Qui',
  'memory.day.fri': 'Sex',
  'memory.day.sat': 'Sáb',
  'memory.ingesting': 'Ingerindo',
  'memory.ingestionQueued': 'Na fila',
  'memory.ingestingTitle': 'Ingerindo {title}',
  'mic.noAudioCaptured': 'Nenhum áudio capturado',
  'mic.noSpeechDetected': 'Nenhuma fala detectada',
  'mic.lowConfidenceResult': 'Não foi possível entender o áudio com clareza: tente novamente',
  'mic.failedToStopRecording': 'Falha ao parar a gravação: {message}',
  'mic.transcriptionFailed': 'Falha na transcrição: {message}',
  'mic.voiceNotCompiled':
    'A transcrição de voz não está incluída nesta versão do aplicativo. Atualize o OpenHuman para ativá-la.',
  'reflections.kind.retrospective': 'Retrospectiva',
  'reflections.kind.derivedFact': 'Fato Derivado',
  'reflections.kind.moodInsight': 'Insight de Humor',
  'reflections.kind.relationshipInsight': 'Insight de Relacionamento',
  'graph.tooltip.summary': 'Resumo',
  'graph.tooltip.contact': 'Contato',
  'localModel.usage.never': 'Nunca',
  'localModel.usage.mediumLoad': 'Carga média',
  'localModel.usage.lowLoad': 'Carga baixa',
  'localModel.usage.idleMode': 'Modo inativo',
  'localModel.rebootstrapComplete': 'Re-bootstrap do modelo concluído.',
  'localModel.modelsVerified': 'Modelos locais verificados.',
  'accounts.addModal.allConnected': 'Todos conectados',
  'accounts.addModal.title': 'Adicionar conta',
  'accounts.respondQueue.empty': 'Vazio',
  'accounts.respondQueue.hide': 'Ocultar fila de respostas',
  'accounts.respondQueue.loadFailed': 'Falha ao carregar fila de respostas',
  'accounts.respondQueue.loading': 'Carregando fila…',
  'accounts.respondQueue.pending': 'Pendente',
  'accounts.respondQueue.show': 'Mostrar fila de respostas',
  'accounts.respondQueue.title': 'Fila de respostas',
  'accounts.webviewHost.almostReady': 'Quase pronto...',
  'accounts.webviewHost.loadTimeout': 'Tempo limite de carregamento do webview',
  'accounts.webviewHost.loading': 'Carregando {providerName}...',
  'accounts.webviewHost.loadingAccount': 'Carregando conta',
  'accounts.webviewHost.restoringSession': 'Restaurando sessão...',
  'accounts.webviewHost.retryLoading': 'Tentar carregar novamente',
  'accounts.webviewHost.takingLonger': '{providerName} está demorando mais do que o esperado.',
  'accounts.webviewHost.timeoutHint': 'Dica de timeout',
  'app.connectionBadge.composio': 'Composio',
  'app.connectionBadge.messaging': 'Mensagens',
  'app.connectionIndicator.connected': 'Conectado ao OpenHuman AI 🚀',
  'app.connectionIndicator.connecting': 'Conectando',
  'app.connectionIndicator.coreOffline': 'Núcleo offline',
  'app.connectionIndicator.disconnected': 'Desconectado',
  'app.connectionIndicator.offline': 'Offline',
  'app.connectionIndicator.reconnecting': 'Reconectando…',
  'app.errorFallback.componentStack': 'Pilha de componentes',
  'app.errorFallback.contactSupport': 'Falar com o suporte',
  'app.errorFallback.copyEventId': 'Copiar',
  'app.errorFallback.eventIdCopied': 'Copiado',
  'app.errorFallback.eventIdLabel': 'ID do erro',
  'app.errorFallback.revealLogs': 'Mostrar registros',
  'app.errorFallback.downloadLatest': 'Baixar mais recente',
  'app.errorFallback.heading': 'Título',
  'app.errorFallback.hint': 'Dica',
  'app.errorFallback.reloadApp': 'Recarregar app',
  'app.errorFallback.subheading': 'Subtítulo',
  'app.errorFallback.tryRecover': 'Tentar recuperar',
  'app.localAiDownload.installing': 'Instalando...',
  'app.localAiDownload.preparing': 'Preparando...',
  'app.openhumanLink.accounts.continueWith': 'Continuar com login de {label}',
  'app.openhumanLink.accounts.done': 'Concluído',
  'app.openhumanLink.accounts.intro': 'Introdução',
  'app.openhumanLink.accounts.webviewNote': 'Nota do webview',
  'app.openhumanLink.billing.openDashboard': 'Abrir painel',
  'app.openhumanLink.billing.stayOnTrial': 'Ficar no período de teste',
  'app.openhumanLink.billing.trialCredit': 'Créditos de cadastro',
  'app.openhumanLink.billing.trialDesc':
    'As ofertas de créditos podem variar conforme a promoção e a elegibilidade da conta.',
  'app.openhumanLink.defaultBody':
    'Ainda não disponível no popup. Abra a página completa de configurações quando precisar.',
  'app.openhumanLink.discord.intro': 'Introdução',
  'app.openhumanLink.discord.openInvite': 'Abrir convite',
  'app.openhumanLink.discord.perk1': 'Benefício 1',
  'app.openhumanLink.discord.perk2': 'Benefício 2',
  'app.openhumanLink.discord.perk3': 'Benefício 3',
  'app.openhumanLink.discord.perk4': 'Benefício 4',
  'app.openhumanLink.discordReport.intro':
    'Desculpe: algo deu errado do nosso lado. Tentamos registrar esses erros automaticamente, mas compartilhar os detalhes no Discord nos ajuda a corrigi-lo mais rápido.',
  'app.openhumanLink.discordReport.openDiscord': 'Abrir Discord',
  'app.openhumanLink.done': 'Concluído',
  'app.openhumanLink.notifications.desktopOnly':
    'As notificações nativas só estão disponíveis no aplicativo de desktop (execute `pnpm dev:app`).',
  'app.openhumanLink.notifications.permissionOff':
    'A permissão de notificações está desativada. Ative o OpenHuman em Configurações do sistema → Notificações e tente novamente.',
  'app.openhumanLink.notifications.triggerFailed':
    'O OpenHuman não conseguiu disparar uma notificação do sistema. Verifique as configurações de notificação do sistema operacional e tente novamente.',
  'app.openhumanLink.notifications.welcomeBody':
    'Você receberá avisos aqui quando algo precisar da sua atenção.',
  'app.openhumanLink.notifications.welcomeTitle': 'O OpenHuman está pronto',
  'app.openhumanLink.status.closed': 'Fechado',
  'app.openhumanLink.status.connected': 'Conectado',
  'app.openhumanLink.status.error': 'Erro',
  'app.openhumanLink.status.loading': 'Carregando…',
  'app.openhumanLink.status.needsSignIn': 'Requer login',
  'app.openhumanLink.status.timedOut': 'Tempo esgotado',
  'app.openhumanLink.loadingChannelSetup': 'Carregando configuração do canal',
  'app.openhumanLink.maybeLater': 'Talvez depois',
  'app.openhumanLink.notifications.asking': 'Solicitando ao SO…',
  'app.openhumanLink.notifications.blocked': 'Bloqueado',
  'app.openhumanLink.notifications.blockedStep1': 'Passo 1 bloqueado',
  'app.openhumanLink.notifications.blockedStep2': 'Passo 2 bloqueado',
  'app.openhumanLink.notifications.blockedStep3': 'Passo 3 bloqueado',
  'app.openhumanLink.notifications.intro': 'Introdução',
  'app.openhumanLink.notifications.promptHint': 'Dica de solicitação',
  'app.openhumanLink.notifications.retry': 'Tentar notificação de teste novamente',
  'app.openhumanLink.notifications.send': 'Enviar notificação de teste',
  'app.openhumanLink.notifications.sendFailed': 'Não foi possível enviar: {error}',
  'app.openhumanLink.notifications.sent':
    'Notificação de teste enviada. Se você não a recebeu, vá em Configurações do Sistema → Notificações → OpenHuman, ative Permitir Notificações e defina o Estilo de Banner como Persistente.',
  'app.openhumanLink.skipForNow': 'Pular por enquanto',
  'app.openhumanLink.telegramUnavailable': 'Telegram indisponível',
  'app.openhumanLink.title.accounts': 'Conecte seus apps',
  'app.openhumanLink.title.billing': 'Cobrança e créditos',
  'app.openhumanLink.title.discord': 'Entrar na comunidade',
  'app.openhumanLink.title.discordReport': 'Reportar este erro',
  'app.openhumanLink.title.messaging': 'Conectar um canal de chat',
  'app.openhumanLink.title.notifications': 'Permitir notificações',
  'app.persistRehydration.body': 'Corpo',
  'app.persistRehydration.heading': 'Título',
  'app.persistRehydration.resetCta': 'Redefinindo…',
  'app.persistRehydration.resetting': 'Redefinindo…',
  'app.routeLoading.initializing': 'Inicializando OpenHuman...',
  'app.update.currentlyOn': '{version}',
  'app.update.errorFallback': 'Algo deu errado durante a atualização.',
  'app.update.header.default': 'Atualizar',
  'app.update.header.error': 'Falha na atualização',
  'app.update.header.installing': 'Instalando atualização',
  'app.update.header.readyToInstall': 'Atualização pronta para instalar',
  'app.update.header.restarting': 'Reiniciando…',
  'app.update.later': 'Depois',
  'app.update.newVersionReady': 'Uma nova versão está pronta para instalar.',
  'app.update.progress.downloaded': '{amount} baixados',
  'app.update.progress.installing': 'Instalando a nova versão…',
  'app.update.progress.restarting': 'Relançando o app…',
  'app.update.progress.working': '{percent}%',
  'app.update.restartNote': 'Nota de reinicialização',
  'app.update.restartNow': 'Reiniciar agora',
  'app.update.versionReady': 'Versão {newVersion} está pronta para instalar.',
  'channels.discord.accountLinked': 'Conta vinculada',
  'channels.discord.connect': 'Conectar',
  'channels.discord.linkTokenExpired': 'Token de vinculação expirado. Por favor, tente novamente.',
  'channels.discord.linkTokenInstruction': '{token}',
  'channels.discord.linkTokenLabel': 'Rótulo do token de vinculação',
  'channels.discord.linkTokenOnce': 'Token de vinculação único',
  'channels.discord.picker.allPermissionsOk':
    'O bot tem todas as permissões necessárias neste canal.',
  'channels.discord.picker.botNotInServers': 'Bot não está nos servidores',
  'channels.discord.picker.category': 'Categoria',
  'channels.discord.picker.channel': 'Canal',
  'channels.discord.picker.checkingPermissions': 'Verificando permissões',
  'channels.discord.picker.loadingChannels': 'Carregando canais...',
  'channels.discord.picker.loadingServers': 'Carregando servidores...',
  'channels.discord.picker.missingPermissions': 'Permissões faltando',
  'channels.discord.picker.noChannels': 'Nenhum canal de texto encontrado',
  'channels.discord.picker.noServers': 'Nenhum servidor encontrado',
  'channels.discord.picker.selectChannel': 'Selecione um canal',
  'channels.discord.picker.selectServer': 'Selecione um servidor',
  'channels.discord.picker.server': 'Servidor',
  'channels.discord.picker.serverChannelSelection': 'Seleção de Servidor e Canal',
  'channels.discord.savedRestartRequired': 'Canal salvo. Reinicie o app para ativá-lo.',
  'channels.telegram.connect': 'Conectar',
  'channels.telegram.managedDmConnecting': 'DM gerenciado conectando',
  'channels.telegram.managedDmTimeout': 'Timeout de DM gerenciado',
  'channels.telegram.reconnect': 'Reconectar',
  'channels.telegram.savedRestartRequired': 'Canal salvo. Reinicie o app para ativá-lo.',
  'channels.web.alwaysAvailable': 'Sempre disponível',
  'chat.approval.approve': 'Aprovar',
  'chat.approval.alwaysAllow': 'Sempre permitir',
  'chat.approval.alwaysAllowHint':
    'Pare de pedir por esta ferramenta: adicione-a à sua lista de Sempre permitir',
  'chat.approval.deciding': 'Trabalhando…',
  'chat.approval.deny': 'Negar',
  'chat.approval.error': 'Não foi possível registrar sua decisão: tente novamente.',
  'chat.approval.fallback': 'O agente quer executar uma ação que precisa da sua aprovação.',
  'chat.approval.title': 'Aprovação necessária',
  'chat.approval.tool': 'Ferramenta:',
  'chat.flowApproval.title': 'O fluxo de trabalho precisa de aprovação',
  'chat.flowApproval.fallback':
    'Uma execução de fluxo de trabalho deseja realizar uma ação que precisa da sua aprovação.',
  'chat.flowApproval.tool': 'Ferramenta:',
  'chat.flowApproval.flow': 'Fluxo:',
  'chat.flowApproval.approve': 'Aprovar uma vez',
  'chat.flowApproval.approveAlways': 'Aprovar sempre',
  'chat.flowApproval.approveAlwaysHint':
    'Ignorar esta verificação em futuras execuções deste fluxo',
  'chat.flowApproval.deny': 'Negar',
  'chat.flowApproval.deciding': 'Trabalhando…',
  'chat.flowApproval.error': 'Não foi possível registrar sua decisão: tente novamente.',
  'chat.flowProposal.title': 'Proposta de fluxo de trabalho',
  'chat.flowProposal.subtitle': 'Revise esta automação antes de salvá-la.',
  'chat.flowProposal.triggerLabel': 'Gatilho',
  'chat.flowProposal.stepsLabel': 'Etapas',
  'chat.flowProposal.noSteps': 'Nenhuma etapa adicional.',
  'chat.flowProposal.requireApprovalHint': 'Cada ação de saída exigirá sua aprovação.',
  'chat.flowProposal.save': 'Salvar e ativar',
  'chat.flowProposal.saving': 'Salvando…',
  'chat.flowProposal.openInCanvas': 'Abrir no canvas',
  'chat.flowProposal.dismiss': 'Dispensar',
  'chat.flowProposal.error': 'Não foi possível salvar o fluxo de trabalho. Tente novamente.',
  'chat.flowProposal.enableError':
    'Fluxo de trabalho salvo, mas não foi possível ativá-lo. Tente novamente ou ative-o na página Workflows.',
  'chat.flowProposal.savedConfirmation': 'Salvo',
  'chat.flowProposal.viewWorkflow': 'Ver fluxo de trabalho',
  'chat.flowProposal.stepKind.agent': 'Agente',
  'chat.flowProposal.stepKind.toolCall': 'Ação',
  'chat.flowProposal.stepKind.httpRequest': 'Pedido web',
  'chat.flowProposal.stepKind.code': 'Executar código',
  'chat.flowProposal.stepKind.condition': 'Condição',
  'chat.flowProposal.stepKind.switch': 'Seletor',
  'chat.flowProposal.stepKind.merge': 'Mesclar',
  'chat.flowProposal.stepKind.splitOut': 'Dividir',
  'chat.flowProposal.stepKind.transform': 'Transformar',
  'chat.flowProposal.stepKind.outputParser': 'Analisar resultado',
  'chat.flowProposal.stepKind.subWorkflow': 'Subfluxo de trabalho',
  'channels.authMode.managed_dm': 'Faça login com OpenHuman',
  'channels.authMode.oauth': 'OAuth Faça login',
  'channels.authMode.bot_token': 'Use seu próprio token de bot',
  'channels.authMode.api_key': 'Use o seu próprio Chave API',
  'channels.fieldRequired': '{field} é necessária',
  'channels.mcp.title': 'MCP Servidores',
  'channels.mcp.description':
    'Navegue e gerencie servidores do Model Context Protocol que ampliam a IA com novas ferramentas.',
  'channels.discord.displayName': 'Discord',
  'channels.discord.description': 'Envie e receba mensagens via Discord.',
  'channels.discord.authMode.bot_token.description': 'Forneça seu próprio token de bot Discord.',
  'channels.discord.authMode.oauth.description':
    'Instale o bot OpenHuman em seu servidor Discord via OAuth.',
  'channels.discord.authMode.managed_dm.description':
    'Vincule sua conta pessoal Discord ao bot OpenHuman.',
  'channels.discord.fields.bot_token.label': 'Token de bot',
  'channels.discord.fields.bot_token.placeholder': 'Seu token de bot Discord',
  'channels.discord.fields.guild_id.label': 'ID do servidor (guilda)',
  'channels.discord.fields.guild_id.placeholder': 'Opcional: restringir a um servidor específico',
  'channels.telegram.displayName': 'Telegram',
  'channels.telegram.description': 'Enviar e receber mensagens via Telegram.',
  'channels.telegram.authMode.managed_dm.description':
    'Envie uma mensagem diretamente para o bot OpenHuman Telegram.',
  'channels.telegram.authMode.bot_token.description':
    'Forneça seu próprio token de bot Telegram de @BotFather.',
  'channels.telegram.fields.bot_token.label': 'Token de bot',
  'channels.telegram.fields.bot_token.placeholder': '123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11',
  'channels.telegram.fields.allowed_users.label': 'Usuários permitidos',
  'channels.telegram.fields.allowed_users.placeholder':
    'Separados por vírgula Telegram nomes de usuário',
  'channels.telegram.remoteControlTitle': 'Controle remoto (Telegram)',
  'channels.telegram.remoteControlBody':
    'Em um bate-papo Telegram permitido, envie /status, /sessions, /new ou /help. O roteamento de modelo ainda usa /model e /models.',
  'channels.connectHelp.title': 'Como conectar',
  'channels.connectHelp.discord':
    'Escolha um método abaixo: vincule sua conta pelo OpenHuman, instale o bot com OAuth ou cole seu próprio token de bot do portal de desenvolvedores do Discord.',
  'channels.connectHelp.telegram':
    'Escolha um método abaixo: envie uma mensagem ao bot gerenciado do OpenHuman para vincular sua conta, ou cole seu próprio token de bot do @BotFather.',
  'channels.connectHelp.slackNote':
    'Procurando o Slack? O Slack é conectado como um app em Conexões → OAuth, não como um canal de mensagens aqui.',
  'channels.web.displayName': 'Web',
  'channels.web.description': 'Bate-papo por meio da interface da web integrada.',
  'channels.web.authMode.managed_dm.description':
    'Use o chat da web incorporado – não é necessária nenhuma configuração.',
  'channels.yuanbao.connect': 'Connect',
  'channels.yuanbao.connecting': 'Conectando…',
  'channels.yuanbao.fieldRequired': '{field} é obrigatório',
  'channels.yuanbao.reconnect': 'Reconnect',
  'channels.yuanbao.savedRestartRequired': 'Canal salvo. Reinicie o app para ativá-lo.',
  'channels.yuanbao.unexpectedStatus': 'Status de conexão inesperado: {status}',
  'chat.unsubscribeApproval.approve': 'Aprovar e Cancelar Inscrição',
  'chat.unsubscribeApproval.approved': '✓ Inscrição cancelada com sucesso.',
  'chat.unsubscribeApproval.denied': '✕ Solicitação negada.',
  'chat.unsubscribeApproval.deny': 'Negar',
  'chat.unsubscribeApproval.processing': 'Processando...',
  'chat.unsubscribeApproval.title': 'Solicitação de Cancelamento',
  'commandPalette.ariaLabel': 'Paleta de comandos',
  'commandPalette.description': 'Descrição',
  'commandPalette.label': 'Comandos',
  'commandPalette.noResults': 'Sem resultados',
  'commandPalette.placeholder': 'Digite um comando ou pesquise…',
  'commandPalette.searchAria': 'Pesquisar comandos',
  'commandPalette.shortcutHint': 'Pressione ? para ver todos os atalhos',
  'commandPalette.title': 'Paleta de comandos',
  'kbd.ariaLabel': 'Atalho de teclado: {shortcut}',
  'shortcuts.title': 'Atalhos de teclado',
  'shortcuts.subtitle': 'Agilize seu fluxo de trabalho com estes atalhos de teclado.',
  'shortcuts.menuDesc': 'Explore todos os atalhos de teclado do aplicativo.',
  'shortcuts.empty': 'Nenhum atalho de teclado disponível no momento.',
  'shortcuts.openHint': 'Abra esta lista a qualquer momento com',
  'shortcuts.group.navigation': 'Navegação',
  'shortcuts.group.profiles': 'Perfis',
  'shortcuts.group.chat': 'Chat',
  'shortcuts.group.view': 'Visualização',
  'shortcuts.group.general': 'Geral',
  'shortcuts.group.help': 'Ajuda',
  'shortcuts.action.home': 'Ir para o início',
  'shortcuts.action.chat': 'Ir para o chat',
  'shortcuts.action.knowledge': 'Ir para Conhecimento e memória',
  'shortcuts.action.connections': 'Ir para Conexões',
  'shortcuts.action.activity': 'Ir para Atividade',
  'shortcuts.action.settings': 'Abrir Configurações',
  'shortcuts.action.newChat': 'Nova conversa',
  'shortcuts.action.toggleSidebar': 'Alternar barra lateral',
  'shortcuts.action.commandPalette': 'Paleta de comandos',
  'iosMascot.connectedTo': 'Conectado a',
  'iosMascot.defaultPairedLabel': 'Desktop',
  'iosMascot.disconnect': 'Desconectar',
  'iosMascot.error.generic': 'Algo deu errado. Por favor, tente novamente.',
  'iosMascot.error.sendFailed': 'Falha ao enviar. Verifique sua conexão.',
  'iosMascot.pushToTalk': 'Pressione para falar',
  'iosMascot.sendMessage': 'Enviar mensagem',
  'iosMascot.thinking': 'Pensando...',
  'iosMascot.typeMessage': 'Digite um mensagem...',
  'iosPair.connectedLoading': 'Conectado! Carregando...',
  'iosPair.connecting': 'Conectando à área de trabalho...',
  'iosPair.desktopLabel': 'Desktop',
  'iosPair.error.camera':
    'Falha na leitura pela câmera. Verifique as permissões de câmera e tente novamente.',
  'iosPair.error.connectionFailed':
    'Falha na conexão. Verifique se o app desktop está em execução e tente novamente.',
  'iosPair.error.invalidQr':
    'QR code inválido. Certifique-se de estar escaneando um código de pareamento do OpenHuman.',
  'iosPair.error.unreachableDesktop':
    'Não foi possível alcançar o desktop. Certifique-se de que ambos os dispositivos estão online e tente novamente.',
  'iosPair.expired': 'QR code expirou. Peça à área de trabalho para regenerar o código.',
  'iosPair.instructions':
    'Abra o OpenHuman no seu desktop, vá em Configurações > Dispositivos e toque em "Parear telefone" para exibir o QR code.',
  'iosPair.retryScan': 'Repetir verificação',
  'iosPair.scanQrCode': 'Digitalizar QR code',
  'iosPair.scannerOpening': 'Scanner abrindo...',
  'iosPair.step.openDesktop': 'Abra OpenHuman na área de trabalho',
  'iosPair.step.openSettings': 'Vá para Configurações > Dispositivos',
  'iosPair.step.showQr': 'Toque em "Parear telefone" para mostrar QR',
  'iosPair.title': 'Emparelhe com seu desktop',
  'composio.connect.additionalConfigRequired': 'Configuração adicional necessária',
  'composio.connect.atlassianSubdomainHint': 'acme',
  'composio.connect.atlassianSubdomainLabel': 'Rótulo de subdomínio Atlassian',
  'composio.connect.connect': 'Conectar',
  'composio.connect.connectedAccounts': 'Contas conectadas',
  'composio.connect.defaultLabel': 'Padrão',
  'composio.connect.disconnectAccount': 'Remover',
  'composio.connect.addAnotherAccount': 'Adicionar outra conta',
  'composio.connect.dynamicsOrgNameHint':
    'Por exemplo, "myorg" para myorg.crm.dynamics.com. Insira apenas o nome curto da organização, não a URL completa.',
  'composio.connect.dynamicsOrgNameLabel': 'Nome da organização do Dynamics 365',
  'composio.connect.connectionFailed': 'Falha na conexão (status: {status}).',
  'composio.connect.disconnectFailed': 'Falha ao desconectar: {msg}',
  'composio.connect.disconnecting': 'Desconectando…',
  'composio.connect.idleDescription': 'Conecte sua',
  'composio.connect.idleDescriptionSuffix':
    'conta. Abriremos uma janela do navegador, você aprova o acesso lá, e este app detectará a conexão automaticamente.',
  'composio.connect.isConnected': 'está conectado.',
  'composio.connect.manage': 'Gerenciar',
  'composio.connect.needsFieldsPrefix': 'Para conectar',
  'composio.connect.needsFieldsSuffix':
    'precisamos de mais algumas informações. Preencha os campos faltantes abaixo e tente novamente.',
  'composio.connect.needsSubdomain': 'Para conectar',
  'composio.connect.needsSubdomainSuffix':
    'informe seu subdomínio Atlassian (ex.: acme para acme.atlassian.net) e tente novamente.',
  'composio.connect.oauthComplete': 'OAuth a concluir…',
  'composio.connect.oauthTimeout': 'Timeout de OAuth',
  'composio.connect.permissions': 'Permissões',
  'composio.connect.permissionsDefault': 'Leitura + Escrita ativadas por padrão',
  'composio.connect.permissionsNote': 'pode expor',
  'composio.connect.permissionsNoteSuffix':
    'As permissões do agente do OpenHuman são controladas abaixo como botões de leitura, escrita e admin.',
  'composio.connect.reopenBrowser': 'Reabrir navegador',
  'composio.connect.requestingUrl': 'Solicitando URL de conexão…',
  'composio.connect.requiredFieldEmpty': 'Este campo é obrigatório.',
  'composio.connect.retryConnection': 'Tentar conexão novamente',
  'composio.connect.scopeLoadError': 'Não foi possível carregar preferências de escopo: {msg}',
  'composio.connect.scopeSaveError': 'Não foi possível salvar escopo {key}: {msg}',
  'composio.connect.scope.read': 'Leitura',
  'composio.connect.scope.readHint': 'Permitir que o agente leia dados desta conexão.',
  'composio.connect.scope.write': 'Gravar',
  'composio.connect.scope.writeHint':
    'Permitir que o agente crie ou modifique dados por meio desta conexão.',
  'composio.connect.scope.admin': 'Administrador',
  'composio.connect.scope.adminHint':
    'Permitir que o agente gerencie configurações, permissões ou ações destrutivas.',
  'composio.connect.subdomainInvalid':
    'Informe apenas o subdomínio curto (ex.: "acme"), não a URL completa. Deve conter apenas letras, números e hífens.',
  'composio.connect.subdomainRequired':
    'Por favor, insira seu subdomínio Atlassian para continuar.',
  'composio.connect.wabaIdHint':
    'Encontre-o via GET /me/businesses depois GET /{business_id}/owned_whatsapp_business_accounts usando seu token de acesso do Meta.',
  'composio.connect.wabaIdLabel': 'Rótulo de ID WABA',
  'composio.connect.atlassianSubdomainPlaceholder': 'your-subdomain',
  'composio.connect.dynamicsOrgNamePlaceholder': 'myorg',
  'composio.connect.wabaIdPlaceholder': 'e.g. 123456789012345',
  'composio.connect.wabaIdRequired':
    'Por favor, insira seu ID de Conta Empresarial do WhatsApp (WABA ID) para continuar.',
  'composio.connect.waitingFor': 'Aguardando',
  'composio.connect.waitingHint': 'Dica de espera',
  'composio.triggers.heading': 'Gatilhos',
  'composio.triggers.listenFrom': 'Ouvir eventos de',
  'composio.triggers.loadError': 'Não foi possível carregar os gatilhos',
  'composio.triggers.sessionExpired':
    'Sua sessão do OpenHuman expirou. Entre novamente para carregar os gatilhos.',
  'composio.triggers.needsConfiguration': 'Precisa de configuração',
  'composio.triggers.noneAvailable': 'Nenhum gatilho disponível no momento para',
  'conversations.taskKanban.moveLeft': 'Mover para esquerda',
  'conversations.taskKanban.moveRight': 'Mover para direita',
  'conversations.taskKanban.title': 'Tarefas',
  'conversations.threadTodo.title': 'Plano',
  'conversations.planReview.title': 'Revisar plano',
  'conversations.planReview.subtitle':
    'Aprove para executá-lo, rejeite para descartá-lo ou envie comentários para revisá-lo.',
  'conversations.planReview.approve': 'Aprovar e executar',
  'conversations.planReview.reject': 'Rejeitar',
  'conversations.planReview.feedbackLabel': 'Solicitar alterações',
  'conversations.planReview.feedbackPlaceholder': 'Descreva o que mudar…',
  'conversations.planReview.sendFeedback': 'Enviar comentários',
  'conversations.threadGoal.label': 'Objetivo',
  'conversations.threadGoal.setCta': 'Definir objetivo',
  'conversations.threadGoal.placeholder': 'O que esta conversa deve realizar?',
  'conversations.threadGoal.save': 'Salvar',
  'conversations.threadGoal.cancel': 'Cancelar',
  'conversations.threadGoal.edit': 'Editar objetivo',
  'conversations.threadGoal.clear': 'Limpar objetivo',
  'conversations.threadGoal.complete': 'Marcar como concluído',
  'conversations.threadGoal.pause': 'Pausar',
  'conversations.threadGoal.resume': 'Retomar',
  'conversations.threadGoal.tokensSuffix': 'tokens',
  'conversations.threadGoal.status.active': 'Ativo',
  'conversations.threadGoal.status.paused': 'Pausado',
  'conversations.threadGoal.status.budget_limited': 'Orçamento atingido',
  'conversations.threadGoal.status.complete': 'Concluído',
  'conversations.taskKanban.approval.default': 'Padrão',
  'conversations.taskKanban.approval.notRequired': 'Não obrigatório',
  'conversations.taskKanban.approval.notRequiredBadge': 'sem aprovação',
  'conversations.taskKanban.approval.required': 'Obrigatório',
  'conversations.taskKanban.approval.requiredBadge': 'aprovação',
  'conversations.taskKanban.approval.requiredBeforeExecution': 'Necessário antes da execução',
  'conversations.taskKanban.briefButton': 'Resumo da tarefa',
  'conversations.taskKanban.briefTitle': 'Resumo da tarefa',
  'conversations.taskKanban.closeBrief': 'Fechar resumo da tarefa',
  'conversations.taskKanban.field.acceptanceCriteria': 'Critérios de aceitação',
  'conversations.taskKanban.field.allowedTools': 'Ferramentas permitidas',
  'conversations.taskKanban.field.approval': 'Aprovação',
  'conversations.taskKanban.field.assignedAgent': 'Agente designado',
  'conversations.taskKanban.field.blocker': 'Bloqueador',
  'conversations.taskKanban.field.evidence': 'Evidência',
  'conversations.taskKanban.field.notes': 'Notas',
  'conversations.taskKanban.field.objective': 'Objetivo',
  'conversations.taskKanban.field.plan': 'Plano',
  'conversations.taskKanban.field.status': 'Status',
  'conversations.taskKanban.field.title': 'Título',
  'conversations.taskKanban.saveChanges': 'Salvar alterações',
  'conversations.taskKanban.deleteCard': 'Excluir',
  'conversations.taskKanban.workTask': 'Trabalhar na tarefa',
  'conversations.taskKanban.viewWork': 'Ver trabalho',
  'conversations.taskKanban.startingTask': 'Iniciando…',
  'conversations.taskKanban.updateFailed':
    'Não foi possível atualizar a tarefa; as alterações não foram salvas.',
  'conversations.taskKanban.sourcesButton': 'Fontes',
  'conversations.taskKanban.source.openExternal': 'Abrir tarefa externa',
  'conversations.taskKanban.source.openExternalShort': 'Abrir',
  'conversations.taskKanban.source.unknownProvider': 'Fonte desconhecida',
  'conversations.taskKanban.source.urgencyValue': 'Urgência {percent}%',
  'conversations.taskKanban.sources.desktopOnly':
    'Os controles de fontes de tarefas estão disponíveis no app de desktop.',
  'conversations.taskKanban.sources.title': 'Fontes de tarefas',
  'conversations.taskKanban.sources.statusEnabled': 'Polling automático ativado',
  'conversations.taskKanban.sources.manage': 'Gerenciar fontes',
  'conversations.taskKanban.source.title': 'Fonte',
  'conversations.taskKanban.source.sourceId': 'ID da fonte',
  'conversations.taskKanban.source.externalId': 'ID externo',
  'conversations.taskKanban.source.repo': 'Repositório',
  'conversations.taskKanban.source.urgency': 'Urgência',
  'conversations.toolTimeline.turn': 'turno',
  'conversations.toolTimeline.step': 'Passo',
  'conversations.toolTimeline.workerThread': 'thread de worker',
  'conversations.subagent.viewProcessing': 'Ver processamento completo',
  'conversations.subagent.parent': 'Principal',
  'conversations.subagent.thinking': 'Pensando',
  'conversations.subagent.thoughts': 'Pensamentos',
  'conversations.subagent.response': 'Resposta',
  'conversations.subagent.toolCalls': 'Chamadas de ferramentas',
  'conversations.subagent.working': 'Trabalhando…',
  'conversations.subagent.noOutputYet': 'Ainda sem resultado',
  'conversations.subagent.input': 'Entrada',
  'conversations.subagent.output': 'Saída',
  'conversations.subagent.noOutput': 'Nenhuma saída retornada',
  'conversations.subagent.close': 'Fechar',
  'conversations.subagent.cancel': 'Cancelar tarefa',
  'conversations.subagent.cancelling': 'Cancelando…',
  'conversations.subagent.cancelFailed': 'Não foi possível cancelar a tarefa. Tente novamente.',
  'conversations.subagent.statusRunning': 'em execução',
  'conversations.subagent.statusCompleted': 'concluído',
  'conversations.subagent.statusFailed': 'falhou',
  'conversations.subagent.statusAwaitingUser': 'aguardando usuário',
  'conversations.subagent.statusCancelled': 'cancelado',
  'conversations.agentTaskInsights.title': 'Insights de tarefas do agente',
  'conversations.agentTaskInsights.response': 'Resposta',
  'conversations.agentTaskInsights.processSourceTitle': 'Fonte do processo do agente',
  'conversations.agentTaskInsights.stepsHeading': 'Etapas',
  'conversations.agentTaskInsights.sourcesHeading': 'Fontes',
  'conversations.agentTaskInsights.noSteps': 'Nenhuma etapa registrada',
  'conversations.agentTaskInsights.viewProcessSource': 'Ver a fonte completa do processo do agente',
  'conversations.agentTaskInsights.processing': 'Processando',
  'conversations.agentTaskInsights.done': 'Concluído',
  'conversations.agentTaskInsights.failed': 'Falhou',
  'conversations.agentTaskInsights.running': 'Em execução',
  'conversations.agentTaskInsights.cancelled': 'Cancelado',
  'conversations.agentTaskInsights.awaitingUser': 'Aguardando entrada',
  'conversations.agentTaskInsights.viewDetails': 'Ver detalhes',
  'conversations.agentTaskInsights.subagentsHeading': 'Subagentes',
  'daemon.serviceBlockingGate.body': 'Corpo',
  'daemon.serviceBlockingGate.downloadHint': 'Dica de download',
  'daemon.serviceBlockingGate.downloadLatest': 'Baixar Versão Mais Recente',
  'daemon.serviceBlockingGate.retryCore': 'Tentar Core Novamente',
  'daemon.serviceBlockingGate.retryFailed':
    'Nova tentativa falhou. Baixe a versão mais recente do app e tente novamente.',
  'daemon.serviceBlockingGate.retrying': 'Tentando novamente...',
  'daemon.serviceBlockingGate.title': 'O core do OpenHuman está indisponível',
  'home.banners.discordSubtitle': 'Subtítulo do Discord',
  'home.banners.discordTitle': 'Entre no Nosso Discord',
  'home.banners.earlyBirdDismiss': 'Dispensar banner de early bird',
  'home.banners.earlyBirdFirstSub': 'primeira assinatura.',
  'home.banners.earlyBirdOn': 'Early bird ativo',
  'home.banners.earlyBirdTitle': 'Os primeiros 1.000 usuários ganham 60% de desconto.',
  'home.banners.earlyBirdUseCode': 'Usar código early bird',
  'home.banners.getSubscription': 'fazer uma assinatura',
  'home.banners.promoCreditsBody': 'Você tem {amount} em créditos promocionais. Você pode',
  'home.banners.promoCreditsUsage': 'Uso dos créditos promocionais',
  'intelligence.memoryChunk.detail.chunk': 'Bloco',
  'intelligence.memoryChunk.detail.copyChunkId': 'Copiar ID do bloco',
  'intelligence.memoryChunk.detail.embeddingInfo': 'bge-m3 1024dim',
  'intelligence.memoryChunk.detail.noEmbedding': 'Sem embedding',
  'intelligence.memoryChunk.letterhead.from': 'de',
  'intelligence.memoryChunk.letterhead.to': 'para',
  'intelligence.memoryChunk.mentioned.chunkOne': '1 pedaço',
  'intelligence.memoryChunk.mentioned.chunkOther': '{count} pedaços',
  'intelligence.memoryChunk.mentioned.heading': 'm e n c i o n a d o',
  'intelligence.memoryChunk.scoreBars.ariaScore': '{name} pontuação {pct} por cento',
  'intelligence.memoryChunk.scoreBars.atThreshold': 'em {threshold}',
  'intelligence.memoryChunk.scoreBars.dropped': 'descartado',
  'intelligence.memoryChunk.scoreBars.heading': 'p o r  q u ê   m a n t i d o',
  'intelligence.memoryChunk.scoreBars.kept': 'mantido',
  'intelligence.diagram.title': 'Diagrama de Arquitetura',
  'intelligence.diagram.description':
    'Última saída de arquitetura local do endpoint de diagrama configurado.',
  'intelligence.diagram.refresh': 'Refresh',
  'intelligence.diagram.refreshAria': 'Atualizar diagrama',
  'intelligence.diagram.emptyTitle': 'Nenhum diagrama disponível ainda',
  'intelligence.diagram.emptyDescription':
    'Gere um diagrama de arquitetura pelo orquestrador e este painel será atualizado a partir do endpoint local configurado.',
  'intelligence.diagram.skillInstallCommand': 'npx skills add yizhiyanhua-ai/fireworks-tech-graph',
  'intelligence.diagram.promptExample':
    'Gere um diagrama de arquitetura do swarm atual no estilo de terminal escuro',
  'intelligence.diagram.imageAlt': 'Último diagrama de arquitetura OpenHuman gerado',
  'intelligence.diagram.refreshesEvery': 'Atualiza a cada {seconds}s',
  'intelligence.memoryText.entityTypePrefix': 'Tipo de entidade',
  'intelligence.tasks.activeBoardOne': '1 quadro ativo entre conversas',
  'intelligence.tasks.activeBoardOther': '{count} quadros ativos entre conversas',
  'intelligence.tasks.empty': 'Nenhum quadro de tarefas de agente ainda',
  'intelligence.tasks.emptyHint': 'Dica de vazio',
  'intelligence.tasks.failedToLoad': 'Falha ao carregar',
  'intelligence.tasks.live': 'ao vivo',
  'intelligence.tasks.loadingBoards': 'Carregando quadros de tarefas…',
  'intelligence.tasks.threadPrefix': 'Tópico {thread}',
  'intelligence.tasks.subtitle':
    'Suas tarefas e quadros de tarefas de agentes em todo o espaço de trabalho.',
  'intelligence.tasks.newTask': 'Nova tarefa',
  'intelligence.tasks.personalBoardTitle': 'Tarefas do Agente',
  'intelligence.tasks.personalEmpty': 'Nenhuma tarefa pessoal ainda',
  'intelligence.tasks.composer.title': 'Nova tarefa',
  'intelligence.tasks.composer.titleLabel': 'Título',
  'intelligence.tasks.composer.titlePlaceholder': 'O que precisa ser feito?',
  'intelligence.tasks.composer.statusLabel': 'Status',
  'intelligence.tasks.composer.attachLabel': 'Anexar à conversa',
  'intelligence.tasks.composer.attachNone': 'Pessoal (sem conversa)',
  'intelligence.tasks.composer.objectiveLabel': 'Objetivo',
  'intelligence.tasks.composer.objectivePlaceholder': 'Opcional: o resultado desejado',
  'intelligence.tasks.composer.notesLabel': 'Notas',
  'intelligence.tasks.composer.notesPlaceholder': 'Notas opcionais',
  'intelligence.tasks.composer.create': 'Criar tarefa',
  'intelligence.tasks.composer.creating': 'Criando…',
  'intelligence.tasks.composer.createFailed': 'Não foi possível criar a tarefa',
  'intelligence.tasks.composer.assignAgentLabel': 'Deixe um agente cuidar disto automaticamente',
  'intelligence.tasks.composer.assignAgentHint':
    'O quadro de tarefas o executa por você. Deixe desativado para uma tarefa pessoal simples.',
  'intelligence.tasks.sourceList.subtitle':
    'Tarefas de fontes aguardando virar trabalho de agente.',
  'intelligence.tasks.sourceList.empty': 'Nenhuma tarefa de fonte aguardando.',
  'intelligence.tasks.sourceList.queued': 'Na fila',
  'intelligence.tasks.sourceList.workOnTask': 'Trabalhar na tarefa',
  'intelligence.tasks.sourcePlan.title': 'Refinar tarefa da fonte',
  'intelligence.tasks.sourcePlan.subtitle':
    'Revise o rascunho de pesquisa antes de criar uma tarefa de agente.',
  'intelligence.tasks.sourcePlan.researchAgent': 'Rascunho do agente de pesquisa',
  'intelligence.tasks.sourcePlan.approve': 'Aprovar plano',
  'intelligence.tasks.sourcePlan.creating': 'Criando tarefa…',
  'intelligence.tasks.sourcePlan.createFailed': 'Não foi possível criar a tarefa de agente',
  'intelligence.tasks.workTaskFailed': 'Não foi possível iniciar o trabalho na tarefa',
  'intelligence.workTask.sourceTaskHeading': 'Tarefa de origem:',
  'intelligence.workTask.repositoryLine': '- Repositório: {repo}',
  'intelligence.workTask.externalIdLine': '- ID externo: {externalId}',
  'intelligence.workTask.urlLine': '- Endereço: {url}',
  'intelligence.workTask.closingInstruction':
    'Comece reformulando brevemente o plano de implementação concreto e depois execute-o. Mantenha o progresso visível neste tópico e atualize o quadro de tarefas quando o estado do trabalho mudar.',
  'intelligence.agentWork.subtitle':
    'Cada execução de agente em segundo plano, agrupada por estado do ciclo de vida.',
  'intelligence.agentWork.loading': 'Carregando trabalho do agente…',
  'intelligence.agentWork.failedToLoad': 'Não foi possível carregar o trabalho do agente',
  'intelligence.agentWork.empty': 'Ainda não há execuções de agente em segundo plano.',
  'intelligence.agentWork.bucket.needsInput': 'Requer intervenção',
  'intelligence.agentWork.bucket.working': 'Em andamento',
  'intelligence.agentWork.bucket.completed': 'Concluído',
  'intelligence.agentWork.bucket.failed': 'Falhou',
  'intelligence.agentWork.bucket.stopped': 'Parado',
  'intelligence.agentWork.column.agent': 'Agente',
  'intelligence.agentWork.column.status': 'Status',
  'intelligence.agentWork.column.elapsed': 'Decorrido',
  'intelligence.agentWork.column.cost': 'Custo',
  'intelligence.agentWork.column.tokens': 'Tokens',
  'intelligence.agentWork.status.pending': 'Pendente',
  'intelligence.agentWork.status.running': 'Em andamento',
  'intelligence.agentWork.status.awaitingUser': 'Requer intervenção',
  'intelligence.agentWork.status.paused': 'Pausado',
  'intelligence.agentWork.status.completed': 'Concluído',
  'intelligence.agentWork.status.failed': 'Falhou',
  'intelligence.agentWork.status.cancelled': 'Cancelado',
  'intelligence.agentWork.status.interrupted': 'Interrompido',
  'intelligence.agentWork.kind.subagent': 'Subagente',
  'intelligence.agentWork.kind.workerThread': 'Thread de worker',
  'intelligence.agentWork.kind.backgroundAgent': 'Agente em segundo plano',
  'intelligence.agentWork.kind.teamMember': 'Membro da equipe',
  'intelligence.agentWork.kind.workflowChild': 'Filho de fluxo de trabalho',
  'intelligence.agentWork.openThread': 'Abrir tópico',
  'intelligence.agentWork.openWorker': 'Abrir trabalhador',
  'worktree.label': 'Worktree',
  'worktree.dirty': 'Alterações não confirmadas',
  'worktree.clean': 'Limpo',
  'worktree.changedFile': 'arquivo alterado',
  'worktree.changedFiles': 'arquivos alterados',
  'worktree.removing': 'Removendo…',
  'worktree.removeFailed': 'Falha ao remover o worktree',
  'worktree.diffFailed': 'Falha ao carregar o diff',
  'worktree.diffLoading': 'Carregando diff…',
  'worktree.diffEmpty': 'Nenhuma alteração em relação ao HEAD.',
  'worktree.dirtyConfirm':
    'Este worktree tem alterações não confirmadas. Removê-lo descarta esse trabalho. O branch do worker é mantido.',
  'worktree.action.open': 'Abrir pasta',
  'worktree.action.diff': 'Diff',
  'worktree.action.hideDiff': 'Ocultar diff',
  'worktree.action.remove': 'Remover',
  'worktree.action.removeAnyway': 'Descartar e remover',
  'worktree.action.preserve': 'Preservar',
  'worktree.panel.subtitle': 'Worktrees git isolados criados por workers de agentes paralelos.',
  'worktree.panel.loading': 'Carregando worktrees…',
  'worktree.panel.failedToLoad': 'Falha ao carregar os worktrees',
  'worktree.panel.empty':
    'Nenhum worktree isolado. Workers paralelos com isolamento por worktree aparecerão aqui.',
  'worktree.panel.overlapsTitle': 'Alterações sobrepostas',
  'worktree.panel.overlapHint':
    'Estes arquivos foram alterados por mais de um worktree: reconcilie antes de mesclar.',
  'intelligence.agentWork.action.stop': 'Parar',
  'intelligence.agentWork.action.retry': 'Tentar novamente',
  'intelligence.agentWork.action.continue': 'Continuar',
  'intelligence.agentWork.action.followUp': 'Acompanhar',
  'intelligence.agentWork.action.send': 'Enviar',
  'intelligence.agentWork.action.cancel': 'Cancelar',
  'intelligence.agentWork.action.continuePlaceholder': 'Responda para desbloquear este agente…',
  'intelligence.agentWork.action.followUpPlaceholder': 'Envie uma instrução de acompanhamento…',
  'intelligence.agentWork.action.failed': 'A ação falhou',
  'intelligence.teams.subtitle': 'Equipes de agentes coordenadas e as tarefas que compartilham.',
  'intelligence.teams.loading': 'Carregando equipes…',
  'intelligence.teams.failedToLoad': 'Falha ao carregar equipes',
  'intelligence.teams.empty': 'Ainda não há equipes de agentes',
  'intelligence.teams.emptyHint':
    'As equipes aparecem aqui quando um agente gera subagentes coordenados para compartilhar um objetivo.',
  'intelligence.teams.refresh': 'Atualizar',
  'intelligence.teams.backToList': 'Todas as equipes',
  'intelligence.teams.status.active': 'Ativo',
  'intelligence.teams.status.closed': 'Fechado',
  'intelligence.teams.header.lead': 'líder',
  'intelligence.teams.header.taskCount': '{count} tarefas',
  'intelligence.teams.header.memberCount': '{count} membros',
  'intelligence.teams.member.active': 'Ativo',
  'intelligence.teams.member.pending': 'Pendente',
  'intelligence.teams.member.idle': 'Ocioso',
  'intelligence.teams.member.stopped': 'Parado',
  'intelligence.teams.column.todo': 'A fazer',
  'intelligence.teams.column.ready': 'Pronto',
  'intelligence.teams.column.inProgress': 'Em andamento',
  'intelligence.teams.column.blocked': 'Bloqueado',
  'intelligence.teams.column.done': 'Concluído',
  'intelligence.teams.emptyColumn': 'Vazio',
  'intelligence.teams.unclaimed': 'Não atribuído',
  'intelligence.teams.pickedUpBy': 'Assumido por {name}',
  'intelligence.teams.depLockTitle': '{count} dependências não atendidas',
  'intelligence.teams.gate.pending': 'Verificação pendente',
  'intelligence.teams.gate.passed': 'Verificação aprovada',
  'intelligence.teams.gate.failed': 'Verificação reprovada',
  'intelligence.teams.gate.label': 'Verificação: {status}',
  'intelligence.teams.activity.title': 'Atividade da equipe',
  'intelligence.teams.activity.empty': 'Nenhuma mensagem ainda',
  'intelligence.teams.activity.toTeam': 'equipe',
  'intelligence.teams.member.start': 'Iniciar',
  'intelligence.teams.composer.placeholder': 'Mensagem para um colega…',
  'intelligence.teams.composer.send': 'Enviar',
  'intelligence.teams.composer.recipient': 'Destinatário',
  'intelligence.teams.composer.toTeam': 'Toda a equipe',
  'intelligence.teams.action.blocked': 'Aguardando dependências',
  'intelligence.teams.action.alreadyClaimed': 'Já reivindicada por outro colega',
  'intelligence.teams.action.alreadyActive': 'O colega já está em execução',
  'intelligence.teams.action.noClaimableTask': 'Nenhuma tarefa pronta para este colega',
  'intelligence.teams.action.unknownTask': 'Tarefa não encontrada',
  'intelligence.refine.objectiveDefault':
    'Transforme a tarefa de origem em uma tarefa de agente pronta para implementação: {title}',
  'intelligence.refine.sourceLine': 'Origem: {url}',
  'intelligence.refine.sourceIntake': 'Origem: recepção de fontes de tarefas',
  'intelligence.refine.repositoryLine': 'Repositório: {repo}',
  'intelligence.refine.externalTaskLine': 'Tarefa externa: {externalId}',
  'intelligence.refine.planStep1':
    'Leia a tarefa de origem vinculada e confirme o comportamento exato solicitado.',
  'intelligence.refine.planStep2':
    'Inspecione os caminhos de código relevantes e identifique o menor limite de implementação.',
  'intelligence.refine.planStep3':
    'Implemente a mudança com testes focados no comportamento visível ao usuário.',
  'intelligence.refine.planStep4':
    'Execute validação direcionada e registre quaisquer riscos remanescentes ou trabalho de acompanhamento.',
  'intelligence.refine.acceptance1':
    'Os requisitos da tarefa de origem estão representados na implementação final.',
  'intelligence.refine.acceptance2':
    'Testes unitários ou de integração relevantes cobrem o comportamento alterado.',
  'intelligence.refine.acceptance3':
    'Os resultados da validação e qualquer risco não resolvido são registrados na conclusão.',
  'notifications.card.dismiss': 'Dispensar notificação',
  'notifications.card.importanceTitle': 'Importância: {pct}%',
  'notifications.center.empty': 'Nenhuma notificação ainda',
  'notifications.center.emptyHint': 'Dica de vazio',
  'notifications.center.filterAll': 'Filtrar todos',
  'notifications.center.markAllRead': 'Marcar todos como lidos',
  'notifications.center.title': 'Notificações',
  'notifications.meeting.joinListen': 'Entrar (apenas ouvir)',
  'notifications.meeting.joinActive': 'Entrar e responder',
  'notifications.meeting.skip': 'Ignorar',
  'notifications.meeting.alwaysJoin': 'Entrar sempre',
  'notifications.meeting.actionError': 'Não foi possível concluir essa ação. Tente novamente.',
  'notifications.flow.approveTitle': 'O fluxo de trabalho precisa de aprovação',
  'notifications.flow.approve': 'Aprovar',
  'notifications.flow.approving': 'Aprovando…',
  'notifications.flow.dismiss': 'Dispensar',
  'notifications.flow.error': 'Não foi possível retomar o fluxo de trabalho. Tente novamente.',
  'notifications.flow.gateCount': 'Aguardando {count} porta(s) de aprovação',
  'notifications.flow.approveHint': 'Retomar o fluxo de trabalho após este ponto de verificação',
  'notifications.flow.dismissHint': 'Ocultar este aviso sem retomar o fluxo de trabalho',
  'notifications.flow.viewRun': 'Ver execução',
  'notifications.flowGate.title': 'O fluxo de trabalho precisa de aprovação',
  'notifications.flowGate.tool': 'Ferramenta:',
  'notifications.flowGate.approve': 'Aprovar uma vez',
  'notifications.flowGate.approveAlways': 'Aprovar sempre',
  'notifications.flowGate.approveAlwaysHint':
    'Ignorar esta verificação em futuras execuções deste fluxo',
  'notifications.flowGate.deny': 'Negar',
  'notifications.flowGate.deciding': 'Trabalhando…',
  'notifications.flowGate.error': 'Não foi possível registrar sua decisão: tente novamente.',
  'flowRuns.inspector.title': 'Detalhes da execução',
  'flowRuns.inspector.startedAt': 'Iniciado',
  'flowRuns.inspector.finishedAt': 'Concluído',
  'flowRuns.inspector.running': 'Em execução…',
  'flowRuns.inspector.error': 'Erro',
  'flowRuns.inspector.pendingApprovals': 'Aprovações pendentes',
  'flowRuns.inspector.pendingApprovalsCount': '{count} nó(s) aguardando aprovação',
  'flowRuns.inspector.approval.tool': 'Ferramenta:',
  'flowRuns.inspector.approval.approve': 'Aprovar uma vez',
  'flowRuns.inspector.approval.approveAlways': 'Aprovar sempre',
  'flowRuns.inspector.approval.approveAlwaysHint':
    'Ignorar esta verificação em futuras execuções deste fluxo',
  'flowRuns.inspector.approval.deny': 'Negar',
  'flowRuns.inspector.approval.deciding': 'Trabalhando…',
  'flowRuns.inspector.approval.loadError':
    'Não foi possível carregar as aprovações pendentes desta execução.',
  'flowRuns.inspector.steps': 'Etapas',
  'flowRuns.inspector.noSteps': 'Nenhuma etapa registrada ainda.',
  'flowRuns.inspector.output': 'Mostrar saída bruta',
  'flowRuns.inspector.summary.failedPrefix': 'Não foi possível concluir:',
  'flowRuns.inspector.summary.unknownError': 'algo deu errado',
  'flowRuns.inspector.summary.itemsFetched': '{count} item(ns) obtido(s)',
  'flowRuns.inspector.summary.completed': 'Etapa concluída',
  'flowRuns.inspector.summary.noOutput': 'Nenhuma saída produzida',
  'flowRuns.inspector.port': 'Porta',
  'flowRuns.inspector.loading': 'Carregando execução…',
  'flowRuns.inspector.loadError': 'Não foi possível carregar esta execução',
  'flowRuns.inspector.fixWithAgent': 'Corrigir com o agente',
  'flowRuns.inspector.dataTable': 'Tabela',
  'flowRuns.inspector.dataJson': 'JSON',
  'flowRuns.inspector.dataViewLabel': 'Visualização de saída',
  'flowRuns.inspector.itemCount': '{count} item(ns)',
  'flowRuns.inspector.noItems': 'Sem itens de saída',
  'flowRuns.inspector.emptyValue': '(vazio)',
  'flowRuns.inspector.binaryLabel': 'Binário',
  'flowRuns.inspector.showSource': 'Origem',
  'flowRuns.inspector.hideSource': 'Ocultar origem',
  'flowRuns.inspector.sourceInputTitle': 'Item de entrada de origem',
  'flowRuns.status.running': 'Em execução',
  'flowRuns.status.completed': 'Concluído',
  'flowRuns.status.completed_with_warnings': 'Concluído com avisos',
  'flowRuns.status.pending_approval': 'Aguardando aprovação',
  'flowRuns.status.failed': 'Falhou',
  'flowRuns.status.cancelled': 'Cancelado',
  'flowRuns.status.interrupted': 'Interrompido',

  'flows.page.title': 'Fluxos de trabalho',
  'flows.page.description': 'Automações salvas que você pode habilitar, executar e monitorar.',
  'flows.page.emptyTitle': 'Ainda não há fluxos de trabalho',
  'flows.page.emptyDescription':
    'Os fluxos de trabalho salvos aparecerão aqui assim que você criar um a partir do canvas.',
  'flows.page.loading': 'Carregando fluxos de trabalho…',
  'flows.page.loadError': 'Não foi possível carregar os fluxos de trabalho. Tente novamente.',
  'flows.page.newWorkflow': 'Novo fluxo de trabalho',
  'flows.list.lastRun': 'Última execução',
  'flows.list.neverRun': 'Nunca executado',
  'flows.list.justNow': 'Agora mesmo',
  'flows.discoveries.title': 'Descobertas de fluxos',
  'flows.discoveries.description':
    'Automações que o Flow Scout sugere, com base em como você trabalha.',
  'flows.allRuns.title': 'Execuções de fluxos',
  'flows.allRuns.description': 'Cada execução de fluxo no seu espaço, as mais recentes primeiro.',
  'flows.allRuns.loading': 'Carregando execuções…',
  'flows.allRuns.empty': 'Ainda não há execuções de fluxos.',
  'flows.allRuns.unknownWorkflow': 'Fluxo desconhecido',
  'flows.allRuns.status.running': 'Em execução',
  'flows.allRuns.status.completed': 'Concluído',
  'flows.allRuns.status.completed_with_warnings': 'Concluído com avisos',
  'flows.allRuns.status.pending_approval': 'Aguardando aprovação',
  'flows.allRuns.status.failed': 'Falhou',
  'flows.allRuns.status.cancelled': 'Cancelado',
  'flows.allRuns.status.interrupted': 'Interrompido',
  'flows.list.minutesAgo': 'há {count} min',
  'flows.list.hoursAgo': 'há {count} h',
  'flows.list.daysAgo': 'há {count} d',
  'flows.list.runNow': 'Executar',
  'flows.list.running': 'Executando…',
  'flows.list.viewRuns': 'Ver execuções',
  'flows.list.toggleEnabled': 'Habilitar fluxo de trabalho',
  'flows.list.enabled': 'Habilitado',
  'flows.list.paused': 'Pausado',
  'flows.list.runStarted': 'Fluxo de trabalho iniciado',
  'flows.runs.title': 'Execuções de {name}',
  'flows.runs.titleFallback': 'Execuções do fluxo de trabalho',
  'flows.runs.loading': 'Carregando execuções…',
  'flows.runs.loadError': 'Não foi possível carregar as execuções',
  'flows.runs.empty': 'Ainda não há execuções',
  'flows.promptBar.label': 'Descreva um fluxo de trabalho',
  'flows.promptBar.placeholder': 'Descreva seu fluxo de trabalho',
  'flows.promptBar.copilotTitle': 'Copiloto',
  'flows.promptBar.submit': 'Criar',
  'flows.promptBar.startBuilding': 'Começar a criar',
  'flows.promptBar.disclaimer': 'O Copiloto usa IA e pode cometer erros. Confira as respostas.',
  'flows.promptBar.thinking': 'Criando…',
  'flows.promptBar.heroTitle': 'Descreva um fluxo de trabalho',
  'flows.promptBar.heroSubtitle': 'Diga ao gerador o que automatizar e revise a proposta dele.',
  'flows.promptBar.error': 'Não foi possível contatar o gerador de fluxos. Tente novamente.',
  'flows.promptBar.offline': 'Você está offline. Reconecte-se para criar um fluxo.',
  'flows.suggest.title': 'Sugestões para você',
  'flows.suggest.subtitle':
    'Automações que o Flow Scout considera úteis, com base em como você trabalha.',
  'flows.suggest.discover': 'Descobrir',
  'flows.suggest.rediscover': 'Atualizar',
  'flows.suggest.discovering': 'Procurando automações…',
  'flows.suggest.empty':
    'Ainda não há sugestões. Execute Descobrir e o Flow Scout vai analisar seu trabalho em busca de automações que valham a pena configurar.',
  'flows.suggest.error': 'Não foi possível executar a descoberta. Tente novamente.',
  'flows.suggest.why': 'Por quê',
  'flows.suggest.build': 'Criar isto',
  'flows.suggest.opening': 'Abrindo…',
  'flows.suggest.dismiss': 'Dispensar',
  'flows.suggest.uses': 'Usa',
  'flows.suggest.trigger.schedule': 'Agendado',
  'flows.suggest.trigger.app_event': 'Em evento',
  'flows.suggest.trigger.manual': 'Sob demanda',
  'flows.copilot.open': 'Copiloto',
  'flows.copilot.title': 'Copiloto de fluxos',
  'flows.copilot.subtitle': 'Peça alterações e revise cada proposta antes de aplicá-la.',
  'flows.copilot.close': 'Fechar copiloto',
  'flows.copilot.placeholder': 'Peça uma alteração…',
  'flows.copilot.send': 'Enviar',
  'flows.copilot.thinking': 'Pensando…',
  'flows.copilot.error': 'Não foi possível contatar o gerador de fluxos. Tente novamente.',
  'flows.copilot.offline': 'Você está offline. Reconecte-se para usar o copiloto.',
  'flows.copilot.emptyState':
    'Descreva uma alteração neste fluxo e o gerador proporá uma atualização.',
  'flows.copilot.proposalTitle': 'Alterações propostas',
  'flows.copilot.added': '{count} adicionados',
  'flows.copilot.removed': '{count} removidos',
  'flows.copilot.noChanges': 'Esta proposta não altera nenhum nó.',
  'flows.copilot.accept': 'Aplicar ao rascunho',
  'flows.copilot.acceptAndSave': 'Aceitar e salvar',
  'flows.copilot.saveAndEnable': 'Salvar e ativar',
  'flows.copilot.saving': 'Salvando…',
  'flows.copilot.enabling': 'Ativando…',
  'flows.copilot.enableError':
    'Salvo, mas não foi possível ativar o fluxo de trabalho. Tente ativá-lo pela lista.',
  'flows.copilot.reject': 'Descartar',
  'flows.copilot.previewHint': 'Revisando um rascunho proposto: nada foi salvo ainda.',
  'flows.copilot.repairDisplay': 'Uma execução falhou; analise-a e proponha uma correção.',
  'flows.copilot.tool.proposing': 'Propondo fluxo de trabalho…',
  'flows.copilot.tool.dryRunning': 'Executando teste do fluxo de trabalho…',
  'flows.copilot.tool.saving': 'Salvando fluxo de trabalho…',
  'flows.copilot.tool.usingTools': 'Usando ferramentas…',
  'flows.copilot.cappedNotice':
    'O construtor atingiu o limite de iterações antes de concluir este fluxo de trabalho. Ao continuar, a construção prosseguirá a partir do rascunho atual.',
  'flows.copilot.continueBuilding': 'Continuar a construir',
  'flows.list.view': 'Ver fluxo de trabalho',
  'flows.list.export': 'Exportar',
  'flows.list.exported': 'Fluxo de trabalho exportado',
  'flows.page.import': 'Importar',
  'flows.import.invalidFile': 'Esse arquivo não é um JSON de fluxo de trabalho válido.',
  'flows.import.error':
    'Não foi possível importar este fluxo de trabalho. Verifique o arquivo e tente novamente.',
  'flows.import.warningTitle': 'Aviso de importação',
  'flows.canvas.title': 'Fluxo de trabalho',
  'flows.canvas.loading': 'Carregando fluxo de trabalho…',
  'flows.canvas.loadError': 'Não foi possível carregar este fluxo de trabalho. Tente novamente.',
  'flows.canvas.notFound': 'Este fluxo de trabalho não foi encontrado.',
  'flows.canvas.draftMissing':
    'Nenhum rascunho de fluxo para abrir. Proponha um pelo chat primeiro.',
  'flows.canvas.backToList': 'Voltar para os fluxos de trabalho',
  'flows.nodeKind.trigger': 'Gatilho',
  'flows.nodeKind.agent': 'Agente',
  'flows.nodeKind.tool_call': 'Chamada de ferramenta',
  'flows.nodeKind.http_request': 'Solicitação HTTP',
  'flows.nodeKind.code': 'Código',
  'flows.nodeKind.condition': 'Condição',
  'flows.nodeKind.switch': 'Seletor',
  'flows.nodeKind.merge': 'Mesclar',
  'flows.nodeKind.split_out': 'Dividir saída',
  'flows.nodeKind.transform': 'Transformação',
  'flows.nodeKind.output_parser': 'Analisador de saída',
  'flows.nodeKind.sub_workflow': 'Subfluxo de trabalho',
  'flows.nodeKind.memory': 'Memória',
  'flows.nodeKind.dedup': 'Deduplicação',
  'flows.nodeKind.loop': 'Laço',
  'flows.nodeSummary.trigger.manual': 'Executa sob demanda',
  'flows.nodeSummary.trigger.webhook': 'Executa a partir de um webhook recebido',
  'flows.nodeSummary.trigger.appEventOn': 'Em {parts}',
  'flows.nodeSummary.trigger.appEvent': 'Executa a partir de um evento de app',
  'flows.nodeSummary.trigger.unknownKind': 'Gatilho: {kind}',
  'flows.nodeSummary.agent.defaultModel': 'modelo padrão',
  'flows.nodeSummary.agent.withPrompt': '“{prompt}” · {model}',
  'flows.nodeSummary.agent.default': 'Consulta o {model}',
  'flows.nodeSummary.toolCall.runsNative': 'Executa {name}',
  'flows.nodeSummary.toolCall.pickNative': 'Executa uma ferramenta do OpenHuman (escolha uma)',
  'flows.nodeSummary.toolCall.runs': 'Executa {slug}',
  'flows.nodeSummary.toolCall.pick': 'Executa uma ação de app (escolha uma)',
  'flows.nodeSummary.http.withUrl': '{method} {url}',
  'flows.nodeSummary.http.noUrl': 'Solicitação {method} (defina uma URL)',
  'flows.nodeSummary.code.runs': 'Executa código {lang}',
  'flows.nodeSummary.condition.withField': 'Se {field} → verdadeiro / falso',
  'flows.nodeSummary.condition.default': 'Bifurca em verdadeiro / falso',
  'flows.nodeSummary.switch.byExpr': 'Roteia por {expr}',
  'flows.nodeSummary.switch.byExprWithRoutes': 'Roteia por {expr} ({count} rotas)',
  'flows.nodeSummary.switch.byValue': 'Roteia por um valor',
  'flows.nodeSummary.switch.byValueWithRoutes': 'Roteia por um valor ({count} rotas)',
  'flows.nodeSummary.merge': 'Mescla ramificações paralelas',
  'flows.nodeSummary.splitOut.withPath': 'Divide cada {path}',
  'flows.nodeSummary.splitOut.default': 'Divide uma lista em itens',
  'flows.nodeSummary.transform.default': 'Reestrutura cada item',
  'flows.nodeSummary.transform.setFieldsSingular': 'Define {n} campo em cada item',
  'flows.nodeSummary.transform.setFieldsPlural': 'Define {n} campos em cada item',
  'flows.nodeSummary.outputParser': 'Analisa a saída anterior',
  'flows.nodeSummary.subWorkflow': 'Executa um fluxo de trabalho aninhado',
  'flows.nodeSummary.memory.flavourWith': 'Lê o estilo "{flavour}"',
  'flows.nodeSummary.memory.flavour': 'Lê um estilo de memória',
  'flows.nodeSummary.memory.people': 'Consulta a memória de pessoas',
  'flows.nodeSummary.memory.remember': 'Salva um valor neste fluxo de trabalho',
  'flows.nodeSummary.memory.forget': 'Esquece um valor deste fluxo de trabalho',
  'flows.nodeSummary.memory.searchScoped': 'Pesquisa na memória ({scope})',
  'flows.nodeSummary.memory.search': 'Pesquisa na memória',
  'flows.nodeSummary.memory.recallScoped': 'Recupera da memória ({scope})',
  'flows.nodeSummary.memory.recall': 'Recupera da memória',
  'flows.nodeSummary.dedup.withKey': 'Ignora itens já vistos por {key}',
  'flows.nodeSummary.dedup.default': 'Ignora itens já processados',
  'flows.nodeSummary.loop.upTo': 'Repete até {max} vezes',
  'flows.nodeSummary.loop.whileCondition': 'Repete até {max} vezes enquanto {condition}',
  'flows.palette.title': 'Nós',
  'flows.palette.addNode': 'Adicionar nó {kind}',
  'flows.editor.save': 'Salvar',
  'flows.editor.deleteSelected': 'Excluir selecionados',
  // ── Validation UX + draft/dirty state (issue B5b / Phase 3c–3d)
  'flows.editor.saving': 'Salvando…',
  'flows.editor.run': 'Executar',
  'flows.editor.running': 'Executando…',
  'flows.editor.runFailed': 'Não foi possível iniciar a execução',
  'flows.editor.validate': 'Validar',
  'flows.editor.validating': 'Validando…',
  'flows.editor.discard': 'Descartar alterações',
  'flows.editor.confirm.runTitle': 'Executar o fluxo de trabalho?',
  'flows.editor.confirm.runBody': 'Isso executará o fluxo de trabalho agora.',
  'flows.editor.confirm.saveTitle': 'Salvar as alterações?',
  'flows.editor.confirm.saveBody': 'Isso salvará suas alterações no fluxo de trabalho.',
  'flows.editor.confirm.discardTitle': 'Descartar as alterações?',
  'flows.editor.confirm.discardBody':
    'Isso reverte todas as edições não salvas e não pode ser desfeito.',
  'flows.editor.confirm.confirm': 'Confirmar',
  'flows.editor.confirm.cancel': 'Cancelar',
  'flows.editor.unsaved': 'Alterações não salvas',
  'flows.editor.saveBlocked': 'Corrija os erros abaixo antes de salvar.',
  'flows.editor.errorsTitle': 'Erros',
  'flows.editor.warningsTitle': 'Avisos',
  'flows.editor.saveFailedTitle': 'Não foi possível salvar',
  'flows.editor.leaveTitle': 'Sair sem salvar?',
  'flows.editor.leaveBody':
    'Você tem alterações não salvas neste fluxo de trabalho. Se sair agora, elas serão perdidas.',
  'flows.editor.leaveStay': 'Ficar',
  'flows.editor.leaveDiscard': 'Sair',
  // ── Node config drawer (issue B5b / Phase 3b): per-kind config forms
  'flowRuns.inspector.diagnosticsTitle': 'Avisos de expressão',
  'flowRuns.inspector.diagnosticResolvedNull': 'resolvido como null',
  'flows.runs.sidebarTitle': 'Execuções',
  'flows.runs.refresh': 'Atualizar execuções',
  'flows.palette.appAction': 'Ação de app',
  'flows.palette.ohTool': 'Ferramenta',
  'flows.editor.deleteNode': 'Excluir',
  'flows.nodeConfig.connections.title': 'Conexões',
  'flows.nodeConfig.connections.inputs': 'Entradas',
  'flows.nodeConfig.connections.outputs': 'Saídas',
  'flows.nodeConfig.connections.none': 'Ainda não conectado a nenhum outro nó.',
  'flows.nodeConfig.connections.remove': 'Remover conexão',
  'flows.nodeConfig.trigger.scheduleCronLabel': 'Expressão cron',
  'flows.nodeConfig.trigger.scheduleFreqLabel': 'Frequência',
  'flows.nodeConfig.trigger.scheduleFreq_minutes': 'A cada N minutos',
  'flows.nodeConfig.trigger.scheduleFreq_hours': 'A cada N horas',
  'flows.nodeConfig.trigger.scheduleFreq_daily': 'Em um horário todos os dias',
  'flows.nodeConfig.trigger.scheduleEvery': 'a cada',
  'flows.nodeConfig.trigger.scheduleInterval': 'Intervalo',
  'flows.nodeConfig.trigger.scheduleUnit_minutes': 'min.',
  'flows.nodeConfig.trigger.scheduleUnit_hours': 'h',
  'flows.nodeConfig.trigger.scheduleAt': 'às',
  'flows.nodeConfig.trigger.scheduleTime': 'Hora do dia',
  'flows.nodeConfig.trigger.scheduleDays': 'Nos dias (opcional: deixe vazio para todos os dias)',
  'flows.nodeConfig.trigger.scheduleAdvanced': 'Avançado (editar cron)',
  'flows.nodeConfig.trigger.scheduleSimple': 'Voltar ao agendamento simples',
  'flows.cron.customSchedule': 'Agendamento personalizado ({expr})',
  'flows.cron.noScheduleSet': 'Nenhum agendamento definido',
  'flows.cron.weekdays': 'dias úteis',
  'flows.cron.weekends': 'fins de semana',
  'flows.cron.everyMinute': 'A cada minuto',
  'flows.cron.everyMinuteOnDays': 'A cada minuto nos dias {days}',
  'flows.cron.everyNMinutes': 'A cada {n} minutos',
  'flows.cron.everyNMinutesOnDays': 'A cada {n} minutos nos dias {days}',
  'flows.cron.everyHour': 'A cada hora',
  'flows.cron.everyHourOnDays': 'A cada hora nos dias {days}',
  'flows.cron.everyNHours': 'A cada {n} horas',
  'flows.cron.everyNHoursOnDays': 'A cada {n} horas nos dias {days}',
  'flows.cron.everyDayAtTime': 'Todos os dias às {time}',
  'flows.cron.atTimeOnDays': 'Às {time} nos dias {days}',
  'flows.cron.invalidInterval': 'Intervalo inválido',
  'flows.cron.dailyEvery24h': 'Diário (a cada 24 h)',
  'flows.cron.everyNDays': 'A cada {n} dias',
  'flows.cron.everyNHoursShort': 'A cada {n} h',
  'flows.cron.everyNMinutesShort': 'A cada {n} min',
  'flows.cron.everySecond': 'A cada segundo',
  'flows.cron.everyNSeconds': 'A cada {n} s',
  'flows.cron.onceAtRaw': 'Uma vez em {at}',
  'flows.cron.onceAt': 'Uma vez em {at}',
  'flows.nodeConfig.trigger.pickApp': 'Escolha primeiro um app conectado.',
  'flows.nodeConfig.tool.pickConnection': 'Escolha primeiro uma conexão.',
  'flows.nodeConfig.composio.noConnections':
    'Ainda não há apps conectados. Conecte um em Configurações → Apps e escolha aqui.',
  'flows.nodeConfig.composio.selectApp': 'Selecionar um app…',
  'flows.nodeConfig.composio.select': 'Selecionar…',
  'flows.nodeConfig.composio.loading': 'Carregando…',
  'flows.nodeConfig.composio.custom': 'Inserir manualmente…',
  'flows.nodeConfig.composio.customPlaceholder': 'SLUG_NAME',
  'flows.nodeConfig.agent.modelHint':
    'Escolha um nível de capacidade: o workspace resolve o modelo.',
  'flows.nodeConfig.agent.modelInherit': 'Padrão (herdar)',
  'flows.nodeConfig.agent.agentRefLabel': 'Agente',
  'flows.nodeConfig.agent.agentRefHint':
    'Executar este nó como um agente registrado: suas ferramentas e proteções se aplicam.',
  'flows.nodeConfig.agent.agentRefInherit': 'Padrão (construtor de fluxos)',
  'flows.nodeConfig.agent.modelManagedTiers': 'Níveis gerenciados',
  'flows.nodeConfig.agent.modelHints': 'Dicas de modelo',
  'flows.nodeConfig.agent.modelCustom': 'Modelo personalizado…',
  'flows.nodeConfig.agent.modelCustomPlaceholder': 'ex.: gpt-4o-mini',
  'flows.nodeConfig.tool.requiredMark': 'obrigatório',
  'flows.nodeConfig.tool.requiredMissing': 'Obrigatório: não conectado',
  'flows.nodeConfig.tool.argsAdvancedLabel': 'Todos os argumentos (avançado)',
  'flows.nodeConfig.upstream.insert': 'Inserir…',
  'flows.nodeConfig.upstream.insertLabel': 'Inserir um valor de uma etapa anterior',
  'flows.nodeConfig.native.toolLabel': 'Ferramenta',
  'flows.nodeConfig.native.toolHint':
    'Uma das ferramentas integradas do assistente (busca, mídia, arquivos, …).',
  'flows.nodeConfig.native.select': 'Selecionar uma ferramenta…',
  'flows.nodeConfig.native.loading': 'Carregando ferramentas…',
  'flows.nodeConfig.close': 'Fechar configurações',
  'flows.nodeConfig.nameLabel': 'Nome',
  'flows.nodeConfig.namePlaceholder': 'Nome do nó',
  'flows.nodeConfig.editForm': 'Editar como formulário',
  'flows.nodeConfig.editJson': 'Editar como JSON',
  'flows.nodeConfig.rawJsonLabel': 'Configuração (JSON)',
  'flows.nodeConfig.rawJsonHint': 'Configuração livre para este nó.',
  'flows.nodeConfig.rawJsonInvalid':
    'JSON inválido: as alterações só são aplicadas quando for válido.',
  'flows.nodeConfig.expressionHint':
    'Comece com = para calcular o valor a partir da entrada do nó, ex.: =item.url',
  'flows.nodeConfig.expressionBadge': 'Expressão',
  'flows.nodeConfig.keymapKeyPlaceholder': 'Chave',
  'flows.nodeConfig.keymapValuePlaceholder': 'Valor',
  'flows.nodeConfig.keymapRemove': 'Remover linha',
  'flows.nodeConfig.keymapAdd': 'Adicionar linha',
  'flows.nodeConfig.credentialLabel': 'Credencial',
  'flows.nodeConfig.credentialHint': 'Escolha uma conta ou credencial conectada para este nó.',
  'flows.nodeConfig.credentialEmpty': 'Nenhuma credencial conectada disponível.',
  'flows.nodeConfig.credentialNone': 'Nenhuma',
  'flows.nodeConfig.trigger.kindLabel': 'Tipo de gatilho',
  'flows.nodeConfig.trigger.kind_manual': 'Manual',
  'flows.nodeConfig.trigger.kind_schedule': 'Agendamento',
  'flows.nodeConfig.trigger.kind_webhook': 'Webhook',
  'flows.nodeConfig.trigger.kind_app_event': 'Evento de app',
  'flows.nodeConfig.trigger.scheduleLabel': 'Agendamento cron',
  'flows.nodeConfig.trigger.scheduleHint': 'Expressão cron: minuto hora dia mês dia da semana.',
  'flows.nodeConfig.trigger.toolkitLabel': 'Kit de ferramentas',
  'flows.nodeConfig.trigger.triggerSlugLabel': 'Slug do gatilho',
  'flows.nodeConfig.trigger.webhookHint':
    'Os gatilhos de webhook são salvos, mas ainda não são disparados automaticamente.',
  'flows.nodeConfig.http.methodLabel': 'Método',
  'flows.nodeConfig.http.urlLabel': 'URL',
  'flows.nodeConfig.http.headersLabel': 'Cabeçalhos',
  'flows.nodeConfig.http.bodyLabel': 'Corpo (JSON)',
  'flows.nodeConfig.agent.promptLabel': 'Prompt',
  'flows.nodeConfig.agent.promptPlaceholder': 'Instruções para o agente…',
  'flows.nodeConfig.agent.modelLabel': 'Modelo',
  'flows.nodeConfig.tool.slugLabel': 'Slug da ferramenta',
  'flows.nodeConfig.tool.argsLabel': 'Argumentos (JSON)',
  'flows.nodeConfig.condition.fieldLabel': 'Campo',
  'flows.nodeConfig.condition.fieldHint':
    'Chave do item de entrada avaliada como verdadeira. Encaminha para verdadeiro ou falso.',
  'flows.nodeConfig.switch.expressionLabel': 'Expressão',
  'flows.nodeConfig.switch.hint':
    'O valor resultante seleciona a porta de saída correspondente; null vai para default.',
  'flows.nodeConfig.switch.fieldLabel': 'Campo (alternativa)',
  'flows.nodeConfig.transform.setLabel': 'Definir campos',
  'flows.nodeConfig.transform.setHint':
    'Cada valor é uma expressão avaliada por item, ex.: =item.name',
  'flows.nodeConfig.code.languageLabel': 'Linguagem',
  'flows.nodeConfig.code.language_javascript': 'JavaScript',
  'flows.nodeConfig.code.language_python': 'Python',
  'flows.nodeConfig.code.sourceLabel': 'Código-fonte',
  'flows.nodeConfig.memory.operationLabel': 'Operação',
  'flows.nodeConfig.memory.operation_recall': 'Recordar',
  'flows.nodeConfig.memory.operation_search': 'Pesquisar',
  'flows.nodeConfig.memory.operation_flavour': 'Estilo',
  'flows.nodeConfig.memory.operation_people': 'Pessoas',
  'flows.nodeConfig.memory.operation_remember': 'Lembrar',
  'flows.nodeConfig.memory.operation_forget': 'Esquecer',
  'flows.nodeConfig.memory.scopeLabel': 'Escopo',
  'flows.nodeConfig.memory.scopeHint': 'Onde procurar esta memória.',
  'flows.nodeConfig.memory.scopeWriteHint':
    'A escrita só é permitida dentro deste fluxo de trabalho, nunca na sua memória pessoal.',
  'flows.nodeConfig.memory.scope_user': 'Você (somente leitura)',
  'flows.nodeConfig.memory.scope_flow': 'Este fluxo de trabalho',
  'flows.nodeConfig.memory.scope_flows': 'Todos os fluxos de trabalho (somente leitura)',
  'flows.nodeConfig.memory.queryLabel': 'Consulta',
  'flows.nodeConfig.memory.queryOptionalHint': 'Opcional: restringe a busca de pessoas.',
  'flows.nodeConfig.memory.flavourLabel': 'Estilo',
  'flows.nodeConfig.memory.flavourHint': 'Qual faceta da persona ler, por exemplo communication.',
  'flows.nodeConfig.memory.flavour_communication': 'Comunicação',
  'flows.nodeConfig.memory.flavour_coding_style': 'Estilo de código',
  'flows.nodeConfig.memory.flavour_stack': 'Stack técnica',
  'flows.nodeConfig.memory.flavour_workflow': 'Fluxo de trabalho',
  'flows.nodeConfig.memory.flavour_environment': 'Ambiente',
  'flows.nodeConfig.memory.flavour_directives': 'Diretrizes',
  'flows.nodeConfig.memory.flavour_anti_preferences': 'Preferências negativas',
  'flows.nodeConfig.memory.keyLabel': 'Chave',
  'flows.nodeConfig.memory.valueLabel': 'Valor',
  'flows.nodeConfig.memory.limitLabel': 'Limite',
  'flows.nodeConfig.memory.limitHint': 'Número máximo de resultados.',
  'flows.nodeConfig.memory.minScoreLabel': 'Pontuação mínima',
  'flows.nodeConfig.memory.minScoreHint': 'Limite de relevância de 0 a 1.',
  'flows.nodeConfig.dedup.keyLabel': 'Chave',
  'flows.nodeConfig.dedup.keyHint':
    'Uma expressão de id estável por item, ex.: =item.id. Itens com uma chave já vista são ignorados.',

  // `loop` node: a bounded loop head. Emits on `body` until its cap or
  // condition says stop, then on `done`.
  'flows.nodeConfig.loop.maxIterationsLabel': 'Iterações máximas',
  'flows.nodeConfig.loop.maxIterationsHint':
    'Quantas vezes o corpo pode ser executado antes de o laço parar. Sempre finito.',
  'flows.nodeConfig.loop.onExceededLabel': 'Ao atingir o limite',
  'flows.nodeConfig.loop.onExceededHint':
    'Falhar a execução, ou parar de repetir e continuar pela porta done com os itens da última passagem.',
  'flows.nodeConfig.loop.onExceeded_error': 'Falhar a execução',
  'flows.nodeConfig.loop.onExceeded_continue': 'Continuar com resultados parciais',
  'flows.nodeConfig.loop.conditionLabel': 'Continuar enquanto',
  'flows.nodeConfig.loop.conditionHint':
    'Opcional. Enquanto isto for verdadeiro o laço continua; o primeiro resultado falso sai pela porta done.',

  'flows.enableApproval.title': 'Permitir que este fluxo de trabalho aja?',
  'flows.enableApproval.intro':
    'Este fluxo de trabalho precisa da sua permissão para as ações abaixo. A aprovação vale apenas para este fluxo de trabalho.',
  'flows.enableApproval.approveAll': 'Aprovar tudo',
  'flows.enableApproval.deny': 'Negar',
  'flows.enableApproval.enableAnyway': 'Ativar mesmo assim',
  'flows.enableApproval.granting': 'Aprovando…',
  'flows.enableApproval.error': 'Não foi possível salvar as aprovações. Tente novamente.',
  'flows.enableApproval.blockedHint': 'Bloqueado pelas suas configurações de acesso do agente.',
  'flows.enableApproval.dynamicHint':
    'Decidido durante a execução; ele perguntará se for necessário.',
  'flows.enableApproval.agentHint':
    'Esta etapa de IA pode pedir permissão separadamente para as próprias ações.',
  'flows.enableApproval.deniedDisabled': 'Salvo, mas o fluxo de trabalho ficou desativado.',
  'flows.chooser.title': 'Criar um fluxo de trabalho',
  'flows.chooser.subtitle': 'Escolha como quer começar.',
  'flows.chooser.scratchTitle': 'Começar do zero',
  'flows.chooser.scratchDescription': 'Comece com uma tela em branco e um único acionador manual.',
  'flows.chooser.templateTitle': 'A partir de um modelo',
  'flows.chooser.templateDescription': 'Comece com um exemplo pronto e personalize-o.',
  'flows.chooser.describeTitle': 'Descreva',
  'flows.chooser.describeDescription':
    'Diga ao assistente o que deseja e deixe-o esboçar o fluxo de trabalho.',
  'flows.chooser.creating': 'Criando o fluxo de trabalho…',
  'flows.chooser.createError': 'Não foi possível criar o fluxo de trabalho. Tente novamente.',
  'flows.templates.title': 'Começar a partir de um modelo',
  'flows.templates.subtitle': 'Escolha um ponto de partida e personalize-o no editor.',
  'flows.templates.use': 'Usar modelo',
  'flows.templates.back': 'Voltar',
  'flows.templates.empty': 'Nenhum modelo disponível.',
  'flows.templates.category.scheduled': 'Agendado',
  'flows.templates.category.triggered': 'Acionado',
  'flows.templates.category.onDemand': 'Sob demanda',
  'flows.templates.daily-digest.name': 'Resumo diário para o canal',
  'flows.templates.daily-digest.description':
    'Conforme um agendamento, um agente escreve um breve resumo e o publica em um canal.',
  'flows.templates.scheduled-scrape.name': 'Extração agendada para a memória',
  'flows.templates.scheduled-scrape.description':
    'Busque uma fonte conforme um agendamento, remodele os resultados e guarde-os na memória.',
  'flows.templates.webhook-triage.name': 'Triagem de webhook e aviso',
  'flows.templates.webhook-triage.description':
    'Um webhook recebido é triado por um agente e depois você é avisado.',
  'flows.templates.app-event-route.name': 'Evento de app para ação condicional',
  'flows.templates.app-event-route.description':
    'Um evento de um app conectado executa uma verificação e age quando corresponde.',
  'flows.templates.http-fetch-parse.name': 'Buscar e analisar uma API',
  'flows.templates.http-fetch-parse.description':
    'Chame um endpoint HTTP sob demanda e analise a resposta em um formato utilizável.',
  'flows.templates.ask-agent.name': 'Perguntar ao agente',
  'flows.templates.ask-agent.description':
    'Um acionador manual simples que entrega uma tarefa a um agente.',
  'flows.templates.opus-sonnet-brief.name': 'Resumo de pesquisa (Opus planeja, Sonnet redige)',
  'flows.templates.opus-sonnet-brief.description':
    'Um agente de nível raciocínio planeja o resumo, um agente de nível chat o redige e, em seguida, o resultado é formatado para você.',

  'oauth.button.connecting': 'Conectando...',
  'oauth.button.loopbackTimeout':
    'Login expirou: o navegador não concluiu o redirecionamento OAuth. Por favor, tente novamente.',
  'oauth.login.continueWith': 'Continuar com',
  'onboarding.contextGathering.buildingDesc': 'Descrição de construção',
  'onboarding.contextGathering.buildingProfile': 'Construindo seu perfil...',
  'onboarding.contextGathering.continueToChat': 'Continuar para o chat',
  'onboarding.contextGathering.coreAlive':
    'Núcleo acessível: a primeira inicialização pode demorar um minuto.',
  'onboarding.contextGathering.coreAliveProbing': 'Verificando a conexão com o núcleo…',
  'onboarding.contextGathering.coreUnreachable':
    'O núcleo não está respondendo. Você pode continuar e tentar novamente mais tarde.',
  'onboarding.contextGathering.errorDesc':
    'Não conseguimos montar seu perfil completo agora, mas tudo bem: você pode continuar e seu perfil será construído ao longo do tempo.',
  'onboarding.contextGathering.stillWorkingDesc':
    'A primeira inicialização pode levar 30–60 segundos enquanto preparamos seu modelo local e ferramentas. Você pode continuar para o chat a qualquer momento: a construção do perfil continua em segundo plano.',
  'onboarding.contextGathering.stillWorkingTitle': 'Ainda construindo seu perfil…',
  'onboarding.contextGathering.title': 'Coleta de Contexto',
  'openhuman.team_list_teams': 'Listar equipes',
  'overlay.ariaAttention': 'Mensagem de atenção',
  'overlay.ariaCompanion': 'Companion ativo',
  'overlay.ariaOrb': 'Orb do OpenHuman',
  'overlay.ariaVoiceActive': 'Entrada de voz ativa',
  'overlay.companion.error': 'Erro',
  'overlay.companion.listening': 'Ouvindo…',
  'overlay.companion.speaking': 'Falando…',
  'overlay.companion.thinking': 'Pensando…',
  'overlay.orbTitle': 'Arraste para mover · Clique duplo para redefinir posição',
  'pages.settings.account.connections': 'Conexões',
  'pages.settings.account.connectionsDesc': 'Descrição de conexões',
  'pages.settings.account.migration': 'Importar de outro assistente',
  'pages.settings.account.migrationDesc':
    'Migre memória e anotações do OpenClaw (e, em breve, do Hermes) para este espaço de trabalho.',
  'pages.settings.account.privacy': 'Privacidade',
  'pages.settings.account.privacyDesc': 'Descrição de privacidade',
  'pages.settings.account.recoveryPhrase': 'Frase de recuperação',
  'pages.settings.account.recoveryPhraseDesc': 'Descrição da frase de recuperação',
  'pages.settings.account.team': 'Equipe',
  'pages.settings.account.teamDesc': 'Descrição de equipe',
  'pages.settings.accountSection.description':
    'Frase de recuperação, equipe, conexões e configurações de privacidade.',
  'pages.settings.accountSection.title': 'Conta',
  'pages.settings.ai.llm': 'LLM',
  'pages.settings.ai.llmDesc': 'Descrição do LLM',
  'pages.settings.ai.voice': 'Voz',
  'pages.settings.ai.voiceDesc': 'Descrição de voz',
  'pages.settings.aiSection.description':
    'Provedores de modelos de linguagem, Ollama local e voz (STT / TTS).',
  'pages.settings.aiSection.title': 'IA',
  'settings.developerMenu.composio.title': 'Composio',
  'settings.developerMenu.composio.desc':
    'Modo de roteamento, gatilhos de integração e arquivo de histórico de gatilhos.',
  'pages.settings.features.messagingChannels': 'Canais de mensagens',
  'pages.settings.features.messagingChannelsDesc': 'Descrição dos canais de mensagens',
  'pages.settings.features.notifications': 'Notificações',
  'pages.settings.features.notificationsDesc': 'Descrição de notificações',
  'pages.settings.features.tools': 'Ferramentas',
  'pages.settings.features.toolsDesc': 'Descrição de ferramentas',
  'pages.settings.featuresSection.title': 'Recursos',
  'privacy.dataKind.credentials': 'Credenciais',
  'privacy.dataKind.derived': 'Derivado',
  'privacy.dataKind.diagnostics': 'Diagnósticos',
  'privacy.dataKind.metadata': 'Metadados',
  'privacy.dataKind.raw': 'Bruto',
  'privacy.whatLeaves.link.label': 'O que sai do meu computador?',
  'rewards.community.achievementsUnlocked': '{unlocked} de {total} conquistas desbloqueadas',
  'rewards.community.activityStreakHint':
    'Dias consecutivos em que você esteve ativo no OpenHuman.',
  'rewards.community.activityTitle': 'Sua atividade',
  'rewards.community.claimCredited': '{amount} creditados no seu saldo',
  'rewards.community.claimError': 'Não foi possível resgatar. Tente novamente.',
  'rewards.community.claimTokens': 'Resgatar {tokens} tokens',
  'rewards.community.claimed': 'Resgatado',
  'rewards.community.claiming': 'Resgatando…',
  'rewards.community.connectDiscord': 'Conectar Discord',
  'rewards.community.connectDiscordError':
    'Não foi possível iniciar a conexão com o Discord. Tente novamente.',
  'rewards.community.connectingDiscord': 'Conectando…',
  'rewards.community.cumulativeTokens': 'Tokens acumulados',
  'rewards.community.currentStreak': 'Sequência de atividade',
  'rewards.community.disconnectDiscord': 'Desconectar',
  'rewards.community.disconnectDiscordError':
    'Não foi possível desconectar o Discord. Tente novamente.',
  'rewards.community.disconnectingDiscord': 'Desconectando…',
  'rewards.community.discordAccount': 'Conta do Discord',
  'rewards.community.discordConnected': 'Discord conectado',
  'rewards.community.discordConnectedAs': 'Conectado como {username}',
  'rewards.community.discordDetails': 'Discord',
  'rewards.community.discordLinkedNotInGuild': 'Discord vinculado mas não no servidor',
  'rewards.community.discordMember': 'Entrou no servidor',
  'rewards.community.discordNotLinked': 'Discord não vinculado',
  'rewards.community.discordServer': 'Servidor do Discord',
  'rewards.community.discordStatusUnavailable': 'Status do Discord indisponível',
  'rewards.community.discordWaiting': 'Aguardando Discord',
  'rewards.community.heroSubtitle': 'Subtítulo do herói',
  'rewards.community.heroTitle': 'Título do herói',
  'rewards.community.joinDiscord': 'Entrar no Discord',
  'rewards.community.loadingRewards': 'Carregando recompensas…',
  'rewards.community.locked': 'Desbloqueado',
  'rewards.community.longestStreak': 'Maior sequência',
  'rewards.community.retrying': 'Tentando novamente…',
  'rewards.community.rewardTokens': '+{tokens} tokens',
  'rewards.community.rewardTokensMonthly': '+{tokens} tokens/mês',
  'rewards.community.roleAssigned': 'Cargo atribuído',
  'rewards.community.roleAssignmentCount': '{assigned} de {unlocked} cargos atribuídos',
  'rewards.community.roleClaimDesc':
    'Você desbloqueou cargos do Discord, mas ainda não entrou no servidor do OpenHuman. Entre para que sejam atribuídos automaticamente.',
  'rewards.community.roleClaimTitle': 'Resgate seus cargos do Discord',
  'rewards.community.roleJoinToClaim': 'Entre no servidor para resgatar',
  'rewards.community.rolePending': 'Sincronizando cargo…',
  'rewards.community.rolesAndRewards': 'Funções e Recompensas',
  'rewards.community.streakDays': '{n} dias',
  'rewards.community.syncPending': 'Sincronização de recompensas pendente',
  'rewards.community.syncPendingDesc': 'Descrição de sincronização pendente',
  'rewards.community.syncUnavailable': 'Sincronização indisponível',
  'rewards.community.tryAgain': 'Tentando novamente…',
  'rewards.community.unknown': 'Desconhecido',
  'rewards.community.unlocked': 'Desbloqueado',
  'rewards.community.yourProgress': 'Seu Progresso',
  'rewards.coupon.colCode': 'Código',
  'rewards.coupon.colRedeemed': 'Resgatado',
  'rewards.coupon.colReward': 'Recompensa',
  'rewards.coupon.colStatus': 'Status',
  'rewards.coupon.loadingHistory': 'Carregando histórico de recompensas…',
  'rewards.coupon.noCodes': 'Nenhum código de recompensa resgatado ainda.',
  'rewards.coupon.pending': 'Pendente',
  'rewards.coupon.placeholder': 'Código de cupom',
  'rewards.coupon.promoCredits': 'Créditos promocionais',
  'rewards.coupon.recentRedemptions': 'Resgates recentes',
  'rewards.coupon.redeemAccepted':
    '{code} aceito. {amount} será desbloqueado após a ação necessária ser concluída.',
  'rewards.coupon.redeemButton': 'Resgatar Código',
  'rewards.coupon.redeemSuccess': '{code} resgatado. {amount} foi adicionado aos seus créditos.',
  'rewards.coupon.redeemedCodes': 'Códigos resgatados',
  'rewards.coupon.redeeming': 'Resgatando...',
  'rewards.coupon.statusApplied': 'Aplicado',
  'rewards.coupon.statusPendingAction': 'Ação pendente',
  'rewards.coupon.statusRedeemed': 'Resgatado',
  'rewards.coupon.subtitle': 'Subtítulo',
  'rewards.coupon.title': 'Resgatar um código de cupom',
  'rewards.referralSection.activity': 'Atividade de indicações',
  'rewards.referralSection.apply': 'Aplicando…',
  'rewards.referralSection.applying': 'Aplicando…',
  'rewards.referralSection.colReferredUser': 'Usuário indicado',
  'rewards.referralSection.colReward': 'Recompensa',
  'rewards.referralSection.colStatus': 'Status',
  'rewards.referralSection.colUpdated': 'Atualizado',
  'rewards.referralSection.completed': 'Concluído',
  'rewards.referralSection.copyCode': 'Copiar código',
  'rewards.referralSection.copyFailed': 'Falha ao copiar',
  'rewards.referralSection.haveCode': 'Tem um código de indicação?',
  'rewards.referralSection.haveCodeDesc': 'Descrição do código',
  'rewards.referralSection.linked': 'Vinculado',
  'rewards.referralSection.linkedCode': '(código {code})',
  'rewards.referralSection.loading': 'Carregando programa de indicações…',
  'rewards.referralSection.retry': 'Tentar novamente',
  'rewards.referralSection.noReferrals': 'Sem indicações',
  'rewards.referralSection.pendingReferrals': 'Indicações pendentes',
  'rewards.referralSection.placeholder': 'Código de indicação',
  'rewards.referralSection.share': 'Compartilhar',
  'rewards.referralSection.statusCompleted': 'Status concluído',
  'rewards.referralSection.statusExpired': 'Status expirado',
  'rewards.referralSection.statusJoined': 'Status de ingresso',
  'rewards.referralSection.subtitle': 'Subtítulo',
  'rewards.referralSection.title': 'Convide amigos, ganhe créditos',
  'rewards.referralSection.totalEarned': 'Total ganho',
  'rewards.referralSection.yourCode': 'Seu código',
  'settings.ai.addCloudProvider': 'Adicionar provedor de nuvem',
  'settings.ai.addProvider': 'Salvando…',
  'settings.ai.apiKeyFieldLabel': 'Rótulo do campo de chave de API',
  'settings.ai.apiKeyRequired': 'Por favor, cole sua chave de API para continuar.',
  'settings.ai.apiKeyStoredEncrypted': 'Chave de API armazenada criptografada',
  'settings.ai.apiKeysEncrypted': 'auth-profiles.json',
  'settings.ai.clearStoredKey': 'Limpar chave armazenada',
  'settings.ai.connectProvider': 'Conectar provedor',
  'settings.ai.customRouting': 'Roteamento personalizado',
  'settings.ai.defaultResolvesTo': 'O padrão resolve para',
  'settings.ai.discard': 'Descartar',
  'settings.ai.editProvider': 'Editar provedor',
  'settings.ai.llmProviders': 'Provedores LLM',
  'settings.ai.llmProvidersDesc': 'Descrição dos provedores LLM',
  'settings.ai.localOllama': 'Local (Ollama)',
  'settings.ai.modelLabel': 'Modelo',
  'settings.ai.noCustomProviders': 'Sem provedores personalizados',
  'settings.ai.openAiCompat.authHeaderExample': 'Autorização: Portador <sua chave>',
  'settings.ai.openAiCompat.authHeaderLabel': 'Cabeçalho de autenticação',
  'settings.ai.openAiCompat.baseUrlLabel': 'URL base',
  'settings.ai.openAiCompat.baseUrlUnavailable': 'Indisponível',
  'settings.ai.openAiCompat.clearKey': 'Limpar chave',
  'settings.ai.openAiCompat.description':
    'Aponte os harnesses locais para este servidor /v1 para rotear através dos provedores configurados abaixo. A autenticação usa uma chave estável que você define aqui, e não o bearer interno do núcleo do aplicativo.',
  'settings.ai.openAiCompat.keyConfigured': 'Chave configurada',
  'settings.ai.openAiCompat.keyRequired': 'Chave necessária',
  'settings.ai.openAiCompat.rotateKey': 'Girar chave',
  'settings.ai.openAiCompat.setKey': 'Definir chave',
  'settings.ai.openAiCompat.title': 'Endpoint compatível com OpenAI',
  'settings.ai.providerLabel': 'Provedor',
  'skills.mcpComingSoon.title': 'MCP Servidores',
  'skills.mcpComingSoon.description':
    'O gerenciamento de servidores MCP chegará em breve. Esta aba será o local para descobrir, conectar e monitorar suas integrações de servidores MCP.',
  'settings.ai.routing': 'Roteamento',
  'settings.ai.claudeCode.button': 'Claude Code',
  'settings.ai.claudeCode.inlineNotConnected':
    'Não conectado: encaminha o chat pela sua Claude Code CLI local.',
  'settings.ai.claudeCode.checkingSignIn': 'Verificando login…',
  'settings.ai.claudeCode.inlineConnected': 'Conectado.',
  'settings.ai.claudeCode.signedInAs': 'Conectado como',
  'settings.ai.claudeCode.subscriptionFallback': 'Assinatura do Claude',
  'settings.ai.claudeCode.usingApiKeyEnv': 'Usando ANTHROPIC_API_KEY',
  'settings.ai.claudeCode.cliNotInstalled': 'CLI não instalada',
  'settings.ai.claudeCode.signInUnknown': 'Estado de login desconhecido',
  'settings.ai.claudeCode.connectedNotSignedIn': 'Conectado · não autenticado',
  'settings.ai.claudeCode.modalTitle': 'Claude Code CLI',
  'settings.ai.claudeCode.modelHelp':
    'Um ID de modelo aceito pela CLI claude: um alias (sonnet, opus) ou um nome completo (claude-sonnet-4-5). Ele é repassado sem alterações para claude --model, portanto nomes comerciais como sonnet-4-5 são recusados.',
  'settings.ai.claudeCode.modalDescription':
    'Encaminha cargas de chat, agênticas e de raciocínio pela sua Claude Code CLI instalada localmente. Sem chave de API: usa o próprio login da CLI.',
  'settings.ai.claudeCode.close': 'Fechar',
  'settings.ai.claudeCode.connection': 'Conexão',
  'settings.ai.claudeCode.enabled': 'Ativado',
  'settings.ai.claudeCode.notEnabled': 'Não ativado',
  'settings.ai.claudeCode.disconnect': 'Desconectar',
  'settings.ai.claudeCode.disconnecting': 'Desconectando…',
  'settings.ai.claudeCode.enable': 'Ativar Claude Code',
  'settings.ai.claudeCode.enabling': 'Ativando…',
  'settings.ai.claudeCode.authentication': 'Autenticação',
  'settings.ai.claudeCode.recheck': 'Verificar novamente',
  'settings.ai.claudeCode.checking': 'Verificando…',
  'settings.ai.claudeCode.openingTerminal': 'Abrindo terminal…',
  'settings.ai.claudeCode.signIn': 'Entrar com Claude',
  'settings.ai.claudeCode.reconnect': 'Reconectar',
  'settings.ai.claudeCode.loginHint':
    'Abre um terminal executando claude login. Quando terminar, clique em Verificar novamente.',
  'settings.ai.claudeCode.loginError':
    'Não foi possível abrir o terminal de login. Tente novamente.',
  'settings.ai.claudeCode.fullAccess': 'Acesso total',
  'settings.ai.claudeCode.fullAccessOn':
    'O Claude Code pode executar comandos, usar a rede e criar subagentes.',
  'settings.ai.claudeCode.fullAccessOff':
    'Aceitar apenas edições: aplica edições de arquivos automaticamente e restringe comandos e rede.',
  'settings.ai.claudeCode.sandboxNoteMac':
    'No macOS, ~/.openhuman permanece protegido pelo sandbox em ambos os modos.',
  'settings.ai.claudeCode.sandboxNoteOther':
    'O acesso total não tem restrições nesta plataforma: ative-o apenas se confiar no espaço de trabalho.',
  'settings.ai.claudeCode.enableToCheck': 'Ative o Claude Code para verificar o login.',
  'settings.ai.claudeCode.usingApiKeyEnvDetail': 'Usando ANTHROPIC_API_KEY do ambiente.',
  'settings.ai.claudeCode.notFoundInstall':
    'Claude Code CLI não encontrada: instale com: npm install -g @anthropic-ai/claude-code',
  'settings.ai.claudeCode.unknownDetail':
    'Não foi possível determinar o estado de login. Sua claude CLI pode ser anterior ao status de autenticação: tente Reconectar e depois Verificar novamente.',
  'settings.ai.claudeCode.notSignedIn': 'Não autenticado.',
  'settings.ai.routingCustom': 'Roteamento personalizado',
  'settings.ai.routingDefault': 'Padrão',
  'settings.ai.routingDesc': 'Descrição do roteamento',
  'settings.ai.saveChanges': 'Salvando…',
  'settings.ai.saving': 'Salvando…',
  'settings.ai.unsavedChange': 'alteração não salva',
  'settings.ai.unsavedChanges': 'alterações não salvas',
  'settings.ai.workloadGroupBackground': 'Grupo de carga de trabalho em segundo plano',
  'settings.ai.workloadGroupChat': 'Grupo de carga de trabalho de chat',
  'settings.ai.disconnectProvider': 'Desconecte {label}',
  'settings.ai.connectProviderLabel': 'Conecte {label}',
  'settings.ai.editProviderEndpoint': 'Editar ponto de extremidade de {label}',
  'settings.ai.defaultLocalEndpoint': 'http://localhost:11434/v1',
  'settings.ai.editEndpoint': 'Editar ponto de extremidade',
  'settings.ai.endpointUrlLabel': 'Ponto de extremidade URL',
  'settings.ai.localRuntimeHelper':
    'Onde {label} é acessível. O padrão é localhost; aponte isso para um host remoto (por exemplo, http://10.0.0.4:11434/v1) para usar uma instância compartilhada.',
  'settings.ai.endpointUrlRequired': 'Endpoint URL é necessário.',
  'settings.ai.endpointProtocolRequired': 'Endpoint deve começar com http:// ou https://.',
  'settings.ai.connectProviderDialog': 'Conectar {label}',
  'settings.ai.getProviderApiKey': 'Obter API Key',
  'settings.ai.or': 'Ou',
  'settings.ai.codexOauthMissingAuthUrl':
    'O Codex OAuth não retornou uma URL de autorização. Tente entrar novamente.',
  'settings.ai.codexOauthMissingCallbackUrl':
    'Cole a URL de redirecionamento do seu navegador após entrar.',
  'settings.ai.openRouterOauthDescription':
    'Faça login com OpenRouter e importe uma chave API controlada pelo usuário usando PKCE.',
  'settings.ai.connecting': 'Conectando...',
  'settings.ai.codexAuthButton': 'Conectar Codex',
  'settings.ai.codexAuthHelper': 'Usa o login existente da CLI do Codex de ~/.codex/auth.json.',
  'settings.ai.backgroundLoops': 'Loops de segundo plano.',
  'settings.ai.backgroundLoopsDesc':
    'Veja o que funciona sem uma mensagem de chat, pause o trabalho do pulso e inspecione as linhas recentes do livro razão de créditos.',
  'settings.ai.heartbeatControls': 'Controles de pulsação',
  'settings.ai.heartbeatControlsDesc':
    'Padrões desativados. Ativar inicia o loop; desativar aborta a tarefa em execução.',
  'settings.ai.heartbeatLoop': 'Loop de pulsação',
  'settings.ai.heartbeatLoopDesc':
    'Agendador mestre para planejador + inferência subconsciente opcional.',
  'settings.ai.subconsciousInference': 'Inferência subconsciente',
  'settings.ai.subconsciousInferenceDesc':
    'Executa avaliação task/reflection com suporte a modelo em batimentos de pulso.',
  'settings.ai.calendarMeetingChecks': 'Verificações de reuniões do calendário',
  'settings.ai.calendarMeetingChecksDesc':
    'Chama a lista de eventos do calendário para conexões ativas do Calendário Google.',
  'settings.ai.calendarCap': 'Limite do calendário',
  'settings.ai.connectionsPerTick': '{count} conn/tick',
  'settings.ai.meetingLookahead': 'Antecipação da reunião',
  'settings.ai.minutesShort': '{count} min',
  'settings.ai.reminderLookahead': 'Antecipação do lembrete',
  'settings.ai.cronReminderChecks': 'Verificações de lembretes do Cron',
  'settings.ai.cronReminderChecksDesc':
    'Verifica trabalhos agendados no cron para itens futuros semelhantes a lembretes.',
  'settings.ai.relevantNotificationChecks': 'Verificações de notificações relevantes',
  'settings.ai.relevantNotificationChecksDesc':
    'Promove notificações locais urgentes em alertas proativos.',
  'settings.ai.externalDelivery': 'Entrega externa',
  'settings.ai.externalDeliveryDesc':
    'Vamos fazer com que os alertas de batimento cardíaco enviem mensagens proativas para canais externos.',
  'settings.ai.interval': 'Intervalo',
  'settings.ai.running': 'Em execução...',
  'settings.ai.plannerTickNow': 'Marcação do planejador agora',
  'settings.ai.loadingHeartbeatControls': 'Carregando controles de pulsação...',
  'settings.ai.heartbeatControlsUnavailable': 'Controles de pulsação indisponíveis.',
  'settings.ai.loopMap': 'Mapa de loop',
  'settings.ai.plannerSummary':
    'Planejador: {sourceEvents} eventos de origem, {sent} enviados, {deduped} desduplicados.',
  'settings.ai.routeLabel': 'rota: {route}',
  'settings.ai.on': 'ativado',
  'settings.ai.off': 'desativado',
  'settings.ai.recentUsageLedger': 'Razão de uso recente',
  'settings.ai.recentUsageLedgerDesc':
    'As linhas do backend expõem action/time hoje; as tags de origem precisam de suporte do backend.',
  'settings.ai.latestSpend': 'Último gasto: {amount} em {time} ({action})',
  'settings.ai.topActions': 'Principais ações',
  'settings.ai.noSpendRows': 'Nenhuma linha de gastos carregada.',
  'settings.ai.topHours': 'Principais horários',
  'settings.ai.noHourlySpend': 'Ainda não há gasto por hora.',
  'settings.ai.openhumanDefault': 'OpenHuman (padrão)',
  'settings.ai.localModelResolved': 'Ollama · {model}',
  'settings.ai.customRoutingForWorkload': 'Roteamento personalizado para {label}',
  'settings.ai.loadingModels': 'Carregando modelos...',
  'settings.ai.enterModelIdManually': 'ou insira o ID do modelo manualmente:',
  'settings.ai.modelIdPlaceholderForProvider': '{slug} ID do modelo',
  'settings.ai.modelIdPlaceholder': 'model-id',
  'settings.ai.selectModel': 'Selecione um modelo...',
  'settings.ai.deploymentNameLabel': 'Nome da implantação',
  'settings.ai.deploymentNamePlaceholder': 'my-gpt-deployment',
  'settings.ai.deploymentNameHelp':
    'Digite o nome da implantação que você definiu no Azure AI Foundry. Este não é o ID do modelo.',
  'settings.ai.deploymentNameLegacyHint':
    'Este valor corresponde a um ID de modelo base do catálogo do provedor. O Azure roteia as solicitações pelo nome da implantação, portanto confirme que este é o nome que você deu à sua implantação.',
  'settings.ai.deploymentNameProviderHint':
    'Endpoint do Azure detectado. Defina o nome da sua implantação no campo do modelo depois de escolher este provedor.',
  'settings.ai.chooseModelFromList': 'Escolher da lista',
  'settings.ai.enterModelIdManuallyAction': 'Inserir o ID do modelo manualmente',
  'settings.ai.enterDeploymentNameManuallyAction': 'Inserir o nome da implantação manualmente',
  'settings.ai.probeFailedHint':
    'Não foi possível ler a lista de modelos deste provedor. Essa lista só preenche o menu suspenso, portanto você ainda pode adicionar o provedor e digitar o nome do modelo ou da implantação.',
  'settings.ai.probeFailedAddAnyway': 'Adicionar sem verificar',
  'settings.ai.azureV1EndpointHint':
    'No Azure, use o URL base v1: https://YOUR-RESOURCE.openai.azure.com/openai/v1. O URL de recurso antigo não fornece uma lista de modelos e espera outro cabeçalho de autenticação.',
  'settings.ai.temperatureOverride': 'Substituição de temperatura',
  'settings.ai.temperatureOverrideSlider': 'Substituição de temperatura (controle deslizante)',
  'settings.ai.temperatureOverrideValue': 'Substituição de temperatura (valor)',
  'settings.ai.temperatureOverrideDesc':
    'Mais baixo = mais determinístico. Deixe desmarcado para usar o padrão do provedor.',
  'settings.ai.modelVision': 'Suporta visão (entrada de imagem)',
  'settings.ai.modelVisionDesc':
    'Ative se este modelo aceitar imagens. Permite anexar imagens no chat quando este modelo está selecionado.',
  'settings.ai.testFailed': 'Teste falhou',
  'settings.ai.providerTest.authRejected':
    "A chave foi salva, mas '{slug}' a recusou. Verifique se você colou a chave inteira e se ela continua ativa no painel do provedor.",
  'settings.ai.providerTest.modelNotRecognized':
    "A chave foi salva e aceita, mas '{slug}' não reconhece o modelo selecionado. Escolha um id de modelo que este provedor realmente ofereça (o modelo padrão é definido no registro do provedor).",
  'settings.ai.providerTest.quotaOrBilling':
    "A chave foi salva e aceita, mas '{slug}' recusou a solicitação por motivos de cota ou faturamento. Verifique o saldo da sua conta e os limites de uso com o provedor.",
  'settings.ai.providerTest.endpointNotFound':
    "A chave foi salva, mas o endpoint configurado para '{slug}' retornou 404. Verifique a URL base: um provedor compatível com OpenAI normalmente precisa do sufixo '/v1' (por exemplo, https://api.openai.com/v1).",
  'settings.ai.providerTest.timeout':
    "A chave foi salva, mas '{slug}' não respondeu a tempo. Verifique a URL do endpoint e sua rede e teste novamente.",
  'settings.ai.providerTest.emptyReply':
    "A chave foi salva, mas '{slug}' retornou uma resposta vazia a um prompt de teste. Verifique o id do modelo configurado para este provedor.",
  'settings.ai.providerTest.unknown':
    "A chave foi salva, mas uma chamada de teste para '{slug}' falhou. Verifique a página de status do provedor e a URL do endpoint e teste novamente.",
  'settings.ai.testingModel': 'Modelo de teste...',
  'settings.ai.modelResponse': 'Resposta do modelo',
  'settings.ai.providerWithValue': 'Provedor: {value}',
  'settings.ai.noneDash': 'Nenhum',
  'settings.ai.promptHelloWorld': 'Prompt: Olá, mundo',
  'settings.ai.startedAt': 'Iniciado: {value}',
  'settings.ai.waitingForModelResponse': 'Aguardando resposta do modelo selecionado...',
  'settings.ai.response': 'Resposta',
  'settings.ai.testing': 'Testando...',
  'settings.ai.test': 'Teste',
  'settings.ai.slugMissingError': 'Insira um nome de provedor para gerar um slug.',
  'settings.ai.slugInUseError': 'Esse nome de provedor já está em uso.',
  'settings.ai.slugReservedError': 'Escolha um nome de provedor diferente.',
  'settings.ai.providerNamePlaceholder': 'Meu provedor',
  'settings.ai.slugLabel': 'Lesma:',
  'settings.ai.openAiUrlLabel': 'URL da OpenAI',
  'settings.ai.openAiUrlPlaceholder': 'https://api.openai.com/v1',
  'settings.ai.keepExistingKeyPlaceholder': 'Deixe em branco para manter a chave existente',
  'settings.ai.reindexingMemory': 'Reindexando a memória',
  'settings.ai.reindexingMemoryMessage':
    'Os embeddings estão sendo reprocessados. O(s) item(s) de memória {pending} estão sendo re-embarcados sob o modelo atual: a recordação semântica é reduzida até que isso termine. A busca por palavras-chave continua funcionando, e a re-embarcação continua em segundo plano se você fechar isto.',
  'settings.ai.signInWithOpenRouter': 'Faça login com OpenRouter',
  'settings.ai.weekBudget': 'Orçamento semanal',
  'settings.ai.cycleRemaining': 'Ciclo restante',
  'settings.ai.cycleTotalSpend': 'Gasto total do ciclo',
  'settings.ai.avgSpendRow': 'Linha de gasto médio',
  'settings.ai.backgroundApiReads': 'Bg API lê',
  'settings.ai.backgroundWakeups': 'Ativações de Bg',
  'settings.ai.budgetMath': 'Matemática do orçamento',
  'settings.ai.rowsLeft': 'Linhas restantes',
  'settings.ai.rowsPerFullWeekBudget': 'Linhas por orçamento de semana inteira',
  'settings.ai.sampleBurnRate': 'Taxa de queima de amostra',
  'settings.ai.projectedEmpty': 'Vazio projetado',
  'settings.ai.apiReadsPerDollarRemaining': 'API leituras por $ restantes',
  'settings.ai.loopCallBudget': 'Orçamento de chamada de loop',
  'settings.ai.heartbeatTicks': 'Pulsações',
  'settings.ai.calendarPlannerCalls': 'Chamadas do planejador de calendário',
  'settings.ai.calendarFanoutCap': 'Limite de fanout do calendário',
  'settings.ai.subconsciousModelCalls': 'Chamadas de modelo subconsciente',
  'settings.ai.composioSyncScans': 'Composio varreduras de sincronização',
  'settings.ai.totalBackgroundApiReadBudget': 'Total bg API orçamento de leitura',
  'settings.ai.memoryWorkerPolls': 'Pesquisas de trabalho de memória',
  'settings.ai.defaultProviderName': 'OpenHuman',
  'settings.ai.routing.managed': 'Gerenciadas',
  'settings.ai.routing.managedAlwaysOn': 'Sempre ligado',
  'settings.ai.routing.managedHint':
    'Gerenciado está sempre disponível como alternativa. Para usar seu próprio modelo, escolha um modo de roteamento abaixo.',
  'settings.ai.routing.managedDesc':
    'OpenHuman executará toda a inferência na nuvem, escolherá o melhor modelo para a tarefa, otimizará os custos e manterá os padrões de roteamento mais seguros.',
  'settings.ai.routing.managedMsg':
    'OpenHuman irá gerenciar toda a inferência para cada carga de trabalho e escolherá automaticamente a melhor rota em termos de custo, qualidade e segurança.',
  'settings.ai.routing.useYourOwn': 'Use seus próprios modelos',
  'settings.ai.routing.useYourOwnDesc':
    'Escolha um provedor + modelo e direcione todas as cargas de trabalho através dele. Isso é simples, mas pode ser ineficiente porque inferências leves e pesadas compartilham a mesma rota.',
  'settings.ai.routing.advanced': 'Avançado',
  'settings.ai.routing.advancedDesc':
    'Escolha modelos diferentes para tarefas diferentes. Esta é a melhor opção para otimização de custos rigorosa e o máximo de controle.',
  'settings.ai.routing.customDesc':
    'O roteamento detalhado oferece a melhor otimização de custos e o máximo de controle. Use as linhas abaixo para decidir quais cargas de trabalho permanecem Gerenciadas, quais usam seu padrão compartilhado e quais são fixadas a um modelo específico.',
  'settings.ai.routing.chatAndConversations': 'Bate-papo e conversas',
  'settings.ai.routing.chatDesc':
    'Modelos usados durante a interação direta com o usuário, respostas, raciocínio, ciclos de agentes e ajuda com programação.',
  'settings.ai.routing.backgroundTasks': 'Tarefas de segundo plano',
  'settings.ai.routing.bgTasksDesc':
    'Modelos usados fora do fluxo principal de conversa para resumir, monitoramento, aprendizado e avaliação subconsciente.',
  'settings.ai.routing.workload.chat.label': 'Chat',
  'settings.ai.routing.workload.chat.description':
    'Conversa direta entre conversas: modo “Rápido” em Conversas',
  'settings.ai.routing.workload.chat.hint':
    'Recomendado: um modelo de chat rápido barato ou de custo médio com altos tokens/s e baixa latência. Modelos locais de código aberto podem funcionar bem aqui se forem responsivos.',
  'settings.ai.routing.workload.reasoning.label': 'Reasoning',
  'settings.ai.routing.workload.reasoning.description':
    'Agente principal do chat, resumidor da reunião: modo “Raciocínio” em Conversas',
  'settings.ai.routing.workload.reasoning.hint':
    'Recomendado: uma fronteira mais cara ou um modelo de raciocínio forte para pensamento profundo. Isso é usado para o agente de chat principal, resumos de reuniões e síntese de respostas mais pesadas.',
  'settings.ai.routing.workload.agentic.label': 'Agentic',
  'settings.ai.routing.workload.agentic.description':
    'Executores de subagentes, loops de ferramentas, decisões GIF',
  'settings.ai.routing.workload.agentic.hint':
    'Recomendado: um modelo confiável de seguimento de instruções com forte uso de ferramentas. Os modelos fronteiriços de custo médio são geralmente mais seguros; modelos de código aberto capazes podem funcionar se a chamada de ferramenta for estável.',
  'settings.ai.routing.workload.coding.label': 'Coding',
  'settings.ai.routing.workload.coding.description': 'Geração de código e refatorações',
  'settings.ai.routing.workload.coding.hint':
    'Recomendado: um modelo ajustado para codificação com forte acompanhamento de instruções, qualidade de edição e desempenho em contexto longo. Geralmente vale a pena gastar mais nisso.',
  'settings.ai.routing.workload.vision.label': 'Vision',
  'settings.ai.routing.workload.vision.description':
    'Compreensão da imagem para o subagente da visão: sempre multimodal',
  'settings.ai.routing.workload.vision.hint':
    'Recomendado: um modelo multimodal que aceita entrada de imagem. O padrão gerenciado (vision-v1) é compatível com imagens; qualquer fornecedor que você encaminhar para cá é sempre tratado como capacitado para visão.',
  'settings.ai.routing.workload.memory.label': 'Resumo de memória',
  'settings.ai.routing.workload.memory.description': 'Extratos de árvores e consolidações',
  'settings.ai.routing.workload.memory.hint':
    'Recomendado: um modelo de resumo mais barato. Deve ser consistente e compacto, mas não necessita de raciocínio de nível superior de fronteira.',
  'settings.ai.routing.workload.heartbeat.label': 'Heartbeat',
  'settings.ai.routing.workload.heartbeat.description':
    'Raciocínio de fundo entre turnos de usuário',
  'settings.ai.routing.workload.heartbeat.hint':
    'Recomendado: um modelo de fundo barato e eficiente. Isso ocorre frequentemente entre os turnos, então o baixo custo é mais importante do que a inteligência máxima.',
  'settings.ai.routing.workload.learning.label': 'Aprendizagem · Reflexões',
  'settings.ai.routing.workload.learning.description':
    'Reflexão periódica sobre a história recente',
  'settings.ai.routing.workload.learning.hint':
    'Recomendado: um modelo reflexivo mais forte. Pode ser de custo médio ou premium porque se beneficia de uma melhor síntese ao longo da história recente.',
  'settings.ai.routing.workload.subconscious.label': 'Subconscious',
  'settings.ai.routing.workload.subconscious.description':
    'Pontuação de eventos + verificações de desvios',
  'settings.ai.routing.workload.subconscious.hint':
    'Recomendado: um modelo de monitoramento muito barato, de preferência leve e previsível. Isso é para pontuação de eventos, verificações de desvios e avaliação silenciosa de antecedentes.',
  'settings.ai.routing.addCustomProvider': 'Adicionar provedor personalizado',
  'settings.ai.globalModel.title': 'Escolha um modelo para tudo',
  'settings.ai.globalModel.desc':
    'Isso direciona toda a inferência através de um modelo. É mais simples, mas pode ser ineficiente em termos de custo e qualidade porque tarefas leves e pesadas usarão todas o mesmo caminho.',
  'settings.ai.globalModel.noProviders':
    'Adicione ou conecte um provedor primeiro. Então você pode direcionar toda carga de trabalho através de um modelo aqui.',
  'settings.ai.globalModel.provider': 'Provedor',
  'settings.ai.globalModel.model': 'Modelo',
  'settings.ai.globalModel.loadingModels': 'Carregando modelos…',
  'settings.ai.globalModel.enterModelId': 'Insira o ID do modelo',
  'settings.ai.globalModel.appliesToAll':
    'Aplica o mesmo provedor + modelo ao chat, raciocínio, codificação, memória, batimento cardíaco, aprendizado e subconsciente. Embeddings são configurados separadamente. As alterações são salvas quando você clica em salvar.',
  'settings.ai.globalModel.saving': 'Salvando…',
  'settings.ai.globalModel.saved': 'Salvo',
  'settings.ai.workload.noModel': 'Nenhum modelo selecionado',
  'settings.ai.workload.changeModel': 'Alterar modelo',
  'settings.ai.workload.chooseModel': 'Escolher modelo',
  'settings.ai.provider.ollama': 'Ollama',
  'settings.billing.autoRecharge.addAmount': 'Adicionar este valor',
  'settings.billing.autoRecharge.addCard': 'Adicionar cartão',
  'settings.billing.autoRecharge.amountHint': 'Dica de valor',
  'settings.billing.autoRecharge.defaultCard': 'Cartão padrão',
  'settings.billing.autoRecharge.lastRechargeFailed': 'Última recarga falhou',
  'settings.billing.autoRecharge.lastRecharged': 'Última recarga',
  'settings.billing.autoRecharge.expires': 'Expira {date}',
  'settings.billing.autoRecharge.noCards': 'Sem cartões',
  'settings.billing.autoRecharge.paymentMethods': 'Métodos de Pagamento',
  'settings.billing.autoRecharge.rechargeInProgress': 'Recarga em andamento',
  'settings.billing.autoRecharge.spentThisWeek': '${spent} de ${limit} usado esta semana',
  'settings.billing.autoRecharge.rechargeWhen': 'Recarregar quando o saldo cair abaixo de',
  'settings.billing.autoRecharge.saveSettings': 'Salvando…',
  'settings.billing.autoRecharge.saving': 'Salvando…',
  'settings.billing.autoRecharge.setDefault': ':',
  'settings.billing.autoRecharge.subtitle': 'Subtítulo',
  'settings.billing.autoRecharge.title': 'Ativar Recarga Automática',
  'settings.billing.autoRecharge.toggleAriaLabel': 'Alternar recarga automática',
  'settings.billing.autoRecharge.weeklyLimit': 'Limite de gastos semanal',
  'settings.billing.history.desc': 'Descrição',
  'settings.billing.history.empty': 'Vazio',
  'settings.billing.history.openPortal': 'Abrir portal',
  'settings.billing.history.posted': 'Postado',
  'settings.billing.history.title': 'Título',
  'settings.billing.inferenceBudget.cycleEnds': 'Ciclo termina',
  'settings.billing.inferenceBudget.exhausted': 'Esgotado',
  'settings.billing.inferenceBudget.loadError': 'Erro de carregamento',
  'settings.billing.inferenceBudget.noBudgetDesc': 'Descrição sem orçamento',
  'settings.billing.inferenceBudget.noRecurringBudget': 'Sem orçamento recorrente',
  'settings.billing.inferenceBudget.noRecurringPlanBudget': 'Nenhum orçamento de plano recorrente',
  'settings.billing.inferenceBudget.noRecurringWeeklyDesc':
    'Seu plano atual não inclui um orçamento recorrente de inferência semanal. O uso é pago a partir dos créditos disponíveis, em vez disso.',
  'settings.billing.inferenceBudget.remaining': 'Restante',
  'settings.billing.inferenceBudget.remainingSummary': '{remaining} / {budget} restantes',
  'settings.billing.inferenceBudget.spentThisCycle': 'Gasto {amount} neste ciclo',
  'settings.billing.inferenceBudget.cycleEndsOn': 'O ciclo termina em {date}',
  'settings.billing.inferenceBudget.exhaustedDesc':
    'O uso da assinatura incluída foi esgotado. Recarregue créditos para continuar usando AI sem esperar pelo próximo ciclo.',
  'settings.billing.inferenceBudget.discountVsPayg':
    '{pct}% mais barato por chamada do que pagar conforme o uso.',
  'settings.billing.inferenceBudget.cycleSpend': 'Gasto do ciclo',
  'settings.billing.inferenceBudget.totalAmount': '{amount} no total',
  'settings.billing.inferenceBudget.inference': 'Inferência',
  'settings.billing.inferenceBudget.integrations': 'Integrações',
  'settings.billing.inferenceBudget.calls': '{count} chamadas',
  'settings.billing.inferenceBudget.dailySpend': 'Gasto diário',
  'settings.billing.inferenceBudget.dailySpendPoint': '{date}: {amount}',
  'settings.billing.inferenceBudget.topModels': 'Principais modelos',
  'settings.billing.inferenceBudget.noInferenceUsage': 'Nenhum uso de inferência neste ciclo.',
  'settings.billing.inferenceBudget.topIntegrations': 'Principais integrações',
  'settings.billing.inferenceBudget.noIntegrationUsage': 'Nenhum uso de integração neste ciclo.',
  'settings.billing.inferenceBudget.tenHourCap': 'Limite de dez horas',
  'settings.billing.inferenceBudget.title': 'Título',
  'settings.billing.inferenceBudget.unableToLoad': 'Não foi possível carregar os dados de uso',
  'settings.billing.inferenceBudget.notAvailable': 'n/a',
  'settings.billing.payAsYouGo.available': 'Disponível',
  'settings.billing.payAsYouGo.chargeCustomAmount': 'Abrindo…',
  'settings.billing.payAsYouGo.chooseTopUpDesc': 'Descrição de recarga',
  'settings.billing.payAsYouGo.chooseTopUpTitle': 'Título de recarga',
  'settings.billing.payAsYouGo.creditBalanceDesc': 'Descrição do saldo de crédito',
  'settings.billing.payAsYouGo.creditBalanceTitle': 'Título do saldo de crédito',
  'settings.billing.payAsYouGo.customAmount': 'Valor personalizado',
  'settings.billing.payAsYouGo.enterAmount': 'Inserir valor',
  'settings.billing.payAsYouGo.opening': 'Abrindo',
  'settings.billing.payAsYouGo.promotionalCredits': 'Créditos Promocionais',
  'settings.billing.payAsYouGo.topUpBalance': 'Recarregar Saldo',
  'settings.billing.payAsYouGo.topUpCredits': 'Recarregar Créditos',
  'settings.billing.payAsYouGo.unableToLoad': 'Não foi possível carregar o saldo.',
  'settings.billing.subscription.annual': 'Anual',
  'settings.billing.subscription.billedAnnually': 'Cobrado anualmente',
  'settings.billing.subscription.chooseSubtitle': 'Subtítulo de escolha',
  'settings.billing.subscription.chooseTitle': 'Título de escolha',
  'settings.billing.subscription.cryptoDesc': 'Descrição de cripto',
  'settings.billing.subscription.cryptoQuestion': 'Pergunta sobre cripto',
  'settings.billing.subscription.current': 'Atual',
  'settings.billing.subscription.currentPlan': 'Plano atual',
  'settings.billing.subscription.monthly': 'Mensal',
  'settings.billing.subscription.paymentConfirmed': 'Pagamento confirmado',
  'settings.billing.subscription.perMonth': 'Por mês',
  'settings.billing.subscription.popular': 'Popular',
  'settings.billing.subscription.save': '{pct}',
  'settings.billing.subscription.upgrade': 'Fazer upgrade',
  'settings.billing.subscription.waiting': 'Aguardando',
  'settings.billing.subscription.waitingPayment': 'Aguardando pagamento',
  'settings.composio.apiKeyDesc':
    'Uma chave de API do Composio está atualmente armazenada neste dispositivo.',
  'settings.composio.apiKeyExamplePlaceholder': 'ck_live_xxxxxxxxxxxxxxx',
  'settings.composio.apiKeyLabel': 'Chave de API do Composio',
  'settings.composio.apiKeyStored': 'Chave de API armazenada',
  'settings.composio.apiKeyStoredPlaceholder': '••••••••••••••••',
  'settings.composio.clearedToBackend': 'Alternado para modo Backend',
  'settings.composio.confirmItem1': 'Uma conta em app.composio.dev com uma chave de API',
  'settings.composio.confirmItem2':
    'Religar cada integração através da sua conta pessoal do Composio',
  'settings.composio.confirmItem3':
    'Observação: gatilhos do Composio (webhooks em tempo real) ainda não funcionam no modo Direto: apenas chamadas síncronas de ferramentas',
  'settings.composio.confirmNeedItems': 'Você precisará de:',
  'settings.composio.confirmSwitch': 'Entendi, alternar para Direto',
  'settings.composio.confirmTitle': '⚠️ Alternando para o modo Direto',
  'settings.composio.confirmWarning':
    'Suas integrações existentes (Gmail, Slack, GitHub, etc. conectadas via OpenHuman) não ficarão visíveis: elas vivem no tenant do Composio gerenciado pelo OpenHuman.',
  'settings.composio.intro':
    'O Composio integra mais de 250 apps externos como ferramentas que seu agente pode chamar. Escolha como essas chamadas são roteadas.',
  'settings.composio.title': 'Composio',
  'settings.composio.modeDirect': 'Direto (traga sua própria chave de API)',
  'settings.composio.modeDirectDesc':
    'As chamadas vão direto para backend.composio.dev. Soberano / amigável para offline. A execução de ferramentas funciona de forma síncrona; webhooks de gatilhos em tempo real ainda não são roteados no modo direto (issue de acompanhamento).',
  'settings.composio.modeManaged': 'Gerenciado (OpenHuman cuida para você)',
  'settings.composio.modeManagedDesc':
    'O OpenHuman faz proxy das chamadas de ferramentas pelo nosso backend (recomendado). A autenticação é intermediada; você nunca cola uma chave de API do Composio. Webhooks são totalmente roteados.',
  'settings.composio.routingMode': 'Modo de roteamento',
  'settings.composio.saveErrorNoKey':
    'Falha ao salvar. O modo Direto requer uma chave de API não vazia.',
  'settings.composio.saving': 'Salvando…',
  'settings.composio.switching': 'Alternando…',
  'settings.cron.jobs.commandRequired': 'O comando é obrigatório para tarefas shell',
  'settings.cron.jobs.createJob': 'Nova tarefa agendada',
  'settings.cron.jobs.created': 'Tarefa criada',
  'settings.cron.jobs.custom': 'Personalizado',
  'settings.cron.jobs.desc': 'Descrição',
  'settings.cron.jobs.edit': 'Editar',
  'settings.cron.jobs.editJob': 'Editar tarefa agendada',
  'settings.cron.jobs.empty': 'Nenhuma tarefa cron do core encontrada.',
  'settings.cron.jobs.errorCreate': 'Falha ao criar tarefa cron: {message}',
  'settings.cron.jobs.errorLoadList': 'Falha ao carregar tarefas cron do núcleo: {message}',
  'settings.cron.jobs.errorLoadRuns': 'Falha ao carregar o histórico de execuções: {message}',
  'settings.cron.jobs.errorRemove': 'Falha ao remover tarefa cron do núcleo: {message}',
  'settings.cron.jobs.errorRun': 'Falha ao executar tarefa cron do núcleo: {message}',
  'settings.cron.jobs.errorToggle': 'Falha ao atualizar tarefa cron do núcleo: {message}',
  'settings.cron.jobs.errorUpdate': 'Falha ao atualizar tarefa cron: {message}',
  'settings.cron.jobs.formAtLabel': 'Executar às',
  'settings.cron.jobs.formCancel': 'Cancelar',
  'settings.cron.jobs.formCommand': 'Comando shell',
  'settings.cron.jobs.formCommandPlaceholder': 'ex.: curl https://example.com/health',
  'settings.cron.jobs.formCreate': 'Criar',
  'settings.cron.jobs.formCronCustom': 'Expressão personalizada',
  'settings.cron.jobs.formCronCustomPlaceholder': 'ex.: */30 * * * *',
  'settings.cron.jobs.formCronPreset': 'Predefinição',
  'settings.cron.jobs.formCronPreview': 'Execuções: {preview}',
  'settings.cron.jobs.formDeleteAfterRun': 'Excluir após a primeira execução',
  'settings.cron.jobs.formDelivery': 'Modo de entrega',
  'settings.cron.jobs.formDeliveryNone': 'Nenhum (apenas saída)',
  'settings.cron.jobs.formDeliveryProactive': 'Proativo (notificação push)',
  'settings.cron.jobs.formError': 'Falha ao salvar a tarefa',
  'settings.cron.jobs.formEveryLabel': 'Intervalo (milissegundos)',
  'settings.cron.jobs.formEveryPlaceholder': 'ex.: 3600000',
  'settings.cron.jobs.formJobType': 'Tipo de tarefa',
  'settings.cron.jobs.formJobTypeAgent': 'Agent (prompt de IA)',
  'settings.cron.jobs.formJobTypeShell': 'Comando shell',
  'settings.cron.jobs.formName': 'Nome da tarefa',
  'settings.cron.jobs.formNamePlaceholder': 'ex.: daily-report, cleanup-task',
  'settings.cron.jobs.formPrompt': 'Prompt do Agent',
  'settings.cron.jobs.formPromptPlaceholder': 'O que o agent deve fazer em cada execução?',
  'settings.cron.jobs.formPromptRequired': 'O prompt é obrigatório para tarefas de agent',
  'settings.cron.jobs.formSave': 'Salvar',
  'settings.cron.jobs.formSaving': 'Salvando…',
  'settings.cron.jobs.formScheduleAt': 'Única (executar às)',
  'settings.cron.jobs.formScheduleCron': 'Recorrente (cron)',
  'settings.cron.jobs.formScheduleEvery': 'Intervalo (a cada N ms)',
  'settings.cron.jobs.formScheduleRequired': 'O agendamento é obrigatório',
  'settings.cron.jobs.formScheduleType': 'Tipo de agendamento',
  'settings.cron.jobs.formSessionIsolated': 'Isolada (recomendada)',
  'settings.cron.jobs.formSessionMain': 'Sessão principal',
  'settings.cron.jobs.formSessionTarget': 'Sessão de destino',
  'settings.cron.jobs.formProfile': 'Perfil do agente',
  'settings.cron.jobs.formProfileNone': 'Sem perfil',
  'settings.cron.jobs.formProfileHint':
    'Execute esta tarefa como o perfil selecionado, usando sua alma, memória e espaço de trabalho.',
  'settings.cron.jobs.profile': 'Perfil',
  'settings.cron.jobs.lastStatus': 'Último status',
  'settings.cron.jobs.loading': 'Carregando tarefas cron...',
  'settings.cron.jobs.loadingRuns': 'Carregando execuções',
  'settings.cron.jobs.nextRun': 'Próxima execução',
  'settings.cron.jobs.pause': 'Pausar',
  'settings.cron.jobs.paused': 'Pausado',
  'settings.cron.jobs.recentRuns': 'Execuções recentes',
  'settings.cron.jobs.removing': 'Removendo',
  'settings.cron.jobs.resume': 'Retomar',
  'settings.cron.jobs.runningNow': 'Executando agora',
  'settings.cron.jobs.saving': 'Salvando…',
  'settings.cron.jobs.schedule': 'Agendamento',
  'settings.cron.jobs.title': 'Tarefas Cron do Core',
  'settings.cron.jobs.updated': 'Tarefa atualizada',
  'settings.cron.jobs.viewRuns': 'Ver execuções',
  'settings.cron.schedule.every2hours': 'A cada 2 horas',
  'settings.cron.schedule.every30min': 'A cada 30 minutos',
  'settings.cron.schedule.every6hours': 'A cada 6 horas',
  'settings.cron.schedule.everyHour': 'A cada hora',
  'settings.cron.schedule.onceDaily': 'Uma vez por dia (9h)',
  'settings.localModel.deviceCapability.active': 'Ativo',
  'settings.localModel.deviceCapability.appliedTier': 'Nível aplicado',
  'settings.localModel.deviceCapability.applying': 'Aplicando',
  'settings.localModel.deviceCapability.cores': '{count}',
  'settings.localModel.deviceCapability.couldNotLoadPresets':
    'Não foi possível carregar predefinições',
  'settings.localModel.deviceCapability.cpu': 'CPU',
  'settings.localModel.deviceCapability.customModelIds': 'IDs de modelos personalizados',
  'settings.localModel.deviceCapability.detected': 'Detectado',
  'settings.localModel.deviceCapability.disabled': 'Desativado',
  'settings.localModel.deviceCapability.disabledDesc': 'Descrição desativado',
  'settings.localModel.deviceCapability.downloadingModels': '(baixando modelos)',
  'settings.localModel.deviceCapability.downloadingSetupDesc':
    'Baixando o instalador OllamaSetup (~2 GB) e descompactando. Isso pode levar um minuto na primeira instalação.',
  'settings.localModel.deviceCapability.failedToApplyPreset': 'Falha ao aplicar predefinição',
  'settings.localModel.deviceCapability.gpu': 'GPU',
  'settings.localModel.deviceCapability.installFailed': 'Instalação do Ollama falhou',
  'settings.localModel.deviceCapability.installFailedDesc':
    'O instalador encerrou antes que o Ollama estivesse utilizável. Clique em tentar novamente ou instale manualmente em ollama.com.',
  'settings.localModel.deviceCapability.installFirst': 'Execute o Ollama primeiro.',
  'settings.localModel.deviceCapability.installFirstDesc':
    'Os níveis locais dependem de um endpoint Ollama gerenciado externamente. Inicie-o você mesmo, baixe os modelos desejados e continue usando "Desativado (fallback de nuvem)" até que o runtime esteja acessível.',
  'settings.localModel.deviceCapability.installOllamaFirst':
    'Execute o Ollama primeiro para usar este nível',
  'settings.localModel.deviceCapability.installingOllama': 'Instalando ollama',
  'settings.localModel.deviceCapability.loadingDeviceInfo': 'Carregando informações do dispositivo',
  'settings.localModel.deviceCapability.localAiDisabled':
    'IA local desativada: usando fallback na nuvem.',
  'settings.localModel.deviceCapability.modelTier': 'Nível do Modelo',
  'settings.localModel.deviceCapability.needsOllama': 'Precisa de ollama',
  'settings.localModel.deviceCapability.notDetected': 'Não detectado',
  'settings.localModel.deviceCapability.disabledLowercase': 'desativado',
  'settings.localModel.deviceCapability.presetDetails':
    'Bate-papo: {chatModel} · Visão: {visionModel} · RAM de destino: {targetRamGb} GB',
  'settings.localModel.deviceCapability.ram': 'RAM',
  'settings.localModel.deviceCapability.recommended': 'Recomendado',
  'settings.localModel.deviceCapability.retryInstall': 'Tentando novamente…',
  'settings.localModel.deviceCapability.retrying': 'Tentando novamente…',
  'settings.localModel.deviceCapability.starting': 'Iniciando…',
  'settings.localModel.download.audioPathPlaceholder': 'Caminho absoluto para arquivo de áudio',
  'settings.localModel.download.capabilityChat': 'Bate-papo',
  'settings.localModel.download.capabilityEmbedding': 'Incorporação',
  'settings.localModel.download.capabilityAssets': 'Assets de Funcionalidade',
  'settings.localModel.download.capabilityStt': 'STT',
  'settings.localModel.download.capabilityTts': 'TTS',
  'settings.localModel.download.capabilityVision': 'Visão',
  'settings.localModel.download.downloading': 'Baixando...',
  'settings.localModel.download.embeddingDimensions': 'Dimensões: {dimensions}',
  'settings.localModel.download.embeddingModel': 'Modelo: {modelId}',
  'settings.localModel.download.embeddingPlaceholder': 'Uma string de entrada por linha...',
  'settings.localModel.download.embeddingVectors': 'Vetores: {count}',
  'settings.localModel.download.noThinkMode': 'Sem modo de pensamento',
  'settings.localModel.download.notAvailable': 'n/a',
  'settings.localModel.download.promptPlaceholder':
    'Digite qualquer prompt e execute-o no modelo local...',
  'settings.localModel.download.quantizationPref': 'Preferência de quantização',
  'settings.localModel.download.runEmbeddingTest': 'Executando...',
  'settings.localModel.download.runPromptTest': 'Executar Teste de Prompt',
  'settings.localModel.download.runSummaryTest': 'Executar Teste de Resumo',
  'settings.localModel.download.runTranscriptionTest': 'Executando...',
  'settings.localModel.download.runTtsTest': 'Executando...',
  'settings.localModel.download.runVisionTest': 'Executando...',
  'settings.localModel.download.running': 'Executando...',
  'settings.localModel.download.runningPrompt': 'Executando prompt',
  'settings.localModel.download.summaryHelper':
    'Chamadas `openhuman.inference_summarize` via Rust core',
  'settings.localModel.download.summarizePlaceholder':
    'Cole o texto para resumir com o modelo local...',
  'settings.localModel.download.testCustomPrompt': 'Testar Prompt Personalizado',
  'settings.localModel.download.testEmbeddings': 'Testar Embeddings',
  'settings.localModel.download.testSummarization': 'Testar Sumarização',
  'settings.localModel.download.testVisionPrompt': 'Testar Prompt de Visão',
  'settings.localModel.download.testVoiceInput': 'Testar Entrada de Voz (STT)',
  'settings.localModel.download.testVoiceOutput': 'Testar Saída de Voz (TTS)',
  'settings.localModel.download.transcript': 'Transcrição:',
  'settings.localModel.download.ttsOutput': 'Saída: {outputPath}',
  'settings.localModel.download.ttsOutputPlaceholder': 'Caminho WAV de saída opcional',
  'settings.localModel.download.ttsPlaceholder': 'Insira o texto para sintetizar...',
  'settings.localModel.download.ttsVoice': 'Voz: {voiceId}',
  'settings.localModel.download.visionImagePlaceholder':
    'Uma referência de imagem por linha (URI de dados, URL ou marcador de caminho local)',
  'settings.localModel.download.visionPromptPlaceholder':
    'Insira um prompt para o modelo de visão...',
  'settings.localModel.status.allChecksPassed': 'Todas as verificações passaram',
  'settings.localModel.status.artifact': 'Artefato',
  'settings.localModel.status.backend': 'Back-end',
  'settings.localModel.status.binary': 'Binário',
  'settings.localModel.status.bootstrapResume': 'Bootstrap / Retomar',
  'settings.localModel.status.checking': 'Verificando...',
  'settings.localModel.status.checkingOllama': 'Verificando ollama',
  'settings.localModel.status.contextBelowMinimumBadge':
    '{contextLength} ctx - abaixo de {required} min',
  'settings.localModel.status.contextBelowMinimumTitle':
    'Rejeitado: os tokens {contextLength} da janela de contexto estão abaixo do mínimo de token {required} que a camada de memória exige. A recuperação seria corrompida pelo truncamento silencioso.',
  'settings.localModel.status.contextOkBadge': '{contextLength} ctx ✓',
  'settings.localModel.status.contextOkTitle':
    'Os tokens {contextLength} da janela de contexto atendem ao mínimo da camada de memória de {required} tokens.',
  'settings.localModel.status.contextUnknownBadge': 'ctx desconhecido',
  'settings.localModel.status.contextUnknownTitle':
    'Janela de contexto desconhecida; não foi possível confirmar se atende ao mínimo da camada de memória do token {required}.',
  'settings.localModel.status.customLocation': 'Localização personalizada',
  'settings.localModel.status.customLocationDesc': 'Descrição de localização personalizada',
  'settings.localModel.status.diagnosticsHint':
    'Clique em "Executar Diagnóstico" para verificar se o Ollama está rodando e os modelos estão instalados.',
  'settings.localModel.status.downloadingUnknown': 'Baixando (tamanho desconhecido)',
  'settings.localModel.status.eta': 'ETA',
  'settings.localModel.status.expectedModels': 'Modelos esperados',
  'settings.localModel.status.expectedChat': 'Bate-papo: {model}',
  'settings.localModel.status.expectedEmbedding': 'Incorporação: {model}',
  'settings.localModel.status.expectedVision': 'Visão: {model}',
  'settings.localModel.status.externalProcess': 'Processo externo',
  'settings.localModel.status.forceRebootstrap': 'Forçar Re-bootstrap',
  'settings.localModel.status.generationTps': 'TPS de geração',
  'settings.localModel.status.hideErrorDetails': 'Ocultar detalhes do erro',
  'settings.localModel.status.installManually': 'Instalar manualmente',
  'settings.localModel.status.installManuallyFrom': 'Instalar manualmente em',
  'settings.localModel.status.installOllama': 'Iniciando…',
  'settings.localModel.status.installedModels': 'Modelos instalados',
  'settings.localModel.status.installing': 'Instalando...',
  'settings.localModel.status.installingOllama': 'Instalando runtime Ollama...',
  'settings.localModel.status.issues': 'Problemas',
  'settings.localModel.status.issuesFound': '{count} problema(s) encontrado(s)',
  'settings.localModel.status.lastLatency': 'Última Latência',
  'settings.localModel.status.model': 'Modelo',
  'settings.localModel.status.notAvailable': 'n/a',
  'settings.localModel.status.notFound': 'Não encontrado',
  'settings.localModel.status.notRunning': 'Não está em execução',
  'settings.localModel.status.ollamaBinaryPath': 'Caminho do binário Ollama',
  'localModel.ollamaServer.helperText': 'Exemplo: http://192.168.1.5:11434',
  'localModel.ollamaServer.label': 'URL do servidor Ollama',
  'localModel.ollamaServer.modelCount': 'modelos',
  'localModel.ollamaServer.placeholder': 'http://localhost:11434',
  'localModel.ollamaServer.reachable': 'Acessível',
  'localModel.ollamaServer.resetButton': 'Redefinir para padrão',
  'localModel.ollamaServer.saveButton': 'Salvar',
  'localModel.ollamaServer.testButton': 'Testar conexão',
  'localModel.ollamaServer.unreachable': 'Inacessível',
  'localModel.ollamaServer.validationError': 'Deve ser uma URL http:// ou https:// válida',
  'settings.localModel.status.ollamaDiagnostics': 'Diagnósticos do Ollama',
  'settings.localModel.status.ollamaNotInstalled': 'Runtime do Ollama indisponível',
  'settings.localModel.status.ollamaNotInstalledDesc':
    'O OpenHuman agora trata o Ollama como um runtime de inferência externo. Inicie seu próprio servidor Ollama, baixe os modelos desejados e aponte o roteamento de carga para ele.',
  'settings.localModel.status.progress': 'Progresso',
  'settings.localModel.status.provider': 'Provedor',
  'settings.localModel.status.retryBootstrap': 'Tentar Bootstrap Novamente',
  'settings.localModel.status.runDiagnostics': 'Verificando...',
  'settings.localModel.status.running': 'Rodando',
  'settings.localModel.status.runningExternalProcess': 'Rodando via processo externo',
  'settings.localModel.status.runtimeStatus': 'Status do Runtime',
  'settings.localModel.status.server': 'Servidor',
  'settings.localModel.status.setPath': 'Definindo...',
  'settings.localModel.status.setting': 'Definindo...',
  'settings.localModel.status.showErrorDetails': 'Ocultar detalhes do erro',
  'settings.localModel.status.showInstallErrorDetails': 'Ocultar detalhes do erro',
  'settings.localModel.status.suggestedFixes': 'Correções sugeridas',
  'settings.localModel.status.thenSetPath': 'Então defina o caminho',
  'settings.localModel.status.triggering': 'Disparando...',
  'settings.localModel.status.unavailable': 'Indisponível',
  'settings.localModel.status.working': 'Trabalhando...',
  'settings.developerMenu.ai.title': 'Configuração de IA',
  'settings.developerMenu.ai.desc':
    'Provedores em nuvem, modelos Ollama locais e roteamento por carga de trabalho',
  'settings.developerMenu.messagingChannels.title': 'Canais de mensagens',
  'settings.developerMenu.messagingChannels.desc':
    'Configure modos de autenticação Telegram/Discord e o roteamento de canal padrão',
  'settings.developerMenu.tools.title': 'Ferramentas',
  'settings.developerMenu.tools.desc':
    'Ative ou desative capacidades que o OpenHuman pode usar em seu nome',
  'settings.developerMenu.agentChat.title': 'Chat do agente',
  'settings.developerMenu.agentChat.desc':
    'Teste conversas do agente com substituições de modelo e temperatura',
  'settings.developerMenu.devWorkflow.title': 'Fluxo de Trabalho de Desenvolvimento',
  'settings.developerMenu.devWorkflow.desc':
    'Agente autônomo que seleciona seus problemas GitHub e cria PRs em um cronograma',
  'settings.developerMenu.devWorkflow.panelDesc':
    'Configure um agente de desenvolvedor autônomo que selecione problemas GitHub atribuídos a você e faça pull requests automaticamente em um cronograma.',
  'settings.developerMenu.skillsRunner.title': 'Corredor de Habilidades',
  'settings.developerMenu.skillsRunner.desc':
    'Execute qualquer habilidade incluída ad-hoc: preencha suas entradas e inicie uma execução autônoma em segundo plano',
  'settings.developerMenu.skillsRunner.panelDesc':
    'Escolha uma habilidade agrupada, preencha suas entradas declaradas e execute uma execução em segundo plano de disparo e esquecimento. Use Dev Workflow em vez disso se você quiser um trabalho recorrente agendado pelo cron.',
  'settings.skillsRunner.skill': 'Habilidade',
  'settings.skillsRunner.selectSkill': 'Selecione uma habilidade…',
  'settings.skillsRunner.loadingSkills': 'Carregando habilidades…',
  'settings.skillsRunner.loadingDescription': 'Carregando entradas de habilidade…',
  'settings.skillsRunner.noInputs': 'Esta habilidade não declara entradas.',
  'settings.skillsRunner.placeholder.required': 'obrigatório',
  'settings.skillsRunner.runNow': 'Corra agora',
  'settings.skillsRunner.starting': 'Iniciando…',
  'settings.skillsRunner.started': 'Iniciado: id da execução:',
  'settings.skillsRunner.logPath': 'Registro:',
  'settings.skillsRunner.error.listSkills': 'Falha ao carregar habilidades:',
  'settings.skillsRunner.error.describe': 'Falha ao carregar entradas:',
  'settings.skillsRunner.error.missingRequired': 'Entrada(s) obrigatória(s) ausente(s):',
  'settings.skillsRunner.error.run': 'Falha ao iniciar a execução:',
  'settings.skillsRunner.error.preflightGate': 'Portão de embarque pré-voo falhou',
  'settings.skillsRunner.error.runtimeUnavailable': 'Runtime indisponível',
  'settings.skillsRunner.error.runtimeUnavailableDefault': 'indisponível',
  'settings.skillsRunner.schedule.heading': 'Agenda (recorrente)',
  'settings.skillsRunner.schedule.help':
    'Salve esta habilidade + entradas como um trabalho cron recorrente. O agente chamará run_workflow a cada tick.',
  'settings.skillsRunner.schedule.frequency': 'Frequência',
  'settings.skillsRunner.schedule.every30min': 'A cada 30 minutos',
  'settings.skillsRunner.schedule.everyHour': 'A cada hora',
  'settings.skillsRunner.schedule.every2hours': 'A cada 2 horas',
  'settings.skillsRunner.schedule.every6hours': 'A cada 6 horas',
  'settings.skillsRunner.schedule.onceDaily': 'Uma vez ao dia (9:00)',
  'settings.skillsRunner.schedule.save': 'Salvar cronograma',
  'settings.skillsRunner.schedule.saving': 'Salvando…',
  'settings.skillsRunner.schedule.saved': 'Cronograma salvo.',
  'settings.skillsRunner.schedule.error': 'Falha ao salvar a programação:',
  'settings.skillsRunner.schedule.loadingJobs': 'Carregando horários existentes…',
  'settings.skillsRunner.schedule.noJobs': 'Nenhum cronograma salvo para esta habilidade ainda.',
  'settings.skillsRunner.schedule.existing': 'Trabalhos agendados para esta habilidade:',
  'settings.skillsRunner.schedule.inputsLabel': 'Entradas',
  'settings.skillsRunner.schedule.inputsNone': 'Sem entradas',
  'settings.skillsRunner.schedule.runNow': 'Correr',
  'settings.skillsRunner.schedule.remove': 'Remover',
  'settings.skillsRunner.scheduleEnabled': 'Ativado',
  'settings.skillsRunner.scheduleDisabled': 'Pausado',
  'settings.skillsRunner.scheduleToggleAria': 'Alternar programação ativada',
  'settings.skillsRunner.schedule.history': 'História',
  'settings.skillsRunner.schedule.historyLoading': 'Carregando histórico…',
  'settings.skillsRunner.schedule.historyEmpty': 'Nenhuma execução ainda para esta programação.',
  'settings.skillsRunner.schedule.historyNoOutput': 'Nenhuma saída capturada.',
  'settings.skillsRunner.schedule.active': 'Ativo',
  'settings.skillsRunner.schedule.lastRunLabel': 'último:',
  'settings.skillsRunner.recentRuns.headingForSkill': 'Execuções recentes para esta habilidade',
  'settings.skillsRunner.recentRuns.headingAll': 'Execuções de habilidade recentes (todas)',
  'settings.skillsRunner.recentRuns.refresh': 'Atualizar',
  'settings.skillsRunner.recentRuns.loading': 'Carregando corridas recentes…',
  'settings.skillsRunner.recentRuns.empty': 'Nenhuma execução recente.',
  'settings.skillsRunner.viewer.loading': 'Carregando registro…',
  'settings.skillsRunner.viewer.tailing': 'Acompanhamento ao vivo',
  'settings.skillsRunner.viewer.fetching': 'buscando',
  'settings.skillsRunner.viewer.error': 'Falha ao ler o log:',
  'settings.skillsRunner.repoPicker.loading': 'Carregando repositórios…',
  'settings.skillsRunner.repoPicker.select': 'Selecione um repositório…',
  'settings.skillsRunner.repoPicker.empty':
    'Nenhum repositório retornado. Conecte GitHub via Composio para preencher esta lista.',
  'settings.skillsRunner.repoPicker.notConnected':
    'GitHub não está conectado via Composio. Conecte-o primeiro em Habilidades → Composio.',
  'settings.skillsRunner.repoPicker.privateTag': '(privado)',
  'settings.skillsRunner.branchPicker.needRepo': 'Escolha um repositório primeiro…',
  'settings.skillsRunner.branchPicker.loading': 'Carregando ramificações…',
  'settings.skillsRunner.branchPicker.select': 'Selecione um ramo…',
  'settings.devWorkflow.githubRepository': 'Repositório GitHub',
  'settings.devWorkflow.loadingRepositories': 'Carregando repositórios...',
  'settings.devWorkflow.selectRepository': 'Selecione um repositório',
  'settings.devWorkflow.privateTag': '(privado)',
  'settings.devWorkflow.detectingForkInfo': 'Detectando informações de fork...',
  'settings.devWorkflow.forkDetected': 'Bifurcação detectada',
  'settings.devWorkflow.upstream': 'A montante:',
  'settings.devWorkflow.forkPrNote': 'PRs serão criados contra o repositório upstream.',
  'settings.devWorkflow.notForkNote':
    'Não é um fork. PRs serão submetidos diretamente a este repositório.',
  'settings.devWorkflow.targetBranch': 'Branch de Destino',
  'settings.devWorkflow.targetBranchNote': 'PRs serão criados contra este branch',
  'settings.devWorkflow.loadingBranches': 'Carregando ramificações...',
  'settings.devWorkflow.runFrequency': 'Frequência de execução',
  'settings.devWorkflow.runFrequencyNote':
    'Com que frequência o agente deve verificar problemas e abrir PRs.',
  'settings.devWorkflow.updateConfiguration': 'Atualizar Configuração',
  'settings.devWorkflow.saveConfiguration': 'Salvar Configuração',
  'settings.devWorkflow.remove': 'Remover',
  'settings.devWorkflow.saved': 'Salvo',
  'settings.devWorkflow.activeConfiguration': 'Configuração ativa',
  'settings.devWorkflow.activeConfigRepository': 'Repositório:',
  'settings.devWorkflow.activeConfigUpstream': 'A montante:',
  'settings.devWorkflow.activeConfigTargetBranch': 'Branch de destino:',
  'settings.devWorkflow.activeConfigSchedule': 'Cronograma:',
  'settings.devWorkflow.enabled': 'Ativado',
  'settings.devWorkflow.paused': 'Pausado',
  'settings.devWorkflow.nextRun': 'Próxima execução',
  'settings.devWorkflow.lastRun': 'Última execução',
  'settings.devWorkflow.runNow': 'Corra agora',
  'settings.devWorkflow.running': 'Executando…',
  'settings.devWorkflow.recentRuns': 'Corridas recentes',
  'settings.devWorkflow.cronSaveError': 'Falha ao salvar a configuração',
  'settings.devWorkflow.lastOutput': 'Última saída',
  'settings.devWorkflow.noOutput': 'Nenhuma saída capturada',
  'settings.devWorkflow.runningStatus':
    'O agente está em execução: selecionando um problema e trabalhando em uma correção...',
  'settings.devWorkflow.errorNotConnected':
    'GitHub não está conectado. Por favor, conecte o GitHub através de Configurações > Avançado > Composio primeiro.',
  'settings.devWorkflow.errorToolNotEnabled':
    'A ferramenta GITHUB_LIST_REPOSITORIES_FOR_THE_AUTHENTICATED_USER não está habilitada neste backend. Por favor, peça ao seu administrador para habilitá-la na integração Composio (backend#842).',
  'settings.devWorkflow.errorNotAuthenticated': 'Não autenticado. Por favor, faça login primeiro.',
  'settings.devWorkflow.errorNoRepositories':
    'Nenhum repositório encontrado para esta conta GitHub.',
  'settings.devWorkflow.schedule.every30min': 'A cada 30 minutos',
  'settings.devWorkflow.schedule.everyHour': 'A cada hora',
  'settings.devWorkflow.schedule.every2hours': 'A cada 2 horas',
  'settings.devWorkflow.schedule.every6hours': 'A cada 6 horas',
  'settings.devWorkflow.schedule.onceDaily': 'Uma vez ao dia (9h)',
  'settings.developerMenu.tasks.title': 'Tarefas',
  'settings.developerMenu.tasks.desc':
    'Navegue e gerencie os quadros de tarefas: suas próprias pendências e os quadros que os agentes criam nas conversas.',
  'settings.developerMenu.cronJobs.title': 'Tarefas cron',
  'settings.developerMenu.cronJobs.desc':
    'Veja e configure tarefas agendadas para habilidades em tempo de execução',
  'settings.developerMenu.localModelDebug.title': 'Depuração do modelo local',
  'settings.developerMenu.localModelDebug.desc':
    'Configuração do Ollama, downloads de recursos, testes de modelo e diagnósticos',
  'settings.developerMenu.webhooks.title': 'Webhooks',
  'settings.developerMenu.webhooks.desc':
    'Inspecione registros de webhooks em tempo de execução e logs de solicitações capturadas',
  'settings.developerMenu.eventLog.title': 'Registro de Eventos',
  'settings.developerMenu.eventLog.desc':
    'Transmissão ao vivo com cores codificadas de todos os eventos de agentes, ferramentas e sistemas',
  'settings.developerMenu.eventLog.allTypes': 'Todos os tipos',
  'settings.developerMenu.eventLog.filterAgent': 'Filtrar...',
  'settings.developerMenu.eventLog.download': 'Baixar',
  'settings.developerMenu.eventLog.events': 'eventos',
  'settings.developerMenu.eventLog.live': 'Ao vivo',
  'settings.developerMenu.eventLog.disconnected': 'Desconectado',
  'settings.developerMenu.eventLog.waiting': 'Aguardando eventos...',
  'settings.developerMenu.eventLog.notConnected': 'Não conectado ao núcleo',
  'settings.developerMenu.eventLog.jumpToLatest': 'Ir para o mais recente',
  'settings.developerMenu.eventLog.badge.tool': 'TOOL',
  'settings.developerMenu.eventLog.badge.agent': 'AGENT',
  'settings.developerMenu.eventLog.badge.info': 'INFO',
  'settings.developerMenu.eventLog.badge.mem': 'MEM',
  'settings.developerMenu.eventLog.badge.chan': 'CHAN',
  'settings.developerMenu.eventLog.badge.cron': 'CRON',
  'settings.developerMenu.eventLog.badge.hook': 'HOOK',
  'settings.developerMenu.eventLog.badge.warn': 'WARN',
  'settings.developerMenu.eventLog.badge.skill': 'SKILL',
  'settings.developerMenu.eventLog.badge.comp': 'COMP',
  'settings.developerMenu.eventLog.badge.mcp': 'MCP',
  'settings.developerMenu.intelligence.title': 'Inteligência',
  'settings.developerMenu.intelligence.desc':
    'Espaço de trabalho de memória, motor subconsciente, sonhos e configurações',
  'settings.developerMenu.notificationRouting.title': 'Roteamento de notificações',
  'settings.developerMenu.notificationRouting.desc':
    'Pontuação de importância por IA e escalonamento do orquestrador para alertas de integração',
  'settings.developerMenu.composeioTriggers.title': 'Gatilhos ComposeIO',
  'settings.developerMenu.composeioTriggers.desc':
    'Veja o histórico e o arquivo de gatilhos do ComposeIO',
  'settings.developerMenu.composioRouting.title': 'Roteamento Composio (modo direto)',
  'settings.developerMenu.composioRouting.desc':
    'Use sua própria chave de API da Composio e roteie chamadas diretamente para backend.composio.dev',
  'settings.developerMenu.integrationTriggers.title': 'Gatilhos de integração',
  'settings.developerMenu.integrationTriggers.desc':
    'Configure as opções de triagem por IA para gatilhos de integração Composio',
  'settings.developerMenu.mcpServer.title': 'MCP Servidor',
  'settings.developerMenu.mcpServer.desc':
    'Configurar clientes MCP externos para se conectarem a OpenHuman',
  'settings.developerMenu.autonomy.title': 'Autonomia do agente',
  'settings.developerMenu.autonomy.desc':
    'Limites de taxa de ações de ferramentas e limites de segurança',
  'settings.developerMenu.voiceDebug.title': 'Voz (depuração)',
  'settings.developerMenu.voiceDebug.desc':
    'Status de tempo de execução do ditado de voz e configurações de depuração',
  'settings.mcpServer.title': 'Servidor MCP',
  'settings.mcpServer.toolsSectionTitle': 'Ferramentas disponíveis',
  'settings.mcpServer.toolsSectionDesc':
    'Ferramentas expostas por meio do servidor MCP stdio ao executar openhuman-core mcp',
  'settings.mcpServer.configSectionTitle': 'Configuração do cliente',
  'settings.mcpServer.configSectionDesc':
    'Selecione seu cliente MCP para gerar o snippet de configuração correto',
  'settings.mcpServer.copySnippet': 'Copiar para a área de transferência',
  'settings.mcpServer.copied': 'Copiado!',
  'settings.mcpServer.openConfigFile': 'Abra o arquivo de configuração',
  'settings.mcpServer.binaryPathNotFound':
    'OpenHuman binário não encontrado. Se estiver executando a partir do código-fonte, crie com: cargo build --bin openhuman-core',
  'settings.mcpServer.openConfigError': 'Falha ao abrir o arquivo de configuração',
  'settings.mcpServer.clientClaudeDesktop': 'Área de trabalho Claude',
  'settings.mcpServer.clientCursor': 'Cursor',
  'settings.mcpServer.clientCodex': 'Códice',
  'settings.mcpServer.clientZed': 'Zed',
  'settings.mcpServer.configFilePath': 'Arquivo de configuração',
  'settings.mcpServer.clientSelectorAriaLabel': 'MCP seletor de cliente',
  'settings.appearance.menuDesc': 'Escolha claro, escuro ou o tema do sistema',
  'settings.agentAccess.title': 'Acesso ao sistema operacional do agente',
  'settings.agentAccess.menuDesc':
    'Controle onde o agente pode read/write e se ele pode usar o shell.',
  'settings.agentAccess.loadError': 'Falha ao carregar as configurações de acesso',
  'settings.agentAccess.saveError': 'Falha ao salvar as configurações de acesso',
  'settings.agentAccess.saved': 'Salvo: aplicado na sua próxima mensagem.',
  'settings.agentAccess.desktopOnly':
    'As configurações de acesso estão disponíveis apenas no aplicativo para computador.',
  'settings.agentAccess.loading': 'Carregando…',
  'settings.agentAccess.accessMode': 'Modo de acesso',
  'settings.agentAccess.tier.readonly.title': 'Somente leitura',
  'settings.agentAccess.tier.readonly.desc':
    'Lê arquivos e executa comandos apenas de leitura para explorar, mas nunca escreve, edita ou executa nada que altere o estado.',
  'settings.agentAccess.tier.supervised.title': 'Pergunte antes de editar',
  'settings.agentAccess.tier.supervised.desc':
    'Cria novos arquivos livremente, mas pede sua aprovação antes de editar um arquivo existente, executar um comando, acessar a rede ou instalar qualquer coisa.',
  'settings.agentAccess.tier.full.title': 'Acesso total',
  'settings.agentAccess.tier.full.desc':
    'Executa comandos com acesso total à sua conta de usuário: pode read/write em qualquer lugar permitido, exceto em credenciais e repositórios do sistema. Comandos destrutivos, acesso à rede e instalações ainda solicitam aprovação.',
  'settings.agentAccess.defaultTag': '(padrão)',
  'settings.agentAccess.fullWarning':
    '⚠ O acesso total executa comandos com acesso completo à sua conta e não é isolado. Só o habilite quando você confiar no agente com esta máquina. Diretórios de credenciais e do sistema continuam bloqueados, e ações destrutivas, de rede e de instalação ainda solicitam aprovação.',
  'settings.agentAccess.confine.label': 'Confinar ao espaço de trabalho',
  'settings.agentAccess.confine.desc':
    'Restrinja o agente ao diretório de trabalho (mais quaisquer pastas concedidas), qualquer que seja o modo de acesso selecionado. Quando desligado, ele pode acessar qualquer lugar que seu usuário possa, exceto os diretórios de credenciais e do sistema que sempre são bloqueados.',
  'settings.agentAccess.requireTaskPlanApproval.label': 'Exigir aprovação do plano de tarefas',
  'settings.agentAccess.requireTaskPlanApproval.desc':
    'Pausa antes que um agente designado execute um briefing de tarefa elaborado pelo agente.',
  'settings.agentAccess.autoApproveAll.label': 'Aprovar automaticamente todas as ações',
  'settings.agentAccess.autoApproveAll.desc':
    'Quando ativado, o agente executará todas as ações sem pedir sua aprovação antes. Isso inclui gravação de arquivos, comandos de shell, solicitações de rede e qualquer outro efeito colateral. Os bloqueios de segurança rígidos (diretórios de credenciais, caminhos internos do espaço de trabalho) continuam em vigor.',
  'settings.agentAccess.tinyplaceAutopilot.title': 'Agente autônomo do tiny.place',
  'settings.agentAccess.tinyplaceAutopilot.desc':
    'Deixe o OpenHuman agir sozinho no tiny.place. De forma agendada, ele busca trabalhos relevantes (priorizando recompensas abertas), executa o que combina com suas habilidades e age com a sua identidade. Funciona sem supervisão e pode gastar, então mantenha-o na devnet durante os testes. Desativado por padrão.',
  'settings.agentAccess.tinyplaceAutopilot.label': 'Executar automaticamente',
  'settings.agentAccess.timeout.label': 'Tempo limite da ação',
  'settings.agentAccess.timeout.desc':
    'Por quanto tempo uma única ferramenta ou ação pode ser executada antes de ser cancelada. Aumente este valor se um modelo local grande for interrompido antes de terminar a resposta.',
  'settings.agentAccess.timeout.unit': 'segundos',
  'settings.agentAccess.timeout.invalid':
    'Insira um número inteiro de segundos dentro do intervalo permitido',
  'settings.agentAccess.timeout.envOverride':
    'A variável de ambiente OPENHUMAN_TOOL_TIMEOUT_SECS está substituindo esta configuração, portanto as alterações aqui não terão efeito até que ela seja removida.',
  'settings.agentAccess.grantedFolders': 'Pastas concedidas',
  'settings.agentAccess.alwaysAllow': 'Ferramentas sempre permitidas',
  'settings.agentAccess.alwaysAllowDesc':
    'As ferramentas que você marcou como "Sempre permitir" no chat funcionam sem perguntar. Remova uma para ser solicitado novamente.',
  'settings.agentAccess.alwaysAllowNone': 'Ainda sem ferramentas sempre permitidas.',
  'settings.agentAccess.grantedDesc':
    'Pastas que o agente pode ler e escrever, além do espaço de trabalho. Armazenamentos de credenciais (~/.ssh, ~/.gnupg, ~/.aws, chaveiros) e diretórios do sistema (/etc, /System, C:\\Windows,…) estão sempre bloqueados, mesmo dentro de uma pasta concedida.',
  'settings.agentAccess.noneGranted': 'Nenhuma pasta concedida.',
  'settings.agentAccess.readWrite': 'ler + escrever',
  'settings.agentAccess.readOnly': 'somente leitura',
  'settings.agentAccess.remove': 'Remover',
  'settings.agentAccess.pathPlaceholder': 'Caminho absoluto da pasta',
  'settings.agentAccess.accessLevelLabel': 'Nível de acesso',
  'settings.agentAccess.add': 'Adicionar',
  'settings.agentAccess.saving': 'Salvando…',
  'settings.agentAccess.changesApply': 'As alterações serão aplicadas na sua próxima mensagem.',
  'settings.agentAccess.directories': 'Diretórios',
  'settings.agentAccess.actionSandbox': 'Sandbox de ações',
  'settings.agentAccess.readWriteAccess': 'leitura + escrita',
  'settings.agentAccess.actionSandboxDesc':
    'Diretório de trabalho padrão para ferramentas de shell, arquivos e git.',
  'settings.agentAccess.actionDir.edit': 'Editar',
  'settings.agentAccess.actionDir.save': 'Salvar',
  'settings.agentAccess.actionDir.cancel': 'Cancelar',
  'settings.agentAccess.actionDir.placeholder': 'Caminho absoluto, ex. /Users/you/Projects',
  'settings.agentAccess.actionDir.envLocked':
    'Definido por OPENHUMAN_ACTION_DIR. Altere a variável de ambiente para substituir.',
  'settings.agentAccess.actionDir.saved': 'Diretório de ações atualizado.',
  'settings.agentAccess.internalState': 'Estado interno',
  'settings.agentAccess.agentBlocked': 'bloqueado para o agente',
  'settings.agentAccess.internalStateDesc':
    'Bancos de dados de memória, sessões, tokens e outros dados essenciais. Não acessível pelas ferramentas do agente.',
  'settings.agentAccess.actionDirInputLabel': 'Caminho da sandbox de ações',
  'settings.agentAccess.actionDirSave': 'Salvar',
  'settings.agentAccess.actionDirSaving': 'Salvando…',
  'settings.agentAccess.actionDirSaved': 'Sandbox de ações atualizada.',
  'settings.agentAccess.actionDirEmptyError': 'O caminho não pode estar vazio.',
  'settings.agentAccess.actionDirSaveError': 'Não foi possível atualizar a sandbox de ações.',
  'settings.agentAccess.actionDirEnvOverrideError':
    'OPENHUMAN_ACTION_DIR está definido: remova a variável de ambiente para editar isto em Configurações.',
  'settings.agentAccess.actionDirEnvOverrideNote':
    'Substituído por OPENHUMAN_ACTION_DIR: remova a variável de ambiente para gerenciar em Configurações.',
  'settings.agentAccess.approvalHistory': 'Histórico de aprovações',
  'settings.agentAccess.approvalHistoryDesc':
    'Revise as decisões anteriores de Aprovar / Negar solicitadas pelo agente.',
  'settings.agentAccess.viewApprovalHistory': 'Ver histórico de aprovações',

  // ── Painel de Permissões ──────────────────────────────────────────
  'settings.permissions.title': 'Permissões',
  'settings.permissions.menuDesc':
    'Escolha o que o seu assistente pode fazer e onde pode trabalhar.',
  'settings.permissions.accessMode': 'O que o assistente pode fazer?',
  'settings.permissions.accessModeDesc':
    'Escolha quanta liberdade o assistente tem ao realizar ações no seu computador.',
  'settings.permissions.preset.readonly.title': 'Olhar, não tocar',
  'settings.permissions.preset.readonly.desc':
    'O assistente pode ler ficheiros e explorar, mas nunca escrever, editar ou executar qualquer coisa que mude o estado.',
  'settings.permissions.preset.supervised.title': 'Perguntar primeiro',
  'settings.permissions.preset.supervised.desc':
    'Pode criar novos ficheiros livremente, mas pede sempre a sua aprovação antes de editar, executar comandos ou aceder à rede.',
  'settings.permissions.preset.full.title': 'Controlo total',
  'settings.permissions.preset.full.desc':
    'Opera com o seu acesso completo à conta. Comandos destrutivos, acesso à rede e instalações ainda pedem aprovação.',
  'settings.permissions.folders': 'Onde pode trabalhar?',
  'settings.permissions.foldersDesc':
    'A pasta predefinida que o assistente lê e escreve. Pode adicionar mais pastas nas definições Avançadas.',

  'settings.meetings.title': 'Reuniões',
  'settings.meetings.menuDesc':
    'Entrada automática, resumos e transcrições do Assistente de reuniões',
  'settings.meetings.desktopOnly':
    'As configurações de reunião estão disponíveis apenas no desktop.',
  'settings.meetings.loading': 'Carregando…',
  'settings.meetings.loadError': 'Falha ao carregar as configurações de reunião.',
  'settings.meetings.saveError': 'Falha ao salvar as configurações de reunião.',
  'settings.meetings.saved': 'Salvo',
  'settings.meetings.saving': 'Salvando…',
  'settings.meetings.autoJoin.title': 'Política de entrada automática',
  'settings.meetings.autoJoin.desc': 'Quando um evento do calendário tem um link do Google Meet',
  'settings.meetings.autoJoin.askEachTime': 'Perguntar sempre',
  'settings.meetings.autoJoin.always': 'Entrar sempre',
  'settings.meetings.autoJoin.never': 'Nunca entrar',
  'settings.meetings.autoSummarize.title': 'Resumo após a chamada',
  'settings.meetings.autoSummarize.desc': 'Gerar um resumo ao fim da chamada',
  'settings.meetings.autoSummarize.ask': 'Perguntar após a chamada',
  'settings.meetings.autoSummarize.always': 'Resumir sempre',
  'settings.meetings.autoSummarize.never': 'Nunca resumir',
  'settings.meetings.listenOnly': 'Modo somente ouvir',
  'settings.meetings.listenOnlyDesc': 'Entrar com o microfone silenciado',
  'settings.meetings.ingestTranscripts': 'Ingerir transcrições do backend',
  'settings.meetings.ingestTranscriptsDesc': 'Armazenar transcrições de reunião na memória',
  'settings.sandbox.title': 'Execução em sandbox',
  'settings.sandbox.menuDesc':
    'Configure backends de sandbox para isolamento das ferramentas do agente.',
  'settings.sandbox.loading': 'Carregando…',
  'settings.sandbox.desktopOnly':
    'As definições de sandbox estão disponíveis apenas na aplicação de ambiente de trabalho.',
  'settings.sandbox.loadError': 'Falha ao carregar as definições de sandbox.',
  'settings.sandbox.saveError': 'Falha ao salvar as configurações de sandbox.',
  'settings.sandbox.saved': 'Salvo: aplica-se a novas sessões do agente.',
  'settings.sandbox.saving': 'Salvando…',
  'settings.sandbox.status': 'Estado',
  'settings.sandbox.dockerStatus': 'Docker',
  'settings.sandbox.available': 'Disponível',
  'settings.sandbox.unavailable': 'Indisponível',
  'settings.sandbox.detectedBackend': 'Backend do sistema operativo',
  'settings.sandbox.enableLabel': 'Ativar execução em sandbox',
  'settings.sandbox.enableDesc': 'Execute as ferramentas do agente num ambiente sandbox isolado.',
  'settings.sandbox.backendLabel': 'Backend',
  'settings.sandbox.backendDesc':
    'Escolha qual backend de isolamento utilizar para a execução em sandbox.',
  'settings.sandbox.backend.auto': 'Automático (detetar o melhor disponível)',
  'settings.sandbox.backend.docker': 'Docker',
  'settings.sandbox.backend.landlock': 'Landlock (Linux)',
  'settings.sandbox.backend.firejail': 'Firejail (Linux)',
  'settings.sandbox.backend.bubblewrap': 'Bubblewrap (Linux)',
  'settings.sandbox.backend.none': 'Nenhum (sem sandbox)',
  'settings.sandbox.dockerSettings': 'Definições Docker',
  'settings.sandbox.dockerImage': 'Imagem',
  'settings.sandbox.dockerImagePlaceholder': 'alpine:3.20',
  'settings.sandbox.memoryLimit': 'Limite de memória',
  'settings.sandbox.memoryUnit': 'MB',
  'settings.sandbox.cpuLimit': 'Limite de CPU',
  'settings.sandbox.cpuUnit': 'núcleos',
  'settings.sandbox.envPassthrough': 'Passagem de variáveis de ambiente',
  'settings.sandbox.envPassthroughDesc': 'Variáveis de ambiente encaminhadas para o sandbox.',
  'settings.sandbox.noEnvVars': 'Nenhuma variável de ambiente configurada.',
  'settings.approvalHistory.title': 'Histórico de aprovações',
  'settings.approvalHistory.subtitle':
    'Decisões recentes de aprovação de ferramentas, as mais recentes primeiro.',
  'settings.approvalHistory.refresh': 'Refresh',
  'settings.approvalHistory.loading': 'Carregando histórico de aprovações…',
  'settings.approvalHistory.retry': 'Retry',
  'settings.approvalHistory.emptyState': 'Nenhuma decisão de aprovação registrada ainda.',
  'settings.approvalHistory.errorGeneric':
    'Não foi possível carregar o histórico de aprovações. Tente novamente.',
  'settings.approvalHistory.decidedAt': 'Decidido em {date}',
  'settings.approvalHistory.decision.approveOnce': 'Aprovado uma vez',
  'settings.approvalHistory.decision.approveAlways': 'Sempre permitido',
  'settings.approvalHistory.decision.approveAlwaysFlow': 'Sempre permitido (fluxo)',
  'settings.approvalHistory.decision.deny': 'Denied',
  'settings.theme.variantLight': 'Claro',
  'settings.theme.variantDark': 'Escuro',
  'settings.theme.variantAuto': 'Automático',
  'settings.theme.variantAria': 'Variante do tema',
  'settings.theme.backdropHeading': 'Fundo',
  'settings.theme.backdrop.mesh': 'Malha',
  'settings.theme.backdrop.solid': 'Sólido',
  'settings.theme.backdrop.image': 'Imagem',
  'settings.theme.backdropImageUrl': 'URL da imagem de fundo',
  'settings.theme.backdropDots': 'Mostrar pontos de fundo',
  'settings.theme.backdropHint':
    'A malha mostra o gradiente animado; Sólido usa um fundo plano; Imagem exibe o seu próprio.',
  'settings.theme.autoForkHint':
    'Editar uma predefinição salva automaticamente suas alterações como um novo tema personalizado.',
  'settings.theme.title': 'Estúdio de Temas',
  'settings.theme.menuDesc':
    'Personalize totalmente as cores e fontes, ou escolha um tema predefinido.',
  'settings.theme.presetsHeading': 'Temas',
  'settings.theme.builtInBadge': 'Predefinido',
  'settings.theme.customBadge': 'Personalizado',
  'settings.theme.customizeHint':
    'As predefinições integradas são somente leitura. Duplique este tema para editar as suas cores e fontes.',
  'settings.theme.duplicate': 'Duplicar e personalizar',
  'settings.theme.copyName': '{name} (personalizado)',
  'settings.theme.importedName': 'Tema importado',
  'settings.theme.contrastWarn':
    'Baixo contraste entre o texto e o fundo: este tema pode ser difícil de ler.',
  'settings.theme.group.surfaces': 'Superfícies',
  'settings.theme.group.text': 'Texto',
  'settings.theme.group.borders': 'Bordas',
  'settings.theme.group.accents': 'Cores de destaque',
  'settings.theme.showShades': 'Mostrar todos os tons de destaque',
  'settings.theme.hideShades': 'Ocultar todos os tons de destaque',
  'settings.theme.fontsHeading': 'Fontes',
  'settings.theme.fontRole.title': 'Título',
  'settings.theme.fontRole.heading': 'Cabeçalho',
  'settings.theme.fontRole.body': 'Corpo',
  'settings.theme.fontRole.mono': 'Monoespaçada',
  'settings.theme.fontRole.serif': 'Serifada',
  'settings.theme.fontCurrent': 'Atual',
  'settings.theme.actions': 'Gerir tema',
  'settings.theme.reset': 'Repor substituições',
  'settings.theme.delete': 'Eliminar tema',
  'settings.theme.export': 'Copiar JSON',
  'settings.theme.copied': 'Copiado!',
  'settings.theme.import': 'Importar tema',
  'settings.theme.importHint':
    'Cole o JSON do tema exportado para adicioná-lo como um tema personalizado.',
  'settings.theme.importApply': 'Importar',
  'settings.theme.importError': 'Não foi possível analisar esse JSON de tema.',
  'settings.appearance.title': 'Aparência',
  'settings.appearance.themeHeading': 'Tema',
  'settings.appearance.themeAria': 'Tema',
  'settings.appearance.modeLight': 'Claro',
  'settings.appearance.modeLightDesc': 'Superfícies brilhantes, texto escuro.',
  'settings.appearance.modeDark': 'Escuro',
  'settings.appearance.modeDarkDesc':
    'Superfícies escuras, mais agradáveis ​​aos olhos após o anoitecer.',
  'settings.appearance.modeSystem': 'Sistema de correspondência',
  'settings.appearance.modeSystemDesc':
    'Siga a configuração de aparência do seu sistema operacional.',
  'settings.appearance.helperText':
    'O modo escuro muda todo o aplicativo – bate-papo, configurações, painéis – para uma paleta escura. "Match system" segue a aparência do seu sistema operacional e atualiza ao vivo.',
  'settings.appearance.fontSizeHeading': 'Tamanho da fonte',
  'settings.appearance.fontSizeAria': 'Tamanho da fonte',
  'settings.appearance.fontSizeSmall': 'Pequeno',
  'settings.appearance.fontSizeSmallDesc': 'Texto compacto: mais conteúdo na tela.',
  'settings.appearance.fontSizeMedium': 'Médio',
  'settings.appearance.fontSizeMediumDesc': 'O tamanho padrão e equilibrado.',
  'settings.appearance.fontSizeLarge': 'Grande',
  'settings.appearance.fontSizeLargeDesc': 'Texto maior para leitura mais fácil.',
  'settings.appearance.fontSizeXLarge': 'Extra grande',
  'settings.appearance.fontSizeXLargeDesc': 'O maior texto, para máxima legibilidade.',
  'settings.appearance.fontSizeHelperText':
    'Dimensiona o texto em todo o app (chat, configurações e painéis) independentemente da configuração de fonte do seu sistema.',
  'settings.appearance.fontSizeCustomLabel': 'Tamanho personalizado',
  'settings.appearance.fontSizeCustomAria': 'Tamanho da fonte personalizado em pixels',
  'settings.appearance.fontSizeCustomSliderAria':
    'Controle deslizante de tamanho de fonte personalizado, em pixels',
  'settings.appearance.fontSizeUnit': 'px',
  'settings.appearance.tabBarHeading': 'Barra inferior da guia',
  'settings.appearance.tabBarAlwaysShowLabels': 'Sempre mostrar rótulos',
  'settings.appearance.tabBarAlwaysShowLabelsDesc':
    'Quando desativado, os rótulos só aparecem ao passar o mouse ou para a guia ativa.',
  'settings.appearance.chatHeading': 'Chat',
  'settings.appearance.assistantTextMode': 'Respostas do assistente em texto',
  'settings.appearance.hideAgentInsights': 'Ocultar o raciocínio do agente',
  'settings.appearance.hideAgentInsightsDesc':
    'Recolhe a linha do tempo passo a passo do agente no chat. Um link “Processando” piscando ainda permite abrir o processo completo.',
  'settings.appearance.showChatMascot': 'Mostrar o Tiny na caixa de mensagem',
  'settings.appearance.showChatMascotDesc':
    'O mascote fica em pé sobre o campo de escrita. Oculto, a conversa fica apenas em texto até você ativar de novo.',
  'settings.appearance.assistantTextModeDesc':
    'Renderiza as respostas do assistente como texto sem moldura e mantém suas mensagens em balões.',
  'settings.mascot.active': 'Ativo',
  'settings.mascot.characterDesc': 'Descrição do personagem',
  'settings.mascot.characterDraft': 'Rascunho',
  'settings.mascot.characterHeading': 'Título do personagem',
  'settings.mascot.customGifError':
    'Insira uma URL de imagem HTTPS, file:// ou local (PNG, GIF, JPEG, WebP ou BMP), ou envie um arquivo.',
  'settings.mascot.customGifHeading': 'Avatar de imagem personalizado',
  'settings.mascot.customGifLabel': 'URL do avatar de imagem personalizado',
  'settings.mascot.customGifPlaceholder': 'https://example.com/avatar.png',
  'settings.mascot.customGifUpload': 'Enviar imagem',
  'settings.mascot.customGifInvalidType':
    'Tipo de arquivo não suportado. Envie uma imagem PNG, GIF, JPEG, WebP ou BMP.',
  'settings.mascot.customGifTooLarge': 'A imagem é muito grande. Envie um arquivo de até 1,5 MB.',
  'settings.mascot.customGifReadError': 'Não foi possível ler essa imagem. Tente outro arquivo.',
  'settings.mascot.characterPreview': 'Visualização',
  'settings.mascot.characterStates': 'estados',
  'settings.mascot.characterVisemes': 'visemas',
  'settings.mascot.colorAria': 'OpenHuman cor',
  'settings.mascot.colorDesc': 'Descrição de cor',
  'settings.mascot.colorHeading': 'Título de cor',
  'settings.mascot.colorBlack': 'Preto',
  'settings.mascot.colorBurgundy': 'Borgonha',
  'settings.mascot.colorCustom': 'Personalizado',
  'settings.mascot.colorNavy': 'Marinho',
  'settings.mascot.primaryColor': 'Cor primária',
  'settings.mascot.secondaryColor': 'Cor secundária',
  'settings.mascot.colorYellow': 'Amarelo',
  'settings.mascot.libraryUnavailable': 'OpenHuman biblioteca indisponível',
  'settings.mascot.title': 'OpenHuman',
  'settings.mascot.loadingLibrary': 'Carregando biblioteca do OpenHuman…',
  'settings.mascot.loadDetailError': 'Não foi possível carregar o mascote.',
  'settings.mascot.loadLibraryError': 'Não foi possível carregar a biblioteca de mascotes.',
  'settings.mascot.localDefault': 'OpenHuman local (padrão)',
  'settings.mascot.menuTitle': 'Mascote',
  'settings.mascot.menuDesc': 'Escolha a cor do mascote usada em todo o app',
  'settings.mascot.noCharacters': 'Nenhum personagem do OpenHuman disponível ainda',
  'settings.mascot.noColorVariants': 'Sem variantes de cor',
  'settings.mascot.secondaryHeading': 'Dupla de reunião (segundo mascote)',
  'settings.mascot.secondaryDesc':
    'Adicione um segundo mascote para as reuniões. Com dois definidos, eles aparecem juntos e falam em turnos. Deixe como Nenhum para um único mascote.',
  'settings.mascot.secondaryNone': 'Nenhum (mascote único)',
  'settings.mascot.perMascotVoiceHeading': 'Vozes por mascote',
  'settings.mascot.primaryVoiceLabel': 'Voz do primeiro mascote',
  'settings.mascot.secondaryVoiceLabel': 'Voz do segundo mascote',
  'settings.mascot.voice.current': 'atual',
  'settings.mascot.voice.customDesc':
    'Encontre IDs de voz em api.elevenlabs.io/v1/voices ou no seu painel da ElevenLabs. Apenas o ID é armazenado: sua chave de API permanece no backend.',
  'settings.mascot.voice.customHeading': 'ID de voz personalizado',
  'settings.mascot.voice.customOption': 'Outro (colar ID de voz)…',
  'settings.mascot.voice.customPlaceholder': 'por exemplo. 21m00Tcm4TlvDq8ikWAM',
  'settings.mascot.voice.desc':
    'Escolha a voz da ElevenLabs que o mascote usa para respostas faladas. Filtre por gênero, escolha na lista curada, cole um ID personalizado, ou deixe o app escolher uma voz que combine com o idioma da interface.',
  'settings.mascot.voice.genderFemale': 'Feminino',
  'settings.mascot.voice.genderHeading': 'Gênero da voz',
  'settings.mascot.voice.genderMale': 'Masculino',
  'settings.mascot.voice.heading': 'Voz',
  'settings.mascot.voice.preset': 'Predefinição de voz',
  'settings.mascot.voice.presetHeading': 'Predefinição de voz',
  'settings.mascot.voice.preview': 'Pré-visualização da voz',
  'settings.mascot.voice.previewError': 'Falha na pré-visualização da voz',
  'settings.mascot.voice.previewText': 'Oi, eu sou seu assistente. Esta é uma prévia de voz.',
  'settings.mascot.voice.previewing': 'Pré-visualizando…',
  'settings.mascot.voice.reset': 'Redefinir para o padrão',
  'settings.mascot.voice.useLocaleDefault': 'Corresponder ao idioma do app',
  'settings.mascot.voice.useLocaleDefaultDesc':
    'Escolher automaticamente uma voz para o idioma atual da interface.',
  'settings.persona.title': 'Persona',
  'settings.persona.menuTitle': 'Persona',
  'settings.persona.menuDesc':
    'Nome, personalidade, avatar e voz: seu assistente como uma só identidade',
  'settings.persona.identityHeading': 'Identidade',
  'settings.persona.identityDesc':
    'Um nome de exibição e uma breve descrição para o seu assistente. Mostrado no aplicativo; não altera a forma como o assistente raciocina.',
  'settings.persona.displayNameLabel': 'Nome de exibição',
  'settings.persona.displayNamePlaceholder': 'por exemplo Nova',
  'settings.persona.descriptionLabel': 'Descrição',
  'settings.persona.descriptionPlaceholder':
    'por exemplo, um assistente calmo e conciso para minha equipe.',
  'settings.persona.soul.heading': 'Personalidade (SOUL.md)',
  'settings.persona.soul.desc':
    'A personalidade que o assistente segue em cada conversa. As edições são salvas no seu espaço de trabalho e entram em vigor na próxima resposta.',
  'settings.persona.soul.editorLabel': 'Conteúdo do SOUL.md',
  'settings.persona.soul.reset': 'Redefinir para o padrão',
  'settings.persona.soul.usingDefault': 'Usando o padrão incluído',
  'settings.persona.soul.loadError': 'Não foi possível carregar SOUL.md',
  'settings.persona.soul.saveError': 'Não foi possível salvar SOUL.md',
  'settings.persona.soul.resetError': 'Não foi possível resetar SOUL.md',
  'settings.persona.builder.modeLabel': 'Modo do editor de persona',
  'settings.persona.builder.modeGuided': 'Guiado',
  'settings.persona.builder.modeAdvanced': 'Avançado',
  'settings.persona.builder.intro':
    'Preencha alguns campos e nós os escrevemos na sua persona. Não é preciso markdown.',
  'settings.persona.builder.personalityLabel': 'Personalidade',
  'settings.persona.builder.personalityPlaceholder':
    'ex.: Acolhedor, curioso e direto. Honesto quanto à incerteza.',
  'settings.persona.builder.voiceLabel': 'Estilo de comunicação',
  'settings.persona.builder.voicePlaceholder':
    'ex.: Comece pela resposta, seja breve e acompanhe o meu tom.',
  'settings.persona.builder.aboutLabel': 'Sobre você',
  'settings.persona.builder.aboutPlaceholder':
    'ex.: Tenho um pequeno estúdio de design e prefiro linguagem simples.',
  'settings.persona.builder.preservedNote':
    'Quaisquer outras seções que você escreveu à mão são mantidas: mude para Avançado para ver a persona completa.',
  'settings.persona.builder.securityNote': 'Quer escolher o que o assistente pode fazer?',
  'settings.persona.builder.securityLink': 'Abrir Acesso do agente',
  'settings.persona.templates.heading': 'Começar a partir de um modelo',
  'settings.persona.templates.desc':
    'Escolha um ponto de partida: preenche Personalidade e Estilo de comunicação. Depois você pode editar tudo.',
  'settings.persona.templates.doctor.label': 'Assistente clínico',
  'settings.persona.templates.doctor.desc': 'Cuidadoso, cita fontes, sinaliza incerteza',
  'settings.persona.templates.researcher.label': 'Assistente de pesquisa',
  'settings.persona.templates.researcher.desc': 'Rigoroso, estruturado, baseado em evidências',
  'settings.persona.templates.executive.label': 'Assistente executivo',
  'settings.persona.templates.executive.desc': 'Conciso, decidido, orientado à ação',
  'settings.persona.templates.teacher.label': 'Professor',
  'settings.persona.templates.teacher.desc': 'Paciente, explica passo a passo',
  'settings.persona.templates.student.label': 'Parceiro de estudos',
  'settings.persona.templates.student.desc': 'Encorajador, faz perguntas, linguagem simples',
  'settings.persona.templates.family.label': 'Assistente da família',
  'settings.persona.templates.family.desc': 'Acolhedor, amigável, seguro para todas as idades',
  'settings.persona.appearanceHeading': 'Avatar e Voz',
  'settings.persona.appearanceDesc':
    'A cor do mascote, o avatar de imagem personalizado e a voz de resposta são configurados nas configurações do mascote.',
  'settings.persona.openMascotSettings': 'Abrir configurações do Mascote',
  'settings.memoryWindow.balanced.badge': 'Recomendado',
  'settings.memoryWindow.balanced.hint':
    'Padrão sensato: boa continuidade sem queimar tokens extras em cada execução.',
  'settings.memoryWindow.balanced.label': 'Balanceado',
  'settings.memoryWindow.description':
    'A quantidade de contexto que o OpenHuman injeta em cada nova execução do agente. Janelas maiores parecem mais cientes de conversas passadas, mas usam mais tokens e custam mais a cada execução.',
  'settings.memoryWindow.extended.badge': 'Mais contexto',
  'settings.memoryWindow.extended.hint':
    'Mais memória de longo prazo injetada em cada execução. Custo maior por turno.',
  'settings.memoryWindow.extended.label': 'Estendido',
  'settings.memoryWindow.maximum.badge': 'Maior custo',
  'settings.memoryWindow.maximum.hint':
    'A maior janela segura. Melhor continuidade, conta de tokens significativamente maior a cada execução.',
  'settings.memoryWindow.maximum.label': 'Máximo',
  'settings.memoryWindow.minimal.badge': 'Mais barato',
  'settings.memoryWindow.minimal.hint':
    'Menor janela de memória. Mais barato, mais rápido, menor continuidade entre execuções.',
  'settings.memoryWindow.minimal.label': 'Mínimo',
  'settings.memoryWindow.title': 'Janela de memória de longo prazo',
  'settings.agentbox.title': 'AgentBox',
  'settings.agentbox.desc':
    'Estado do adaptador do marketplace GMI Cloud e configuração do provedor',
  'settings.agentbox.intro':
    'Estado somente leitura do adaptador do marketplace AgentBox. O modo e o provedor GMI MaaS são definidos por variáveis de ambiente quando o núcleo é iniciado.',
  'settings.agentbox.modeLabel': 'Modo do marketplace',
  'settings.agentbox.providerHeading': 'Provedor GMI MaaS',
  'settings.agentbox.slug': 'Identificador do provedor',
  'settings.agentbox.baseUrl': 'URL base',
  'settings.agentbox.model': 'Modelo',
  'settings.agentbox.notConfigured':
    'Não configurado. Defina as variáveis de ambiente GMI_MAAS_BASE_URL, GMI_MAAS_API_KEY e GMI_MODELS.',
  'settings.agentbox.unavailable': 'Estado do AgentBox indisponível',
  'settings.modelHealth.title': 'Saúde do Modelo',
  'settings.modelHealth.desc':
    'Qualidade por modelo, taxa de alucinações e comparação de custos entre os modelos ativos',
  'settings.modelHealth.allStatuses': 'Todos os status',
  'settings.modelHealth.models': 'modelos',
  'settings.modelHealth.loading': 'Carregando dados do modelo...',
  'settings.modelHealth.empty': 'Nenhum modelo registrado',
  'settings.modelHealth.col.model': 'Modelo',
  'settings.modelHealth.col.quality': 'Qualidade',
  'settings.modelHealth.col.halluc': 'Taxa de alucinação',
  'settings.modelHealth.col.cost': 'Custo / 1M fora',
  'settings.modelHealth.col.agents': 'Agentes',
  'settings.modelHealth.col.status': 'Status',
  'settings.modelHealth.badge.keep': 'Manter',
  'settings.modelHealth.badge.replace': 'Substituir',
  'settings.modelHealth.badge.staging': 'Teste de encenação',
  'settings.modelHealth.badge.vision': 'Somente visão',
  'settings.modelHealth.swap': 'Trocar?',
  'settings.modelHealth.modal.title': 'Substituir modelo?',
  'settings.modelHealth.modal.hallucRate': 'Taxa de alucinação',
  'settings.modelHealth.modal.cancel': 'Cancelar',
  'settings.modelHealth.modal.apply': 'Aplicar Substituição',
  'settings.modelHealth.tag.cheaper': 'CHEAPER',
  'settings.modelHealth.tag.better': 'BETTER',
  'skills.card.moreActions': 'Mais ações',
  'skills.channelIcon.discord': 'Discord',
  'skills.channelIcon.imessage': 'iMessage',
  'skills.channelIcon.telegram': 'Telegram',
  'skills.channelIcon.web': 'Web',
  'skills.channelIcon.yuanbao': 'Yuanbao',
  'skills.composio.poweredBy': 'Desenvolvido por Composio',
  'skills.composio.staleStatusTitle': 'As conexões estão mostrando status obsoleto',
  'skills.create.allowedTools': 'Ferramentas permitidas',
  'skills.create.allowedToolsHelp': 'Renderizado no frontmatter SKILL.md como',
  'skills.create.allowedToolsPlaceholder': 'node_exec, fetch',
  'skills.create.author': 'Autor',
  'skills.create.authorPlaceholder': 'Seu nome',
  'skills.create.commaSeparated': '(separado por vírgulas)',
  'skills.create.createBtn': 'Criar skill',
  'skills.create.createError': 'Não foi possível criar habilidade',
  'skills.create.creating': 'Criando…',
  'skills.create.description': 'Descrição',
  'skills.create.descriptionPlaceholder': 'O que essa habilidade faz?',
  'skills.create.optional': '(opcional)',
  'skills.create.inputs.heading': 'Inputs',
  'skills.create.inputs.help':
    'Declare os parâmetros que a skill precisa. O Skills Runner renderizará um formulário para estes em tempo de execução.',
  'skills.create.inputs.add': 'Adicionar entrada',
  'skills.create.inputs.row.name': 'Nome da entrada',
  'skills.create.inputs.row.namePlaceholder': 'ex.: repo',
  'skills.create.inputs.row.nameError':
    'Apenas letras, dígitos, sublinhados e hifens; deve começar com uma letra.',
  'skills.create.inputs.row.description': 'Descrição da entrada',
  'skills.create.inputs.row.descriptionPlaceholder': 'O que vai neste campo?',
  'skills.create.inputs.row.type': 'Type',
  'skills.create.inputs.row.required': 'Required',
  'skills.create.inputs.row.remove': 'Remover entrada',
  'skills.create.inputs.type.string': 'Text',
  'skills.create.inputs.type.integer': 'Number',
  'skills.create.inputs.type.boolean': 'Sim / Não',
  'skills.create.license': 'Licença',
  'skills.create.licensePlaceholder': 'MIT',
  'skills.create.name': 'Nome',
  'skills.create.namePlaceholder': 'ex.: Trade Journal',
  'skills.create.scope': 'Escopo',
  'skills.create.scopeProjectHint': '/.openhuman/skills/',
  'skills.create.scopeUserHint':
    'Escrito em ~/.openhuman/skills/<slug>/SKILL.md: disponível em todos os espaços de trabalho.',
  'skills.create.slugLabel': 'Rótulo do slug',
  'skills.create.subtitle': 'SKILL.md',
  'skills.create.tags': 'Tags',
  'skills.create.tagsPlaceholder': 'negociação, pesquisa',
  'skills.create.title': 'Nova skill',
  'skills.detail.allowedTools': 'Ferramentas permitidas',
  'skills.detail.author': 'Autor',
  'skills.detail.license': 'Licença',
  'skills.detail.bundledResources': 'Recursos incluídos',
  'skills.detail.description': 'Descrição',
  'skills.detail.closeAriaLabel': 'Fechar detalhes da habilidade',
  'skills.detail.location': 'Localização',
  'skills.detail.noBundledResources': 'Sem recursos incluídos.',
  'skills.detail.platforms': 'Plataformas',
  'skills.detail.relatedSkills': 'Skills relacionadas',
  'skills.detail.source': 'URL de origem',
  'skills.detail.sourceFormat': 'Formato',
  'skills.detail.stars': 'Estrelas',
  'skills.detail.tags': 'Tags',
  'skills.detail.warnings': 'Avisos',
  'skills.detail.version': 'Versão',
  'skills.install.errors.alreadyInstalledHint':
    'Uma habilidade com este slug já existe no espaço de trabalho. Remova-o primeiro ou altere o frontmatter `metadata.id` / `name`.',
  'skills.install.errors.alreadyInstalledTitle': 'Habilidade já instalada',
  'skills.install.errors.fetchFailedHint':
    'A solicitação não foi concluída com êxito. Verifique os pontos URL em um arquivo público acessível e se o host retornou uma resposta 2xx.',
  'skills.install.errors.fetchFailedTitle': 'Falha na busca',
  'skills.install.errors.fetchTimedOutHint':
    'O host remoto não respondeu a tempo. Tente novamente ou aumente o tempo limite (1-600 s).',
  'skills.install.errors.fetchTimedOutTitle': 'Tempo limite de busca esgotado',
  'skills.install.errors.fetchTooLargeHint':
    'O SKILL.md deve ter menos de 1 MiB. Divida os recursos agrupados em arquivos `references/` ou `scripts/` em vez de inlinhá-los.',
  'skills.install.errors.fetchTooLargeTitle': 'SKILL.md muito grande',
  'skills.install.errors.genericHint':
    'O back-end retornou um erro. A mensagem bruta é mostrada abaixo.',
  'skills.install.errors.genericTitle': 'Não foi possível instalar a habilidade',
  'skills.install.errors.invalidSkillHint':
    'O frontmatter deve ser YAML válido com campos `name` e `description` não vazios, terminados por `---`.',
  'skills.install.errors.invalidSkillTitle': 'SKILL.md não analisou',
  'skills.install.errors.invalidUrlHint':
    'Somente HTTPS URLs públicos são permitidos. Hosts privados, de loopback e de metadados são bloqueados.',
  'skills.install.errors.invalidUrlTitle': 'URL rejeitado',
  'skills.install.errors.unsupportedUrlHint':
    'Somente links diretos `.md` funcionam. Para GitHub, link para um arquivo (github.com/owner/repo/blob/.../SKILL.md) - as raízes da árvore e do repositório não estão instaladas.',
  'skills.install.errors.unsupportedUrlTitle': 'Formulário URL não suportado',
  'skills.install.errors.writeFailedHint':
    'O diretório de habilidades do espaço de trabalho não era gravável. Verifique as permissões do sistema de arquivos para `<workspace>/.openhuman/skills/`.',
  'skills.install.errors.writeFailedTitle': 'Não foi possível gravar SKILL.md',
  'skills.install.fetchLog': 'Buscar log',
  'skills.install.fetchingPrefix': 'Buscando',
  'skills.install.fetchingSuffix': 'isso pode levar até o tempo limite que você configurou.',
  'skills.install.installBtn': 'Instalando…',
  'skills.install.installComplete': 'Instalação concluída',
  'skills.install.installing': 'Instalando…',
  'skills.install.parseWarnings': 'Avisos de análise',
  'skills.install.rawError': 'Erro bruto',
  'skills.install.subtitleMiddle': 'sobre HTTPS e instala-o em',
  'skills.install.subtitlePrefix': 'Busca apenas um único',
  'skills.install.subtitleSuffix': 'HTTPS; hosts privados e de loopback são bloqueados.',
  'skills.install.successDiscovered': 'Descobertas {count} novas habilidades.',
  'skills.install.successNoNewIds':
    'Habilidade instalada, mas nenhum novo ID de habilidade apareceu - o catálogo pode já conter uma habilidade com o mesmo slug.',
  'skills.install.timeoutHint': '(segundos, opcional)',
  'skills.install.timeoutHelp':
    'O padrão é 60 segundos. Valores fora de 1-600 são fixados no lado do servidor.',
  'skills.install.timeoutInvalid': 'Deve ser um número inteiro entre 1 e 600.',
  'skills.install.timeoutLabel': 'Rótulo de timeout',
  'skills.install.timeoutPlaceholder': '60',
  'skills.install.title': 'Instalar skill a partir de URL',
  'skills.install.urlHelpMiddle': 'arquivo.',
  'skills.install.urlHelpPrefix': 'Link direto para uma reescrita automática de',
  'skills.install.urlHelpSuffix': 'URLs para',
  'skills.install.urlInvalidPrefix': 'URL deve ser um link',
  'skills.install.urlInvalidSuffix': 'bem formado.',
  'skills.install.urlLabel': 'URL da skill',
  'skills.install.urlPlaceholder': 'https://raw.githubusercontent.com/owner/repo/main/SKILL.md',
  'skills.meetingBots.bannerDesc': 'Descrição do banner',
  'skills.meetingBots.bannerTitle': 'Título do banner',
  'skills.meetingBots.busyTitle': 'OpenHuman está ocupado',
  'skills.meetingBots.comingSoon': 'Em breve',
  'skills.meetingBots.couldNotLeaveTitle': 'Não foi possível sair da reunião',
  'skills.meetingBots.couldNotStartTitle': 'Não foi possível iniciar o OpenHuman',
  'skills.meetingBots.displayName': 'Nome de exibição',
  'skills.meetingBots.failedToStart': 'Falha ao iniciar o OpenHuman.',
  'skills.meetingBots.joiningMessage': 'Ele deve aparecer como participante em alguns segundos.',
  'skills.meetingBots.joiningTitle': 'OpenHuman está entrando na reunião',
  'skills.meetingBots.meetingLink': 'Link da reunião',
  'skills.meetingBots.modalAriaLabel': 'Enviar OpenHuman para uma reunião',
  'skills.meetingBots.modalDesc': 'Descrição do modal',
  'skills.meetingBots.modalTitle': 'Enviar OpenHuman para uma reunião',
  'skills.meetingBots.newBadge': 'Badge novo',
  'skills.meetingBots.platformComingSoon': 'O suporte {label} estará disponível em breve.',
  'skills.meetingBots.platformHints.gmeet': 'meet.google.com/abc-defg-hij',
  'skills.meetingBots.platformHints.teams': 'times.microsoft.com/...',
  'skills.meetingBots.platformHints.webex': 'webex.com/meet/...',
  'skills.meetingBots.platformHints.zoom': 'zoom.us/j/...',
  'skills.meetingBots.platforms.gmeet': 'Google Conheça',
  'skills.meetingBots.platforms.teams': 'Microsoft Teams',
  'skills.meetingBots.platforms.webex': 'Webex',
  'skills.meetingBots.platforms.zoom': 'Zoom',
  'skills.meetingBots.sendTo': 'Enviar para',
  'skills.meetingBots.serverOverloaded':
    'O OpenHuman está sob carga intensa no momento. Tente novamente em alguns minutos.',
  'skills.meetingBots.soonSuffix': 'em breve',
  'skills.meetingBots.starting': 'Iniciando…',
  'skills.meetingBots.recentCallsAriaLabel': 'Chamadas de reunião recentes',
  'skills.meetingBots.recentCallsHeading': 'Chamadas recentes',
  'skills.meetingBots.recentCallsEmpty':
    'Nenhuma chamada anterior ainda: seu histórico de reuniões aparecerá aqui.',
  'skills.meetingBots.recentCallsLoading': 'Carregando\u2026',
  'skills.meetingBots.recentCallAddedBy': 'Adicionado por {name}',
  'skills.meetingBots.recentCallParticipants': 'Com {names}',
  'skills.meetingBots.recentCallTurnSingular': '{count} turno',
  'skills.meetingBots.recentCallTurnPlural': '{count} turnos',
  'skills.meetingBots.recentCallDuration': '{seconds}s em chamada',
  'skills.meetingBots.callDetailLoading': 'Carregando transcrição…',
  'skills.meetingBots.callDetailError': 'Não foi possível carregar a transcrição.',
  'skills.meetingBots.callDetailRetry': 'Tentar novamente',
  'skills.meetingBots.callDetailEmpty':
    'Nenhuma transcrição ou resumo foi registrado para esta chamada.',
  'skills.meetingBots.callSummaryHeading': 'Resumo',
  'skills.meetingBots.callKeyPointsHeading': 'Pontos principais',
  'skills.meetingBots.callActionItemsHeading': 'Itens de ação',
  'skills.meetingBots.callTranscriptHeading': 'Transcrição',
  'skills.meetingBots.liveBadge': 'Ao vivo',
  'skills.meetingBots.liveTitle': 'Em reunião',
  'skills.meetingBots.liveStatusJoining': 'Entrando\u2026',
  'skills.meetingBots.liveStatusActive': 'Ao vivo na reunião',
  'skills.meetingBots.liveStatusListening': 'Ouvindo (mudo)',
  'skills.meetingBots.liveStatusEnded': 'Reunião encerrada',
  'skills.meetingBots.liveStatusError': 'Falha ao entrar',
  'skills.meetingBots.liveTranscriptHeading': 'Transcrição ao vivo',
  'skills.meetingBots.liveTranscriptEmpty': 'Aguardando fala…',
  'skills.meetingBots.leaveButton': 'Sair',
  'skills.meetingBots.leavingButton': 'Saindo…',
  'skills.meetingBots.respondToParticipant': 'Seu nome nesta reunião',
  'skills.meetingBots.respondToParticipantHint': 'ex. João (seu nome exibido na chamada)',
  'skills.meetingBots.replyName.label': 'Seu nome nas reuniões',
  'skills.meetingBots.replyName.description':
    'O nome que o bot escuta e ao qual responde. Digite seu nome como aparece na chamada: aplicado a cada reunião de que participa.',
  'skills.meetingBots.replyName.placeholder': 'ex.: Alex Kim',
  'skills.meetingBots.respondToParticipantDesc':
    'Insira o seu nome de exibição exato da reunião. O bot só responde quando você diz o nome dele (frase de ativação).',
  'skills.meetingBots.wakePhrase': 'Frase de ativação',
  'skills.meetingBots.wakePhraseHint': 'Hey OpenHuman',
  'skills.meetingBots.wakePhraseDesc': 'O participante deve dizer isso antes de o bot responder.',
  'skills.meetingBots.activeMode': 'Responder quando eu falar com ele',
  'skills.meetingBots.activeModeDesc':
    'Quando ativado, o bot responde em voz alta depois que você diz a frase de ativação. Quando desativado, ele apenas ouve e transcreve.',
  'skills.meetingBots.history.allPlatforms': 'Todas as plataformas',
  'skills.meetingBots.history.copyTranscript': 'Copiar',
  'skills.meetingBots.history.downloadTranscript': 'Baixar',
  'skills.meetingBots.history.earlier': 'Antes',
  'skills.meetingBots.history.participantCount': '{count} participante',
  'skills.meetingBots.history.participantCountPlural': '{count} participantes',
  'skills.meetingBots.history.runWithOpenHuman': 'Executar com OpenHuman',
  'skills.meetingBots.history.searchPlaceholder': 'Pesquisar chamadas…',
  'skills.meetingBots.history.selectPrompt':
    'Selecione uma chamada para ver seu resumo e transcrição.',
  'skills.meetingBots.history.today': 'Hoje',
  'skills.meetingBots.history.yesterday': 'Ontem',
  'skills.meetingBots.upcoming.heading': 'Próximas',
  'skills.meetingBots.upcoming.when': 'Quando',
  'skills.meetingBots.upcoming.meeting': 'Reunião',
  'skills.meetingBots.upcoming.platform': 'Plataforma',
  'skills.meetingBots.upcoming.people': 'Pessoas',
  'skills.meetingBots.upcoming.joinPolicy': 'Política de participação',
  'skills.meetingBots.upcoming.joinNow': 'Participar agora',
  'skills.meetingBots.upcoming.joinNowAriaLabel': 'Participar de {title}',
  'skills.meetingBots.upcoming.join': 'Participar',
  'skills.meetingBots.upcoming.auto': 'Auto',
  'skills.meetingBots.upcoming.ask': 'Perguntar',
  'skills.meetingBots.upcoming.skip': 'Ignorar',
  'skills.meetingBots.upcoming.today': 'Hoje',
  'skills.meetingBots.upcoming.tomorrow': 'Amanhã',
  'skills.meetingBots.upcoming.empty':
    'Sem reuniões próximas: conecte o Google Calendar para vê-las aqui.',
  'skills.meetingBots.upcoming.error': 'Não foi possível carregar as reuniões próximas.',
  'skills.meetingBots.upcoming.retry': 'Tentar novamente',
  'skills.meetingBots.upcoming.refresh': 'Atualizar',
  'skills.meetingBots.upcoming.filterAll': 'Todas as plataformas',
  'skills.meetingBots.upcoming.participants': '{count} participantes',
  'skills.meetingBots.upcoming.imminent': 'Começa em breve',
  'skills.meetingBots.upcoming.autoJoinsAt': 'Entra automaticamente ~às {time}',
  'skills.meetingBots.upcoming.asksAtStart': 'Pergunta no início',
  'skills.meetingBots.upcoming.watchCalendarHint':
    "Ative 'Monitorar meu calendário' nos Padrões (ícone de engrenagem) para que Auto/Perguntar entre em vigor: caso contrário, essas políticas ficam salvas mas não serão acionadas.",
  'skills.meetingBots.relative.now': 'agora',
  'skills.meetingBots.relative.inMinutes': 'em {count}m',
  'skills.meetingBots.relative.inHours': 'em {count}h',
  'skills.meetingBots.relative.minutesAgo': 'há {count}m',
  'skills.meetingBots.relative.hoursAgo': 'há {count}h',
  'skills.meetingBots.relative.daysAgo': 'há {count}d',
  'skills.meetingBots.relative.yesterday': 'ontem',
  'skills.meetingBots.defaults.drawerTitle': 'Padrões de reunião',
  'skills.meetingBots.defaults.closeDrawer': 'Fechar',
  'skills.meetingBots.defaults.openDefaults': 'Configurações de reunião',
  'skills.meetingBots.defaults.watchCalendar': 'Monitorar meu calendário',
  'skills.meetingBots.defaults.watchCalendarDesc':
    'Permita que o OpenHuman monitore seu calendário conectado para entrar automaticamente em reuniões ou solicitar confirmação com base nas políticas abaixo. Isso é separado das notificações de lembrete de reunião.',
  'skills.meetingBots.defaults.globalPolicy': 'Política global de entrada automática',
  'skills.meetingBots.defaults.perPlatformTitle': 'Configurações por plataforma',
  'skills.meetingBots.defaults.perPlatformDesc':
    'Substituir a política global para plataformas específicas.',
  'skills.meetingBots.defaults.useDefault': 'Usar padrão',
  'skills.resource.preview.closeAriaLabel': 'Fechar visualização',
  'skills.resource.preview.failed': 'Falha na pré-visualização',
  'skills.resource.preview.loading': 'Carregando visualização…',
  'skills.resource.tree.assets': 'Recursos',
  'skills.resource.tree.examples': 'Exemplos',
  'skills.resource.tree.other': 'Outros',
  'skills.resource.tree.prompts': 'Prompts',
  'skills.resource.tree.references': 'Referências',
  'skills.resource.tree.scripts': 'Scripts',
  'skills.resource.tree.templates': 'Modelos',
  'skills.resource.tree.empty': 'Sem recursos incluídos.',
  'skills.search.placeholder': 'Espaço reservado',
  'skills.setup.voice.activation': 'Ativação',
  'skills.setup.voice.activeDescPrefix': 'Fn',
  'skills.setup.voice.activeDescSuffix': 'Fn',
  'skills.setup.voice.activeTitle': 'Inteligência de Voz está Ativa',
  'skills.setup.voice.customizeSettings': 'Personalizar configurações',
  'skills.setup.voice.downloadSttBtn': 'Botão de download STT',
  'skills.setup.voice.enableDesc': 'Descrição de ativação',
  'skills.setup.voice.hotkey': 'Tecla de atalho',
  'skills.setup.voice.startBtn': 'Iniciando...',
  'skills.setup.voice.startError': 'Falha ao iniciar servidor de voz',
  'skills.setup.voice.starting': 'Iniciando...',
  'skills.setup.voice.stepEnable': 'Iniciar servidor de voz',
  'skills.setup.voice.stepSetup': 'Download de modelo necessário',
  'skills.setup.voice.stepSuccess': 'Pronto para usar',
  'skills.setup.voice.sttNotReady': 'Modelo de fala para texto não está pronto',
  'skills.setup.voice.sttNotReadyDesc':
    'A Inteligência de Voz requer um modelo Whisper local para transcrição. Baixe-o nas configurações de Modelo Local.',
  'skills.setup.voice.sttReady': 'Modelo de fala para texto pronto',
  'skills.setup.voice.sttReturnHint': 'Dica de retorno STT',
  'skills.setup.voice.title': 'Inteligência de Voz',
  'skills.uninstall.couldNotUninstall': 'Não foi possível desinstalar',
  'skills.uninstall.description':
    'Isso exclui permanentemente o diretório da skill e todos os recursos empacotados. O agente deixará de vê-la no próximo turno.',
  'skills.uninstall.title': 'Desinstalar',
  'skills.uninstall.uninstallBtn': 'Desinstalar',
  'skills.uninstall.uninstalling': 'Desinstalando…',
  'upsell.global.limitMessage': 'Faça upgrade do seu plano ou adicione créditos para continuar',
  'upsell.global.limitTitle': 'Você',
  'upsell.global.nearLimitMessage':
    'Você usou {pct}% do seu limite de uso. Faça upgrade para limites mais altos.',
  'upsell.global.nearLimitTitle': 'Aproximando-se do limite de uso',
  'upsell.usageLimit.bodyBudget':
    'Você atingiu seu limite semanal.{reset} Atualize seu plano ou recarregue créditos para evitar limites.',
  'upsell.usageLimit.bodyRate':
    'Você atingiu seu limite de taxa de inferência de 10 horas.{reset} Atualize para limites maiores.',
  'upsell.usageLimit.heading': 'Limite de Uso Atingido',
  'upsell.usageLimit.notNow': 'Agora não',
  'upsell.usageLimit.perWindow': '{amount}',
  'upsell.usageLimit.planIncludes': '{plan}',
  'upsell.usageLimit.resetsIn': 'Será redefinido {time}.',
  'upsell.usageLimit.upgradePlan': 'Fazer upgrade do plano',
  'upsell.usageLimit.weeklyInference': '{amount}',
  'walkthrough.steps.startChat.title': 'Comece no chat',
  'walkthrough.steps.startChat.content':
    'O chat é seu ponto de partida. Novas janelas abrem com a mesma saudação e ações rápidas vistas na configuração.',
  'walkthrough.steps.sayHello.title': 'Diga olá',
  'walkthrough.steps.sayHello.content':
    'Toque aqui para iniciar uma conversa com seu assistente de IA quando quiser.',
  'walkthrough.steps.meetAi.title': 'Conheça sua IA',
  'walkthrough.steps.meetAi.content':
    'É aqui que as conversas acontecem. Faça perguntas, peça resumos ou desenvolva ideias. Tudo continua pesquisável.',
  'walkthrough.steps.connectWorld.title': 'Conecte seu mundo',
  'walkthrough.steps.connectWorld.content':
    'Gmail, Slack, WhatsApp e mais: cada conexão dá novos poderes ao seu assistente.',
  'walkthrough.steps.messagingApps.title': 'Converse onde você já está',
  'walkthrough.steps.messagingApps.content':
    'WhatsApp, Telegram, Slack, Discord: conecte seus apps de mensagens para que seu assistente alcance você em qualquer lugar.',
  'walkthrough.steps.settings.title': 'Deixe do seu jeito',
  'walkthrough.steps.settings.content':
    'Preferências, privacidade e notificações ficam aqui. Você pode reiniciar este tour por esta página a qualquer momento.',
  'walkthrough.steps.chatTab.title': 'Volte ao chat',
  'walkthrough.steps.chatTab.content': 'Use a aba Chat sempre que quiser retornar às conversas.',
  'walkthrough.steps.humanTab.title': 'Conheça seu perfil humano',
  'walkthrough.steps.humanTab.content':
    'Human reúne seu contexto pessoal, identidade e perfil visível ao assistente.',
  'walkthrough.steps.brainTab.title': 'Abra seu Brain',
  'walkthrough.steps.brainTab.content':
    'Brain é o grafo de memória: o lugar para ver o que o OpenHuman sabe e como as ideias se conectam.',
  'walkthrough.steps.agentWorldTab.title': 'Explore o Agent World',
  'walkthrough.steps.agentWorldTab.content':
    'Agent World é onde ficam agentes reutilizáveis e automações compartilhadas.',
  'walkthrough.steps.connectionsTab.title': 'Gerencie conexões',
  'walkthrough.steps.connectionsTab.content':
    'Connections está sempre na navegação principal quando você quiser adicionar ou ajustar serviços.',
  'walkthrough.steps.feedbackTab.title': 'Enviar feedback',
  'walkthrough.steps.feedbackTab.content':
    'Feedback oferece um lugar direto para relatar problemas ou pedir melhorias.',
  'walkthrough.steps.allSet.title': 'Tudo pronto!',
  'walkthrough.steps.allSet.content':
    'Seu assistente deixou uma nota de boas-vindas: este é seu espaço para conversar, perguntar ou explorar ideias. Divirta-se!',
  'walkthrough.tooltip.letsGo': 'Vamos lá!',
  'walkthrough.tooltip.next': 'Próximo →',
  'walkthrough.tooltip.skip': 'Pular tour',
  'walkthrough.tooltip.stepCounter': '{n} de {total}',
  'webhooks.activity.empty': 'Vazio',
  'webhooks.activity.title': 'Atividade Recente',
  'webhooks.composioHistory.empty': 'Vazio',
  'webhooks.composioHistory.metadataId': 'ID de Metadados',
  'webhooks.composioHistory.metadataUuid': 'UUID de Metadados',
  'webhooks.composioHistory.payload': 'Carga útil',
  'webhooks.composioHistory.title': 'Histórico de Gatilhos ComposeIO',
  'webhooks.tunnels.active': 'Ativo',
  'webhooks.tunnels.createFailed': 'Falha ao criar tunnel',
  'webhooks.tunnels.creating': 'Criando...',
  'webhooks.tunnels.deleteFailed': 'Falha ao excluir tunnel',
  'webhooks.tunnels.descriptionPlaceholder': 'Descrição (opcional)',
  'webhooks.tunnels.echo': 'Echo',
  'webhooks.tunnels.empty': 'Vazio',
  'webhooks.tunnels.enableEcho': 'Ativar Echo',
  'webhooks.tunnels.inactive': 'Inativo',
  'webhooks.tunnels.namePlaceholder': 'Nome do tunnel (ex.: telegram-bot)',
  'webhooks.tunnels.newTunnel': 'Novo tunnel',
  'webhooks.tunnels.removeEcho': 'Remover Echo',
  'webhooks.tunnels.title': 'Tunnels de Webhook',
  'webhooks.tunnels.toggleFailed': 'Falha ao alternar echo',
  'composio.directModeRequiresKey':
    'Falha ao salvar. O modo Direto requer uma chave de API não vazia.',
  'composio.integrationSlugsHelp': 'Slugs de integração separados por vírgula, por exemplo.',
  'composio.integrationSlugsExample': 'Gmail, folga',
  'composio.integrationSlugsCaseInsensitive': 'Não diferencia maiúsculas de minúsculas.',
  'composio.integrationSlugsPlaceholder': 'gmail, slack, ...',
  'composio.notYetRouted': 'ainda não roteado',
  'composio.triggers.loading': 'Carregando…',
  'conversations.taskKanban.todo': 'A fazer',
  'chat.addReaction': 'Adicionar reação',
  'chat.agentProfile.create': 'Criar perfil de agente',
  'chat.agentProfile.createFailed': 'Não foi possível criar perfil de agente.',
  'chat.agentProfile.customDescription': 'Perfil de agente personalizado',
  'chat.agentProfile.defaultAgentLabel': 'Orquestrador',
  'chat.agentProfile.exists': 'O perfil de agente "{name}" já existe.',
  'chat.agentProfile.label': 'Perfil do agente',
  'chat.agentProfile.quick': 'Rápido',
  'chat.agentProfile.reasoning': 'Raciocínio',
  'chat.agentProfile.namePlaceholder': 'Nome do perfil',
  'chat.agentProfile.promptStylePlaceholder': 'Estilo de prompt',
  'chat.agentProfile.allowedToolsPlaceholder': 'Ferramentas permitidas',
  'chat.backToThread': 'voltar para {title}',
  'chat.parentThread': 'thread pai',
  'chat.removeReaction': 'Remover {emoji}',
  'settings.composio.loading': 'Carregando…',
  'settings.mascot.noCharactersAvailable': 'Nenhum personagem do OpenHuman disponível ainda',
  'skills.uninstall.confirmTitle': 'Desinstalar {name}?',
  'conversations.taskKanban.blocked': 'Bloqueado',
  'conversations.taskKanban.done': 'Concluído',
  'conversations.taskKanban.pending': 'Pendente',
  'conversations.taskKanban.working': 'Trabalhando',
  'conversations.taskKanban.awaitingApproval': 'Aguardando aprovação',
  'conversations.taskKanban.ready': 'Pronto',
  'conversations.taskKanban.rejected': 'Rejeitado',
  'conversations.taskKanban.inProgress': 'Em andamento',
  'conversations.taskKanban.awaitingApprovalColumn': 'Aguardando aprovação',
  'conversations.taskKanban.blockedColumn': 'Bloqueado',
  'conversations.taskKanban.evidenceBadge': 'Evidência ({count})',
  'conversations.taskKanban.needsInput': 'Estas tarefas precisam da sua participação',
  'conversations.taskKanban.emptyColumn': 'Sem tarefas',
  'conversations.taskKanban.dragHint': 'Arraste para mover entre colunas',
  'conversations.taskKanban.movingCard': 'Movendo…',
  'conversations.taskKanban.statusBadge.ready': 'Pronto para começar',
  'conversations.taskKanban.statusBadge.rejected': 'Rejeitado',
  'intelligence.memoryChunk.detail.copiedHint': 'copiado',
  'settings.composio.notYetRouted': 'ainda não roteado',
  'settings.localModel.download.manageExternal': 'Gerencie este modelo no seu runtime externo.',
  'settings.localModel.status.manageOllamaExternal':
    'Gerencie o processo do Ollama e o download de modelos fora do OpenHuman e, em seguida, execute o diagnóstico novamente.',
  'settings.localModel.status.ollamaDocs': 'Documentação do Ollama',
  'settings.localModel.status.thenRetry':
    'para instruções de configuração, em seguida tente novamente depois que seu runtime estiver acessível.',
  'devOptions.menuAi': 'Configuração de IA',
  'devOptions.menuAiDesc':
    'Provedores de nuvem, modelos Ollama locais e roteamento por carga de trabalho',
  'devOptions.menuMessaging': 'Canais de mensagens',
  'devOptions.menuMessagingDesc':
    'Configurar modos de autenticação Telegram/Discord e roteamento de canal padrão',
  'devOptions.menuTools': 'Ferramentas',
  'devOptions.menuToolsDesc':
    'Habilitar ou desabilitar recursos que OpenHuman pode usar em seu nome',
  'devOptions.menuAgentChat': 'Bate-papo do agente',
  'devOptions.menuAgentChatDesc':
    'Testar conversação do agente com substituições de modelo e temperatura',
  'devOptions.menuCronJobs': 'Tarefas Cron',
  'devOptions.menuCronJobsDesc':
    'Visualizar e configurar trabalhos agendados para habilidades de tempo de execução',
  'devOptions.menuLocalModelDebug': 'Depuração de modelo local',
  'devOptions.menuLocalModelDebugDesc':
    'Configuração de Ollama, downloads de ativos, testes de modelo e diagnósticos',
  'devOptions.menuWebhooksDebug': 'Webhooks',
  'devOptions.menuWebhooksDebugDesc':
    'Inspecione registros de webhook em tempo de execução e logs de solicitação capturados',
  'devOptions.menuIntelligence': 'Inteligência',
  'devOptions.menuIntelligenceDesc':
    'Espaço de trabalho de memória, mecanismo subconsciente, sonhos e configurações',
  'devOptions.menuNotificationRouting': 'Roteamento de notificação',
  'devOptions.menuNotificationRoutingDesc':
    'AI pontuação de importância e escalonamento do orquestrador para alertas de integração',
  'devOptions.menuComposeIOTriggers': 'Acionadores do ComposeIO',
  'devOptions.menuComposeIOTriggersDesc':
    'Visualizar histórico e arquivo do acionador do ComposeIO',
  'devOptions.menuComposioRouting': 'Composio Roteamento (modo direto)',
  'devOptions.menuComposioRoutingDesc':
    'Traga sua própria chave Composio API e encaminhar chamadas diretamente para backend.composio.dev',
  'devOptions.menuComposioTriggers': 'Gatilhos de integração',
  'devOptions.menuComposioTriggersDesc':
    'Definir configurações de triagem de IA para gatilhos de integração Composio',
  'memory.sourceFilterAria': 'Filtrar por origem',
  'calls.comingSoonDescription': 'Chamadas assistidas por IA chegam em breve. Fique ligado.',
  'whatsapp.title': 'WhatsApp',
  'subconscious.priority.critical': 'crítico',
  'subconscious.priority.important': 'importante',
  'subconscious.priority.normal': 'normal',
  'subconscious.durationSeconds': '{seconds}s',
  'subconscious.durationMilliseconds': '{milliseconds}ms',
  'settings.appearance': 'Aparência',
  'settings.appearanceDesc': 'Escolha claro, escuro ou combine com o tema do seu sistema',
  'settings.mascot': 'Mascote',
  'settings.mascotDesc': 'Escolha a cor do mascote usada no aplicativo',
  'pages.settings.account.walletBalances': 'Saldos da Carteira',
  'pages.settings.account.walletBalancesDesc': 'Visualize saldos multi-chain da sua carteira local',
  'walletBalances.title': 'Saldos da Carteira',
  'walletBalances.refresh': 'Refresh',
  'walletBalances.loading': 'Carregando saldos…',
  'walletBalances.retry': 'Retry',
  'walletBalances.emptyState':
    'Nenhuma conta na carteira ainda: configure uma carteira em Frase de Recuperação.',
  'walletBalances.copyAddress': 'Copiar endereço',
  'walletBalances.providerMissing': 'provedor indisponível',
  'walletBalances.rawBalance': 'Bruto: {raw}',
  'walletBalances.errorGeneric':
    'Não foi possível carregar os saldos da carteira. Configure sua carteira em Frase de Recuperação e tente novamente.',
  'walletBalances.setupHint':
    'A sua frase de recuperação ainda não está configurada. Configure-a para ativar a sua carteira e ver os saldos em tempo real.',
  'walletBalances.setupCta': 'Configurar frase de recuperação',
  'walletBalances.notSetUp': 'Não configurada',
  'walletBalances.send': 'Enviar',
  'walletBalances.receive': 'Receber',
  'walletReceive.scanHint': 'Leia este código ou copie o endereço abaixo para receber fundos.',
  'walletReceive.addressLabel': 'Endereço de {network}',
  'walletReceive.onlyChainWarning':
    'Envie apenas ativos de {network} para este endereço. Enviar ativos de outra rede pode resultar em perda permanente.',
  'walletSend.available': 'Disponível',
  'walletSend.recipient': 'Endereço do destinatário',
  'walletSend.recipientPlaceholder': 'Cole o endereço de destino',
  'walletSend.recipientRequired': 'Insira um endereço de destinatário',
  'walletSend.amount': 'Valor',
  'walletSend.invalidAmount': 'Insira um valor válido',
  'walletSend.review': 'Revisar',
  'walletSend.preparing': 'Preparando…',
  'walletSend.confirmHint':
    'Revise os detalhes abaixo. A assinatura acontece localmente: nada é transmitido até você confirmar.',
  'walletSend.estimatedFee': 'Taxa de rede estimada',
  'walletSend.confirmSend': 'Confirmar e enviar',
  'walletSend.sending': 'Enviando…',
  'walletSend.sent': 'Transação enviada',
  'walletSend.txHash': 'Hash da transação',
  'walletSend.viewExplorer': 'Ver no explorador',
  'walletSend.done': 'Concluído',
  'walletSend.genericError': 'Não foi possível concluir a transferência. Tente novamente.',
  'settings.taskSources.title': 'Fontes da Tarefa',
  'settings.integrations.title': 'Integrações',
  'settings.integrations.menuDesc': 'Fontes de tarefas, roteamento Composio e gatilhos de webhooks',
  'settings.taskSources.subtitle':
    'Puxe tarefas de suas ferramentas para o quadro de tarefas do agente',
  'settings.taskSources.description':
    'Coletar itens de trabalho do GitHub, Notion, Linear e ClickUp, enriquecê-los e encaminhá-los para o quadro de tarefas do agente.',
  'settings.taskSources.connectHint':
    'As fontes de tarefas usam suas contas conectadas. Conecte-as primeiro em Integrações.',
  'settings.taskSources.disabledBanner':
    'As fontes de tarefas estão desativadas nas configurações. Ative-as para realizar a verificação automaticamente.',
  'settings.taskSources.loadError': 'Falha ao carregar fontes da tarefa',
  'settings.taskSources.addTitle': 'Adicionar uma fonte de tarefa',
  'settings.taskSources.provider': 'Fornecedor',
  'settings.taskSources.name': 'Nome (opcional)',
  'settings.taskSources.namePlaceholder': 'por exemplo, minhas questões abertas',
  'settings.taskSources.github.repo': 'Repositório (proprietário/nome, opcional)',
  'settings.taskSources.github.labels': 'Etiquetas (separadas por vírgula)',
  'settings.taskSources.notion.database': 'ID do banco de dados (quadro)',
  'settings.taskSources.notion.browseDatabases': 'Explorar bancos de dados',
  'settings.taskSources.notion.loadingDatabases': 'Carregando bancos de dados…',
  'settings.taskSources.notion.selectDatabase': 'Selecione um banco de dados…',
  'settings.taskSources.notion.noDatabases': 'Nenhum banco de dados encontrado para esta conexão.',
  'settings.taskSources.linear.team': 'ID da equipe (opcional)',
  'settings.taskSources.clickup.team': 'ID do espaço de trabalho (equipe) (opcional)',
  'settings.taskSources.assignedToMe': 'Apenas itens atribuídos a mim',
  'settings.taskSources.add': 'Adicionar fonte',
  'settings.taskSources.adding': 'Adicionando…',
  'settings.taskSources.preview': 'Visualizar',
  'settings.taskSources.previewResult': 'A tarefa(s) {count} corresponde(m) a este filtro',
  'settings.taskSources.fetchNow': 'Buscar agora',
  'settings.taskSources.fetching': 'Buscando…',
  'settings.taskSources.fetchResult':
    'Roteado {routed} de {fetched} tarefa(s); removidas {pruned} tarefa(s) antigas',
  'settings.taskSources.syncAll': 'Sincronizar tudo',
  'settings.taskSources.syncing': 'Sincronizando…',
  'settings.taskSources.configured': 'Fontes configuradas',
  'settings.taskSources.empty': 'Nenhuma fonte de tarefa configurada ainda.',
  'settings.taskSources.proactive': 'Proativo',
  'settings.taskSources.lastFetch': 'Última busca',
  'settings.taskSources.never': 'Nunca',
  'settings.taskSources.statusEnabled': 'Ativado',
  'settings.taskSources.statusDisabled': 'Desativado',
  'settings.taskSources.enable': 'Ativar',
  'settings.taskSources.disable': 'Desativar',
  'settings.taskSources.remove': 'Remover',
  'settings.taskSources.removeConfirm':
    'Remover esta fonte de tarefa? Todo o histórico de tarefas ingerido será excluído e não pode ser desfeito.',
  'settings.taskSources.refresh': 'Atualizar',
  'settings.taskSources.providers.github': 'GitHub',
  'settings.taskSources.providers.notion': 'Noção',
  'settings.taskSources.providers.linear': 'Linear',
  'settings.taskSources.providers.clickup': 'ClickUp',
  'skills.dashboard.enable': 'Ativar fluxo de trabalho agendado',
  'skills.dashboard.disable': 'Desativar fluxo de trabalho agendado',
  'skills.dashboard.lastRun': 'Última execução',
  'skills.dashboard.nextRun': 'Próxima execução',
  'skills.dashboard.cardOpenRunner': 'Abrir no runner',
  'skills.new.title': 'Criar um fluxo de trabalho',
  'settings.agents.title': 'Agentes',
  'settings.agents.subtitle':
    'Gerencie os agentes disponíveis para delegação: padrões integrados e seus próprios agentes personalizados.',
  'settings.agents.menuDesc': 'Gerenciar agentes incorporados e personalizados',
  'settings.agents.newAgent': 'Novo agente',
  'settings.agents.loadError': 'Não foi possível carregar os agentes',
  'settings.agents.empty': 'Ainda não há agentes',
  'settings.agents.sourceDefault': 'Integrado',
  'settings.agents.sourceCustom': 'Personalizado',
  'settings.agents.enable': 'Ativar agente',
  'settings.agents.disable': 'Desativar agente',
  'settings.agents.edit': 'Editar',
  'settings.agents.delete': 'Excluir',
  'settings.agents.reset': 'Redefinir para o padrão',
  'settings.agents.modelLabel': 'Modelo',
  'settings.agents.toolsLabel': 'Ferramentas',
  'settings.agents.toolsAll': 'Todas as ferramentas',
  'settings.agents.toolsCount': 'ferramentas {count}',
  'settings.agents.actionFailed': 'Não foi possível atualizar o agente',
  'settings.agents.orchestratorLocked': 'O orquestrador está sempre habilitado.',
  'settings.agents.editor.createTitle': 'Novo agente',
  'settings.agents.editor.editTitle': 'Editar agente',
  'settings.agents.editor.id': 'ID',
  'settings.agents.editor.idHint': 'Somente letras minúsculas, números, _ e -.',
  'settings.agents.editor.name': 'Nome',
  'settings.agents.editor.description': 'Descrição',
  'settings.agents.editor.model': 'Modelo (opcional)',
  'settings.agents.editor.modelPlaceholder': 'por exemplo, herdar, dica:rápido, ou um id de modelo',
  'settings.agents.editor.systemPrompt': 'Prompt do sistema (opcional)',
  'settings.agents.editor.tools': 'Ferramentas permitidas',
  'settings.agents.editor.toolsHint':
    'Um nome de ferramenta por linha. Use * para todas as ferramentas.',
  'settings.agents.editor.defaultsNote':
    'Editar um agente integrado salva uma substituição que você pode redefinir depois.',
  'settings.agents.editor.save': 'Salvar',
  'settings.agents.editor.create': 'Criar agente',
  'settings.agents.editor.saving': 'Salvando…',
  'nav.workflows': 'Workflows',
  'workflows.title': 'Fluxos de Trabalho',
  'workflows.subtitle':
    'Procedimentos reutilizáveis e executáveis: um objetivo e os passos para alcançá-lo. Crie um, instale a partir de uma URL ou abra um fluxo de trabalho para executá-lo.',
  'workflows.createNew': 'Novo fluxo de trabalho',
  'workflows.listHeading': 'Workflows',
  'workflows.delete': 'Excluir Fluxo de Trabalho',
  'workflows.deleteError': 'Falha ao excluir o fluxo de trabalho',
  'workflows.warnings': '{count} aviso(s)',
  'workflows.empty.title': 'Nenhum fluxo de trabalho ainda',
  'workflows.empty.body':
    'Crie um fluxo de trabalho para definir regras e scripts para as fases do ciclo de vida de tarefas.',
  'workflows.create.title': 'Novo Fluxo de Trabalho',
  'workflows.create.subtitle': 'Defina um conjunto de regras vinculado ao ciclo de vida do agente.',
  'workflows.create.name': 'Name',
  'workflows.create.namePlaceholder': 'ex. Fluxo de trabalho de projeto Python',
  'workflows.create.description': 'Description',
  'workflows.create.descriptionPlaceholder': 'O que este fluxo de trabalho faz?',
  'workflows.create.whenToUse': 'Quando usar',
  'workflows.create.whenToUsePlaceholder': 'Quando o agente deve usar este fluxo de trabalho?',
  'workflows.create.optional': '(opcional)',
  'workflows.create.createBtn': 'Criar fluxo de trabalho',
  'workflows.create.creating': 'Creating…',
  'workflows.create.createError': 'Não foi possível criar o fluxo de trabalho',
  'workflows.create.successTitle': 'Fluxo de trabalho criado',
  'workflows.create.successMessage': 'foi criado com sucesso.',
  'workflows.deleteConfirm.title': 'Excluir fluxo de trabalho',
  'workflows.deleteConfirm.body': 'Remover "{name}"? Esta ação não pode ser desfeita.',
  'workflows.detail.tags': 'Tags',
  'workflows.detail.location': 'Location',
  'workflows.detail.warnings': 'Warnings',
  'workflows.detail.phases': 'Phases',
  'workflows.detail.noPhases': 'Nenhuma fase definida.',
  'workflows.detail.loadError': 'Falha ao carregar o fluxo de trabalho completo',
  'workflows.phase.rules': 'Rules',
  'workflows.phase.rules.empty': 'Sem regras.',
  'workflows.phase.scripts': 'Scripts',
  'workflows.phase.scripts.empty': 'Sem scripts.',
  'workflows.phase.toolScope': 'Escopo de ferramentas',
  'workflows.phase.toolScope.allow': 'Allow',
  'workflows.phase.toolScope.deny': 'Deny',
  'workflows.phase.toolScope.inherited': 'Herdado do padrão do fluxo de trabalho.',
  'workflows.phase.toolScope.empty': 'Sem restrições de ferramentas.',
  'workflows.phase.context': 'Context',
  'workflows.phase.context.empty': 'Sem provedores de contexto.',
  'settings.agentsSection.title': 'Agents',
  'settings.agentsSection.description':
    'Gerencie seus agentes, sua autonomia e o que eles podem acessar neste computador.',
  'settings.agentsSection.menuDesc': 'Registro, autonomia e acesso ao SO',
  'settings.cryptoSection.title': 'Cripto',
  'settings.cryptoSection.description':
    'Gerencie sua frase de recuperação e veja os saldos das suas contas de carteira.',
  'settings.cryptoSection.menuDesc': 'Frase de recuperação e saldos da carteira',
  'settings.notificationsHub.title': 'Notificações',
  'settings.notificationsHub.description':
    'Veja a sua caixa de entrada de alertas e gerencie as preferências de notificação e o encaminhamento.',
  'settings.notificationsHub.menuDesc': 'Caixa de entrada de alertas e preferências de notificação',
  'settings.notificationsHub.settingsItem': 'Configurações de notificação',
  'settings.notificationsHub.settingsItemDesc': 'Preferências e encaminhamento',
  'settings.agents.editor.notFound': 'Agente não encontrado.',
  'settings.agents.editor.modelInherit': 'Herdar (padrão da plataforma)',
  'settings.agents.editor.modelHints': 'Dicas de roteamento',
  'settings.agents.editor.modelTiers': 'Níveis de modelo',
  'settings.agents.editor.modelCustom': 'ID de modelo personalizado…',
  'settings.agents.editor.modelCustomPlaceholder': 'ex.: anthropic/claude-sonnet-4',
  'settings.agents.editor.selectTools': 'Adicionar ferramentas',
  'settings.agents.editor.toolsAllSelected': 'Todas as ferramentas',
  'settings.agents.editor.toolsNoneSelected': 'Nenhuma ferramenta selecionada',
  'settings.agents.editor.removeToolAria': 'Remover {tool}',
  'settings.agents.editor.toolsModalTitle': 'Ferramentas permitidas',
  'settings.agents.editor.toolsSelectedCount': '{count} selecionadas',
  'settings.agents.editor.toolsSearchPlaceholder': 'Pesquisar ferramentas…',
  'settings.agents.editor.toolsAllowAll': 'Permitir todas as ferramentas (*)',
  'settings.agents.editor.toolsAllowAllHint':
    'Este agente pode usar todas as ferramentas disponíveis.',
  'settings.agents.editor.toolsLoading': 'Carregando ferramentas…',
  'settings.agents.editor.toolsLoadError': 'Não foi possível carregar as ferramentas',
  'settings.agents.editor.toolsEmpty': 'Nenhuma ferramenta corresponde à sua pesquisa.',
  'settings.agents.editor.toolsDone': 'Done',
  'settings.agents.editor.builtInReadonly':
    'Agentes integrados não podem ser editados. Você pode ativá-los, desativá-los ou redefini-los na lista de agentes.',
  // Chat: agent-generated artifacts (#2779)
  'chat.artifact.aria': 'Artefato: {title}',
  'chat.artifact.generating': 'Gerando {kind}…',
  'chat.artifact.ready': 'Pronto',
  'chat.artifact.failed': 'Falha ao gerar',
  'chat.artifact.download': 'Baixar',
  'chat.artifact.downloading': 'Baixando…',
  'chat.artifact.downloaded': 'Salvo em {path}',
  'chat.artifact.download_failed': 'Falha no download: {reason}',
  'chat.artifact.retry': 'Tentar novamente',
  'chat.artifact.reveal': 'Mostrar na pasta',
  'chat.artifact.show_more': 'Mostrar mais',
  'chat.artifact.show_less': 'Mostrar menos',

  // Chat: files panel (#3024)
  'chat.files.chip.aria.one': '{count} arquivo neste chat',
  'chat.files.chip.aria.other': '{count} arquivos neste chat',
  'chat.files.panel.aria': 'Arquivos neste chat',
  'chat.files.panel.title': 'Arquivos ({count})',
  'chat.files.panel.empty': 'Ainda não há arquivos. Peça ao agente para gerar um.',
  'chat.files.panel.close': 'Fechar painel de arquivos',
  'chat.files.delete.aria': 'Excluir {title}',
  'chat.files.delete.confirm': 'Excluir este arquivo?',
  'chat.files.delete.cancel': 'Cancelar',
  'chat.files.delete.action': 'Excluir',
  'chat.files.delete.failed': 'Não foi possível excluir o arquivo. Tente novamente.',
  'chat.files.error.not_desktop': 'Os downloads estão disponíveis apenas no app de desktop.',
  'chat.files.error.missing_artifact_id': 'ID do artefato ausente.',
  'chat.files.error.missing_artifact_path': 'Caminho do artefato ausente na resposta do core.',
  'chat.files.error.resolve_failed': 'Não foi possível resolver o artefato. Tente novamente.',
  'chat.files.error.download_failed': 'O download falhou. Tente novamente.',
  'chat.files.error.delete_failed': 'Não foi possível excluir o arquivo. Tente novamente.',
  'memory.tab.council': 'Council',
  'activity.tabs.automations': 'Automações',
  'activity.tabs.automationsDescription':
    'Procedimentos reutilizáveis e executáveis: um objetivo e os passos para alcançá-lo.',
  'activity.tabs.backgroundActivity': 'Subconsciente',
  'activity.tabs.alerts': 'Alertas',

  'intelligence.agents.title': 'Biblioteca de agentes',
  'intelligence.agents.subtitle':
    'Inspecione especialistas executáveis e envie uma tarefa para um agente nomeado.',
  'intelligence.agents.refresh': 'Atualizar',
  'intelligence.agents.loading': 'Carregando agentes…',
  'intelligence.agents.failedToLoad': 'Não foi possível carregar os agentes',
  'intelligence.agents.empty': 'Nenhum agente executável disponível.',
  'intelligence.agents.readOnly': 'Somente leitura',
  'intelligence.agents.writeCapable': 'Pode escrever',
  'intelligence.agents.allTools': 'Todas as ferramentas',
  'intelligence.agents.toolCountOne': '{count} ferramenta',
  'intelligence.agents.toolCountOther': '{count} ferramentas',
  'intelligence.agents.subagentCountOne': '{count} subagente',
  'intelligence.agents.subagentCountOther': '{count} subagentes',
  'intelligence.agents.startChat': 'Iniciar chat',
  'intelligence.agents.startChatPrompt':
    'Inicie um chat com este agente. Apresente sua especialidade, pergunte o que precisa saber e aguarde minha tarefa.',
  'intelligence.agents.copyId': 'Copiar ID',
  'intelligence.agents.copied': 'Copiado',
  'intelligence.agents.taskPlaceholder': 'Tarefa para este agente',
  'intelligence.agents.runTask': 'Executar tarefa',
  'intelligence.agents.running': 'Executando…',
  'intelligence.agents.runFailed': 'Não foi possível iniciar o agente selecionado',
  'intelligence.agents.model.inherit': 'Herdar',
  'intelligence.agents.tier.chat': 'Chat',
  'intelligence.agents.tier.reasoning': 'Raciocínio',
  'intelligence.agents.tier.worker': 'Trabalhador',
  'graphCohesion.brokerBadge': 'intermediador',
  'graphCohesion.brokerTitle':
    'Buraco estrutural: os vizinhos desta entidade não estão conectados entre si: ela é a única ligação entre eles.',
  'graphCohesion.colCohesion': 'Coesão',
  'graphCohesion.colEntity': 'Entidade',
  'graphCohesion.colLinks': 'Ligações',
  'graphCohesion.colRank': '#',
  'graphCohesion.empty': 'Ainda sem grafo de conhecimento.',
  'graphCohesion.emptyHint':
    'À medida que o assistente registra fatos conectados sobre você, a estrutura de agrupamento aparecerá aqui.',
  'graphCohesion.errorPrefix': 'Não foi possível carregar o grafo:',
  'graphCohesion.intro':
    'Esta métrica mede o grau de interligação da vizinhança em torno de cada entidade. Intermediadores (entidades cujos vizinhos não estão ligados entre si) são os pontos únicos que mantêm grupos separados unidos, algo que uma ordenação por frequência ou PageRank não pode revelar.',
  'graphCohesion.loading': 'Calculando coesão…',
  'graphCohesion.metricConnections': 'Conexões',
  'graphCohesion.metricEntities': 'Entidades',
  'graphCohesion.metricTriangles': 'Triângulos',
  'graphCohesion.namespaceAll': 'Todos os espaços de nomes',
  'graphCohesion.namespaceLabel': 'Espaço de nomes',
  'graphCohesion.noBrokers': 'Ainda não há entidades com duas ou mais conexões.',
  'graphCohesion.rankedHeading': 'Intermediadores: vizinhanças mais soltas',
  'graphCohesion.retry': 'Tentar novamente',
  'graphCohesion.summaryCaption': 'Agrupamento médio {avg} · transitividade {transitivity}',
  'graphCohesion.title': 'Coesão do grafo',
  'memory.tab.cohesion': 'Cohesion',

  'harnessInit.title': 'Preparando tudo',

  'announcement.gotIt': 'Entendi',
  'harnessInit.subtitle':
    'O OpenHuman está preparando os componentes necessários na primeira inicialização.',
  'harnessInit.stepPython': 'Ambiente de execução Python',
  'harnessInit.stepSpacy': 'Modelo de linguagem',
  'harnessInit.stepNode': 'Ambiente de execução Node.js',
  'harnessInit.statePending': 'Aguardando',
  'harnessInit.stateRunning': 'Instalando…',
  'harnessInit.stateDone': 'Pronto',
  'harnessInit.stateSkipped': 'Ignorado',
  'harnessInit.stateFailed': 'Falhou',
  'harnessInit.failedMessage':
    'Algumas etapas de configuração não foram concluídas. Você pode tentar novamente ou continuar: o OpenHuman usará uma alternativa integrada.',
  'harnessInit.retry': 'Tentar novamente',
  'harnessInit.continueAnyway': 'Continuar mesmo assim',
  'harnessInit.runInBackground': 'Executar em segundo plano',
  'harnessInit.backgroundHint': 'Você pode continuar usando o OpenHuman enquanto isso termina.',

  'keyring.consent.title': 'Armazenamento seguro indisponível',
  'keyring.consent.description':
    'O chaveiro do sistema operacional não está acessível. O OpenHuman precisa da sua permissão para armazenar segredos usando armazenamento local criptografado.',
  'keyring.consent.reasonPrefix': 'Motivo:',
  'keyring.consent.showDetails': 'O que isso significa?',
  'keyring.consent.hideDetails': 'Ocultar detalhes',
  'keyring.consent.tradeoffTitle': 'Compromisso de segurança',
  'keyring.consent.tradeoffBody':
    'Com o armazenamento local criptografado, seus segredos são criptografados no disco usando uma chave mestra armazenada junto aos dados. Isso é menos seguro que o chaveiro do SO, que usa proteção por hardware. Backups ou sincronização de arquivos podem incluir os dados criptografados.',
  'keyring.consent.consentButton': 'Usar armazenamento local criptografado',
  'keyring.consent.retryButton': 'Tentar novamente OS Keychain',
  'keyring.consent.declineButton': 'Recusar',
  'keyring.consent.retrying': 'Tentando novamente…',
  'keyring.consent.error': 'Falha ao salvar preferência. Tente novamente.',
  'keyring.consent.retryFailed': 'O chaveiro ainda está indisponível.',
  'keyring.settings.title': 'Segurança',
  'keyring.settings.storageMode': 'Modo de armazenamento de segredos',
  'keyring.settings.mode.osKeychain': 'Chaveiro do SO',
  'keyring.settings.mode.encryptedFile': 'Local criptografado',
  'keyring.settings.mode.consentPending': 'Não configurado',
  'keyring.settings.mode.declined': 'Recusado',
  'keyring.settings.availability': 'Disponibilidade do chaveiro',
  'keyring.settings.available': 'O chaveiro do SO está disponível',
  'keyring.settings.unavailable': 'O chaveiro do SO está indisponível',
  'keyring.settings.backend': 'Motor',
  'keyring.settings.retryButton': 'Tentar novamente detecção do chaveiro',
  'keyring.settings.retryFailed': 'Tentativa falhou. O chaveiro ainda está indisponível.',
  'keyring.settings.consentTitle': 'Consentimento de armazenamento',
  'keyring.settings.consentDescription':
    'Escolha como os segredos são armazenados quando o chaveiro do SO não está disponível.',
  'keyring.settings.grantConsent': 'Permitir armazenamento local criptografado',
  'keyring.settings.revokeConsent': 'Recusar armazenamento local',
  'pages.settings.account.security': 'Segurança',
  'pages.settings.account.securityDesc': 'Modo de armazenamento de segredos e status do chaveiro',
  // #002 memory-pipeline-hardening: degraded badges + typed remediation.
  'memoryTree.status.statusDegraded': 'Degradado',
  'memoryTree.status.statusBudgetExhausted': 'Em pausa: limite de embeddings atingido',
  'memoryTree.status.degradedRecall': 'Recuperação semântica desativada',
  'memoryTree.status.degradedStructure': 'Estrutura do wiki incompleta',
  'memoryTree.status.extractionCoverage':
    'Cobertura de extração: {pct}% dos fragmentos têm estrutura',
  'memory.health.remediation.budget_exhausted':
    'Os embeddings de memória atingiram o orçamento gerenciado. Configure embeddings locais do Ollama (Conexões → Chaves de API → Incorporações) ou adicione sua própria chave de API de embeddings para continuar construindo a memória.',
  'memory.health.remediation.auth_missing':
    'Nenhuma credencial de embeddings encontrada. Faça login no OpenHuman ou configure embeddings locais do Ollama em Conexões → Chaves de API → Incorporações.',
  'memory.health.remediation.auth_invalid':
    'Suas credenciais de embeddings foram rejeitadas. Autentique-se novamente ou mude para embeddings locais do Ollama em Conexões → Chaves de API → Incorporações.',
  'memory.health.remediation.embeddings_unconfigured':
    'Nenhum provedor de embeddings está configurado, então a recuperação semântica está desativada. Configure embeddings locais do Ollama (recomendado) ou adicione uma chave de embeddings em Conexões → Chaves de API → Incorporações.',
  'memory.health.remediation.embedding_dim_mismatch':
    'O modelo de embeddings retorna o tamanho de vetor errado (a memória espera 1024 dimensões). Escolha um modelo de 1024 dimensões ou solicite 1024 dimensões ao seu provedor.',
  'memory.health.remediation.local_model_unavailable':
    'Um modelo local necessário não está disponível. Instale/execute o Ollama e baixe o modelo, ou mude esta carga de trabalho para um provedor de nuvem em Conexões → Chaves de API.',
  'memory.health.remediation.extraction_timeout':
    'O modelo de extração de memória está expirando o tempo limite, então o wiki tem pouca estrutura. Mude o modelo de extração de memória para um mais rápido em Conexões → Chaves de API → LLM.',
  'memory.health.remediation.summarizer_unavailable':
    'Nenhum provedor de resumo está disponível para Criar árvores de resumo. Ative a IA local (Ollama), ou defina memory_tree.cloud_summarization_opt_in=true e configure um provedor LLM em Conexões → Chaves de API → LLM.',
  'memory.health.remediation.empty_input_refused':
    'Um item de memória foi ignorado porque o texto estava vazio. Nenhuma ação necessária: itens novos continuam a ser incorporados normalmente.',
  'memory.health.remediation.storage_unavailable':
    'O OpenHuman não consegue gravar no seu armazenamento de memória: o disco ou cartão SD parece estar com falha, cheio ou somente leitura. Verifique a unidade e libere espaço; o processamento da memória será retomado automaticamente assim que o armazenamento voltar a permitir gravação.',
  'memory.health.remediation.transient':
    'Um erro temporário interrompeu o processamento da memória. Será repetido automaticamente.',
  'memory.health.remediation.unknown':
    'O processamento da memória encontrou um problema. Verifique Conexões → Chaves de API para a configuração.',
  // Chat: agent-generated artifacts (#2779)

  // Chat composer toolbar
  'composer.attachFile': 'Anexar arquivo',
  'composer.modelSelector': 'Modelo',
  'composer.voiceMode': 'Modo de voz',
  'composer.qualityHigh': 'Alta',
  // Agent activity level
  'activityLevel.title': 'Nível de atividade do agente',
  'activityLevel.description':
    'Controle o quão proativo é o seu agente. Níveis mais altos usam mais tokens.',
  'activityLevel.off': 'Desligado',
  'activityLevel.offDesc':
    'Nenhum processamento em segundo plano. Sincroniza apenas ao pressionar o botão.',
  'activityLevel.minimal': 'Mínimo',
  'activityLevel.minimalDesc': 'Sincroniza fontes uma vez por dia. Sem mensagens proativas.',
  'activityLevel.moderate': 'Moderado',
  'activityLevel.moderateDesc': 'Sincroniza a cada hora. Resumo diário. Sugere ações.',
  'activityLevel.active': 'Ativo',
  'activityLevel.activeDesc':
    'Sincroniza a cada 10 min. Monitora canais, prioriza e rascunha respostas.',
  'activityLevel.alwaysOn': 'Sempre ativo',
  'activityLevel.alwaysOnDesc': 'Sincronização em tempo real. Autonomia total dentro dos limites.',
  'activityLevel.currentMonth': 'Este mês: ${amount}',
  'activityLevel.saved': 'Nível de atividade atualizado.',
  'activityLevel.default': 'padrão',
  'activityLevel.costFree': '$0',
  'activityLevel.costRange': '~${min}–${max}/mês',

  // Sync budget dialog
  'syncBudget.title': 'Orçamento de sincronização',
  'syncBudget.maxTokens': 'Tokens máximos por sincronização',
  'syncBudget.maxTokensHelp': 'Parar a sincronização ao consumir este número de tokens.',
  'syncBudget.maxCost': 'Custo máximo por sincronização (USD)',
  'syncBudget.maxCostHelp': 'Limite absoluto em dólares por execução de sincronização.',
  'syncBudget.syncDepth': 'Profundidade de sincronização',
  'syncBudget.syncDepthHelp': 'Buscar apenas itens desta janela de tempo.',
  'syncBudget.days7': 'Últimos 7 dias',
  'syncBudget.days30': 'Últimos 30 dias',
  'syncBudget.days90': 'Últimos 90 dias',
  'syncBudget.allTime': 'Todo o tempo',
  'syncBudget.unlimited': 'Ilimitado',
  'syncBudget.saved': 'Orçamento salvo.',

  // Sync confirm dialog
  'syncConfirm.title': 'Confirmar sincronização',
  'syncConfirm.message':
    'Esta sincronização processará ~{items} itens (~{tokens} tokens, est. ${cost}).',
  'syncConfirm.budgetNote': 'Limite de orçamento: ${max}',
  'syncConfirm.proceed': 'Prosseguir',
  'syncConfirm.cancel': 'Cancelar',
  'syncConfirm.estimating': 'Estimando custo...',

  // Monthly cost badge
  'monthlyCost.badge': '${amount} este mês',
  'monthlyCost.noData': 'Sem sincronizações este mês',

  // Onboarding: Custom > Activity
  'onboarding.custom.stepperActivity': 'Atividade',
  'onboarding.custom.activity.title': 'Atividade do agente',
  'onboarding.custom.activity.subtitle':
    'O quão proativamente seu agente monitora e age em segundo plano.',
  'onboarding.custom.activity.defaultDesc':
    'Atividade moderada: sincronização por hora, resumo diário.',
  'onboarding.custom.activity.configureDesc':
    'Escolha seu próprio nível de atividade. Configurar em Configurações › Nível de atividade do agente.',

  // Onboarding: Custom > Vault
  'onboarding.custom.stepperVault': 'Vault',
  'onboarding.custom.vault.title': 'Configuração de Memória e Vault',
  'onboarding.custom.vault.subtitle':
    'Confirme onde as notas de memória são gravadas, como os dados de origem são lidos e se o pipeline do vault está saudável.',
  'onboarding.custom.vault.defaultDesc':
    'Use os padrões de memória gerenciados pelo OpenHuman. O caminho do vault e a integridade da sincronização ainda podem ser revisados depois.',
  'onboarding.custom.vault.configureDesc':
    'Revise a propriedade do vault, execute verificações de integridade e ajuste os controles de memória agora.',
  'onboarding.custom.vault.localDisabledReason':
    'A configuração gerenciada requer login no OpenHuman e não está disponível no modo local.',
  'onboarding.custom.vault.exitError':
    'Não foi possível concluir o processo de integração. Por favor, tente novamente.',

  // Vault Health
  'vaultHealth.title': 'Checklist de integridade do vault',
  'vaultHealth.setupTitle': 'Integridade da configuração do vault',
  'vaultHealth.workspaceVault': 'Vault do espaço de trabalho:',
  'vaultHealth.refresh': 'Atualizar',
  'vaultHealth.refreshing': 'Atualizando…',
  'vaultHealth.revealFolder': 'Revelar pasta',
  'vaultHealth.openInObsidian': 'Abrir no Obsidian',
  'vaultHealth.installObsidian': 'Instalar Obsidian',
  'vaultHealth.openObsidianError': 'Não foi possível abrir o Obsidian',
  'vaultHealth.revealError': 'Não foi possível revelar a pasta do vault',
  'vaultHealth.downloadError': 'Não foi possível abrir a página de download do Obsidian',
  'vaultHealth.loadError': 'Não foi possível carregar a integridade do vault:',
  'vaultHealth.lastSync': 'Última sincronização:',
  'vaultHealth.passed': 'Aprovado',
  'vaultHealth.needsAttention': 'Requer atenção',
  'vaultHealth.existsLabel': 'O caminho do vault do espaço de trabalho existe',
  'vaultHealth.existsRecovery':
    'A pasta do vault está ausente. Inicie uma sincronização ou crie esta pasta e atualize este checklist.',
  'vaultHealth.writableLabel': 'O vault pode ser gravado pelo OpenHuman',
  'vaultHealth.writableRecovery':
    'O OpenHuman ainda não consegue gravar neste vault. Conceda permissões de escrita e atualize.',
  'vaultHealth.obsidianLabel': 'O vault está registrado no Obsidian',
  'vaultHealth.obsidianRecovery':
    'No Obsidian, escolha "Abrir pasta como vault" para este caminho e atualize este checklist.',
  'vaultHealth.pipelineLabel': 'O pipeline de memória está saudável',
  'vaultHealth.pipelineRecovery':
    'O pipeline de memória está pausado ou com erro. Reative a Sincronização automática no status da Árvore de Memória e tente novamente.',
  'vaultHealth.timeNever': 'Nunca',
  'vaultHealth.timeJustNow': 'agora mesmo',
  'vaultHealth.timeMinAgo': 'há {n} min',
  'vaultHealth.timeHrAgo': 'há {n} h',
  'vaultHealth.timeDayAgo': 'há {n} dia',
  'vaultHealth.timeDaysAgo': 'há {n} dias',

  // Memory Data
  'memoryData.howItWorks': 'Como o armazenamento de memória funciona',
  'memoryData.workspaceVault': 'Vault do espaço de trabalho · gravação',
  'memoryData.workspaceVaultDesc':
    'O OpenHuman grava as notas de memória geradas em memory_tree/content.',
  'memoryData.connectedSources': 'Fontes conectadas · leitura',
  'memoryData.connectedSourcesDesc':
    'Pastas, caixas de correio, chats e repositórios são importados para indexação de memória: seus arquivos originais nunca são reescritos.',
  'memoryData.internalFiles': 'Arquivos internos da árvore de memória',
  'memoryData.internalFilesDesc':
    'Índices, estado da fila e resumos são gerenciados pelo OpenHuman para manter a recuperação e a sincronização saudáveis.',
  'memoryData.windowError': 'Janela de memória',
  'memoryData.windowUpdated': 'Janela de memória atualizada',
  'memoryData.windowUpdatedMsg': 'Definida para {window}.',
  'skills.create.whenToUse': 'Quando usar',
  'skills.create.whenToUsePlaceholder':
    'ex.: quando o usuário pede para organizar a caixa de entrada',
  'skills.create.whenToUseHelp':
    'O gatilho que um agente reconhece para decidir executar este fluxo de trabalho. Deixe em branco para reutilizar a descrição.',
  'skills.create.inputs.row.descriptionError': 'É necessária uma descrição para cada entrada.',
  'skills.detail.run': 'Executar',
  'skills.detail.runAriaLabel': 'Executar este fluxo de trabalho',
  'skills.run.title': 'Fluxo de trabalho',
  'workflows.installFromUrl': 'Instalar a partir de URL',
  // Security banner (approval-gate host-aware boot state)
  'security.approvalGateDisabled.title': 'Portão de aprovação desativado',
  'security.approvalGateDisabled.body':
    'OPENHUMAN_APPROVAL_GATE=0 está definido no seu ambiente. Ferramentas com efeito externo serão executadas sem pedir confirmação.',
  'security.approvalGateOverrideIgnored.title': 'Substituição bloqueada',
  'security.approvalGateOverrideIgnored.body':
    'Uma substituição OPENHUMAN_APPROVAL_GATE=0 foi detetada mas ignorada: o aplicativo de desktop mantém sempre o portão de aprovação ativado.',

  // Run queue
  'runQueue.mode.interrupt': 'Interromper',
  'runQueue.mode.steer': 'Direcionar',
  'runQueue.mode.followup': 'Acompanhamento',
  'runQueue.mode.collect': 'Adicionar contexto',
  'runQueue.queued': 'Mensagem na fila',
  'runQueue.steerHint': 'Direcionar o turno atual',
  'runQueue.followupHint': 'Colocar na fila como acompanhamento',
  'runQueue.collectHint': 'Adicionar como contexto extra',
  'runQueue.status': '{total} na fila',
  'runQueue.cleared': 'Fila limpa',
  'notch.ready': 'Pronto',
  'notch.processing': 'Processando…',
  'notch.listening': 'Ouvindo…',
  'notch.thinking': 'Pensando…',
  'notch.speaking': 'Falando…',
  'notch.transcribing': 'Transcrevendo…',
  'notch.executing': 'Executando…',
  'memory.tab.orchestration': 'Orquestração',
  'memory.tab.orchestrationDescription':
    'Execute fluxos de trabalho com múltiplos agentes: distribua uma pergunta entre agentes paralelos, confronte seus resultados e veja cada fase culminar em uma única resposta sintetizada.',
  'orchestration.subtitle':
    'Inicie um fluxo de trabalho com múltiplos agentes, acompanhe o progresso de suas fases e leia o resultado sintetizado.',
  'orchestration.loading': 'Carregando fluxos de trabalho…',
  'orchestration.failedToLoad': 'Falha ao carregar os fluxos de trabalho',
  'orchestration.definitions': 'Fluxos de trabalho disponíveis',
  'orchestration.noDefinitions': 'Nenhuma definição de fluxo de trabalho disponível.',
  'orchestration.approvalRequired': 'Aprovação necessária',
  'orchestration.start': 'Iniciar',
  'orchestration.confirmStart': 'Iniciar execução',
  'orchestration.starting': 'Iniciando…',
  'orchestration.questionLabel': 'Pergunta de pesquisa (opcional)',
  'orchestration.questionPlaceholder': 'O que os agentes devem pesquisar?',
  'orchestration.runProgress': 'Progresso da execução',
  'orchestration.recentRuns': 'Execuções recentes',
  'orchestration.noRuns': 'Ainda não há execuções de fluxos de trabalho.',
  'orchestration.close': 'Fechar',
  'orchestration.tier.readOnly': 'Somente leitura',
  'orchestration.tier.standard': 'Padrão',
  'orchestration.tier.editCapable': 'Com capacidade de edição',
  'orchestration.approval.title': 'Aprovar esta execução do fluxo de trabalho',
  'orchestration.approval.body':
    'Esta é uma execução de alto custo ou alta concorrência e precisa da sua aprovação explícita antes de iniciar:',
  'orchestration.approval.reason.tier':
    'Seus agentes podem realizar ações além da pesquisa somente leitura.',
  'orchestration.approval.reason.concurrency': 'Ela executa muitos agentes ao mesmo tempo.',
  'orchestration.approval.reason.children': 'Ela pode gerar um grande número de agentes no total.',
  'orchestration.approval.tier': 'Nível de segurança',
  'orchestration.approval.concurrency': 'Concorrência',
  'orchestration.approval.maxChildren': 'Máx. de agentes',
  'orchestration.approval.approve': 'Aprovar e iniciar',
  'orchestration.approval.starting': 'Iniciando…',
  'orchestration.approval.cancel': 'Cancelar',
  'orchestration.runStatus.pending': 'Pendente',
  'orchestration.runStatus.running': 'Em execução',
  'orchestration.runStatus.completed': 'Concluída',
  'orchestration.runStatus.failed': 'Falhou',
  'orchestration.runStatus.cancelled': 'Cancelada',
  'orchestration.runStatus.interrupted': 'Interrompida',
  'orchestration.phaseStatus.pending': 'Pendente',
  'orchestration.phaseStatus.running': 'Em execução',
  'orchestration.phaseStatus.completed': 'Concluída',
  'orchestration.phaseStatus.failed': 'Falhou',
  'orchestration.detail.stop': 'Parar',
  'orchestration.detail.resume': 'Retomar',
  'orchestration.detail.agents': 'agentes',
  'orchestration.detail.childRefs': 'Agentes filhos',
  'orchestration.detail.synthesis': 'Síntese final',
  // ── Agent Profiles ───────────────────────────────────────────────────────
  'settings.profiles.title': 'Perfis de agente',
  'settings.profiles.subtitle':
    'Agentes com personalidade: cada um com sua própria alma, memória, conectores e habilidades.',
  'settings.profiles.menuDesc': 'Crie e gerencie perfis de agente',
  'settings.profiles.new': 'Novo perfil',
  'settings.profiles.empty': 'Ainda não há perfis de agente',
  'settings.profiles.loadError': 'Não foi possível carregar os perfis',
  'settings.profiles.active': 'Ativo',
  'settings.profiles.setActive': 'Definir como ativo',
  'settings.profiles.sourceBuiltIn': 'Integrado',
  'settings.profiles.sourceCustom': 'Personalizado',
  'settings.profiles.deleteConfirm': 'Excluir este perfil? Isso não pode ser desfeito.',
  'settings.profiles.editor.createTitle': 'Novo perfil',
  'settings.profiles.editor.editTitle': 'Editar perfil',
  'settings.profiles.editor.name': 'Nome',
  'settings.profiles.editor.id': 'Identificador',
  'settings.profiles.editor.idHint': 'Apenas letras minúsculas, números e hífens.',
  'settings.profiles.editor.description': 'Descrição',
  'settings.profiles.editor.soul': 'Alma (SOUL.md)',
  'settings.profiles.editor.soulHint':
    'Identidade personalizada deste perfil. Vazio recorre ao SOUL.md do espaço de trabalho.',
  'settings.profiles.editor.baseAgent': 'Agente base',
  'settings.profiles.editor.baseAgentHint':
    'Com qual definição de agente este perfil é executado (por exemplo, orchestrator).',
  'settings.profiles.editor.model': 'Modelo',
  'settings.profiles.editor.modelHint': 'Substituição de modelo opcional. Vazio herda o padrão.',
  'settings.profiles.editor.temperature': 'Temperatura',
  'settings.profiles.editor.systemPromptSuffix': 'Sufixo do prompt do sistema',
  'settings.profiles.editor.agentConversations': 'Lembrar conversas do agente',
  'settings.profiles.editor.agentConversationsHint':
    'Incluir memória de conversas anteriores e entre conversas no contexto deste perfil.',
  'settings.profiles.editor.memorySources': 'Fontes de memória',
  'settings.profiles.editor.memorySourcesHint': 'Fontes de memória das quais este perfil recorda.',
  'settings.profiles.editor.connectors': 'Conectores',
  'settings.profiles.editor.connectorsHint':
    'Kits de ferramentas do Composio que este perfil pode usar.',
  'settings.profiles.editor.skills': 'Habilidades',
  'settings.profiles.editor.skillsHint':
    'Fluxos de trabalho que este perfil pode listar e executar.',
  'settings.profiles.editor.mcpServers': 'Servidores MCP',
  'settings.profiles.editor.mcpServersHint': 'Servidores MCP que este perfil pode acessar.',
  'settings.profiles.editor.dedicatedMemory': 'Memória dedicada',
  'settings.profiles.editor.dedicatedMemoryHint':
    'Dê a este perfil sua própria memória em vez de compartilhar a memória padrão.',
  'settings.profiles.editor.dedicatedWorkspace': 'Espaço de trabalho dedicado',
  'settings.profiles.editor.dedicatedWorkspaceHint':
    'Dê a este perfil seu próprio diretório de trabalho para operações de arquivos e ferramentas.',
  'settings.profiles.editor.soulMdFile': 'Arquivo SOUL.md',
  'settings.profiles.editor.workspaceDir': 'Diretório de trabalho',
  'settings.profiles.editor.skillsDir': 'Diretório de habilidades',
  'settings.profiles.editor.skillsDirHint':
    'Os arquivos SKILL.md colocados aqui são privados deste perfil.',
  'settings.profiles.editor.all': 'Todos',
  'settings.profiles.editor.selected': 'Selecionados',
  'settings.profiles.editor.addPlaceholder': 'Digite um identificador e pressione Enter',
  'settings.profiles.editor.removeAria': 'Remover {item}',
  'settings.profiles.editor.notFound': 'Perfil não encontrado',
  'settings.profiles.editor.saving': 'Salvando…',
  'settings.profiles.editor.idRequired': 'O identificador do perfil não pode estar vazio',
  'agentworld.jobs.applyModal.title': 'Candidatar-se à vaga',
  'agentworld.jobs.applyModal.successHeading': 'Proposta enviada com sucesso!',
  'agentworld.jobs.applyModal.successBody': 'O publicador da vaga irá analisar a sua candidatura.',
  'agentworld.jobs.applyModal.coverLetterLabel': 'Carta de apresentação',
  'agentworld.jobs.applyModal.coverLetterPlaceholder':
    'Descreva a sua experiência e por que você é adequado para esta função',
  'agentworld.jobs.applyModal.bidAmountLabel': 'Valor da proposta',
  'agentworld.jobs.applyModal.bidAmountPlaceholder': 'ex. 450 USDC',
  'agentworld.jobs.applyModal.deliveryLabel': 'Prazo estimado de entrega',
  'agentworld.jobs.applyModal.deliveryPlaceholder': 'ex. 2 semanas',
  'agentworld.feed.live': 'Ao vivo',
  'agentworld.jobs.applyModal.cancel': 'Cancelar',
  'agentworld.jobs.applyModal.submit': 'Enviar candidatura',
  'agentworld.jobs.applyModal.submitting': 'A enviar…',
  'agentworld.messaging.live': 'Ao vivo',
  'agentworld.messaging.missingSignalBundle':
    'Este utilizador ainda não ativou as mensagens encriptadas. Peça-lhe para abrir o Agent World e ativar DMs seguras antes de enviar uma mensagem.',
  'agentworld.messaging.notAContact':
    'Não podes enviar mensagens a esta pessoa até ela ser um contacto. Envia um pedido de contacto e tenta novamente depois de ela aceitar.',
  'agentworld.messaging.sendContactRequest': 'Enviar pedido de contacto',
  'agentworld.messaging.contactRequestSending': 'A enviar pedido…',
  'agentworld.messaging.contactRequestSent':
    'Pedido de contacto enviado. Poderás enviar mensagens quando ela aceitar.',
  'agentworld.messaging.contactRequestFailed':
    'Não foi possível enviar o pedido de contacto. Tenta novamente.',

  // User-actionable runtime errors (#3931)
  'userErrors.title': 'Ação necessária',
  'userErrors.dismiss': 'Dispensar',
  'userErrors.action.openBilling': 'Abrir faturamento',
  'userErrors.action.openProviderSettings': 'Configurações do provedor',
  'userErrors.action.openEmbeddingsSettings': 'Configurar embeddings',
  'userErrors.budgetExceeded.title': 'Orçamento gerenciado esgotado',
  'userErrors.budgetExceeded.body':
    'Seu orçamento de IA gerenciado acabou. Adicione orçamento ou altere seu plano.',
  'userErrors.insufficientCredits.title': 'Créditos do provedor necessários',
  'userErrors.insufficientCredits.body':
    'Seu provedor de IA ficou sem créditos. Recarregue-o ou atualize a chave de API.',
  'userErrors.apiKeyMissing.title': 'Chave de API necessária',
  'userErrors.apiKeyMissing.body':
    'Seu provedor de IA não tem uma chave de API definida. Adicione uma nas configurações do provedor para continuar.',
  'userErrors.localModelUnavailable.title': 'Modelo local indisponível',
  'userErrors.localModelUnavailable.body':
    'O Ollama não está acessível no endpoint configurado, ou o modelo necessário não está instalado nele. Inicie o Ollama e baixe o modelo nesse endpoint, ou mude este trabalho para um provedor na nuvem.',
  'userErrors.scope.chat': 'Chat',
  'userErrors.scope.cron': 'Tarefa agendada',
  'userErrors.scope.workspace': 'Espaço de trabalho',
  'userErrors.memoryBudgetExhausted.title': 'A memória parou de crescer',
  'userErrors.memoryBudgetExhausted.body':
    'Seu orçamento de embeddings acabou, então novos conteúdos não estão mais sendo adicionados à memória. Configure embeddings locais ou adicione sua própria chave de API para retomar.',
  'memoryBudget.approachingTitle': 'A memória está chegando ao limite de embeddings',
  'memoryBudget.approachingMessage':
    'Você já usou {pct}% do seu orçamento de embeddings. Configure embeddings locais ou adicione sua própria chave de API para a memória continuar crescendo sem interrupção.',
  'memoryBudget.exhaustedTitle': 'A memória parou de crescer',
  'memoryBudget.exhaustedMessage':
    'Seu orçamento de embeddings acabou, então novos conteúdos não estão mais sendo adicionados à memória. Configure embeddings locais ou adicione sua própria chave de API para retomar.',
  'memoryBudget.cta': 'Configurar embeddings',
  'userErrors.scope.memory': 'Memória',
  // Agent World: Identity trading (confirm-before-spend + balance gate)
  'agentWorld.trading.amountLabel': 'Valor',
  'agentWorld.trading.networkLabel': 'Rede',
  'agentWorld.trading.balanceLabel': 'Seu saldo',
  'agentWorld.trading.walletLabel': 'Carteira',
  'agentWorld.trading.balanceUnknown': 'Desconhecido',
  'agentWorld.trading.cancel': 'Cancelar',
  'agentWorld.trading.addFunds': 'Adicionar fundos',
  'agentWorld.trading.confirmPay': 'Confirmar e pagar',
  'agentWorld.trading.confirmCommit': 'Confirmar',
  'agentWorld.trading.continue': 'Continuar',
  'agentWorld.trading.submitting': 'Enviando…',
  'agentWorld.trading.placeBid': 'Dar lance',
  'agentWorld.trading.submitOffer': 'Enviar oferta',
  'agentWorld.trading.bidTitlePrefix': 'Lance para',
  'agentWorld.trading.offerTitlePrefix': 'Oferta para',
  'agentWorld.trading.bidReviewTitlePrefix': 'Confirmar lance para',
  'agentWorld.trading.offerReviewTitlePrefix': 'Confirmar oferta para',
  'agentWorld.trading.spendInsufficient':
    'Saldo insuficiente para concluir este pagamento. Adicione fundos à sua carteira para continuar.',
  'agentWorld.trading.spendBroadcastNote':
    'Sua carteira vai assinar e transmitir este pagamento na',
  'agentWorld.trading.commitInsufficientWarning':
    'Seu saldo pode não cobrir isso se o compromisso for aceito. Você ainda pode enviá-lo: os fundos só se movem na aceitação.',
  'agentWorld.trading.commitSettleNote':
    'Este é um compromisso assinado: os fundos só se movem se for aceito.',
  'agentWorld.trading.commitReviewSubtitle': 'Revise seu compromisso antes de enviar.',
  'agentWorld.trading.balanceUnverified':
    'Não conseguimos verificar o saldo da sua carteira. Você ainda pode continuar: o pagamento é verificado no envio.',
  'agentWorld.trading.amountTooManyDecimals': 'Este valor tem casas decimais em excesso.',
  'agentWorld.trading.amountMustBePositive': 'Insira um valor maior que zero.',
  'agentWorld.trading.amountInvalid': 'Insira um valor válido.',

  // Code block chrome
  'codeBlock.copy': 'Copiar',
  'codeBlock.copied': 'Copiado!',
  'flows.editor.undo': 'Desfazer',
  'flows.editor.redo': 'Refazer',
  'flows.editor.onboardingTitle': 'Crie seu fluxo de trabalho',
  'flows.editor.onboardingBody':
    'Adicione um nó a partir da paleta à esquerda e, em seguida, arraste entre os pontos de cada cartão para conectá-los.',
  'flows.palette.search': 'Pesquisar nós…',
  'flows.palette.noResults': 'Nenhum nó correspondente',
  'flows.palette.group.triggers': 'Gatilhos',
  'flows.palette.group.actions': 'Ações',
  'flows.palette.group.logic': 'Lógica',
  'flows.list.duplicate': 'Duplicar',
  'flows.list.duplicated': 'Fluxo de trabalho duplicado',
  'flows.list.delete': 'Excluir',
  'flows.list.deleted': 'Fluxo de trabalho excluído',
  'flows.list.moreActions': 'Mais ações',
  'flows.delete.title': 'Excluir fluxo de trabalho?',
  'flows.delete.body':
    '"{name}" e seu histórico de execuções serão removidos permanentemente. Isso não pode ser desfeito.',
  'flows.delete.cancel': 'Cancelar',
  'flows.delete.confirm': 'Excluir',
  'flows.delete.deleting': 'Excluindo…',
  'flows.canvas.renameLabel': 'Renomear fluxo de trabalho',
  'memorySources.codingSessions.title': 'Sessões de agentes de programação',
  'memorySources.codingSessions.description':
    'Transforme decisões e correções do Codex e Claude Code em memória privada de persona.',
  'memorySources.codingSessions.importAll': 'Importar todas as sessões',
  'memorySources.codingSessions.draining': 'Importando… passagem {passes}',
  'memorySources.codingSessions.stop': 'Parar',
  'memorySources.codingSessions.progress':
    '{processed} sessões importadas · {observations} observações',
  'memorySources.codingSessions.remaining': 'restam cerca de {remaining}',
  'memorySources.codingSessions.stopped': 'Importação pausada',
  'memorySources.codingSessions.stoppedMessage':
    '{processed} sessões importadas. Execute a importação novamente para continuar as {remaining} restantes.',
  'memorySources.codingSessions.claude': 'Histórico do Claude Code',
  'memorySources.codingSessions.codex': 'Codex',
  'memorySources.codingSessions.counts': '{files} sessões · {evidence} mensagens humanas',
  'memorySources.codingSessions.notFound': 'Nenhum histórico local encontrado',
  'memorySources.codingSessions.scanning': 'Verificando o histórico local…',
  'memorySources.codingSessions.truncated':
    'A verificação foi limitada aos primeiros 1.000 arquivos de sessão.',
  'memorySources.codingSessions.complete': 'Sessões de programação ingeridas',
  'memorySources.codingSessions.completeMessage':
    '{processed} sessões produziram {observations} observações de persona.',
  'memorySources.codingSessions.partialFailure':
    '{failed} sessões falharam enquanto {processed} foram processadas. Execute a ingestão novamente para tentar de novo.',
  'memorySources.codingSessions.failed': 'Falha ao ingerir sessões de programação',
  'flows.canvas.sidePanelToggle': 'Painel lateral',
  'flows.canvas.legendTab': 'Manual',

  // Privacy status pill + per-action egress disclosure (#4437 / S3)
  'privacy.status.ariaLabel': 'Estado de privacidade',
  'privacy.status.external': 'Fora do dispositivo',
  'privacy.status.local': 'No dispositivo',
  // Data Sync layered pipeline status (GH-4690)
  'sync.pipeline.ingestedOnly': 'Apenas ingerido',
  'sync.pipeline.storedWithoutVectors': 'Armazenado sem vetores. Pesquisa semântica indisponível.',
  'sync.pipeline.signInToEnable': 'Inicie sessão para ativar',
  'sync.pipeline.extractionFailed':
    'Falha na extração da estrutura de memória. O wiki pode estar incompleto.',
  'sync.pipeline.treeDegraded':
    'Árvore de memória degradada. A recuperação pode retornar resultados desatualizados.',
  'sync.pipeline.viewHealth': 'Ver a saúde da memória',
  'notifications.configRecovered.title': 'Arquivo de configurações recuperado',
  'notifications.configRecovered.body':
    'Não foi possível ler seu arquivo de configurações, então ele foi restaurado de um backup ou redefinido para os padrões. O arquivo ilegível foi mantido com o sufixo ".corrupted" caso você precise dele.',
};

export default messages;
